webpackJsonp([2,5],{

/***/ 1000:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.getFocusabledIn = exports.newFocus = undefined;var _map = __webpack_require__(659);var _map2 = _interopRequireDefault(_map);var _DOMutils = __webpack_require__(1027);
var _firstFocus = __webpack_require__(1031);var _firstFocus2 = _interopRequireDefault(_firstFocus);
var _allAffected = __webpack_require__(989);var _allAffected2 = _interopRequireDefault(_allAffected);
var _array = __webpack_require__(976);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var findAutoFocused = function findAutoFocused(autoFocusables) {
  return function (node) {
    return !!node.autofocus || node.dataset && !!node.dataset.autofocus || autoFocusables.indexOf(node) >= 0;
  };
};

var isGuard = function isGuard(node) {
  return node && node.dataset && node.dataset.focusGuard;
};
var notAGuard = function notAGuard(node) {
  return !isGuard(node);
};

var newFocus = exports.newFocus = function newFocus(innerNodes, outerNodes, activeElement, lastNode, autoFocused) {
  var cnt = innerNodes.length;
  var firstFocus = innerNodes[0];
  var lastFocus = innerNodes[cnt - 1];
  var isOnGuard = isGuard(activeElement);

  // focus is inside
  if (innerNodes.indexOf(activeElement) >= 0) {
    return undefined;
  }

  var activeIndex = outerNodes.indexOf(activeElement);
  var lastIndex = outerNodes.indexOf(lastNode || activeIndex);
  var lastNodeInside = innerNodes.indexOf(lastNode);
  var indexDiff = activeIndex - lastIndex;
  var firstNodeIndex = outerNodes.indexOf(firstFocus);
  var lastNodeIndex = outerNodes.indexOf(lastFocus);

  var returnFirstNode = (0, _firstFocus.pickFocusable)(innerNodes, 0);
  var returnLastNode = (0, _firstFocus.pickFocusable)(innerNodes, cnt - 1);

  // new focus
  if (activeIndex === -1 || lastNodeInside === -1) {
    return innerNodes.indexOf(autoFocused && autoFocused.length ? (0, _firstFocus2.default)(autoFocused) : (0, _firstFocus2.default)(innerNodes));
  }
  // old focus
  if (!indexDiff && lastNodeInside >= 0) {
    return lastNodeInside;
  }
  // first element
  if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
    return returnLastNode;
  }
  // last element
  if (activeIndex >= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
    return returnFirstNode;
  }
  // jump out, but not on the guard
  if (indexDiff && Math.abs(indexDiff) > 1) {
    return lastNodeInside;
  }
  // focus above lock
  if (activeIndex <= firstNodeIndex) {
    return returnLastNode;
  }
  // focus below lock
  if (activeIndex > lastNodeIndex) {
    return returnFirstNode;
  }
  // index is inside tab order, but outside Lock
  if (indexDiff) {
    if (Math.abs(indexDiff) > 1) {
      return lastNodeInside;
    }
    return (cnt + lastNodeInside + indexDiff) % cnt;
  }
  // do nothing
  return undefined;
};

var getTopCommonParent = function getTopCommonParent(baseActiveElement, leftEntry, rightEntries) {
  var activeElements = (0, _array.asArray)(baseActiveElement);
  var leftEntries = (0, _array.asArray)(leftEntry);
  var activeElement = activeElements[0];
  var topCommon = null;
  leftEntries.filter(Boolean).forEach(function (entry) {
    topCommon = (0, _DOMutils.getCommonParent)(topCommon || entry, entry) || topCommon;
    rightEntries.filter(Boolean).forEach(function (subEntry) {
      var common = (0, _DOMutils.getCommonParent)(activeElement, subEntry);
      if (common) {
        if (!topCommon || common.contains(topCommon)) {
          topCommon = common;
        } else {
          topCommon = (0, _DOMutils.getCommonParent)(common, topCommon);
        }
      }
    });
  });
  return topCommon;
};

var allParentAutofocusables = function allParentAutofocusables(entries) {
  return entries.reduce(function (acc, node) {
    return acc.concat((0, _DOMutils.parentAutofocusables)(node));
  }, []);
};

var reorderNodes = function reorderNodes(srcNodes, dstNodes) {
  var remap = new _map2.default();
  // no Set(dstNodes) for IE11 :(
  dstNodes.forEach(function (entity) {
    return remap.set(entity.node, entity);
  });
  // remap to dstNodes
  return srcNodes.map(function (node) {
    return remap.get(node);
  }).filter(Boolean);
};

var getFocusabledIn = exports.getFocusabledIn = function getFocusabledIn(topNode) {
  var entries = (0, _allAffected2.default)(topNode).filter(notAGuard);
  var commonParent = getTopCommonParent(topNode, topNode, entries);
  var outerNodes = (0, _DOMutils.getTabbableNodes)([commonParent], true);
  var innerElements = (0, _DOMutils.getTabbableNodes)(entries).filter(function (_ref) {
    var node = _ref.node;
    return notAGuard(node);
  }).map(function (_ref2) {
    var node = _ref2.node;
    return node;
  });

  return outerNodes.map(function (_ref3) {
    var node = _ref3.node,
    index = _ref3.index;
    return {
      node: node,
      index: index,
      lockItem: innerElements.indexOf(node) >= 0,
      guard: isGuard(node) };

  });
};

var getFocusMerge = function getFocusMerge(topNode, lastNode) {
  var activeElement = document && document.activeElement;
  var entries = (0, _allAffected2.default)(topNode).filter(notAGuard);

  var commonParent = getTopCommonParent(activeElement || topNode, topNode, entries);

  var innerElements = (0, _DOMutils.getTabbableNodes)(entries).filter(function (_ref4) {
    var node = _ref4.node;
    return notAGuard(node);
  });

  if (!innerElements[0]) {
    innerElements = (0, _DOMutils.getAllTabbableNodes)(entries).filter(function (_ref5) {
      var node = _ref5.node;
      return notAGuard(node);
    });
    if (!innerElements[0]) {
      return undefined;
    }
  }

  var outerNodes = (0, _DOMutils.getTabbableNodes)([commonParent]).map(function (_ref6) {
    var node = _ref6.node;
    return node;
  });
  var orderedInnerElements = reorderNodes(outerNodes, innerElements);
  var innerNodes = orderedInnerElements.map(function (_ref7) {
    var node = _ref7.node;
    return node;
  });

  var newId = newFocus(innerNodes, outerNodes, activeElement, lastNode, innerNodes.filter(findAutoFocused(allParentAutofocusables(entries))));

  if (newId === undefined) {
    return newId;
  }
  return orderedInnerElements[newId];
};exports.default =

getFocusMerge;

/***/ }),

/***/ 1001:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.hiddenGuard = undefined;var _react = __webpack_require__(171);var _react2 = _interopRequireDefault(_react);
var _propTypes = __webpack_require__(967);var _propTypes2 = _interopRequireDefault(_propTypes);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var hiddenGuard = exports.hiddenGuard = {
  width: '1px',
  height: '0px',
  padding: 0,
  overflow: 'hidden',
  position: 'fixed',
  top: '1px',
  left: '1px' };


var InFocusGuard = function InFocusGuard(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement("div", {
    key: "guard-first",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard }),
  children, children && _react2.default.createElement("div", {
    key: "guard-last",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard }));

};

InFocusGuard.propTypes =  false ? {
  children: _propTypes2.default.node } :
{};
InFocusGuard.defaultProps = {
  children: null };exports.default =

InFocusGuard;

/***/ }),

/***/ 1002:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequire(obj) {return obj && obj.__esModule ? obj['default'] : obj;}

var _Motion = __webpack_require__(1080);

exports.Motion = _interopRequire(_Motion);

var _StaggeredMotion = __webpack_require__(1086);

exports.StaggeredMotion = _interopRequire(_StaggeredMotion);

var _TransitionMotion = __webpack_require__(1087);

exports.TransitionMotion = _interopRequire(_TransitionMotion);

var _spring = __webpack_require__(1089);

exports.spring = _interopRequire(_spring);

var _presets = __webpack_require__(1045);

exports.presets = _interopRequire(_presets);

var _stripStyle = __webpack_require__(992);

exports.stripStyle = _interopRequire(_stripStyle);

// deprecated, dummy warning function

var _reorderKeys = __webpack_require__(1090);

exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),

/***/ 1003:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _getPrototypeOf = __webpack_require__(232);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(105);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(110);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(515);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _inherits2 = __webpack_require__(516);var _inherits3 = _interopRequireDefault(_inherits2);var _styles = __webpack_require__(1048);var _styles2 = _interopRequireDefault(_styles);
var _react = __webpack_require__(171);var _react2 = _interopRequireDefault(_react);
var _reactFocusLock = __webpack_require__(991);var _reactFocusLock2 = _interopRequireDefault(_reactFocusLock);
var _button = __webpack_require__(973);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var
MiniMenu = function (_React$Component) {(0, _inherits3.default)(MiniMenu, _React$Component);
    function MiniMenu() {(0, _classCallCheck3.default)(this, MiniMenu);var _this = (0, _possibleConstructorReturn3.default)(this, (MiniMenu.__proto__ || (0, _getPrototypeOf2.default)(MiniMenu)).apply(this,
        arguments));
        _this.items = _this.props.items;
        _this.showMiniMenu = _this.props.showMiniMenu;
        _this.toggleMiniMenu = _this.props.toggleMiniMenu;
        _this.onToggle = function () {
            _this.toggleMiniMenu();
        };return _this;
    }(0, _createClass3.default)(MiniMenu, [{ key: 'render', value: function render()
        {var _this2 = this;
            this.items = this.props.items;
            this.showMiniMenu = this.props.showMiniMenu;
            return _react2.default.createElement("div", null,
            _react2.default.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: ['icon-btn', 'dots_vertical'], "aria-label": 'Mini menu activeren', "aria-haspopup": true, tabIndex: 0, onClick: function onClick() {return _this2.onToggle();}, disabled: false },
            _react2.default.createElement("span", { className: "dots_vertical" })),
            this.showMiniMenu ?
            _react2.default.createElement(_reactFocusLock2.default, { disabled: !this.showMiniMenu },
            _react2.default.createElement("div", { tabIndex: -1, className: (0, _styles2.default)(this.showMiniMenu ? ['active', 'test', 'minimenu'] : 'minimenu') },
            _react2.default.createElement("ul", null, this.items ? this.items.map(function (item) {
                return _react2.default.createElement("li", { tabIndex: 0, key: item.key, onKeyDown: function onKeyDown(evt) {
                        return handleKeyDown(evt, function () {return _this2.toggleMiniMenu(!_this2.showMiniMenu);}, function () {return item.function(item.functionitem);});
                    }, onClick: function onClick() {return item.function(item.functionitem);} }, item.name);
            }) :
            null))) :
            null);
        } }]);return MiniMenu;}(_react2.default.Component);exports.default = MiniMenu;

function handleKeyDown(evt, functionEsc, functionEnter) {
    if (evt.key === 'Escape') {
        evt.preventDefault();
        functionEsc();
    }
    if (evt.key === 'Enter') {
        evt.preventDefault();
        functionEnter();
    }
}

/***/ }),

/***/ 1004:
/***/ (function(module, exports, __webpack_require__) {


        // classnames-loader: automatically bind css-modules to classnames
        var classNames = __webpack_require__(492);
        var locals = __webpack_require__(1120);
        var css = classNames.bind(locals);
        for (var style in locals) css[style] = locals[style];
        module.exports = css;
    

/***/ }),

/***/ 1006:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1007);

function emptyFunction() {}

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
    'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
    'Use PropTypes.checkPropTypes() to call them. ' +
    'Read more at http://fb.me/use-check-prop-types');

    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim };


  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ 1007:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ 1008:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
 // shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {return [];};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {return '/';};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {return 0;};

/***/ }),

/***/ 1009:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// currently used to initiate the velocity style object to 0


exports.__esModule = true;
exports['default'] = mapToZero;

function mapToZero(obj) {
  var ret = {};
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      ret[key] = 0;
    }
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),

/***/ 1010:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the


exports.__esModule = true;
exports["default"] = stepper;

var reusedTuple = [0, 0];

function stepper(secondPerFrame, x, v, destX, k, b, precision) {
  // Spring stiffness, in kg / s^2

  // for animations, destX is really spring length (spring at rest). initial
  // position is considered as the stretched/compressed position of a spring
  var Fspring = -k * (x - destX);

  // Damping, in kg / s
  var Fdamper = -b * v;

  // usually we put mass here, but for animation purposes, specifying mass is a
  // bit redundant. you could simply adjust k and b accordingly
  // let a = (Fspring + Fdamper) / mass;
  var a = Fspring + Fdamper;

  var newV = v + a * secondPerFrame;
  var newX = x + newV * secondPerFrame;

  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
    reusedTuple[0] = destX;
    reusedTuple[1] = 0;
    return reusedTuple;
  }

  reusedTuple[0] = newX;
  reusedTuple[1] = newV;
  return reusedTuple;
}

module.exports = exports["default"];
// array reference around.

/***/ }),

/***/ 1011:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) { // Generated by CoffeeScript 1.7.1
(function () {
  var getNanoSeconds, hrtime, loadTime;

  if (typeof performance !== "undefined" && performance !== null && performance.now) {
    module.exports = function () {
      return performance.now();
    };
  } else if (typeof process !== "undefined" && process !== null && process.hrtime) {
    module.exports = function () {
      return (getNanoSeconds() - loadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function getNanoSeconds() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    loadTime = getNanoSeconds();
  } else if (Date.now) {
    module.exports = function () {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function () {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(undefined);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1008)))

/***/ }),

/***/ 1012:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(1081),
root = typeof window === 'undefined' ? global : window,
vendors = ['moz', 'webkit'],
suffix = 'AnimationFrame',
raf = root['request' + suffix],
caf = root['cancel' + suffix] || root['cancelRequest' + suffix];

for (var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix];
  caf = root[vendors[i] + 'Cancel' + suffix] ||
  root[vendors[i] + 'CancelRequest' + suffix];
}

// Some versions of FF have rAF but not cAF
if (!raf || !caf) {
  var last = 0,
  id = 0,
  queue = [],
  frameDuration = 1000 / 60;

  raf = function raf(callback) {
    if (queue.length === 0) {
      var _now = now(),
      next = Math.max(0, frameDuration - (_now - last));
      last = next + _now;
      setTimeout(function () {
        var cp = queue.slice(0);
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0;
        for (var i = 0; i < cp.length; i++) {
          if (!cp[i].cancelled) {
            try {
              cp[i].callback(last);
            } catch (e) {
              setTimeout(function () {throw e;}, 0);
            }
          }
        }
      }, Math.round(next));
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false });

    return id;
  };

  caf = function caf(handle) {
    for (var i = 0; i < queue.length; i++) {
      if (queue[i].handle === handle) {
        queue[i].cancelled = true;
      }
    }
  };
}

module.exports = function (fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn);
};
module.exports.cancel = function () {
  caf.apply(root, arguments);
};
module.exports.polyfill = function (object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf;
  object.cancelAnimationFrame = caf;
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(157)))

/***/ }),

/***/ 1013:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// usage assumption: currentStyle values have already been rendered but it says
// nothing of whether currentStyle is stale (see unreadPropStyle)


exports.__esModule = true;
exports['default'] = shouldStopAnimation;

function shouldStopAnimation(currentStyle, style, currentVelocity) {
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }

    if (currentVelocity[key] !== 0) {
      return false;
    }

    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
    // stepper will have already taken care of rounding precision errors, so
    // won't have such thing as 0.9999 !=== 1
    if (currentStyle[key] !== styleValue) {
      return false;
    }
  }

  return true;
}

module.exports = exports['default'];

/***/ }),

/***/ 1014:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);var _for = __webpack_require__(520);var _for2 = _interopRequireDefault(_for);var _symbol = __webpack_require__(69);var _symbol2 = _interopRequireDefault(_symbol);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} /**
                                                                                                                                                                                                                                                                                                                                                                                                                        * Copyright (c) 2013-present, Facebook, Inc.
                                                                                                                                                                                                                                                                                                                                                                                                                        *
                                                                                                                                                                                                                                                                                                                                                                                                                        * This source code is licensed under the MIT license found in the
                                                                                                                                                                                                                                                                                                                                                                                                                        * LICENSE file in the root directory of this source tree.
                                                                                                                                                                                                                                                                                                                                                                                                                        */

if (false) {
  var REACT_ELEMENT_TYPE = typeof _symbol2.default === 'function' && _for2.default &&

  (0, _for2.default)('react.element') ||
  0xeac7;

  var isValidElement = function isValidElement(object) {
    return (typeof object === 'undefined' ? 'undefined' : (0, _typeof3.default)(object)) === 'object' &&
    object !== null &&
    object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1082)();
}

/***/ }),

/***/ 1015:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}module.exports = function _isPlaceholder(a) {
       return a != null &&
       (typeof a === 'undefined' ? 'undefined' : (0, _typeof3.default)(a)) === 'object' &&
       a['@@functional/placeholder'] === true;
};

/***/ }),

/***/ 1016:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _curry1 = __webpack_require__(985);
var _curry2 = __webpack_require__(996);
var _isPlaceholder = __webpack_require__(1015);


/**
                                                   * Optimized internal three-arity curry function.
                                                   *
                                                   * @private
                                                   * @category Function
                                                   * @param {Function} fn The function to curry.
                                                   * @return {Function} The curried function.
                                                   */
module.exports = function _curry3(fn) {
  return function f3(a, b, c) {
    switch (arguments.length) {
      case 0:
        return f3;
      case 1:
        return _isPlaceholder(a) ? f3 :
        _curry2(function (_b, _c) {return fn(a, _b, _c);});
      case 2:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f3 :
        _isPlaceholder(a) ? _curry2(function (_a, _c) {return fn(_a, b, _c);}) :
        _isPlaceholder(b) ? _curry2(function (_b, _c) {return fn(a, _b, _c);}) :
        _curry1(function (_c) {return fn(a, b, _c);});
      default:
        return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3 :
        _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function (_a, _b) {return fn(_a, _b, c);}) :
        _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function (_a, _c) {return fn(_a, b, _c);}) :
        _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function (_b, _c) {return fn(a, _b, _c);}) :
        _isPlaceholder(a) ? _curry1(function (_a) {return fn(_a, b, c);}) :
        _isPlaceholder(b) ? _curry1(function (_b) {return fn(a, _b, c);}) :
        _isPlaceholder(c) ? _curry1(function (_c) {return fn(a, b, _c);}) :
        fn(a, b, c);}

  };
};

/***/ }),

/***/ 1017:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.ParticipantListOfUsergroups = exports.ParticipantSelectForUsergroups = exports.ParticipantSelectionForUsergroups = exports.ParticipantSelectForFactions = exports.ParticipantSelectionForFactions = exports.UsergroupsListWithSearch = exports.ParticipantListWithSearch = exports.ParticipantAndUsergroupList = exports.ParticipantSelectModel = undefined;__webpack_require__(76);
var _react = __webpack_require__(648);
var _types = __webpack_require__(245);
var _style = __webpack_require__(1148);var _style2 = _interopRequireDefault(_style);
var _resource = __webpack_require__(246);
var _selectors = __webpack_require__(975);var _selectors2 = _interopRequireDefault(_selectors);
var _selectors3 = __webpack_require__(977);var _selectors4 = _interopRequireDefault(_selectors3);
var _CANCEL = __webpack_require__(549);var _CANCEL2 = _interopRequireDefault(_CANCEL);
var _SELECT = __webpack_require__(693);var _SELECT2 = _interopRequireDefault(_SELECT);
var _SELECT_USERGROUP = __webpack_require__(695);var _SELECT_USERGROUP2 = _interopRequireDefault(_SELECT_USERGROUP);
var _SEARCH_TERM = __webpack_require__(694);var _SEARCH_TERM2 = _interopRequireDefault(_SEARCH_TERM);
var _reselectors = __webpack_require__(1151);var _reselectors2 = _interopRequireDefault(_reselectors);
var _reselectorsusergroup = __webpack_require__(1152);var _reselectorsusergroup2 = _interopRequireDefault(_reselectorsusergroup);
var _resource2 = __webpack_require__(233);
var _SEARCH_TERM_USERGROUP = __webpack_require__(696);var _SEARCH_TERM_USERGROUP2 = _interopRequireDefault(_SEARCH_TERM_USERGROUP);
var _resource3 = __webpack_require__(106);
var _collapsiblePanel = __webpack_require__(1065);var _collapsiblePanel2 = _interopRequireDefault(_collapsiblePanel);
var _button = __webpack_require__(973);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
function mapParticipantsNames(participantIds, allparticipants) {
    var participantstring = '';
    var participants = allparticipants.qWhere(function (item) {return participantIds ? participantIds.qIncludes(item.id) : false;});
    participantstring = participants && participants.qAny() ? '' +
    participants.map(function (x) {
        return x.name;
    }).join(', ') :
    '';
    return participantstring;
}
function mapGroups(emailParticipantGroupIds, allparticipantgroups) {
    var groupsstring = '';
    var groups = allparticipantgroups.qWhere(function (item) {return emailParticipantGroupIds ? emailParticipantGroupIds.qSelect(function (itm) {return parseInt(itm);}).qIncludes(item.id) : false;});
    groupsstring =
    groups && groups.qAny() ? '' +
    groups.map(function (x) {
        return x.name;
    }).join(', ') :
    '';
    return groupsstring;
}exports.default =
(0, _react.PureConnect)('ParticipantsDropdown')(function (state) {return {
        currentitem: _resource3.notesEditor.selectors.item(state),
        participants: _resource.participantsResource.selectors.items(state),
        usergroups: _resource2.usergroupResource.selectors.items(state),
        visible: _selectors4.default.visible(state) };},
function (dispatch) {return {
        change: function change(item) {dispatch(_resource3.notesEditor.actions.APPLY({ item: item }));} };},
function (_ref) {var currentitem = _ref.currentitem,change = _ref.change;
    return _react.React.createElement("span", { tabIndex: -1, className: (0, _style2.default)('component', 'wrapped') },
    _react.React.createElement("div", { className: (0, _style2.default)('popupParticipantPopup') },
    _react.React.createElement(ParticipantSelectModel, { selectedparticipantsIDs: currentitem && currentitem.noteParticipantsIDs ? currentitem.noteParticipantsIDs : [], selectedparticipantgroupIDs: currentitem && currentitem.noteParticipantGroupIDs ? currentitem.noteParticipantGroupIDs : [], onSelect: function onSelect(c) {currentitem.noteParticipantsIDs = c;change({ currentitem: currentitem });}, onSelectGroup: function onSelectGroup(d) {currentitem.noteParticipantGroupIDs = d;change({ currentitem: currentitem });} })));
});
var ParticipantSelectModel = exports.ParticipantSelectModel = (0, _react.PureConnect)('ParticipantSelectModel')(function (state) {return {
        alltheparticipants: _reselectors2.default.AllParticipantSelector(state),
        allsearchparticipants: _reselectors2.default.ParticipantSelector(state),
        alltheusergroups: _reselectorsusergroup2.default.AllUsergroupSelector(state),
        allsearchusergroups: _reselectorsusergroup2.default.UsergroupSelector(state),
        usergroups: _resource2.usergroupResource.selectors.items(state),
        visible: _selectors4.default.visible(state),
        screenSmall: _selectors2.default.small(state),
        searchTermParticipant: _selectors4.default.searchTermParticipantSelector(state),
        searchTermUsergroup: _selectors4.default.searchTermUsergroupSelector(state) };},
function (dispatch, _ref2) {var onSelect = _ref2.onSelect,onSelectGroup = _ref2.onSelectGroup;return {
        cancel: function cancel() {dispatch((0, _CANCEL2.default)({}));},
        save: function save() {dispatch((0, _CANCEL2.default)({}));},
        select: function select(participants) {onSelect(participants.qSelect(function (x) {return x.id;}));dispatch((0, _SELECT2.default)({ participants: participants }));},
        selectGroup: function selectGroup(usergroups) {onSelectGroup(usergroups.qSelect(function (y) {return y.id.toString();}));dispatch((0, _SELECT_USERGROUP2.default)({ usergroups: usergroups }));},
        updateSearchTerm: function updateSearchTerm(searchTerm) {dispatch((0, _SEARCH_TERM2.default)({ searchTermParticipant: searchTerm }));},
        updateSearchTermGroup: function updateSearchTermGroup(searchTerm) {dispatch((0, _SEARCH_TERM_USERGROUP2.default)({ searchTermUsergroup: searchTerm }));} };},
function (_ref3) {var visible = _ref3.visible,searchTermParticipant = _ref3.searchTermParticipant,searchTermUsergroup = _ref3.searchTermUsergroup,alltheparticipants = _ref3.alltheparticipants,allsearchparticipants = _ref3.allsearchparticipants,selectedparticipantsIDs = _ref3.selectedparticipantsIDs,alltheusergroups = _ref3.alltheusergroups,allsearchusergroups = _ref3.allsearchusergroups,selectedparticipantgroupIDs = _ref3.selectedparticipantgroupIDs,cancel = _ref3.cancel,save = _ref3.save,select = _ref3.select,selectGroup = _ref3.selectGroup,updateSearchTerm = _ref3.updateSearchTerm,updateSearchTermGroup = _ref3.updateSearchTermGroup;
    var allparticipants = [];
    if (alltheparticipants && alltheparticipants.length)
    alltheparticipants.qWhere(function (itm) {return allparticipants && !allparticipants.qAny(function (itmpart) {return itmpart === itm;});}).map(function (itm) {return allparticipants.push(itm);});
    if (alltheusergroups && alltheusergroups.length)
    alltheusergroups.qWhere(function (itm) {return allparticipants && !allparticipants.qAny(function (itmpart) {return itmpart === itm;});}).map(function (ug) {return allparticipants.push(ug);});
    var theSelectedList = alltheparticipants.qWhere(function (participant) {return selectedparticipantsIDs ? selectedparticipantsIDs.qIncludes(participant.id) : false;});
    var notSelectedList = allsearchparticipants.qWhere(function (participant) {return selectedparticipantsIDs ? !selectedparticipantsIDs.qIncludes(participant.id) : true;});
    var theSelectedParticipantList = alltheparticipants.qWhere(function (participant) {return selectedparticipantsIDs ? selectedparticipantsIDs.qIncludes(participant.id) : false;});
    var theSelectedUsergroupList = alltheusergroups.qWhere(function (usergroup) {return selectedparticipantgroupIDs ? selectedparticipantgroupIDs.qSelect(function (x) {return parseInt(x);}).qIncludes(usergroup.id) : false;});
    theSelectedUsergroupList.map(function (tsu) {return theSelectedList.push(tsu);});
    var notSelectedUsergroupList = allsearchusergroups.qWhere(function (usergroup) {return selectedparticipantgroupIDs ? !selectedparticipantgroupIDs.qSelect(function (x) {return parseInt(x);}).qIncludes(usergroup.id) : true;});
    notSelectedUsergroupList.map(function (nsu) {return notSelectedList.push(nsu);});
    return _react.React.createElement("div", { className: (0, _style2.default)(!visible ? 'wcag-invisible' : '', 'fields-container'), "aria-hidden": !visible, "aria-labelledby": "Selecteer deelnemers" },
    _react.React.createElement("section", { role: "contentinfo", "aria-label": 'Sluit sectie', className: (0, _style2.default)('content-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('button-container') },
    _react.React.createElement(_button.Btn, { type: "button", className: (0, _style2.default)('btn-icon-text_back', 'icon_arrow-back'), "aria-label": 'Terug gaan', "aria-haspopup": true, tabIndex: 0, onClick: cancel, disabled: false },
    _react.React.createElement("span", null, "Terug")))),
    _react.React.createElement("div", { className: (0, _style2.default)('container') },
    _react.React.createElement("div", { className: (0, _style2.default)('selectable-aria') },
    _react.React.createElement("div", { className: (0, _style2.default)('share-with-persons') }, "Deel met personen"),
    _react.React.createElement("section", { "aria-label": 'Selecteer deelnemer', className: (0, _style2.default)('bottom') },
    _react.React.createElement(_collapsiblePanel2.default, { defaultOpened: false, label: theSelectedList.length ? mapParticipantsNames(selectedparticipantsIDs, allparticipants) : 'Selecteer' },
    _react.React.createElement("div", { className: (0, _style2.default)('input-search-div') },
    _react.React.createElement("div", { className: (0, _style2.default)('input-search') },
    _react.React.createElement("span", { className: (0, _style2.default)('icon-search') }),
    _react.React.createElement("input", { placeholder: "Zoeken...", name: "q", ref: "term", value: searchTermParticipant, onChange: function onChange(x) {return updateSearchTerm(x.target.value);} }))),
    _react.React.createElement("section", { "aria-label": 'Deelnemers', className: (0, _style2.default)('top') },
    _react.React.createElement(ParticipantAndUsergroupList, { label: "", up: false, participants: theSelectedParticipantList, allparticipants: allparticipants, onClick: function onClick(p) {
            (0, _types.isParticipant)(p) ?
            select(theSelectedParticipantList ? theSelectedParticipantList.qWhere(function (y) {return y.id !== p.id;}) : []) :
            selectGroup(theSelectedUsergroupList ? theSelectedUsergroupList.qWhere(function (y) {return y.id !== p.id;}) : []);
        }, onClickAdd: function onClickAdd(p) {
            (0, _types.isParticipant)(p) ?
            select(theSelectedParticipantList ? theSelectedParticipantList.concat(p) : []) :
            selectGroup(theSelectedUsergroupList ? theSelectedUsergroupList.concat(p) : []);
        }, onClickSelectAll: function onClickSelectAll() {select([]);selectGroup([]);} })),
    _react.React.createElement(ParticipantListWithSearch, { label: "Overige gebruikers:", participants: theSelectedList, allparticipants: allsearchparticipants, onClickRemove: function onClickRemove(p) {
            select(theSelectedParticipantList ? theSelectedParticipantList.qWhere(function (y) {return y.id !== p.id;}) : []);
        }, onClick: function onClick(p) {
            select(selectedListAndClickedOne(theSelectedParticipantList, p));
        } })),
    _react.React.createElement("div", { className: (0, _style2.default)('share-with-groups') }, "Deel met groepen"),
    _react.React.createElement(_collapsiblePanel2.default, { defaultOpened: false, label: theSelectedUsergroupList.length ? mapGroups(selectedparticipantgroupIDs, alltheusergroups) : 'Selecteer' },
    _react.React.createElement("section", { "aria-label": 'Groepen geselecteerd', className: (0, _style2.default)('top') },
    _react.React.createElement("div", { className: (0, _style2.default)('input-search-div') },
    _react.React.createElement("div", { className: (0, _style2.default)('input-search') },
    _react.React.createElement("span", { className: (0, _style2.default)('icon-search') }),
    _react.React.createElement("input", { placeholder: "Zoeken...", name: "q", ref: "term", value: searchTermUsergroup, onChange: function onChange(x) {return updateSearchTermGroup(x.target.value);} }))),
    _react.React.createElement(ParticipantAndUsergroupList, { label: "", up: false, participants: theSelectedUsergroupList, allparticipants: alltheusergroups, onClick: function onClick(p) {
            selectGroup(theSelectedUsergroupList ? theSelectedUsergroupList.qWhere(function (y) {return y.id !== p.id;}) : []);
        }, onClickAdd: function onClickAdd(p) {
            selectGroup(theSelectedUsergroupList && (0, _types.isUsergroup)(p) ? theSelectedUsergroupList.concat(p) : theSelectedUsergroupList);
        }, onClickSelectAll: function onClickSelectAll() {select([]);selectGroup([]);} })),
    _react.React.createElement(UsergroupsListWithSearch, { usergroups: theSelectedUsergroupList, allusergroups: allsearchusergroups, onClick: function onClick(p) {
            selectGroup(selectedListAndClickedOneUsergroup(theSelectedUsergroupList, p));
        }, onClickRemove: function onClickRemove(p) {
            return selectGroup(theSelectedUsergroupList ? theSelectedUsergroupList.qWhere(function (y) {return y.id !== p.id;}) : []);
        } }))))));
});
var ParticipantAndUsergroupList = exports.ParticipantAndUsergroupList = (0, _react.PureFunctional)('ParticipantList')(function (_ref4) {var participants = _ref4.participants,_onClick = _ref4.onClick;
    return _react.React.createElement("div", { className: (0, _style2.default)('list') }, participants && participants.qSelect(function (participant) {
        var isparticipant = (0, _types.isParticipant)(participant);
        var id = isparticipant ? participant.id : participant.id;
        if (id)
        return _react.React.createElement("div", { tabIndex: 0, className: (0, _style2.default)('selection-list'), key: 'key' + ('' + (isparticipant ? id.toString() : 'u-' + id)), onKeyDown: function onKeyDown(ev) {handleEnters(ev, function () {return _onClick(participant);});}, onClick: function onClick() {return _onClick(participant);} },
        participant.name,
        _react.React.createElement("span", { className: (0, _style2.default)('close') }));
        return null;
    }));
});
var ParticipantListWithSearch = exports.ParticipantListWithSearch = (0, _react.PureFunctional)('ParticipantList')(function (_ref5) {var participants = _ref5.participants,allparticipants = _ref5.allparticipants,_onClick2 = _ref5.onClick,onClickRemove = _ref5.onClickRemove;
    return _react.React.createElement("div", { className: (0, _style2.default)('list') }, allparticipants && allparticipants.qSelect(function (participant) {
        return _react.React.createElement("div", { tabIndex: 0, key: 'key' + ('' + participant.id.toString()), className: (0, _style2.default)('item'), onKeyDown: function onKeyDown(ev) {
                ev.preventDefault();
                handleEnters(ev, function () {return participants.includes(participant) ?
                    onClickRemove(participant) :
                    _onClick2(participant);});
            }, onClick: function onClick(ev) {
                ev.preventDefault();
                participants.includes(participant) ?
                onClickRemove(participant) :
                _onClick2(participant);
            } },
        _react.React.createElement("label", { className: (0, _style2.default)('selection-container') },
        participant.name,
        _react.React.createElement("input", { type: "checkbox", checked: participants.includes(participant), onChange: function onChange() {return null;} }),
        _react.React.createElement("span", { className: (0, _style2.default)('checkmark') })));
    }));
});
var UsergroupsListWithSearch = exports.UsergroupsListWithSearch = (0, _react.PureFunctional)('ParticipantList')(function (_ref6) {var usergroups = _ref6.usergroups,allusergroups = _ref6.allusergroups,_onClick3 = _ref6.onClick,onClickRemove = _ref6.onClickRemove;
    return _react.React.createElement("div", { className: (0, _style2.default)('list') }, allusergroups && allusergroups.qSelect(function (usergroup) {
        return _react.React.createElement("div", { tabIndex: 0, key: 'key' + ('' + usergroup.id.toString()), className: (0, _style2.default)('item'), onKeyDown: function onKeyDown(ev) {
                ev.preventDefault();
                usergroups.includes(usergroup) ?
                onClickRemove(usergroup) :
                _onClick3(usergroup);
            }, onClick: function onClick(ev) {
                ev.preventDefault();
                usergroups.includes(usergroup) ?
                onClickRemove(usergroup) :
                _onClick3(usergroup);
            } },
        _react.React.createElement("label", { className: (0, _style2.default)('selection-container') },
        usergroup.name,
        _react.React.createElement("input", { type: "checkbox", checked: usergroups.includes(usergroup), onChange: function onChange() {return null;} }),
        _react.React.createElement("span", { className: (0, _style2.default)('checkmark') })));
    }));
});
var ParticipantSelectionForFactions = exports.ParticipantSelectionForFactions = (0, _react.PureConnect)('ParticipantSelectionForFactions')(function (state) {return {};}, function (dispatch) {return {};}, function (_ref7) {var title = _ref7.title,selectedparticipantsIDs = _ref7.selectedparticipantsIDs,selectedparticipantgroupIDs = _ref7.selectedparticipantgroupIDs,onChange = _ref7.onChange,onChangeParticipantGroups = _ref7.onChangeParticipantGroups,onAbort = _ref7.onAbort,onSave = _ref7.onSave;
    return _react.React.createElement(ParticipantSelectForFactions, { title: title, selectedparticipantsIDs: selectedparticipantsIDs, selectedparticipantgroupIDs: selectedparticipantgroupIDs, onSelect: onChange, onSelectGroup: onChangeParticipantGroups });
});
var ParticipantSelectForFactions = exports.ParticipantSelectForFactions = (0, _react.PureConnect)('ParticipantSelectForFactions')(function (state) {return {
        alltheparticipants: _reselectors2.default.AllParticipantSelector(state),
        allsearchparticipants: _reselectors2.default.FactionParticipantSelector(state),
        alltheusergroups: _reselectorsusergroup2.default.AllUsergroupSelector(state),
        allsearchusergroups: _reselectorsusergroup2.default.UsergroupSelector(state),
        usergroups: _resource2.usergroupResource.selectors.items(state),
        screenSmall: _selectors2.default.small(state),
        searchTermParticipant: _selectors4.default.searchTermParticipantSelector(state),
        searchTermUsergroup: _selectors4.default.searchTermUsergroupSelector(state) };},
function (dispatch, _ref8) {var onSelect = _ref8.onSelect,onSelectGroup = _ref8.onSelectGroup;return {
        cancel: function cancel() {dispatch((0, _CANCEL2.default)({}));},
        save: function save() {dispatch((0, _CANCEL2.default)({}));},
        select: function select(participants) {onSelect(participants.qSelect(function (x) {return x.id;}));dispatch((0, _SELECT2.default)({ participants: participants }));},
        selectGroup: function selectGroup(usergroups) {onSelectGroup(usergroups.qSelect(function (y) {return y.id.toString();}));dispatch((0, _SELECT_USERGROUP2.default)({ usergroups: usergroups }));},
        updateSearchTerm: function updateSearchTerm(searchTerm) {dispatch((0, _SEARCH_TERM2.default)({ searchTermParticipant: searchTerm }));},
        updateSearchTermGroup: function updateSearchTermGroup(searchTerm) {dispatch((0, _SEARCH_TERM_USERGROUP2.default)({ searchTermUsergroup: searchTerm }));} };},
function (_ref9) {var title = _ref9.title,searchTermParticipant = _ref9.searchTermParticipant,searchTermUsergroup = _ref9.searchTermUsergroup,usergroups = _ref9.usergroups,alltheparticipants = _ref9.alltheparticipants,allsearchparticipants = _ref9.allsearchparticipants,selectedparticipantsIDs = _ref9.selectedparticipantsIDs,alltheusergroups = _ref9.alltheusergroups,allsearchusergroups = _ref9.allsearchusergroups,selectedparticipantgroupIDs = _ref9.selectedparticipantgroupIDs,cancel = _ref9.cancel,save = _ref9.save,select = _ref9.select,selectGroup = _ref9.selectGroup,updateSearchTerm = _ref9.updateSearchTerm,updateSearchTermGroup = _ref9.updateSearchTermGroup;
    var allparticipants = [];
    if (alltheparticipants && alltheparticipants.length)
    alltheparticipants.qWhere(function (itm) {return allparticipants && !allparticipants.qAny(function (itmpart) {return itmpart === itm;});}).map(function (itm) {return allparticipants.push(itm);});
    if (alltheusergroups && alltheusergroups.length)
    alltheusergroups.qWhere(function (itm) {return allparticipants && !allparticipants.qAny(function (itmpart) {return itmpart === itm;});}).map(function (ug) {return allparticipants.push(ug);});
    var theSelectedList = alltheparticipants.qWhere(function (participant) {return selectedparticipantsIDs ? selectedparticipantsIDs.qIncludes(participant.id) : false;});
    var notSelectedList = allsearchparticipants.
    qWhere(function (participant) {return selectedparticipantsIDs ? !selectedparticipantsIDs.qIncludes(participant.id) : true;});
    var theSelectedParticipantList = alltheparticipants.qWhere(function (participant) {return selectedparticipantsIDs ? selectedparticipantsIDs.qIncludes(participant.id) : false;});
    var theSelectedUsergroupList = alltheusergroups.qWhere(function (usergroup) {return selectedparticipantgroupIDs ? selectedparticipantgroupIDs.qSelect(function (x) {return parseInt(x);}).qIncludes(usergroup.id) : false;});
    theSelectedUsergroupList.map(function (tsu) {return theSelectedList.push(tsu);});
    var notSelectedUsergroupList = allsearchusergroups.qWhere(function (usergroup) {return selectedparticipantgroupIDs ? !selectedparticipantgroupIDs.qSelect(function (x) {return parseInt(x);}).qIncludes(usergroup.id) : true;});
    notSelectedUsergroupList.map(function (nsu) {return notSelectedList.push(nsu);});
    return _react.React.createElement("div", { className: (0, _style2.default)('fields-container'), "aria-hidden": false, "aria-labelledby": "Selecteer deelnemers" },
    _react.React.createElement("div", { className: (0, _style2.default)('container') },
    _react.React.createElement("div", { className: (0, _style2.default)('selectable-aria') },
    _react.React.createElement("div", { className: (0, _style2.default)('share-with-persons') }, title && title.length ? title : 'Leden van de groep'),
    _react.React.createElement("section", { "aria-label": 'Selecteer deelnemer', className: (0, _style2.default)('bottom') },
    _react.React.createElement(_collapsiblePanel2.default, { defaultOpened: false, label: theSelectedList.length ? mapParticipantsNames(selectedparticipantsIDs, allparticipants) : 'Selecteer' },
    _react.React.createElement("div", { className: (0, _style2.default)('input-search-div') },
    _react.React.createElement("div", { className: (0, _style2.default)('input-search') },
    _react.React.createElement("span", { className: (0, _style2.default)('icon-search') }),
    _react.React.createElement("input", { placeholder: "Zoeken...", name: "q", ref: "term", value: searchTermParticipant, onChange: function onChange(x) {return updateSearchTerm(x.target.value);} }))),
    _react.React.createElement("section", { "aria-label": 'Deelnemers', className: (0, _style2.default)('top') },
    _react.React.createElement(ParticipantAndUsergroupList, { label: "", up: false, participants: theSelectedParticipantList, allparticipants: allparticipants, onClick: function onClick(p) {
            (0, _types.isParticipant)(p) ?
            select(theSelectedParticipantList ? theSelectedParticipantList.qWhere(function (y) {return y.id !== p.id;}) : []) :
            selectGroup(theSelectedUsergroupList ? theSelectedUsergroupList.qWhere(function (y) {return y.id !== p.id;}) : []);
        }, onClickAdd: function onClickAdd(p) {
            (0, _types.isParticipant)(p) ?
            select(theSelectedParticipantList ? theSelectedParticipantList.concat(p) : []) :
            selectGroup(theSelectedUsergroupList ? theSelectedUsergroupList.concat(p) : []);
        }, onClickSelectAll: function onClickSelectAll() {select([]);selectGroup([]);} })),
    _react.React.createElement(ParticipantListWithSearch, { label: "Overige gebruikers:", participants: theSelectedList, allparticipants: allsearchparticipants, onClickRemove: function onClickRemove(p) {
            select(theSelectedParticipantList ? theSelectedParticipantList.qWhere(function (y) {return y.id !== p.id;}) : []);
        }, onClick: function onClick(p) {
            select(selectedListAndClickedOne(theSelectedParticipantList, p));
        } }))))));
});
var ParticipantSelectionForUsergroups = exports.ParticipantSelectionForUsergroups = (0, _react.PureConnect)('ParticipantSelectionForUsergroups')(function (state) {return {};}, function (dispatch) {return {};}, function (_ref10) {var title = _ref10.title,selectedparticipantsIDs = _ref10.selectedparticipantsIDs,selectedparticipantgroupIDs = _ref10.selectedparticipantgroupIDs,onChange = _ref10.onChange,onChangeParticipantGroups = _ref10.onChangeParticipantGroups,onAbort = _ref10.onAbort,onSave = _ref10.onSave;
    return _react.React.createElement(ParticipantSelectForUsergroups, { title: title, selectedparticipantsIDs: selectedparticipantsIDs, selectedparticipantgroupIDs: selectedparticipantgroupIDs, onSelect: onChange, onSelectGroup: onChangeParticipantGroups });
});
var ParticipantSelectForUsergroups = exports.ParticipantSelectForUsergroups = (0, _react.PureConnect)('ParticipantSelectForUsergroups')(function (state) {return {
        alltheparticipants: _reselectors2.default.AllParticipantSelector(state),
        allsearchparticipants: _reselectors2.default.ParticipantSelector(state),
        alltheusergroups: _reselectorsusergroup2.default.AllUsergroupSelector(state),
        allsearchusergroups: _reselectorsusergroup2.default.UsergroupSelector(state),
        usergroups: _resource2.usergroupResource.selectors.items(state),
        screenSmall: _selectors2.default.small(state),
        searchTermParticipant: _selectors4.default.searchTermParticipantSelector(state),
        searchTermUsergroup: _selectors4.default.searchTermUsergroupSelector(state) };},
function (dispatch, _ref11) {var onSelect = _ref11.onSelect,onSelectGroup = _ref11.onSelectGroup;return {
        cancel: function cancel() {dispatch((0, _CANCEL2.default)({}));},
        save: function save() {dispatch((0, _CANCEL2.default)({}));},
        select: function select(participants) {onSelect(participants.qSelect(function (x) {return x.id;}));dispatch((0, _SELECT2.default)({ participants: participants }));},
        selectGroup: function selectGroup(usergroups) {onSelectGroup(usergroups.qSelect(function (y) {return y.id.toString();}));dispatch((0, _SELECT_USERGROUP2.default)({ usergroups: usergroups }));},
        updateSearchTerm: function updateSearchTerm(searchTerm) {dispatch((0, _SEARCH_TERM2.default)({ searchTermParticipant: searchTerm }));},
        updateSearchTermGroup: function updateSearchTermGroup(searchTerm) {dispatch((0, _SEARCH_TERM_USERGROUP2.default)({ searchTermUsergroup: searchTerm }));} };},
function (_ref12) {var title = _ref12.title,searchTermParticipant = _ref12.searchTermParticipant,searchTermUsergroup = _ref12.searchTermUsergroup,alltheparticipants = _ref12.alltheparticipants,allsearchparticipants = _ref12.allsearchparticipants,selectedparticipantsIDs = _ref12.selectedparticipantsIDs,alltheusergroups = _ref12.alltheusergroups,allsearchusergroups = _ref12.allsearchusergroups,selectedparticipantgroupIDs = _ref12.selectedparticipantgroupIDs,cancel = _ref12.cancel,save = _ref12.save,select = _ref12.select,selectGroup = _ref12.selectGroup,updateSearchTerm = _ref12.updateSearchTerm,updateSearchTermGroup = _ref12.updateSearchTermGroup;
    var allparticipants = [];
    if (alltheparticipants && alltheparticipants.length)
    alltheparticipants.qWhere(function (itm) {return allparticipants && !allparticipants.qAny(function (itmpart) {return itmpart === itm;});}).map(function (itm) {return allparticipants.push(itm);});
    if (alltheusergroups && alltheusergroups.length)
    alltheusergroups.qWhere(function (itm) {return allparticipants && !allparticipants.qAny(function (itmpart) {return itmpart === itm;});}).map(function (ug) {return allparticipants.push(ug);});
    var theSelectedList = alltheparticipants.qWhere(function (participant) {return selectedparticipantsIDs ? selectedparticipantsIDs.qIncludes(participant.id) : false;});
    var notSelectedList = allsearchparticipants.qWhere(function (participant) {return selectedparticipantsIDs ? !selectedparticipantsIDs.qIncludes(participant.id) : true;});
    var theSelectedParticipantList = alltheparticipants.qWhere(function (participant) {return selectedparticipantsIDs ? selectedparticipantsIDs.qIncludes(participant.id) : false;});
    var theSelectedUsergroupList = alltheusergroups.qWhere(function (usergroup) {return selectedparticipantgroupIDs ? selectedparticipantgroupIDs.qSelect(function (x) {return parseInt(x);}).qIncludes(usergroup.id) : false;});
    theSelectedUsergroupList.map(function (tsu) {return theSelectedList.push(tsu);});
    var notSelectedUsergroupList = allsearchusergroups.qWhere(function (usergroup) {return selectedparticipantgroupIDs ? !selectedparticipantgroupIDs.qSelect(function (x) {return parseInt(x);}).qIncludes(usergroup.id) : true;});
    notSelectedUsergroupList.map(function (nsu) {return notSelectedList.push(nsu);});
    return _react.React.createElement("div", { className: (0, _style2.default)('fields-container'), "aria-hidden": false, "aria-labelledby": "Selecteer deelnemers" },
    _react.React.createElement("div", { className: (0, _style2.default)('container') },
    _react.React.createElement("div", { className: (0, _style2.default)('selectable-aria') },
    _react.React.createElement("div", { className: (0, _style2.default)('share-with-persons') }, title && title.length ? title : 'Leden van de groep'),
    _react.React.createElement("section", { "aria-label": 'Selecteer deelnemer', className: (0, _style2.default)('bottom') },
    _react.React.createElement(_collapsiblePanel2.default, { defaultOpened: false, label: theSelectedList.length ? mapParticipantsNames(selectedparticipantsIDs, allparticipants) : 'Selecteer' },
    _react.React.createElement("div", { className: (0, _style2.default)('input-search-div') },
    _react.React.createElement("div", { className: (0, _style2.default)('input-search') },
    _react.React.createElement("span", { className: (0, _style2.default)('icon-search') }),
    _react.React.createElement("input", { placeholder: "Zoeken...", name: "q", ref: "term", value: searchTermParticipant, onChange: function onChange(x) {return updateSearchTerm(x.target.value);} }))),
    _react.React.createElement("section", { "aria-label": 'Deelnemers', className: (0, _style2.default)('top') },
    _react.React.createElement(ParticipantAndUsergroupList, { label: "", up: false, participants: theSelectedParticipantList, allparticipants: allparticipants, onClick: function onClick(p) {
            (0, _types.isParticipant)(p) ?
            select(theSelectedParticipantList ? theSelectedParticipantList.qWhere(function (y) {return y.id !== p.id;}) : []) :
            selectGroup(theSelectedUsergroupList ? theSelectedUsergroupList.qWhere(function (y) {return y.id !== p.id;}) : []);
        }, onClickAdd: function onClickAdd(p) {
            (0, _types.isParticipant)(p) ?
            select(theSelectedParticipantList ? theSelectedParticipantList.concat(p) : []) :
            selectGroup(theSelectedUsergroupList ? theSelectedUsergroupList.concat(p) : []);
        }, onClickSelectAll: function onClickSelectAll() {select([]);selectGroup([]);} })),
    _react.React.createElement(ParticipantListWithSearch, { label: "Overige gebruikers:", participants: theSelectedList, allparticipants: allsearchparticipants, onClickRemove: function onClickRemove(p) {
            select(theSelectedParticipantList ? theSelectedParticipantList.qWhere(function (y) {return y.id !== p.id;}) : []);
        }, onClick: function onClick(p) {
            select(selectedListAndClickedOne(theSelectedParticipantList, p));
        } }))))));
});
var ParticipantListOfUsergroups = exports.ParticipantListOfUsergroups = (0, _react.PureConnect)('ParticipantListOfUsergroups')(function (state) {return {
        alltheparticipants: _reselectors2.default.AllParticipantSelector(state),
        screenSmall: _selectors2.default.small(state) };},
function (dispatch) {return {};}, function (_ref13) {var alltheparticipants = _ref13.alltheparticipants,selectedparticipantsIDs = _ref13.selectedparticipantsIDs;
    var allparticipants = [];
    if (alltheparticipants && alltheparticipants.length)
    alltheparticipants.qWhere(function (itm) {return allparticipants && !allparticipants.qAny(function (itmpart) {return itmpart === itm;});}).map(function (itm) {return allparticipants.push(itm);});
    var theSelectedList = alltheparticipants.qWhere(function (participant) {return selectedparticipantsIDs ? selectedparticipantsIDs.qIncludes(participant.id) : false;});
    return _react.React.createElement("div", { className: (0, _style2.default)('component') },
    _react.React.createElement("div", { className: (0, _style2.default)('header') }, theSelectedList.length ? mapParticipantsNames(selectedparticipantsIDs, allparticipants) : ''));
});
function handleEnters(evt, funct) {
    if (evt.key === 'Enter') {
        evt.preventDefault();
        funct();
    }
}
function selectedListAndClickedOne(items, newone) {
    if (items && !items.qAny(function (itm) {return itm.id === newone.id;}))
    items.push(newone);
    return items;
}
function selectedListAndClickedOneUsergroup(items, newone) {
    if (items && !items.qAny(function (itm) {return itm.id === newone.id;}))
    items.push(newone);
    return items;
}

/***/ }),

/***/ 1018:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var typeRoleAdmin = exports.typeRoleAdmin = 1;
var typeRoleClerk = exports.typeRoleClerk = 2;
var typeRolePracticioner = exports.typeRolePracticioner = 3;
var typeRoleDefault = exports.typeRoleDefault = 4;
var extraTextClerk = exports.extraTextClerk = 'De griffier heeft inzage in alle technische vragen. Hij kan de nieuwe technische vragen markeren en doorzetten naar concern. Wanneer de vragen beantwoord zijn kan de griffier de uiteindelijke antwoorden publiceren.';
var extraTextAdmin = exports.extraTextAdmin = 'De admin kan de notitieservice activeren, de statussen wijzigen, het verdelen van rollen en de deadlines instellen.';
var extraTextPracticioner = exports.extraTextPracticioner = 'De behandelaar heeft inzage in alle technische vragen. Hij kan de technische vragen vanuit \'concern\' naar \'in behandeling\' zetten of van \'in behandeling\' naar \'klaar voor publiceren\'.';
var tileTextClerk = exports.tileTextClerk = 'Verplaats vragen van concern en publiceer de antwoorden';
var tileTextAdmin = exports.tileTextAdmin = 'Beheer instellingen noteservice, wijzigen alle statussen, etc';
var tileTextPracticioner = exports.tileTextPracticioner = 'Beantwoord openstaande vragen en rond deze af';
var captionClerk = exports.captionClerk = 'Griffier';
var captionAdmin = exports.captionAdmin = 'Admin';
var captionPracticioner = exports.captionPracticioner = 'Behandelaar';
var captionTechnicalQuestionModule = exports.captionTechnicalQuestionModule = 'Technische vragen module';
var tileTextTechnicalQuestionModule = exports.tileTextTechnicalQuestionModule = 'Wanneer u deze module uitschakelt kunnen er geen nieuwe vragen worden toegevoegd. Reeds gestelde & beantwoorde vragen blijven zichtbaar';
var captionDeadlineSendingQuestion = exports.captionDeadlineSendingQuestion = 'Deadline insturen technische vragen';
var tileTextDeadlineSendingQuestion = exports.tileTextDeadlineSendingQuestion = 'Tot deze datum kunnen nieuwe technische vragen worden aangemaakt';
var captionDeadlineAnsweringQuestion = exports.captionDeadlineAnsweringQuestion = 'Deadline beantwoording vraag';
var tileTextDeadlineAnsweringQuestion = exports.tileTextDeadlineAnsweringQuestion = 'Uiterlijk deze datum moeten technische vragen beantwoord zijn';
var captionFactionFunctionality = exports.captionFactionFunctionality = 'Vragen alleen zichtbaar voor de fractie';
var tileTextFactionFunctionality = exports.tileTextFactionFunctionality = 'Standaard zijn alle technische vragen voor iedereen zichtbaar. Wanneer u de fractie functionaliteit inschakelt zijn de technische vragen alleen zichtbaar binnen een fractie.';

/***/ }),

/***/ 1019:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.CategorySelectModelSaveArea = exports.CategorySelectModel = exports.CategoryList = exports.Category = exports.CategoryPopupSelection = undefined;var _toConsumableArray2 = __webpack_require__(172);var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);__webpack_require__(76);
var _react = __webpack_require__(648);
var _FontIcon = __webpack_require__(988);
var _resource = __webpack_require__(162);
var _categoryLabel = __webpack_require__(1049);var _categoryLabel2 = _interopRequireDefault(_categoryLabel);
var _selectors = __webpack_require__(78);
var _reselectors = __webpack_require__(1139);var _reselectors2 = _interopRequireDefault(_reselectors);
var _selectors2 = __webpack_require__(981);var _selectors3 = _interopRequireDefault(_selectors2);
var _CANCEL = __webpack_require__(691);var _CANCEL2 = _interopRequireDefault(_CANCEL);
var _SELECT = __webpack_require__(548);var _SELECT2 = _interopRequireDefault(_SELECT);
var _SHOW = __webpack_require__(656);var _SHOW2 = _interopRequireDefault(_SHOW);
var _selectors4 = __webpack_require__(975);var _selectors5 = _interopRequireDefault(_selectors4);




























































var _style = __webpack_require__(1140);var _style2 = _interopRequireDefault(_style);
var _button = __webpack_require__(973);
var _resource2 = __webpack_require__(106);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var countMostUsed = 3;function handleEnters(evt, funct) {if (evt.key === 'Enter') {evt.preventDefault();funct();}}var CategoryPopupSelection = exports.CategoryPopupSelection = (0, _react.PureConnect)('CategoryPopupSelection')(function (state) {return { categories: _resource.categoriesResource.selectors.items(state), currentitem: _resource2.notesEditor.selectors.item(state), visible: _selectors3.default.visible(state), status: state };}, function (dispatch) {return { open: function open() {return dispatch((0, _SHOW2.default)({}));}, change: function change(item) {dispatch(_resource2.notesEditor.actions.APPLY({ item: item }));} };}, function (_ref) {var mode = _ref.mode,currentitem = _ref.currentitem,change = _ref.change;return _react.React.createElement(CategorySelectModel, { onSelect: function onSelect(c) {currentitem.categoryId = c.id;change({ currentitem: currentitem });}, mode: mode });});exports.default = (0, _react.PureConnect)('CategoryDropdown')(function (state) {return { categories: _resource.categoriesResource.selectors.items(state), visible: _selectors3.default.visible(state) };}, function (dispatch) {return { open: function open() {return dispatch((0, _SHOW2.default)({}));} };}, function (_ref2) {var visible = _ref2.visible,categoryId = _ref2.categoryId,mode = _ref2.mode,categories = _ref2.categories,open = _ref2.open,onChange = _ref2.onChange;var multiple = mode === 'edit' && categoryId === undefined ? [{ id: undefined, name: 'Meerdere categorieën', color: '#7f7f7f' }] : mode === 'filter' ? [{ id: undefined, name: 'Alle categorieën', color: '#efefef' }] : [];var categoriesWithEmpty = [].concat(multiple, [{ id: 0, name: 'Geen categorie', color: '#efefef' }], (0, _toConsumableArray3.default)(categories));var item = categoriesWithEmpty.qWhere(function (x) {return x.id === categoryId;}).qFirst();return _react.React.createElement("span", { tabIndex: -1, className: (0, _style2.default)('wrapped') }, _react.React.createElement("span", { tabIndex: 0, role: "button", "aria-labelledby": 'id-label-button', onKeyDown: function onKeyDown(ev) {if (!visible && ev.key === 'Enter') return open();}, className: (0, _style2.default)('component'), onClick: function onClick() {if (!visible) return open();} }, _react.React.createElement(_categoryLabel2.default, { id: 'id-label-button', color: item && item.color, name: item && item.name }), _react.React.createElement("div", { "aria-hidden": "true", className: (0, _style2.default)('arrow') }, _react.React.createElement(_FontIcon.FontIcon, { value: "arrow_drop_down" })), _react.React.createElement(CategorySelectModel, { onSelect: onChange, mode: mode })));});var Category = exports.Category = (0, _react.PureConnect)('Category')(function (state) {return { categories: _resource.categoriesResource.selectors.items(state) };}, function (dispatch) {return { open: function open() {return dispatch((0, _SHOW2.default)({}));} };}, function (_ref3) {var categoryId = _ref3.categoryId,categories = _ref3.categories,extraClassNames = _ref3.extraClassNames;var categoriesWithEmpty = [{ id: 0, name: 'Geen categorie', color: '#efefef' }].concat((0, _toConsumableArray3.default)(categories));var item = categoriesWithEmpty.qWhere(function (x) {return x.id === categoryId;}).qFirst();return _react.React.createElement("span", { tabIndex: -1, className: (0, _style2.default)('wrapped', 'selected-category', extraClassNames) }, _react.React.createElement(_categoryLabel2.default, { id: 'id-label-button', color: item && item.color, name: item && item.name }));});
var CategoryList = exports.CategoryList = (0, _react.PureFunctional)('CategoryList')(function (_ref4) {var categories = _ref4.categories,_onClick = _ref4.onClick;
    return _react.React.createElement("div", { className: (0, _style2.default)('list') }, categories.qSelect(function (item, idx) {return _react.React.createElement("div", { tabIndex: 0, role: "button", "aria-label": 'Categorie ' + item.name, key: idx, className: (0, _style2.default)('item'), onClick: function onClick() {return _onClick(item);}, onKeyDown: function onKeyDown(ev) {handleEnters(ev, function () {return _onClick(item);});} },
        _react.React.createElement(_categoryLabel2.default, { color: item.color, name: item.name, big: true }));}));
});
var CategorySelectModel = exports.CategorySelectModel = (0, _react.PureConnect)('CategorySelectModel')(function (state) {return {
        categories: _resource.categoriesResource.selectors.items(state),
        categoryId: _selectors3.default.categoryId(state),
        documentId: _selectors.selectors.docId(state),
        mostUsed: _reselectors2.default.mostUsed(state),
        visible: _selectors3.default.visible(state),
        categorycreating: _resource.categoriesEditor.selectors.creating(state),
        categoryupdating: _resource.categoriesEditor.selectors.updating(state),
        screenSmall: _selectors5.default.small(state) };},
function (dispatch, _ref5) {var onSelect = _ref5.onSelect;return {
        cancel: function cancel() {dispatch((0, _CANCEL2.default)({}));},
        select: function select(category) {onSelect(category);dispatch((0, _SELECT2.default)({ categoryId: category.id }));} };},
function (_ref6) {var visible = _ref6.visible,categorycreating = _ref6.categorycreating,categoryupdating = _ref6.categoryupdating,categoryId = _ref6.categoryId,mode = _ref6.mode,categories = _ref6.categories,cancel = _ref6.cancel,select = _ref6.select,mostUsed = _ref6.mostUsed;
    var committed = categories.qWhere(function (x) {return _resource.categoriesResource.fields.hasCommited(x);});
    var mostUsedList = mostUsed.qSelect(function (x) {return committed.qFirst(function (y) {return y.id === x.id;});}).qWhere(Boolean).slice(0, countMostUsed);
    var multiple = mode === 'edit' && categoryId === undefined ?
    [{ id: undefined, name: 'Meerdere categorieën', color: '#7f7f7f' }] :
    mode === 'filter' ?
    [{ id: undefined, name: 'Alle categorieën', color: '#efefef' }] :
    [];
    var categoriesWithEmpty = [].concat(
    multiple, [
    { id: 0, name: 'Geen categorie', color: '#efefef' }], (0, _toConsumableArray3.default)(
    committed.qWhere(function (x) {return !mostUsedList.qIncludes(x);}).sort(function (a, b) {return a.name.localeCompare(b.name);})));

    return _react.React.createElement("div", { className: (0, _style2.default)(!visible || categorycreating || categoryupdating ? 'wcag-invisible' : ''), "aria-hidden": !visible },
    _react.React.createElement("section", { role: "contentinfo", "aria-label": 'Sluit sectie', className: (0, _style2.default)('content-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('button-container') },
    _react.React.createElement(_button.Btn, { type: "button", className: (0, _style2.default)('btn-icon-text_back', 'icon_arrow-back'), "aria-label": 'Terug gaan', "aria-haspopup": true, tabIndex: 0, onClick: function onClick() {return cancel();}, disabled: false }, "Terug")),
    _react.React.createElement("div", { className: (0, _style2.default)('sub-title') }, "Selecteer een categorie")),
    _react.React.createElement("section", { role: "contentinfo", "aria-label": 'Lijst met te selecteren categorie', className: (0, _style2.default)('content-container', 'scroll') },
    _react.React.createElement("section", { role: "contentinfo", "aria-label": 'Laatst gebruikt' },
    _react.React.createElement("div", { className: (0, _style2.default)('section-title') }, "Laatst gebruikt"),
    _react.React.createElement(CategoryList, { categories: mostUsedList, onClick: select })),
    _react.React.createElement("section", { role: "contentinfo", "aria-label": 'Alle categorieën' },
    _react.React.createElement("div", { className: (0, _style2.default)('section-title') }, 'Alle categorie\xEBn'),
    _react.React.createElement(CategoryList, { categories: categoriesWithEmpty, onClick: select }))));
});
var CategorySelectModelSaveArea = exports.CategorySelectModelSaveArea = (0, _react.PureConnect)('CategorySelectModel')(function (state) {return {
        categories: _resource.categoriesResource.selectors.items(state),
        categoryId: _selectors3.default.categoryId(state),
        documentId: _selectors.selectors.docId(state),
        visible: _selectors3.default.visible(state),
        categorycreating: _resource.categoriesEditor.selectors.creating(state),
        categoryupdating: _resource.categoriesEditor.selectors.updating(state) };},
function (dispatch) {return {
        createCategory: function createCategory(documentId) {dispatch(_resource.categoriesEditor.actions.CREATE({ item: { documentId: documentId } }));} };},
function (_ref7) {var createCategory = _ref7.createCategory,visible = _ref7.visible,categorycreating = _ref7.categorycreating,categoryupdating = _ref7.categoryupdating,documentId = _ref7.documentId;
    return _react.React.createElement("div", { className: (0, _style2.default)('bottom-container', !visible || categorycreating || categoryupdating ? 'wcag-invisible' : ''), "aria-hidden": !visible || categorycreating || categoryupdating },
    _react.React.createElement("div", { className: (0, _style2.default)('button-container'), role: "contentinfo", "aria-label": 'Sluit sectie' },
    _react.React.createElement(_button.Btn, { type: "button", className: (0, _style2.default)('btn', 'secondary-button_icon'), "aria-label": 'Nieuwe categorie aanmaken', "aria-haspopup": true, tabIndex: 0, onClick: function onClick() {return createCategory(documentId);}, disabled: false },
    _react.React.createElement("span", { className: (0, _style2.default)('icon-plus') }, "NIEUWE CATEGORIE"))));
});

/***/ }),

/***/ 1020:
/***/ (function(module, exports, __webpack_require__) {


        // classnames-loader: automatically bind css-modules to classnames
        var classNames = __webpack_require__(492);
        var locals = __webpack_require__(1145);
        var css = classNames.bind(locals);
        for (var style in locals) css[style] = locals[style];
        module.exports = css;
    

/***/ }),

/***/ 1025:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends3 = __webpack_require__(982);var _extends4 = _interopRequireDefault(_extends3);
var _inheritsLoose2 = __webpack_require__(997);var _inheritsLoose3 = _interopRequireDefault(_inheritsLoose2);
var _assertThisInitialized2 = __webpack_require__(998);var _assertThisInitialized3 = _interopRequireDefault(_assertThisInitialized2);
var _defineProperty2 = __webpack_require__(999);var _defineProperty3 = _interopRequireDefault(_defineProperty2);
var _react = __webpack_require__(171);var _react2 = _interopRequireDefault(_react);
var _propTypes = __webpack_require__(967);var _propTypes2 = _interopRequireDefault(_propTypes);
var _focusLock = __webpack_require__(980);
var _Trap = __webpack_require__(1035);var _Trap2 = _interopRequireDefault(_Trap);
var _FocusGuard = __webpack_require__(1001);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var RenderChildren = function RenderChildren(_ref) {
  var children = _ref.children;
  return _react2.default.createElement("div", null, children);
};

RenderChildren.propTypes =  false ? {
  children: _propTypes2.default.node.isRequired } :
{};
var Fragment = _react2.default.Fragment ? _react2.default.Fragment : RenderChildren;
var emptyArray = [];

var FocusLock =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose3.default)(FocusLock, _Component);

  function FocusLock() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    (0, _defineProperty3.default)((0, _assertThisInitialized3.default)((0, _assertThisInitialized3.default)(_this)), "state", {
      observed: undefined });


    (0, _defineProperty3.default)((0, _assertThisInitialized3.default)((0, _assertThisInitialized3.default)(_this)), "onActivation", function () {
      _this.originalFocusedElement = _this.originalFocusedElement || document && document.activeElement;

      if (_this.state.observed && _this.props.onActivation) {
        _this.props.onActivation(_this.state.observed);
      }

      _this.isActive = true;
    });

    (0, _defineProperty3.default)((0, _assertThisInitialized3.default)((0, _assertThisInitialized3.default)(_this)), "onDeactivation", function () {
      _this.isActive = false;

      if (_this.props.returnFocus && _this.originalFocusedElement && _this.originalFocusedElement.focus) {
        _this.originalFocusedElement.focus();

        _this.originalFocusedElement = null;
      }

      if (_this.props.onDeactivation) {
        _this.props.onDeactivation(_this.state.observed);
      }
    });

    (0, _defineProperty3.default)((0, _assertThisInitialized3.default)((0, _assertThisInitialized3.default)(_this)), "onFocus", function (event) {
      if (_this.isActive) {
        (0, _Trap.onFocus)(event);
      }
    });

    (0, _defineProperty3.default)((0, _assertThisInitialized3.default)((0, _assertThisInitialized3.default)(_this)), "onBlur", _Trap.onBlur);

    (0, _defineProperty3.default)((0, _assertThisInitialized3.default)((0, _assertThisInitialized3.default)(_this)), "setObserveNode", function (observed) {
      if (_this.state.observed !== observed) {
        _this.setState({
          observed: observed });

      }
    });

    (0, _defineProperty3.default)((0, _assertThisInitialized3.default)((0, _assertThisInitialized3.default)(_this)), "isActive", false);

    (0, _defineProperty3.default)((0, _assertThisInitialized3.default)((0, _assertThisInitialized3.default)(_this)), "originalFocusedElement", null);

    return _this;
  }

  var _proto = FocusLock.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
    children = _this$props.children,
    disabled = _this$props.disabled,
    noFocusGuards = _this$props.noFocusGuards,
    persistentFocus = _this$props.persistentFocus,
    autoFocus = _this$props.autoFocus,
    allowTextSelection = _this$props.allowTextSelection,
    group = _this$props.group,
    className = _this$props.className,
    whiteList = _this$props.whiteList,
    _this$props$shards = _this$props.shards,
    shards = _this$props$shards === void 0 ? emptyArray : _this$props$shards,
    _this$props$as = _this$props.as,
    Container = _this$props$as === void 0 ? 'div' : _this$props$as,
    _this$props$lockProps = _this$props.lockProps,
    containerProps = _this$props$lockProps === void 0 ? {} : _this$props$lockProps;
    var observed = this.state.observed;

    if (false) {
      if (typeof allowTextSelection !== 'undefined') {
        // eslint-disable-next-line no-console
        console.warn('React-Focus-Lock: allowTextSelection is deprecated and enabled by default');
      }
    }

    var lockProps = (0, _extends4.default)((_extends2 = {}, _extends2[_focusLock.constants.FOCUS_DISABLED] = disabled && 'disabled', _extends2[_focusLock.constants.FOCUS_GROUP] = group, _extends2), containerProps);

    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    return _react2.default.createElement(Fragment, null, hasLeadingGuards && [_react2.default.createElement("div", {
      key: "guard-first",
      "data-focus-guard": true,
      tabIndex: disabled ? -1 : 0,
      style: _FocusGuard.hiddenGuard }),
    // nearest focus guard
    _react2.default.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": true,
      tabIndex: disabled ? -1 : 1,
      style: _FocusGuard.hiddenGuard })],
    _react2.default.createElement(Container, (0, _extends4.default)({
      ref: this.setObserveNode },
    lockProps, {
      className: className,
      onBlur: this.onBlur,
      onFocus: this.onFocus }),
    _react2.default.createElement(_Trap2.default, {
      observed: observed,
      disabled: disabled,
      persistentFocus: persistentFocus,
      autoFocus: autoFocus,
      whiteList: whiteList,
      shards: shards,
      onActivation: this.onActivation,
      onDeactivation: this.onDeactivation }),
    children), hasTailingGuards && _react2.default.createElement("div", {
      "data-focus-guard": true,
      tabIndex: disabled ? -1 : 0,
      style: _FocusGuard.hiddenGuard }));

  };

  return FocusLock;
}(_react.Component);

FocusLock.propTypes =  false ? {
  children: _propTypes2.default.node.isRequired,
  disabled: _propTypes2.default.bool,
  returnFocus: _propTypes2.default.bool,
  noFocusGuards: _propTypes2.default.bool,
  allowTextSelection: _propTypes2.default.bool,
  autoFocus: _propTypes2.default.bool,
  persistentFocus: _propTypes2.default.bool,
  group: _propTypes2.default.string,
  className: _propTypes2.default.string,
  whiteList: _propTypes2.default.func,
  shards: _propTypes2.default.arrayOf(_propTypes2.default.any),
  as: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.object]),
  lockProps: _propTypes2.default.object,
  onActivation: _propTypes2.default.func,
  onDeactivation: _propTypes2.default.func } :
{};
FocusLock.defaultProps = {
  disabled: false,
  returnFocus: false,
  noFocusGuards: false,
  autoFocus: true,
  persistentFocus: false,
  allowTextSelection: undefined,
  group: undefined,
  className: undefined,
  whiteList: undefined,
  shards: undefined,
  as: 'div',
  lockProps: {},
  onActivation: undefined,
  onDeactivation: undefined };exports.default =

FocusLock;module.exports = exports["default"];

/***/ }),

/***/ 1026:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = {
  attach: function attach() {},
  detach: function detach() {} };module.exports = exports["default"];

/***/ }),

/***/ 1027:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.parentAutofocusables = exports.getAllTabbableNodes = exports.getTabbableNodes = exports.filterFocusable = exports.getCommonParent = exports.notHiddenInput = exports.isVisible = undefined;var _tabOrder = __webpack_require__(1028);
var _tabUtils = __webpack_require__(1029);
var _array = __webpack_require__(976);

var isElementHidden = function isElementHidden(computedStyle) {
  if (!computedStyle || !computedStyle.getPropertyValue) {
    return false;
  }
  return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};

var isVisible = exports.isVisible = function isVisible(node) {
  return !node || node === document || node.nodeType === Node.DOCUMENT_NODE || !isElementHidden(window.getComputedStyle(node, null)) && isVisible(node.parentNode);
};

var notHiddenInput = exports.notHiddenInput = function notHiddenInput(node) {
  return !((node.tagName === 'INPUT' || node.tagName === 'BUTTON') && (node.type === 'hidden' || node.disabled));
};

var getParents = function getParents(node) {
  var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  parents.push(node);
  if (node.parentNode) {
    getParents(node.parentNode, parents);
  }
  return parents;
};

var getCommonParent = exports.getCommonParent = function getCommonParent(nodea, nodeb) {
  var parentsA = getParents(nodea);
  var parentsB = getParents(nodeb);

  for (var i = 0; i < parentsA.length; i += 1) {
    var currentParent = parentsA[i];
    if (parentsB.indexOf(currentParent) >= 0) {
      return currentParent;
    }
  }
  return false;
};

var filterFocusable = exports.filterFocusable = function filterFocusable(nodes) {
  return (0, _array.toArray)(nodes).filter(function (node) {
    return isVisible(node);
  }).filter(function (node) {
    return notHiddenInput(node);
  });
};

var getTabbableNodes = exports.getTabbableNodes = function getTabbableNodes(topNodes, withGuards) {
  return (0, _tabOrder.orderByTabIndex)(filterFocusable((0, _tabUtils.getFocusables)(topNodes, withGuards)), true, withGuards);
};

var getAllTabbableNodes = exports.getAllTabbableNodes = function getAllTabbableNodes(topNodes) {
  return (0, _tabOrder.orderByTabIndex)(filterFocusable((0, _tabUtils.getFocusables)(topNodes)), false);
};

var parentAutofocusables = exports.parentAutofocusables = function parentAutofocusables(topNode) {
  return filterFocusable((0, _tabUtils.getParentAutofocusables)(topNode));
};

/***/ }),

/***/ 1028:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.orderByTabIndex = exports.tabSort = undefined;var _array = __webpack_require__(976);

var tabSort = exports.tabSort = function tabSort(a, b) {
  var tabDiff = a.tabIndex - b.tabIndex;
  var indexDiff = a.index - b.index;

  if (tabDiff) {
    if (!a.tabIndex) return 1;
    if (!b.tabIndex) return -1;
  }

  return tabDiff || indexDiff;
};

var orderByTabIndex = exports.orderByTabIndex = function orderByTabIndex(nodes, filterNegative, keepGuards) {
  return (0, _array.toArray)(nodes).map(function (node, index) {
    return {
      node: node,
      index: index,
      tabIndex: keepGuards && node.tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : node.tabIndex };

  }).filter(function (data) {
    return !filterNegative || data.tabIndex >= 0;
  }).sort(tabSort);
};

/***/ }),

/***/ 1029:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.getParentAutofocusables = exports.getFocusables = undefined;var _tabbables = __webpack_require__(1030);var _tabbables2 = _interopRequireDefault(_tabbables);
var _array = __webpack_require__(976);
var _constants = __webpack_require__(983);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var queryTabbables = _tabbables2.default.join(',');
var queryGuardTabbables = queryTabbables + ', [data-focus-guard]';

var getFocusables = exports.getFocusables = function getFocusables(parents, withGuards) {
  return parents.reduce(function (acc, parent) {
    return acc.concat(
    // add all tabbables inside
    (0, _array.toArray)(parent.querySelectorAll(withGuards ? queryGuardTabbables : queryTabbables)),
    // add if node is tabble itself
    parent.parentNode ? (0, _array.toArray)(parent.parentNode.querySelectorAll(_tabbables2.default.join(','))).filter(function (node) {
      return node === parent;
    }) : []);
  }, []);
};

var getParentAutofocusables = exports.getParentAutofocusables = function getParentAutofocusables(parent) {
  var parentFocus = parent.querySelectorAll('[' + _constants.FOCUS_AUTO + ']');
  return (0, _array.toArray)(parentFocus).map(function (node) {
    return getFocusables([node]);
  }).reduce(function (acc, nodes) {
    return acc.concat(nodes);
  }, []);
};

/***/ }),

/***/ 1030:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = ['button:enabled:not([readonly])', 'select:enabled:not([readonly])', 'textarea:enabled:not([readonly])', 'input:enabled:not([readonly])', 'a[href]', 'area[href]', 'iframe', 'object', 'embed', '[tabindex]', '[contenteditable]', '[autofocus]'];module.exports = exports['default'];

/***/ }),

/***/ 1031:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var isRadio = function isRadio(node) {
  return node.tagName === 'INPUT' && node.type === 'radio';
};

var findSelectedRadio = function findSelectedRadio(node, nodes) {
  return nodes.filter(isRadio).filter(function (el) {
    return el.name === node.name;
  }).filter(function (el) {
    return el.checked;
  })[0] || node;
};

var pickFirstFocus = function pickFirstFocus(nodes) {
  if (nodes[0] && nodes.length > 1) {
    if (isRadio(nodes[0]) && nodes[0].name) {
      return findSelectedRadio(nodes[0], nodes);
    }
  }
  return nodes[0];
};

var pickFocusable = exports.pickFocusable = function pickFocusable(nodes, index) {
  if (nodes.length > 1) {
    if (isRadio(nodes[index]) && nodes[index].name) {
      return nodes.indexOf(findSelectedRadio(nodes[index], nodes));
    }
  }
  return index;
};exports.default =

pickFirstFocus;

/***/ }),

/***/ 1032:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _allAffected = __webpack_require__(989);var _allAffected2 = _interopRequireDefault(_allAffected);
var _array = __webpack_require__(976);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var focusInFrame = function focusInFrame(frame) {
  return frame === document.activeElement;
};

var focusInsideIframe = function focusInsideIframe(topNode) {
  return !!(0, _array.arrayFind)((0, _array.toArray)(topNode.querySelectorAll('iframe')), focusInFrame);
};

var focusInside = function focusInside(topNode) {
  var activeElement = document && document.activeElement;

  if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) {
    return false;
  }
  return (0, _allAffected2.default)(topNode).reduce(function (result, node) {
    return result || node.contains(activeElement) || focusInsideIframe(node);
  }, false);
};exports.default =

focusInside;module.exports = exports['default'];

/***/ }),

/***/ 1033:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _array = __webpack_require__(976);
var _constants = __webpack_require__(983);

var focusIsHidden = function focusIsHidden() {
  return document && (0, _array.toArray)(document.querySelectorAll('[' + _constants.FOCUS_ALLOW + ']')).some(function (node) {
    return node.contains(document.activeElement);
  });
};exports.default =

focusIsHidden;module.exports = exports['default'];

/***/ }),

/***/ 1034:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.focusOn = undefined;var _focusMerge = __webpack_require__(1000);var _focusMerge2 = _interopRequireDefault(_focusMerge);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var focusOn = exports.focusOn = function focusOn(target) {
  target.focus();
  if (target.contentWindow) {
    target.contentWindow.focus();
  }
};

var guardCount = 0;
var lockDisabled = false;exports.default =

function (topNode, lastNode) {
  var focusable = (0, _focusMerge2.default)(topNode, lastNode);

  if (lockDisabled) {
    return;
  }

  if (focusable) {
    if (guardCount > 2) {
      // eslint-disable-next-line no-console
      console.error('FocusLock: focus-fighting detected. Only one focus management system could be active. ' + 'See https://github.com/theKashey/focus-lock/#focus-fighting');
      lockDisabled = true;
      setTimeout(function () {
        lockDisabled = false;
      }, 1);
      return;
    }
    guardCount++;
    focusOn(focusable.node);
    guardCount--;
  }
};

/***/ }),

/***/ 1035:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.onFocus = exports.onBlur = undefined;var _react = __webpack_require__(171);var _react2 = _interopRequireDefault(_react);
var _propTypes = __webpack_require__(967);var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactClientsideEffect = __webpack_require__(1036);var _reactClientsideEffect2 = _interopRequireDefault(_reactClientsideEffect);
var _focusLock = __webpack_require__(980);var _focusLock2 = _interopRequireDefault(_focusLock);
var _util = __webpack_require__(984);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var focusOnBody = function focusOnBody() {
  return document && document.activeElement === document.body;
};

var isFreeFocus = function isFreeFocus() {
  return focusOnBody() || (0, _focusLock.focusIsHidden)();
};

var lastActiveTrap = null;
var lastActiveFocus = null;
var lastPortaledElement = null;
var focusWasOutsideWindow = false;

var defaultWhitelist = function defaultWhitelist() {
  return true;
};

var focusWhitelisted = function focusWhitelisted(activeElement) {
  return (lastActiveTrap.whiteList || defaultWhitelist)(activeElement);
};

var recordPortal = function recordPortal(observerNode, portaledElement) {
  lastPortaledElement = {
    observerNode: observerNode,
    portaledElement: portaledElement };

};

var focusIsPortaledPair = function focusIsPortaledPair(element) {
  return lastPortaledElement && lastPortaledElement.portaledElement === element;
};

function autoGuard(startIndex, end, step, allNodes) {
  var lastGuard = null;
  var i = startIndex;

  do {
    var item = allNodes[i];

    if (item.guard) {
      if (item.node.dataset.focusAutoGuard) {
        lastGuard = item;
      }
    } else if (item.lockItem) {
      if (i !== startIndex) {
        // we will tab to the next element
        return;
      }

      lastGuard = null;
    } else {
      break;
    }
  } while ((i += step) !== end);

  if (lastGuard) {
    lastGuard.node.tabIndex = 0;
  }
}

var extractRef = function extractRef(ref) {
  return ref && 'current' in ref ? ref.current : ref;
};

var activateTrap = function activateTrap() {
  var result = false;

  if (lastActiveTrap) {
    var _lastActiveTrap = lastActiveTrap,
    observed = _lastActiveTrap.observed,
    persistentFocus = _lastActiveTrap.persistentFocus,
    autoFocus = _lastActiveTrap.autoFocus,
    shards = _lastActiveTrap.shards;
    var workingNode = observed || lastPortaledElement && lastPortaledElement.portaledElement;
    var activeElement = document && document.activeElement;

    if (workingNode) {
      var workingArea = [workingNode].concat(shards.map(extractRef).filter(Boolean));

      if (!activeElement || focusWhitelisted(activeElement)) {
        if (persistentFocus || focusWasOutsideWindow || !isFreeFocus() || !lastActiveFocus && autoFocus) {
          if (workingNode && !((0, _focusLock.focusInside)(workingArea) || focusIsPortaledPair(activeElement, workingNode))) {
            if (document && !lastActiveFocus && activeElement && !autoFocus) {
              activeElement.blur();
              document.body.focus();
            } else {
              result = (0, _focusLock2.default)(workingArea, lastActiveFocus);
              lastPortaledElement = {};
            }
          }

          focusWasOutsideWindow = false;
          lastActiveFocus = document && document.activeElement;
        }
      }

      if (document) {
        var newActiveElement = document && document.activeElement;
        var allNodes = (0, _focusLock.getFocusabledIn)(workingArea);
        var focusedItem = allNodes.find(function (_ref) {
          var node = _ref.node;
          return node === newActiveElement;
        });

        if (focusedItem) {
          // remove old focus
          allNodes.filter(function (_ref2) {
            var guard = _ref2.guard,
            node = _ref2.node;
            return guard && node.dataset.focusAutoGuard;
          }).forEach(function (_ref3) {
            var node = _ref3.node;
            return node.removeAttribute('tabIndex');
          });
          var focusedIndex = allNodes.indexOf(focusedItem);
          autoGuard(focusedIndex, allNodes.length, +1, allNodes);
          autoGuard(focusedIndex, -1, -1, allNodes);
        }
      }
    }
  }

  return result;
};

var onTrap = function onTrap(event) {
  if (activateTrap() && event) {
    // prevent scroll jump
    event.stopPropagation();
    event.preventDefault();
  }
};

var onBlur = exports.onBlur = function onBlur() {
  return (0, _util.deferAction)(activateTrap);
};
var onFocus = exports.onFocus = function onFocus(event) {
  // detect portal
  var source = event.target;
  var currentNode = event.currentTarget;

  if (!currentNode.contains(source)) {
    recordPortal(currentNode, source);
  }
};

var FocusWatcher = function FocusWatcher() {
  return null;
};

var FocusTrap = function FocusTrap(_ref4) {
  var children = _ref4.children;
  return _react2.default.createElement("div", {
    onBlur: onBlur,
    onFocus: onFocus },
  children);
};

FocusTrap.propTypes =  false ? {
  children: _propTypes2.default.node.isRequired } :
{};

var onWindowBlur = function onWindowBlur() {
  focusWasOutsideWindow = true;
};

var attachHandler = function attachHandler() {
  document.addEventListener('focusin', onTrap, true);
  document.addEventListener('focusout', onBlur);
  window.addEventListener('blur', onWindowBlur);
};

var detachHandler = function detachHandler() {
  document.removeEventListener('focusin', onTrap, true);
  document.removeEventListener('focusout', onBlur);
  window.removeEventListener('blur', onWindowBlur);
};

function reducePropsToState(propsList) {
  return propsList.filter(function (_ref5) {
    var disabled = _ref5.disabled;
    return !disabled;
  }).slice(-1)[0];
}

function handleStateChangeOnClient(trap) {
  if (trap && !lastActiveTrap) {
    attachHandler();
  }

  var lastTrap = lastActiveTrap;
  var sameTrap = lastTrap && trap && trap.onActivation === lastTrap.onActivation;
  lastActiveTrap = trap;

  if (lastTrap && !sameTrap) {
    lastTrap.onDeactivation();
  }

  if (trap) {
    lastActiveFocus = null;

    if (!sameTrap || lastTrap.observed !== trap.observed) {
      trap.onActivation();
    }

    activateTrap(true);
    (0, _util.deferAction)(activateTrap);
  } else {
    detachHandler();
    lastActiveFocus = null;
  }
}exports.default =

(0, _reactClientsideEffect2.default)(reducePropsToState, handleStateChangeOnClient)(FocusWatcher);

/***/ }),

/***/ 1036:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _inheritsLoose2 = __webpack_require__(1037);var _inheritsLoose3 = _interopRequireDefault(_inheritsLoose2);
var _defineProperty2 = __webpack_require__(1038);var _defineProperty3 = _interopRequireDefault(_defineProperty2);
var _react = __webpack_require__(171);var _react2 = _interopRequireDefault(_react);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

function withSideEffect(reducePropsToState, handleStateChangeOnClient) {
  if (false) {
    if (typeof reducePropsToState !== 'function') {
      throw new Error('Expected reducePropsToState to be a function.');
    }

    if (typeof handleStateChangeOnClient !== 'function') {
      throw new Error('Expected handleStateChangeOnClient to be a function.');
    }
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (false) {
      if (typeof WrappedComponent !== 'function') {
        throw new Error('Expected WrappedComponent to be a React component.');
      }
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));
      handleStateChangeOnClient(state);
    }

    var SideEffect =
    /*#__PURE__*/
    function (_PureComponent) {
      (0, _inheritsLoose3.default)(SideEffect, _PureComponent);

      function SideEffect() {
        return _PureComponent.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      var _proto = SideEffect.prototype;

      _proto.componentDidMount = function componentDidMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return _react2.default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(_react.PureComponent);

    (0, _defineProperty3.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    return SideEffect;
  };
}exports.default =

withSideEffect;module.exports = exports['default'];

/***/ }),

/***/ 1037:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _create = __webpack_require__(222);var _create2 = _interopRequireDefault(_create);exports.default = _inheritsLoose;function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _inheritsLoose(subClass, superClass) {
  subClass.prototype = (0, _create2.default)(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}module.exports = exports["default"];

/***/ }),

/***/ 1038:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _defineProperty2 = __webpack_require__(161);var _defineProperty3 = _interopRequireDefault(_defineProperty2);exports.default = _defineProperty;function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _defineProperty(obj, key, value) {
  if (key in obj) {
    (0, _defineProperty3.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true });

  } else {
    obj[key] = value;
  }

  return obj;
}module.exports = exports["default"];

/***/ }),

/***/ 1039:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(982);var _extends3 = _interopRequireDefault(_extends2);
var _react = __webpack_require__(171);var _react2 = _interopRequireDefault(_react);
var _propTypes = __webpack_require__(967);var _propTypes2 = _interopRequireDefault(_propTypes);
var _focusLock = __webpack_require__(980);
var _util = __webpack_require__(984);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var AutoFocusInside = function AutoFocusInside(_ref) {
  var disabled = _ref.disabled,
  children = _ref.children,
  className = _ref.className;
  return _react2.default.createElement("div", (0, _extends3.default)({}, (0, _util.inlineProp)(_focusLock.constants.FOCUS_AUTO, !disabled), {
    className: className }),
  children);
};

AutoFocusInside.propTypes =  false ? {
  children: _propTypes2.default.node.isRequired,
  disabled: _propTypes2.default.bool,
  className: _propTypes2.default.string } :
{};
AutoFocusInside.defaultProps = {
  disabled: false,
  className: undefined };exports.default =

AutoFocusInside;module.exports = exports['default'];

/***/ }),

/***/ 1040:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = undefined;var _extends2 = __webpack_require__(982);var _extends3 = _interopRequireDefault(_extends2);
var _inheritsLoose2 = __webpack_require__(997);var _inheritsLoose3 = _interopRequireDefault(_inheritsLoose2);
var _assertThisInitialized2 = __webpack_require__(998);var _assertThisInitialized3 = _interopRequireDefault(_assertThisInitialized2);
var _defineProperty2 = __webpack_require__(999);var _defineProperty3 = _interopRequireDefault(_defineProperty2);
var _react = __webpack_require__(171);var _react2 = _interopRequireDefault(_react);
var _propTypes = __webpack_require__(967);var _propTypes2 = _interopRequireDefault(_propTypes);
var _focusLock = __webpack_require__(980);var _focusLock2 = _interopRequireDefault(_focusLock);
var _util = __webpack_require__(984);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var MoveFocusInside =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose3.default)(MoveFocusInside, _Component);

  function MoveFocusInside() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    (0, _defineProperty3.default)((0, _assertThisInitialized3.default)((0, _assertThisInitialized3.default)(_this)), "setObserveNode", function (ref) {
      _this.observed = ref;

      _this.moveFocus();
    });

    return _this;
  }

  var _proto = MoveFocusInside.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.moveFocus();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.disabled && !this.props.disabled) {
      this.moveFocus();
    }
  };

  _proto.moveFocus = function moveFocus() {
    var observed = this.observed;

    if (!this.props.disabled && observed) {
      if (!(0, _focusLock.focusInside)(observed)) {
        (0, _focusLock2.default)(observed, null);
      }
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
    children = _this$props.children,
    disabled = _this$props.disabled,
    className = _this$props.className;
    return _react2.default.createElement("div", (0, _extends3.default)({}, (0, _util.inlineProp)(_focusLock.constants.FOCUS_AUTO, !disabled), {
      ref: this.setObserveNode,
      className: className }),
    children);
  };

  return MoveFocusInside;
}(_react.Component);

(0, _defineProperty3.default)(MoveFocusInside, "defaultProps", {
  disabled: false,
  className: undefined });exports.


default = MoveFocusInside;
MoveFocusInside.propTypes =  false ? {
  children: _propTypes2.default.node.isRequired,
  disabled: _propTypes2.default.bool,
  className: _propTypes2.default.string } :
{};module.exports = exports["default"];

/***/ }),

/***/ 1041:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(982);var _extends3 = _interopRequireDefault(_extends2);
var _react = __webpack_require__(171);var _react2 = _interopRequireDefault(_react);
var _propTypes = __webpack_require__(967);var _propTypes2 = _interopRequireDefault(_propTypes);
var _focusLock = __webpack_require__(980);
var _util = __webpack_require__(984);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var FreeFocusInside = function FreeFocusInside(_ref) {
  var children = _ref.children,
  className = _ref.className;
  return _react2.default.createElement("div", (0, _extends3.default)({}, (0, _util.inlineProp)(_focusLock.constants.FOCUS_ALLOW, true), {
    className: className }),
  children);
};

FreeFocusInside.propTypes =  false ? {
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string } :
{};
FreeFocusInside.defaultProps = {
  disabled: false,
  className: undefined };exports.default =

FreeFocusInside;module.exports = exports['default'];

/***/ }),

/***/ 1042:
/***/ (function(module, exports, __webpack_require__) {


        // classnames-loader: automatically bind css-modules to classnames
        var classNames = __webpack_require__(492);
        var locals = __webpack_require__(1043);
        var css = classNames.bind(locals);
        for (var style in locals) css[style] = locals[style];
        module.exports = css;
    

/***/ }),

/***/ 1043:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(1044);

if (typeof content === 'string') {
  content = [[module.i, content, '']];
}

var options = {"attributes":{}}

options.insert = "head";
options.singleton = false;

var update = __webpack_require__(491)(content, options);

if (content.locals) {
  module.exports = content.locals;
}


/***/ }),

/***/ 1044:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(undefined);
// imports


// module
exports.push([module.i, "._3bPc2GOh{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\"}.XpEl3ZjJ{padding:1px;background:#fff;border:2px solid transparent;border-radius:100px}.XpEl3ZjJ,.XpEl3ZjJ span{-webkit-transition:all .5s ease-in-out;transition:all .5s ease-in-out}.XpEl3ZjJ span{padding:9px 16px 8px;background:#4b55f6;font-size:12px;line-height:18px;letter-spacing:1.2px;text-align:center;color:#fff;display:inline-block;border-radius:100px;font-weight:700;text-transform:uppercase}.XpEl3ZjJ:hover span{background:#30379d}.XpEl3ZjJ:focus{border-color:#30379d;outline:none}.XpEl3ZjJ:focus span{background:#30379d}.XpEl3ZjJ.PVJYaOFd{cursor:not-allowed}.XpEl3ZjJ.PVJYaOFd span{background:#f4f4f8;color:#6e6e77}.XpEl3ZjJ._1Czu0JVU{display:inline-block;width:40px;height:40px;border-radius:100%;background:#4b55f6;color:#fff;margin-right:8px}.XpEl3ZjJ._2Pc4XXN9 span{background:#fff;color:#4b55f6;border:1px solid #4b55f6;letter-spacing:.36px}.XpEl3ZjJ._2Pc4XXN9:hover span{background:#f4f4f8}.XpEl3ZjJ._2Pc4XXN9:focus{border-color:#30379d}.XpEl3ZjJ._2Pc4XXN9.PVJYaOFd{cursor:not-allowed}.XpEl3ZjJ._2Pc4XXN9.PVJYaOFd span{color:#6e6e77;border-color:#6e6e77;background:#f4f4f8}.XpEl3ZjJ.Hu2rpqNE span{background:#fff;color:#4b55f6;border:1px solid #4b55f6}.XpEl3ZjJ.Hu2rpqNE span:before{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";margin-right:3px;vertical-align:middle;display:inline-block}.XpEl3ZjJ.Hu2rpqNE:hover span{background:#f4f4f8}.XpEl3ZjJ.Hu2rpqNE:focus{border-color:#30379d}.XpEl3ZjJ.Hu2rpqNE.PVJYaOFd{cursor:not-allowed}.XpEl3ZjJ.Hu2rpqNE.PVJYaOFd span{color:#6e6e77;border-color:#6e6e77;background:#f4f4f8}.XpEl3ZjJ._39xSEMm6 span{background:transparent;color:#414141;letter-spacing:.36px}.XpEl3ZjJ._39xSEMm6:hover span{background:#f4f4f8}.XpEl3ZjJ._39xSEMm6:focus{border-color:#30379d}.XpEl3ZjJ._39xSEMm6:focus span{background:#f4f4f8}.XpEl3ZjJ._39xSEMm6.PVJYaOFd{cursor:not-allowed}.XpEl3ZjJ._39xSEMm6.PVJYaOFd span{background:#f4f4f8;color:#6e6e77}._3eNtlD5k{color:#4b55f6;letter-spacing:.42px;line-height:19px;font-size:14px;text-transform:uppercase;padding:6px 8px;position:relative;border:none;background:transparent;font-weight:700}._3eNtlD5k._1assUFYp:before{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";content:\"\\E5C4\";color:#4b55f6;font-size:28px;margin-right:6px;width:24px;vertical-align:middle}._3Z4qQhFz{width:100%;border-radius:4px;background:#fff;border:2px solid #fff;padding:6px 40px 6px 16px;text-align:left;position:relative;outline-color:#4b55f6}._3Z4qQhFz,._3Z4qQhFz span{display:inline-block}._3Z4qQhFz span._1Riw2Ywo{font-size:12px;line-height:16px;font-weight:300;color:#414141;padding:10px 34px 10px 8px;font-style:italic;white-space:normal}._3Z4qQhFz span._1VrVSXiS{position:absolute;top:50%;right:16px;float:right;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:24px;height:24px}._3Z4qQhFz span._1VrVSXiS:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle;color:#4b55f6}._3Z4qQhFz span._1VrVSXiS._3F2aUG9H:after{content:\"\\E5CF\"}._3Z4qQhFz span._1VrVSXiS._1sfJBO0P:after{content:\"\\E5CE\"}._3Z4qQhFz:focus{outline-color:#4b55f6}.XpEl3ZjJ._20N4h0JV{border-radius:50%;width:40px;height:40px;position:relative}.XpEl3ZjJ._20N4h0JV span{border-radius:50%;font-size:16px;background:transparent;width:34px;height:34px;padding:5px;margin:0;-webkit-box-shadow:none;box-shadow:none}.XpEl3ZjJ._20N4h0JV span,.XpEl3ZjJ._20N4h0JV span:after{color:#4b55f6;display:inline-block;position:relative}.XpEl3ZjJ._20N4h0JV span:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\"}.XpEl3ZjJ._20N4h0JV:hover span{background:#f4f4f8}.XpEl3ZjJ._20N4h0JV:focus{border-color:#4b55f6}.XpEl3ZjJ._20N4h0JV:focus span{background:#f4f4f8}.XpEl3ZjJ._20N4h0JV.PVJYaOFd span{background:#f4f4f8;color:#6e6e77}.XpEl3ZjJ._20N4h0JV._2ByhCNmW span:after{content:\"\\E7FD\"}.XpEl3ZjJ._20N4h0JV._3L9rGssS span:after{content:\"\\F233\"}.XpEl3ZjJ._20N4h0JV._4FYBQwIQ span:after{content:\"\\F1CF\"}.XpEl3ZjJ._20N4h0JV._2F6h4iZx span:after{content:\"\\F1CE\";font-family:Material Icons Outlined}.XpEl3ZjJ._20N4h0JV._3c4IQLuG span:after{content:\"\\EAAA\";font-family:Material Icons Outlined}.XpEl3ZjJ._20N4h0JV.wJBX2P7_ span:after{content:\"\\E86C\";font-family:Material Icons Outlined}.XpEl3ZjJ._20N4h0JV.QwFEJ6WC span:after{content:\"\\E876\"}.XpEl3ZjJ._20N4h0JV._2EnFcVjp span:after{content:\"\\E835\";font-family:Material Icons Outlined}.XpEl3ZjJ._20N4h0JV._2dN1QmWD span:after{content:\"\\E834\"}.XpEl3ZjJ._20N4h0JV._2bK066JS span:after{content:\"\\E5CF\"}.XpEl3ZjJ._20N4h0JV._2g1Z4Vup span:after{content:\"\\E5CE\"}.XpEl3ZjJ._20N4h0JV._1yAFwdcE span:after{content:\"\\E5CD\"}.XpEl3ZjJ._20N4h0JV._2aqdCTcO span:after{content:\"\\E0C6\"}.XpEl3ZjJ._20N4h0JV._3LBJbCsL span:after{content:\"\\E5D4\"}.XpEl3ZjJ._20N4h0JV._3B3m4ALJ span:after{content:\"\\E880\"}.XpEl3ZjJ._20N4h0JV._3TCuGBtK span:after{content:\"\\EF4F\";font-family:Material Icons Outlined}.XpEl3ZjJ._20N4h0JV._3Ir5nPnJ span:after{content:\"\\E87D\"}.XpEl3ZjJ._20N4h0JV.ojEeHgIS span:after{content:\"\\E87E\";font-family:Material Icons Outlined}.XpEl3ZjJ._20N4h0JV._1O0pDCKo span:after{content:\"\\E41A\"}.XpEl3ZjJ._20N4h0JV._2mxBOlOy span:after{content:\"\\E8B6\"}.XpEl3ZjJ._20N4h0JV._3zPTZtIZ span:after{content:\"\\E0B7\"}.XpEl3ZjJ._20N4h0JV._10IWBZp5 span:after{content:\"\\E150\"}.XpEl3ZjJ._20N4h0JV._10Tve6qv span:after{content:\"\\E150\";font-family:Material Icons Outlined}.XpEl3ZjJ._20N4h0JV._1vBKFS5y span:after{content:\"\\E145\"}.XpEl3ZjJ._20N4h0JV._1oASSyv4 span:after{content:\"\\E836\"}.XpEl3ZjJ._20N4h0JV.BBCqpwnX span:after{content:\"\\E837\"}.XpEl3ZjJ._20N4h0JV._2ukikiYE span:after{content:\"\\E163\"}.XpEl3ZjJ._20N4h0JV.-oWjpsCR span:after{content:\"\\E0B7\";font-family:Material Icons Outlined}.XpEl3ZjJ._20N4h0JV._1fJJiHWq span:after{content:\"\\E872\";font-family:Material Icons Outlined}.XpEl3ZjJ._20N4h0JV._3I-TN97x span:after{content:\"\\E5C4\"}.XpEl3ZjJ._20N4h0JV._1y9PUXZP span:after{content:\"\\E5C8\"}.XpEl3ZjJ._20N4h0JV._1bpi1_YF,.XpEl3ZjJ._20N4h0JV._2LB8_HOG{background:transparent;border-radius:0;color:#414141;padding:0;height:28px;width:28px}.XpEl3ZjJ._20N4h0JV._1bpi1_YF span,.XpEl3ZjJ._20N4h0JV._2LB8_HOG span{padding:0;height:24px;width:24px}.XpEl3ZjJ._20N4h0JV._1bpi1_YF span:after,.XpEl3ZjJ._20N4h0JV._2LB8_HOG span:after{color:#414141}.XpEl3ZjJ._20N4h0JV._1bpi1_YF._2r3md3gs,.XpEl3ZjJ._20N4h0JV._1bpi1_YF._2r3md3gs span:after,.XpEl3ZjJ._20N4h0JV._2LB8_HOG._2r3md3gs,.XpEl3ZjJ._20N4h0JV._2LB8_HOG._2r3md3gs span:after{color:#4b55f6}.XpEl3ZjJ._20N4h0JV._1bpi1_YF span:after{content:\"\\E8EF\"}.XpEl3ZjJ._20N4h0JV._2LB8_HOG span:after{content:\"\\E9B0\"}.XpEl3ZjJ._2P9lTtT2{position:relative;padding:0;border:none;border-radius:0}.XpEl3ZjJ._2P9lTtT2 span{color:#4b55f6;font-size:16px;background:transparent;display:inline-block;width:24px;height:24px;position:relative;margin:0;-webkit-box-shadow:none;box-shadow:none;padding:0;padding:5px}.XpEl3ZjJ._2P9lTtT2 span:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";font-size:14px;font-weight:700}.XpEl3ZjJ._2P9lTtT2:hover span{background:#f4f4f8}.XpEl3ZjJ._2P9lTtT2._3LBJbCsL span:after{content:\"\\E5D4\"}.ZNMgkbk- ._1YMkOuDI{display:none}.ZNMgkbk- ._1YMkOuDI+._3oOdY5UJ{display:inline-block}.ZNMgkbk- ._1YMkOuDI+._3oOdY5UJ:before{content:\"\\E835\";font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle}.ZNMgkbk- ._1YMkOuDI:checked+._3oOdY5UJ:before{content:\"\\E834\"}.ZNMgkbk- span{padding-left:14px}._1lwlcUCf{display:block}._1lwlcUCf input[type=radio]{position:absolute;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";opacity:0}._1lwlcUCf input[type=radio]+._2SgCj7tq:before{content:\"\\E836\";font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle}._1lwlcUCf input[type=radio]+._2SgCj7tq span{padding-left:14px;font-size:12px;line-height:16px;color:#414141;font-weight:400}._1lwlcUCf input[type=radio]:checked+._2SgCj7tq:before{content:\"\\E837\"}._1lwlcUCf input[type=radio]+._2SgCj7tq:empty:before{margin-right:0}", ""]);

// exports
exports.locals = {
	"material-icons": "_3bPc2GOh",
	"btn": "XpEl3ZjJ",
	"disabled": "PVJYaOFd",
	"user-btn": "_1Czu0JVU",
	"secondary-btn": "_2Pc4XXN9",
	"secondary-button_icon": "Hu2rpqNE",
	"ghost-btn": "_39xSEMm6",
	"btn-icon-text_back": "_3eNtlD5k",
	"icon_arrow-back": "_1assUFYp",
	"btn-type-dropdown": "_3Z4qQhFz",
	"default-header": "_1Riw2Ywo",
	"icon": "_1VrVSXiS",
	"icon_chevron-down": "_3F2aUG9H",
	"icon_chevron-up": "_1sfJBO0P",
	"icon-btn": "_20N4h0JV",
	"account": "_2ByhCNmW",
	"account_group": "_3L9rGssS",
	"collapse": "_4FYBQwIQ",
	"expand": "_2F6h4iZx",
	"arrow_right": "_3c4IQLuG",
	"check_circle": "wJBX2P7_",
	"check": "QwFEJ6WC",
	"checkbox_blank": "_2EnFcVjp",
	"checkbox_marked": "_2dN1QmWD",
	"chevron_down": "_2bK066JS",
	"chevron_up": "_2g1Z4Vup",
	"close": "_1yAFwdcE",
	"comment_question": "_2aqdCTcO",
	"dots_vertical": "_3LBJbCsL",
	"file_document_box": "_3B3m4ALJ",
	"filter": "_3TCuGBtK",
	"heart": "_3Ir5nPnJ",
	"heart_outline": "ojEeHgIS",
	"loading": "_1O0pDCKo",
	"magnify": "_2mxBOlOy",
	"message": "_3zPTZtIZ",
	"pencil": "_10IWBZp5",
	"pencil_outline": "_10Tve6qv",
	"plus": "_1vBKFS5y",
	"radiobox_blank": "_1oASSyv4",
	"radiobox_marked": "BBCqpwnX",
	"icon-send": "_2ukikiYE",
	"tooltip_text_outline": "-oWjpsCR",
	"trash_can_outline": "_1fJJiHWq",
	"icon_arrow-left": "_3I-TN97x",
	"icon_arrow-right": "_1y9PUXZP",
	"list": "_1bpi1_YF",
	"tile": "_2LB8_HOG",
	"active": "_2r3md3gs",
	"list-item-icon-btn": "_2P9lTtT2",
	"default-checkbox-div": "ZNMgkbk-",
	"default-checkbox": "_1YMkOuDI",
	"checkmark": "_3oOdY5UJ",
	"radio": "_1lwlcUCf",
	"radio-label": "_2SgCj7tq"
};

/***/ }),

/***/ 1045:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = {
  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
  gentle: { stiffness: 120, damping: 14 },
  wobbly: { stiffness: 180, damping: 12 },
  stiff: { stiffness: 210, damping: 20 } };

module.exports = exports["default"];

/***/ }),

/***/ 1046:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _keys = __webpack_require__(85);var _keys2 = _interopRequireDefault(_keys);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _curry1 = __webpack_require__(985);
var _has = __webpack_require__(1047);
var _isArguments = __webpack_require__(1099);


/**
                                                        * Returns a list containing the names of all the enumerable own properties of
                                                        * the supplied object.
                                                        * Note that the order of the output array is not guaranteed to be consistent
                                                        * across different JS platforms.
                                                        *
                                                        * @func
                                                        * @memberOf R
                                                        * @since v0.1.0
                                                        * @category Object
                                                        * @sig {k: v} -> [k]
                                                        * @param {Object} obj The object to extract properties from
                                                        * @return {Array} An array of the object's own properties.
                                                        * @example
                                                        *
                                                        *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
                                                        */
module.exports = function () {
  // cover IE < 9 keys issues
  var hasEnumBug = !{ toString: null }.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString',
  'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
  // Safari bug
  var hasArgsEnumBug = function () {
    'use strict';
    return arguments.propertyIsEnumerable('length');
  }();

  var contains = function contains(list, item) {
    var idx = 0;
    while (idx < list.length) {
      if (list[idx] === item) {
        return true;
      }
      idx += 1;
    }
    return false;
  };

  return typeof _keys2.default === 'function' && !hasArgsEnumBug ?
  _curry1(function keys(obj) {
    return Object(obj) !== obj ? [] : (0, _keys2.default)(obj);
  }) :
  _curry1(function keys(obj) {
    if (Object(obj) !== obj) {
      return [];
    }
    var prop, nIdx;
    var ks = [];
    var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
    for (prop in obj) {
      if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
        ks[ks.length] = prop;
      }
    }
    if (hasEnumBug) {
      nIdx = nonEnumerableProps.length - 1;
      while (nIdx >= 0) {
        prop = nonEnumerableProps[nIdx];
        if (_has(prop, obj) && !contains(ks, prop)) {
          ks[ks.length] = prop;
        }
        nIdx -= 1;
      }
    }
    return ks;
  });
}();

/***/ }),

/***/ 1047:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
module.exports = function _has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
};

/***/ }),

/***/ 1048:
/***/ (function(module, exports, __webpack_require__) {


        // classnames-loader: automatically bind css-modules to classnames
        var classNames = __webpack_require__(492);
        var locals = __webpack_require__(1104);
        var css = classNames.bind(locals);
        for (var style in locals) css[style] = locals[style];
        module.exports = css;
    

/***/ }),

/***/ 1049:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _react = __webpack_require__(648);
var _style = __webpack_require__(1107);var _style2 = _interopRequireDefault(_style);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
(0, _react.PureFunctional)('CategoryLabel')(function (_ref) {var color = _ref.color,name = _ref.name,bold = _ref.bold,big = _ref.big,id = _ref.id,positionright = _ref.positionright;
    return _react.React.createElement("span", { className: (0, _style2.default)('component', positionright ? 'positionright' : '', { bold: bold, big: big }) },
    positionright ? null : _react.React.createElement("span", { "aria-hidden": "true", className: (0, _style2.default)('color', { bold: bold, big: big }), style: { backgroundColor: color } }),
    _react.React.createElement("span", { id: id, className: (0, _style2.default)('name', { bold: bold, big: big }) }, name),
    positionright ? _react.React.createElement("span", { "aria-hidden": "true", className: (0, _style2.default)('color', { bold: bold, big: big }), style: { backgroundColor: color } }) : null);
});

/***/ }),

/***/ 1050:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.isNoteMissing = exports.selector = undefined;var _reselect = __webpack_require__(221);
var idSelector = function idSelector(_, id) {return id;};
var selector = exports.selector = function selector(state) {return state.noteLocator;};
var isNoteMissing = exports.isNoteMissing = (0, _reselect.createSelector)(idSelector, selector, function (id, state) {return state.missingNoteIds.includes(id);});

/***/ }),

/***/ 1051:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.NoteChatCreate = undefined;var _react = __webpack_require__(648);
var _types = __webpack_require__(245);
var _resource = __webpack_require__(517);
var _style = __webpack_require__(1052);var _style2 = _interopRequireDefault(_style);
var _datalistchat = __webpack_require__(1112);
var _reselectors = __webpack_require__(542);var _reselectors2 = _interopRequireDefault(_reselectors);
var _button = __webpack_require__(973);
var _resource2 = __webpack_require__(106);
var _START_CHAT = __webpack_require__(547);var _START_CHAT2 = _interopRequireDefault(_START_CHAT);
var _dataitemchat = __webpack_require__(1053);
var _selectors = __webpack_require__(977);var _selectors2 = _interopRequireDefault(_selectors);
var _selectors3 = __webpack_require__(981);var _selectors4 = _interopRequireDefault(_selectors3);
var _selectors5 = __webpack_require__(651);var _selectors6 = _interopRequireDefault(_selectors5);
var _resource3 = __webpack_require__(494);
var _authcheck = __webpack_require__(518);
var _resource4 = __webpack_require__(223);
var _resource5 = __webpack_require__(495);
var _resource6 = __webpack_require__(234);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
(0, _react.PureConnect)('NoteChatCreateControl')(function (state) {return {
        updating: _resource.notechatEditor.selectors.updating(state),
        noteChats: _resource.notechatResource.selectors.items(state),
        participants: _reselectors2.default.participantsSelector(state),
        itemNote: _resource2.notesEditor.selectors.item(state),
        itemSharedNote: _resource3.notesSharedEditor.selectors.item(state),
        inspect: _selectors6.default.inspect(state),
        creatingNote: _resource2.notesEditor.selectors.creating(state),
        updatingNote: _resource2.notesEditor.selectors.updating(state),
        selectNote: state.selection.creating,
        participantPopupVisible: _selectors2.default.visible(state),
        categoryPopupVisible: _selectors4.default.visible(state),
        selectTextArea: state.selection.creating,
        flyoverVisible: state.flyover.visible };},
function (dispatch) {return {};}, function (_ref) {var flyoverVisible = _ref.flyoverVisible,itemNote = _ref.itemNote,itemSharedNote = _ref.itemSharedNote,inspect = _ref.inspect,updating = _ref.updating,participants = _ref.participants,noteChats = _ref.noteChats,creatingNote = _ref.creatingNote,updatingNote = _ref.updatingNote,selectNote = _ref.selectNote,participantPopupVisible = _ref.participantPopupVisible,categoryPopupVisible = _ref.categoryPopupVisible,selectTextArea = _ref.selectTextArea;
    var note = itemSharedNote && (0, _types.isSharedNote)(itemSharedNote) ? itemSharedNote : itemNote;
    var visible = !updating && !creatingNote && !updatingNote && !selectNote && !participantPopupVisible && !categoryPopupVisible && !selectTextArea;
    var noteselection = flyoverVisible ? note : inspect;
    return _react.React.createElement("div", { "aria-labelledby": "Geef notitie reactie", className: (0, _style2.default)('notechat-dit-list-container', visible ? '' : 'wcag-invisible', flyoverVisible ? 'flyover-chat' : 'modal-chat') },
    _react.React.createElement("span", { className: (0, _style2.default)('input-label') }, "Reacties"),
    _react.React.createElement(_dataitemchat.ChainedChat, { noteId: noteselection.id }),
    _react.React.createElement(NoteChatCreate, { noteId: noteselection.id }),
    _react.React.createElement(_datalistchat.DataListChat, { items: noteChats, flyoverVisible: flyoverVisible, participants: participants, noteId: noteselection.id }));
});
var NoteChatCreate = exports.NoteChatCreate = (0, _react.PureConnect)('NoteChatCreate')(function (state) {return {
        participants: _reselectors2.default.participantsSelector(state),
        creating: _resource.notechatEditor.selectors.creating(state),
        item: _resource.notechatEditor.selectors.item(state),
        updating: _resource.notechatEditor.selectors.updating(state),
        origin: state.notemenu.origin,
        flyoverVisible: state.flyover.visible,
        inspect: _selectors6.default.inspect(state),
        itemNote: _resource2.notesEditor.selectors.item(state),
        itemSharedNote: _resource3.notesSharedEditor.selectors.item(state),
        questions: _resource4.questionsResource.selectors.items(state),
        currentUser: _resource5.useridResource.selectors.items(state),
        usergroups: _reselectors2.default.usergroupSelector(state),
        beheer: _resource6.beheerResource.selectors.items(state) };},
function (dispatch) {return {
        cancel: function cancel() {return dispatch(_resource.notechatEditor.actions.RESET({}));},
        change: function change(item) {dispatch(_resource.notechatEditor.actions.APPLY({ item: item }));},
        saveCreating: function saveCreating(item, note) {
            item = fixNoteDevelopmentJsonServer(item, note, true);
            dispatch(_resource.notechatEditor.actions.CREATE_CONTINUE({ item: item }));
        },
        deleteUsergroup: function deleteUsergroup(item) {return dispatch(_resource.notechatEditor.actions.DELETE({ item: item }));},
        startChat: function startChat(note) {return dispatch((0, _START_CHAT2.default)({ item: note }));} };},
function (_ref2) {var flyoverVisible = _ref2.flyoverVisible,itemSharedNote = _ref2.itemSharedNote,itemNote = _ref2.itemNote,inspect = _ref2.inspect,questions = _ref2.questions,creating = _ref2.creating,currentUser = _ref2.currentUser,item = _ref2.item,usergroups = _ref2.usergroups,beheer = _ref2.beheer,saveCreating = _ref2.saveCreating,startChat = _ref2.startChat,change = _ref2.change;
    var note = itemSharedNote && (0, _types.isSharedNote)(itemSharedNote) ? itemSharedNote : itemNote;
    var maxNoteTextLength = 3000;
    var noteselection = flyoverVisible ? note : inspect;
    if (creating)
    item.text = !item.text ? '' :
    item.text.length >= maxNoteTextLength ? item.text.substring(0, maxNoteTextLength - 1) : item.text;
    var canChange = true;
    var itemQuestion = null;
    var status = _authcheck.statusNieuw;
    if (note.isquestion) {
        itemQuestion = questions.qFirst(function (o) {return o.noteId === note.id;});
        var currentUserId = currentUser.length > 0 ? currentUser[0].id : '';
        var admin = beheer && beheer.qAny() && beheer.qFirst();
        status = !!itemQuestion && itemQuestion.status ? itemQuestion.status : _authcheck.statusNieuw;
        canChange = (0, _authcheck.canChangeQuestion)(_authcheck.statusses, status, currentUserId, usergroups, admin);
    }
    return _react.React.createElement("div", { "aria-labelledby": "Geef notitie reactie" },
    _react.React.createElement("div", { className: (0, _style2.default)('notechat-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('input-text-chat') },
    _react.React.createElement("textarea", { disabled: !canChange, className: (0, _style2.default)('input-text-chat-area'), placeholder: "Type hier uw reactie...", name: "q", ref: "term", "aria-multiline": true, value: item.text || '', onFocus: function onFocus(itm) {startChat(noteselection);}, onChange: function onChange(x) {
            item.text = x.target.value;
            change(item);
        } }),
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: [(0, _style2.default)('span-button-icon-send'), 'icon-btn', 'icon-send'], "aria-label": 'Opslaan', "aria-haspopup": false, tabIndex: item.text ? 0 : -1, disabled: !item.text, onKeyDown: function onKeyDown(evt) {
            handleEnters(evt, function () {return saveCreating(item, noteselection);});
        }, onClick: function onClick() {return saveCreating(item, noteselection);} },
    _react.React.createElement("span", null)))));
});
function handleEnters(evt, funct) {
    if (evt.key === 'Enter') {
        evt.preventDefault();
        funct();
    }
}
function fixNoteDevelopmentJsonServer(item, note, create) {
    return item;
}

/***/ }),

/***/ 1052:
/***/ (function(module, exports, __webpack_require__) {


        // classnames-loader: automatically bind css-modules to classnames
        var classNames = __webpack_require__(492);
        var locals = __webpack_require__(1110);
        var css = classNames.bind(locals);
        for (var style in locals) css[style] = locals[style];
        module.exports = css;
    

/***/ }),

/***/ 1053:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.ChainedChat = undefined;var _react = __webpack_require__(648);
var _style = __webpack_require__(1113);var _style2 = _interopRequireDefault(_style);
var _resource = __webpack_require__(517);
var _date = __webpack_require__(987);
var _NOTECHAT_TOGGLE_MENU = __webpack_require__(699);var _NOTECHAT_TOGGLE_MENU2 = _interopRequireDefault(_NOTECHAT_TOGGLE_MENU);
var _NOTECHATATTACHED_TOGGLE_MENU = __webpack_require__(700);var _NOTECHATATTACHED_TOGGLE_MENU2 = _interopRequireDefault(_NOTECHATATTACHED_TOGGLE_MENU);
var _miniMenu = __webpack_require__(1003);var _miniMenu2 = _interopRequireDefault(_miniMenu);
var _reselectors = __webpack_require__(542);var _reselectors2 = _interopRequireDefault(_reselectors);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
(0, _react.PureConnect)('DataItemNoteChat')(function (state, props) {return {
        showMiniMenuChat: state.notechat.showMiniMenuChat,
        itemMiniMenuChat: state.notechat.itemMiniMenuChat,
        allParticipants: _reselectors2.default.participantsSelector(state),
        allChats: _resource.notechatResource.selectors.items(state) };},
function (dispatch) {return {
        toggleMiniMenu: function toggleMiniMenu(showMiniMenuChat, itemMiniMenuChat) {
            dispatch((0, _NOTECHAT_TOGGLE_MENU2.default)({ showMiniMenuChat: showMiniMenuChat, itemMiniMenuChat: itemMiniMenuChat }));
        },
        removeChat: function removeChat(item) {return dispatch(_resource.notechatEditor.actions.DELETE_CONTINUE({ item: item }));},
        updateChat: function updateChat(item) {return dispatch(_resource.notechatEditor.actions.UPDATE_CONTINUE({ item: item }));},
        updateBatchChat: function updateBatchChat(items) {return items.forEach(function (item) {return dispatch(_resource.notechatResource.actions.UPDATE({ item: item }));});},
        editChat: function editChat(item) {return dispatch(_resource.notechatEditor.actions.UPDATE({ item: item }));} };},
function (_ref) {var item = _ref.item,allChats = _ref.allChats,participant = _ref.participant,allParticipants = _ref.allParticipants,visible = _ref.visible,editChat = _ref.editChat,updateBatchChat = _ref.updateBatchChat,showMiniMenuChat = _ref.showMiniMenuChat,toggleMiniMenu = _ref.toggleMiniMenu,removeChat = _ref.removeChat,updateChat = _ref.updateChat,itemMiniMenuChat = _ref.itemMiniMenuChat,flyoverVisible = _ref.flyoverVisible;
    var toggle = function toggle() {
        showMiniMenuChat = !showMiniMenuChat;
        toggleMiniMenu(showMiniMenuChat, item);
    };
    var currentUser = allParticipants.qWhere(function (i) {return i.isUser;}).qFirst();
    var itms = currentUser && item && item.id && item.userId === currentUser.id ?
    [{ name: 'Verwijderen', iconName: 'delete', key: item.id.toString() + 'a', functionitem: item, function: function _function(item) {
            toggle();
            return removeChat(item);
        } },
    { name: 'Vastmaken', iconName: 'chain', key: item.id.toString() + 'b', functionitem: item, function: function _function(item) {
            toggle();
            item.attached = true;
            return updateChat(item);
        } },
    { name: 'Bewerken', iconName: 'edit', key: item.id.toString() + 'c', functionitem: item, function: function _function(item) {
            toggle();
            return editChat(item);
        } }] : currentUser && item && item.id && item.userId !== currentUser.id ?
    [
    { name: 'Vastmaken', iconName: 'chain', key: item.id.toString() + 'b', functionitem: item, function: function _function(item) {
            toggle();
            item.attached = true;
            return updateChat(item);
        } }] :

    [];
    return _react.React.createElement("li", { className: (0, _style2.default)('data-item-chat', flyoverVisible ? 'flyover-chat-item' : 'modal-chat-item'), tabIndex: visible ? -1 : 0 },
    _react.React.createElement("div", { className: (0, _style2.default)('data-item-outer-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('top-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('icon-container') },
    _react.React.createElement("span", { className: (0, _style2.default)('icon-shared') })),
    _react.React.createElement("div", { className: (0, _style2.default)('info_container') },
    _react.React.createElement("span", { className: (0, _style2.default)('autho-name') },
    participant ? participant.name + ', ' : '',
    _react.React.createElement(_date.DateTimeText, { date: item.created }))),
    _react.React.createElement("div", { className: (0, _style2.default)('button-container') },
    _react.React.createElement(_miniMenu2.default, { showMiniMenu: showMiniMenuChat && item.id === (itemMiniMenuChat ? itemMiniMenuChat.id : ''), toggleMiniMenu: function toggleMiniMenu() {return toggle();}, items: itms }))),
    _react.React.createElement("div", { className: (0, _style2.default)('bottom-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('text-container_main') }, item.text))));
});
var ChainedChat = exports.ChainedChat = (0, _react.PureConnect)('ChainedChat')(function (state) {return {
        noteChats: _resource.notechatResource.selectors.items(state),
        participants: _reselectors2.default.participantsSelector(state),
        showMiniMenuChatAttached: state.notechat.showMiniMenuChatAttached,
        itemMiniMenuChatAttached: state.notechat.itemMiniMenuChatAttached,
        allParticipants: _reselectors2.default.participantsSelector(state) };},
function (dispatch) {return {
        toggleMiniMenu: function toggleMiniMenu(showMiniMenuChatAttached, itemMiniMenuChatAttached) {
            dispatch((0, _NOTECHATATTACHED_TOGGLE_MENU2.default)({ showMiniMenuChatAttached: showMiniMenuChatAttached, itemMiniMenuChatAttached: itemMiniMenuChatAttached }));
        },
        removeChat: function removeChat(item) {return dispatch(_resource.notechatEditor.actions.DELETE_CONTINUE({ item: item }));},
        updateChat: function updateChat(item) {return dispatch(_resource.notechatEditor.actions.UPDATE_CONTINUE({ item: item }));},
        editChat: function editChat(item) {return dispatch(_resource.notechatEditor.actions.UPDATE({ item: item }));} };},
function (_ref2) {var noteId = _ref2.noteId,noteChats = _ref2.noteChats,participants = _ref2.participants,showMiniMenuChatAttached = _ref2.showMiniMenuChatAttached,itemMiniMenuChatAttached = _ref2.itemMiniMenuChatAttached,allParticipants = _ref2.allParticipants,toggleMiniMenu = _ref2.toggleMiniMenu,removeChat = _ref2.removeChat,updateChat = _ref2.updateChat,editChat = _ref2.editChat;
    var attached = noteChats.qWhere(function (itm) {return itm.attached && noteId === itm.noteId;}).qFirst();
    var attachedParticipant;
    if (attached) {
        attachedParticipant = participants.qWhere(function (itm) {return itm.id === attached.userId;}).qFirst();
        attached.text = !attached.text ? '' : attached.text;
    }
    var toggle = function toggle() {
        showMiniMenuChatAttached = !showMiniMenuChatAttached;
        toggleMiniMenu(showMiniMenuChatAttached, attached);
    };
    var currentUser = allParticipants.qWhere(function (i) {return i.isUser;}).qFirst();
    var itemsattached = currentUser && attached && attached.id && attached.userId === currentUser.id ?
    [{ name: 'Verwijderen', iconName: 'delete', key: '1', functionitem: attached, function: function _function(item) {
            toggle();
            return removeChat(attached);
        } },
    { name: 'Reactie losmaken', iconName: 'chain', key: '2', functionitem: attached, function: function _function(item) {
            toggle();
            item.attached = false;
            return updateChat(attached);
        } },
    { name: 'Bewerken', iconName: 'edit', key: '3', functionitem: attached, function: function _function(item) {
            toggle();
            return editChat(attached);
        } }] : currentUser && attached && attached.id && attached.userId !== currentUser.id ?
    [
    { name: 'Reactie losmaken', iconName: 'chain', key: '2', functionitem: attached, function: function _function(item) {
            toggle();
            attached.attached = false;
            return updateChat(attached);
        } }] :

    [];
    return attached ?
    _react.React.createElement("div", { className: (0, _style2.default)('data-item-chat-attached') },
    _react.React.createElement("div", { className: (0, _style2.default)('attached-top-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('attached-info-container') },
    _react.React.createElement("span", { className: (0, _style2.default)('attached-title') }, "Vastgemaakte reactie"),
    _react.React.createElement("div", { className: (0, _style2.default)('button-container') },
    _react.React.createElement(_miniMenu2.default, { showMiniMenu: showMiniMenuChatAttached, toggleMiniMenu: function toggleMiniMenu() {return toggle();}, items: itemsattached }))),
    _react.React.createElement("div", { className: (0, _style2.default)('icon-container') },
    _react.React.createElement("span", { className: (0, _style2.default)('icon-shared') })),
    _react.React.createElement("div", { className: (0, _style2.default)('attached-info_container') },
    _react.React.createElement("span", { className: (0, _style2.default)('autho-name') },
    attachedParticipant ? attachedParticipant.name + ', ' : '',
    _react.React.createElement(_date.DateTimeText, { date: attached.created })))),
    _react.React.createElement("div", { className: (0, _style2.default)('attached-bottom-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('text-container_main') }, attached.text))) :

    null;
});
function handleKeyDown(evt, functionEsc, functionEnter) {
    if (evt.key === 'Escape') {
        evt.preventDefault();
        functionEsc();
    }
    if (evt.key === 'Enter') {
        evt.preventDefault();
        functionEnter();
    }
}

/***/ }),

/***/ 1054:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
module.exports = function _arity(n, fn) {
  /* eslint-disable no-unused-vars */
  switch (n) {
    case 0:return function () {return fn.apply(this, arguments);};
    case 1:return function (a0) {return fn.apply(this, arguments);};
    case 2:return function (a0, a1) {return fn.apply(this, arguments);};
    case 3:return function (a0, a1, a2) {return fn.apply(this, arguments);};
    case 4:return function (a0, a1, a2, a3) {return fn.apply(this, arguments);};
    case 5:return function (a0, a1, a2, a3, a4) {return fn.apply(this, arguments);};
    case 6:return function (a0, a1, a2, a3, a4, a5) {return fn.apply(this, arguments);};
    case 7:return function (a0, a1, a2, a3, a4, a5, a6) {return fn.apply(this, arguments);};
    case 8:return function (a0, a1, a2, a3, a4, a5, a6, a7) {return fn.apply(this, arguments);};
    case 9:return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {return fn.apply(this, arguments);};
    case 10:return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {return fn.apply(this, arguments);};
    default:throw new Error('First argument to _arity must be a non-negative integer no greater than ten');}

};

/***/ }),

/***/ 1055:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _curry3 = __webpack_require__(1016);
var _reduce = __webpack_require__(1129);


/**
                                              * Returns a single item by iterating through the list, successively calling
                                              * the iterator function and passing it an accumulator value and the current
                                              * value from the array, and then passing the result to the next call.
                                              *
                                              * The iterator function receives two values: *(acc, value)*. It may use
                                              * `R.reduced` to shortcut the iteration.
                                              *
                                              * The arguments' order of `reduceRight`'s iterator function is *(value, acc)*.
                                              *
                                              * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
                                              * arrays), unlike the native `Array.prototype.reduce` method. For more details
                                              * on this behavior, see:
                                              * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
                                              *
                                              * Dispatches to the `reduce` method of the third argument, if present.
                                              *
                                              * @func
                                              * @memberOf R
                                              * @since v0.1.0
                                              * @category List
                                              * @sig ((a, b) -> a) -> a -> [b] -> a
                                              * @param {Function} fn The iterator function. Receives two values, the accumulator and the
                                              *        current element from the array.
                                              * @param {*} acc The accumulator value.
                                              * @param {Array} list The list to iterate over.
                                              * @return {*} The final, accumulated value.
                                              * @see R.reduced, R.addIndex, R.reduceRight
                                              * @example
                                              *
                                              *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
                                              *                -               -10
                                              *               / \              / \
                                              *              -   4           -6   4
                                              *             / \              / \
                                              *            -   3   ==>     -3   3
                                              *           / \              / \
                                              *          -   2           -1   2
                                              *         / \              / \
                                              *        0   1            0   1
                                              *
                                              * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
                                              */
module.exports = _curry3(_reduce);

/***/ }),

/***/ 1056:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
 /**
               * Tests whether or not an object is an array.
               *
               * @private
               * @param {*} val The object to test.
               * @return {Boolean} `true` if `val` is an array, `false` otherwise.
               * @example
               *
               *      _isArray([]); //=> true
               *      _isArray(null); //=> false
               *      _isArray({}); //=> false
               */
module.exports = Array.isArray || function _isArray(val) {
  return val != null &&
  val.length >= 0 &&
  Object.prototype.toString.call(val) === '[object Array]';
};

/***/ }),

/***/ 1057:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
module.exports = function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
};

/***/ }),

/***/ 1058:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _isArray = __webpack_require__(1056);


/**
                                                    * This checks whether a function has a [methodname] function. If it isn't an
                                                    * array it will execute that function otherwise it will default to the ramda
                                                    * implementation.
                                                    *
                                                    * @private
                                                    * @param {Function} fn ramda implemtation
                                                    * @param {String} methodname property to check for a custom implementation
                                                    * @return {Object} Whatever the return value of the method is.
                                                    */
module.exports = function _checkForMethod(methodname, fn) {
  return function () {
    var length = arguments.length;
    if (length === 0) {
      return fn();
    }
    var obj = arguments[length - 1];
    return _isArray(obj) || typeof obj[methodname] !== 'function' ?
    fn.apply(this, arguments) :
    obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
  };
};

/***/ }),

/***/ 1059:
/***/ (function(module, exports, __webpack_require__) {


        // classnames-loader: automatically bind css-modules to classnames
        var classNames = __webpack_require__(492);
        var locals = __webpack_require__(1340);
        var css = classNames.bind(locals);
        for (var style in locals) css[style] = locals[style];
        module.exports = css;
    

/***/ }),

/***/ 1062:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _getPrototypeOf = __webpack_require__(232);var _getPrototypeOf2 = _interopRequireDefault2(_getPrototypeOf);var _setPrototypeOf = __webpack_require__(493);var _setPrototypeOf2 = _interopRequireDefault2(_setPrototypeOf);var _create = __webpack_require__(222);var _create2 = _interopRequireDefault2(_create);var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault2(_typeof2);var _defineProperty2 = __webpack_require__(161);var _defineProperty3 = _interopRequireDefault2(_defineProperty2);var _assign = __webpack_require__(77);var _assign2 = _interopRequireDefault2(_assign);function _interopRequireDefault2(obj) {return obj && obj.__esModule ? obj : { default: obj };}

Object.defineProperty(exports, "__esModule", {
  value: true });

exports.Button = exports.buttonFactory = undefined;

var _extends = _assign2.default || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};

var _createClass = function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;(0, _defineProperty3.default)(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};}();

var _react = __webpack_require__(171);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(967);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(993);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactCssThemr = __webpack_require__(994);

var _identifiers = __webpack_require__(995);

var _FontIcon = __webpack_require__(988);

var _FontIcon2 = _interopRequireDefault(_FontIcon);

var _Ripple = __webpack_require__(1096);

var _Ripple2 = _interopRequireDefault(_Ripple);

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

function _defineProperty(obj, key, value) {if (key in obj) {(0, _defineProperty3.default)(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}

function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;}

function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));}subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;}

var factory = function factory(ripple, FontIcon) {
  var Button = function (_Component) {
    _inherits(Button, _Component);

    function Button() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Button);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Button.__proto__ || (0, _getPrototypeOf2.default)(Button)).call.apply(_ref, [this].concat(args))), _this), _this.getLevel = function () {
        if (_this.props.primary) return 'primary';
        if (_this.props.accent) return 'accent';
        return 'neutral';
      }, _this.getShape = function () {
        if (_this.props.raised) return 'raised';
        if (_this.props.floating) return 'floating';
        return 'flat';
      }, _this.handleMouseUp = function (event) {
        _this.buttonNode.blur();
        if (_this.props.onMouseUp) _this.props.onMouseUp(event);
      }, _this.handleMouseLeave = function (event) {
        _this.buttonNode.blur();
        if (_this.props.onMouseLeave) _this.props.onMouseLeave(event);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Button, [{
      key: 'render',
      value: function render() {
        var _classnames,
        _this2 = this;

        var _props = this.props,
        accent = _props.accent,
        children = _props.children,
        className = _props.className,
        flat = _props.flat,
        floating = _props.floating,
        href = _props.href,
        icon = _props.icon,
        inverse = _props.inverse,
        label = _props.label,
        mini = _props.mini,
        neutral = _props.neutral,
        primary = _props.primary,
        raised = _props.raised,
        theme = _props.theme,
        type = _props.type,
        others = _objectWithoutProperties(_props, ['accent', 'children', 'className', 'flat', 'floating', 'href', 'icon', 'inverse', 'label', 'mini', 'neutral', 'primary', 'raised', 'theme', 'type']);

        var element = href ? 'a' : 'button';
        var level = this.getLevel();
        var shape = this.getShape();
        var mouseEvents = {
          onMouseUp: this.handleMouseUp,
          onMouseLeave: this.handleMouseLeave };


        var classes = (0, _classnames3.default)(theme.button, [theme[shape]], (_classnames = {}, _defineProperty(_classnames, theme[level], neutral), _defineProperty(_classnames, theme.mini, mini), _defineProperty(_classnames, theme.inverse, inverse), _classnames), className);

        var props = _extends({}, others, mouseEvents, {
          href: href,
          ref: function ref(node) {
            _this2.buttonNode = node;
          },
          className: classes,
          disabled: this.props.disabled,
          type: !href ? type : null,
          'data-react-toolbox': 'button' });


        var buttonElement = _react2.default.createElement(element, props, icon ? _react2.default.createElement(FontIcon, { className: theme.icon, value: icon }) : null, label, children);

        return others.onMouseEnter && this.props.disabled ? _react2.default.createElement(
        'span',
        mouseEvents,
        buttonElement) :
        buttonElement;
      } }]);


    return Button;
  }(_react.Component);

  Button.propTypes = {
    accent: _propTypes2.default.bool,
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    flat: _propTypes2.default.bool,
    floating: _propTypes2.default.bool,
    href: _propTypes2.default.string,
    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
    inverse: _propTypes2.default.bool,
    label: _propTypes2.default.string,
    mini: _propTypes2.default.bool,
    neutral: _propTypes2.default.bool,
    onMouseLeave: _propTypes2.default.func,
    onMouseUp: _propTypes2.default.func,
    primary: _propTypes2.default.bool,
    raised: _propTypes2.default.bool,
    theme: _propTypes2.default.shape({
      accent: _propTypes2.default.string,
      button: _propTypes2.default.string,
      flat: _propTypes2.default.string,
      floating: _propTypes2.default.string,
      icon: _propTypes2.default.string,
      inverse: _propTypes2.default.string,
      mini: _propTypes2.default.string,
      neutral: _propTypes2.default.string,
      primary: _propTypes2.default.string,
      raised: _propTypes2.default.string,
      rippleWrapper: _propTypes2.default.string,
      toggle: _propTypes2.default.string }),

    type: _propTypes2.default.string };

  Button.defaultProps = {
    accent: false,
    className: '',
    flat: false,
    floating: false,
    mini: false,
    neutral: true,
    primary: false,
    raised: false,
    type: 'button' };



  return ripple(Button);
};

var Button = factory((0, _Ripple2.default)({ centered: false }), _FontIcon2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.BUTTON)(Button);
exports.buttonFactory = factory;
exports.Button = Button;

/***/ }),

/***/ 1063:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _getPrototypeOf = __webpack_require__(232);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(105);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(110);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(515);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _inherits2 = __webpack_require__(516);var _inherits3 = _interopRequireDefault(_inherits2);var _react = __webpack_require__(648);
var _style = __webpack_require__(1101);var _style2 = _interopRequireDefault(_style);
var _mathlib = __webpack_require__(667);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var
Plain = function (_React$Component) {(0, _inherits3.default)(Plain, _React$Component);function Plain() {(0, _classCallCheck3.default)(this, Plain);return (0, _possibleConstructorReturn3.default)(this, (Plain.__proto__ || (0, _getPrototypeOf2.default)(Plain)).apply(this, arguments));}(0, _createClass3.default)(Plain, [{ key: 'render', value: function render()
        {var _props =
            this.props,children = _props.children,arialabel = _props.arialabel,header = _props.header,onClick = _props.onClick,onEscKeyDown = _props.onEscKeyDown,transform = _props.transform,type = _props.type,backdrop = _props.backdrop,visible = _props.visible,minimized = _props.minimized;
            if (backdrop)
            return _react.React.createElement("div", null,
            _react.React.createElement("div", { className: (0, _style2.default)('backdrop'), style: { opacity: backdropOpacity(visible ? 1 : 0) }, "aria-hidden": "true", onClick: function onClick(ev) {ev.preventDefault();return onEscKeyDown();}, onMouseDown: function onMouseDown(ev) {ev.preventDefault();return onEscKeyDown();} }),
            _react.React.createElement("div", { onKeyDown: function onKeyDown(ev) {if (ev.key === 'Escape') {
                        ev.preventDefault();
                        return onEscKeyDown();
                    }}, className: (0, _style2.default)('container', type, minimized ? 'minimized' : '', visible ? 'wcag-visible' : 'wcag-invisible'), style: { transform: 'translateY(' + transform.translateY + ')', opacity: transform.opacity, zIndex: type === 'center' || type === 'center2nd' || type === 'maximized' ? transform.zIndex : undefined }, role: "dialog", "aria-label": arialabel, "aria-labelledby": !arialabel ? 'aria-labelledby-id' : '', onClick: onClick },
            _react.React.createElement("div", { className: (0, _style2.default)('component', type, minimized ? 'minimized' : '') },
            _react.React.createElement("div", { className: (0, _style2.default)('shadow', type) }),
            _react.React.createElement("div", { id: 'aria-labelledby-id' }, header),
            _react.React.createElement("div", { className: (0, _style2.default)('content', type) }, children))));
            return _react.React.createElement("div", { onKeyDown: function onKeyDown(ev) {if (ev.key === 'Escape')
                    return onEscKeyDown();}, className: (0, _style2.default)('container', type), style: { transform: 'translateY(' + transform.translateY + ')', opacity: transform.opacity, zIndex: type === 'center' ? transform.zIndex : undefined }, onClick: onClick, role: "dialog", "aria-label": arialabel, "aria-labelledby": !arialabel ? 'dialogHeader' : '' },
            _react.React.createElement("div", { className: (0, _style2.default)('component', type) },
            _react.React.createElement("div", { className: (0, _style2.default)('shadow', type) }),
            header,
            _react.React.createElement("div", { className: (0, _style2.default)('content', type) }, children)));
        } }]);return Plain;}(_react.React.Component);exports.default = Plain;

function backdropOpacity(input) {
    return (0, _mathlib.round_dec)(Math.pow(input, 2) * .5, 1);
}

/***/ }),

/***/ 1064:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.CategoriesEditAreaButtons = undefined;__webpack_require__(76);
var _reselect = __webpack_require__(221);
var _react = __webpack_require__(648);
var _FontIcon = __webpack_require__(988);
var _input = __webpack_require__(990);var _input2 = _interopRequireDefault(_input);
var _colors = __webpack_require__(1144);var _colors2 = _interopRequireDefault(_colors);
var _resource = __webpack_require__(162);
var _style = __webpack_require__(1020);var _style2 = _interopRequireDefault(_style);
var _extendprops = __webpack_require__(1147);var _extendprops2 = _interopRequireDefault(_extendprops);
var _selectors = __webpack_require__(975);var _selectors2 = _interopRequireDefault(_selectors);
var _button = __webpack_require__(973);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var maxCategoryNameLength = 255;
var isValidSelector = (0, _reselect.createSelector)(_resource.categoriesEditor.selectors.item, function (item) {return item.name && item.color;});exports.default =
(0, _react.PureConnect)('CategoriesEditArea')(function (state) {return {
        creating: _resource.categoriesEditor.selectors.creating(state),
        isValid: isValidSelector(state),
        item: _resource.categoriesEditor.selectors.item(state),
        updating: _resource.categoriesEditor.selectors.updating(state),
        origin: state.notemenu.origin,
        screenSmall: _selectors2.default.small(state) };},
function (dispatch) {return {
        change: function change(item) {return dispatch(_resource.categoriesEditor.actions.APPLY({ item: item }));} };},
function (_ref) {var creating = _ref.creating,updating = _ref.updating,item = _ref.item,change = _ref.change;
    var getColorName = function getColorName(color) {
        switch (color) {
            case '#FF062C':return 'Categoriekleur rood';
            case '#FF0062':return 'Categoriekleur roze';
            case '#ECBFEC':return 'Categoriekleur lila';
            case '#7432BB':return 'Categoriekleur paars';
            case '#3550B9':return 'Categoriekleur donkerblauw';
            case '#00B447':return 'Categoriekleur middenzeegroen';
            case '#BFE6E1':return 'Categoriekleur faalturkoois';
            case '#00C1D6':return 'Categoriekleur donkerturkoois';
            case '#00ADF8':return 'Categoriekleur poederblauw';
            case '#BFE5FD':return 'Categoriekleur lichthemelsblauw';
            case '#68C73A':return 'Categoriekleur lentegroen';
            case '#C6DE03':return 'Categoriekleur legergroen';
            case '#FFFABF':return 'Categoriekleur kaki';
            case '#FFBD00':return 'Categoriekleur guldenroede';
            case '#FF8F00':return 'Categoriekleur donkeroranje';
            case '#FF5C06':return 'Categoriekleur pompoenoranje';
            case '#5858FF':return 'Categoriekleur ultramarineblauw';
            case '#0653FF':return 'Categoriekleur oceaanblauw';}

        return 'geen kleur';
    };
    return _react.React.createElement("div", { className: (0, _style2.default)(!(creating || updating) ? 'wcag-invisible' : '', 'fields-container'), "aria-hidden": !(creating || updating), "aria-labelledby": "Maak een categorie aan" },
    _react.React.createElement("div", { className: (0, _style2.default)('categorie-naam') },
    _react.React.createElement("span", { className: (0, _style2.default)('categorie-titel') }, creating ? 'Categorie aanmaken' : 'Categorie bewerken'),
    _react.React.createElement("span", { className: (0, _style2.default)('categorie-input-label') },
    "Naam categorie",
    _react.React.createElement("span", { className: (0, _style2.default)('belangrijk') }, "*")),
    _react.React.createElement(_extendprops2.default, { arialabel: 'Invoer naam categorie' },
    _react.React.createElement(_input2.default, { type: "text", className: (0, _style2.default)('categorie-search'), name: "name", value: item && item.name ? item.name : '', maxLength: maxCategoryNameLength, onChange: function onChange(value) {return change({ name: value });}, floating: true }))),
    _react.React.createElement("div", { className: (0, _style2.default)('radios') },
    _react.React.createElement("span", { className: (0, _style2.default)('radios-label') },
    "Kleur",
    _react.React.createElement("span", { className: (0, _style2.default)('belangrijk') }, "*")),
    _react.React.createElement("div", { className: (0, _style2.default)('radios-container') }, _colors2.default.qSelect(function (radioColor, index) {return _react.React.createElement("div", { className: (0, _style2.default)('radio'), key: index },
        _react.React.createElement("label", { tabIndex: 0, className: (0, _style2.default)('colored-radio'), onKeyDown: function onKeyDown(ev) {
                if (ev.key === 'Enter') {
                    item.color = radioColor;
                    return change({ color: radioColor });
                }
            }, onChange: function onChange() {return change({ color: radioColor });}, style: { backgroundColor: radioColor } },
        _react.React.createElement("input", { type: "radio", name: "color", value: radioColor, checked: item.color === radioColor, onChange: function onChange() {return change({ color: radioColor });} }),
        _react.React.createElement("div", { className: (0, _style2.default)('sr-only') }, getColorName(radioColor)),
        item.color === radioColor ? _react.React.createElement(_FontIcon.FontIcon, { value: "check" }) : null));}))));
});
var CategoriesEditAreaButtons = exports.CategoriesEditAreaButtons = (0, _react.PureConnect)('CategoriesEditAreaButtons')(function (state) {return {
        creating: _resource.categoriesEditor.selectors.creating(state),
        isValid: isValidSelector(state),
        item: _resource.categoriesEditor.selectors.item(state),
        updating: _resource.categoriesEditor.selectors.updating(state),
        origin: state.notemenu.origin,
        screenSmall: _selectors2.default.small(state) };},
function (dispatch) {return {
        cancel: function cancel() {return dispatch(_resource.categoriesEditor.actions.RESET({}));},
        cancelCreating: function cancelCreating() {return dispatch(_resource.categoriesEditor.actions.CREATE_CANCEL({}));},
        cancelUpdating: function cancelUpdating() {return dispatch(_resource.categoriesEditor.actions.UPDATE_CANCEL({}));},
        change: function change(item) {return dispatch(_resource.categoriesEditor.actions.APPLY({ item: item }));},
        saveCreating: function saveCreating(item) {return dispatch(_resource.categoriesEditor.actions.CREATE_CONTINUE({ item: item }));},
        saveUpdating: function saveUpdating(item) {return dispatch(_resource.categoriesEditor.actions.UPDATE_CONTINUE({ item: item }));} };},
function (_ref2) {var creating = _ref2.creating,updating = _ref2.updating,item = _ref2.item,saveCreating = _ref2.saveCreating,cancelCreating = _ref2.cancelCreating,saveUpdating = _ref2.saveUpdating,cancelUpdating = _ref2.cancelUpdating;
    var onCancel = creating ? cancelCreating : cancelUpdating;
    var onSave = creating ? function () {return saveCreating(fixNoteDevelopmentJsonServer(item));} : function () {return saveUpdating(item);};
    var canBeSaved = !!(item && item.name && item.name.length && item.color);
    return _react.React.createElement("div", { className: (0, _style2.default)('bottom-panel', !(creating || updating) ? 'wcag-invisible' : ''), "aria-hidden": !(creating || updating), "aria-labelledby": "Maak categorie aan" },
    _react.React.createElement("div", { className: (0, _style2.default)('bottom-buttons') },
    _react.React.createElement("div", { className: (0, _style2.default)('buttons-container', !(creating || updating) ? 'wcag-invisible' : '') },
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Annuleren van ingevoerde categorie', "aria-haspopup": false, tabIndex: 0, onKeyDown: function onKeyDown(evt) {return handleEnters(evt, function () {return onCancel();});}, onClick: function onClick() {return onCancel();} },
    _react.React.createElement("span", null, "Annuleren")),
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', disabled: !canBeSaved, "aria-label": 'Opslaan van ingevoerde categorie', "aria-haspopup": false, onKeyDown: function onKeyDown(evt) {return handleEnters(evt, function () {return canBeSaved ? onSave() : null;});}, onClick: function onClick() {return canBeSaved ? onSave() : null;} },
    _react.React.createElement("span", null, "Opslaan")))));
});
function handleEnters(evt, funct) {
    if (evt.key === 'Enter') {
        evt.preventDefault();
        funct();
    }
}
function fixNoteDevelopmentJsonServer(item) {
    return item;
}

/***/ }),

/***/ 1065:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _getPrototypeOf = __webpack_require__(232);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(105);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(110);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(515);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _inherits2 = __webpack_require__(516);var _inherits3 = _interopRequireDefault(_inherits2);var _reactMotion = __webpack_require__(1002);
var _react = __webpack_require__(648);
var _button = __webpack_require__(973);
var _style = __webpack_require__(1153);var _style2 = _interopRequireDefault(_style);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var
CollapsablePanel = function (_Component) {(0, _inherits3.default)(CollapsablePanel, _Component);
    function CollapsablePanel() {(0, _classCallCheck3.default)(this, CollapsablePanel);var _this = (0, _possibleConstructorReturn3.default)(this, (CollapsablePanel.__proto__ || (0, _getPrototypeOf2.default)(CollapsablePanel)).apply(this,
        arguments));
        _this.state = {
            contentHeight: 0,
            visible: Boolean(_this.props.defaultOpened) };

        _this._contentHeight = 0;
        _this._initialHeight = undefined;
        _this.onContentMounted = function (div) {
            _this._content = div;
            _this.beginUpdate();
        };
        _this.beginUpdate = function () {
            if (!_this._queue) {
                _this._queue = window.requestAnimationFrame(_this.update);
            }
        };
        _this.update = function () {
            _this._queue = null;
            if (_this._content) {
                var contentHeight = _this._content.scrollHeight || 0;
                if (_this._initialHeight === undefined) {
                    _this._initialHeight = contentHeight;
                }
                if (_this.state.visible && contentHeight !== _this._contentHeight) {
                    _this._contentHeight = contentHeight;
                    _this.setState({ contentHeight: contentHeight });
                }
            }
        };
        _this.onClick = function () {
            _this.setState({ visible: !_this.state.visible });
        };return _this;
    }(0, _createClass3.default)(CollapsablePanel, [{ key: 'render', value: function render()
        {var _this2 = this;var _props =
            this.props,label = _props.label,border = _props.border,children = _props.children;var _state =
            this.state,contentHeight = _state.contentHeight,visible = _state.visible;
            return _react.React.createElement(_reactMotion.Motion, { defaultStyle: { maxHeight: 0 }, style: { maxHeight: this.getInitialHeight(visible, contentHeight) } }, function (_ref) {var maxHeight = _ref.maxHeight;return _react.React.createElement("div", { className: (0, _style2.default)('component', { border: border }) },
                _react.React.createElement("div", { className: (0, _style2.default)('header', { border: border }) },
                _react.React.createElement(_button.Btn, { type: "button", className: (0, _style2.default)('btn-type-dropdown'), "aria-haspopup": false, tabIndex: 0, onClick: _this2.onClick, disabled: false },
                _react.React.createElement("span", { className: (0, _style2.default)('selected-container') },
                _react.React.createElement("span", { className: (0, _style2.default)('default-header') }, label)),
                _react.React.createElement("span", { className: (0, _style2.default)('icon', visible ? 'icon_chevron-up' : 'icon_chevron-down') }))),
                _react.React.createElement("div", { className: (0, _style2.default)(!visible ? 'wcag-invisible' : '', 'content', { opened: contentHeight > 0 && maxHeight === contentHeight }), style: { maxHeight: contentHeight > 0 && maxHeight === contentHeight ? 'initial' : maxHeight }, ref: _this2.onContentMounted }, children));});
        } }, { key: 'componentWillReceiveProps', value: function componentWillReceiveProps(_ref2)
        {var children = _ref2.children;
            if (children !== this.props.children) {
                this.beginUpdate();
            }
        } }, { key: 'componentDidMount', value: function componentDidMount()
        {
            this._initialHeight = undefined;
            this.beginUpdate();
        } }, { key: 'componentDidUpdate', value: function componentDidUpdate()
        {
            this.beginUpdate();
        } }, { key: 'getInitialHeight', value: function getInitialHeight(
        visible, input) {
            if (this._initialHeight) {
                var h = this._initialHeight;
                this._initialHeight = 0;
                return visible ? h : 0;
            } else
            {
                return (0, _reactMotion.spring)(visible ? input : 0);
            }
        } }]);return CollapsablePanel;}(_react.Component);exports.default = CollapsablePanel;

/***/ }),

/***/ 1066:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.NoteChatSaveArea = exports.NoteChatEditArea = undefined;var _react = __webpack_require__(648);
var _resource = __webpack_require__(517);
var _style = __webpack_require__(1052);var _style2 = _interopRequireDefault(_style);
var _button = __webpack_require__(973);
var _resource2 = __webpack_require__(106);
var _selectors = __webpack_require__(977);var _selectors2 = _interopRequireDefault(_selectors);
var _selectors3 = __webpack_require__(981);var _selectors4 = _interopRequireDefault(_selectors3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var NoteChatEditArea = exports.NoteChatEditArea = (0, _react.PureConnect)('NoteChatEditArea')(function (state) {return {
        item: _resource.notechatEditor.selectors.item(state),
        updating: _resource.notechatEditor.selectors.updating(state),
        creatingNote: _resource2.notesEditor.selectors.creating(state),
        updatingNote: _resource2.notesEditor.selectors.updating(state),
        selectNote: state.selection.creating,
        participantPopupVisible: _selectors2.default.visible(state),
        categoryPopupVisible: _selectors4.default.visible(state),
        selectTextArea: state.selection.creating,
        flyoverVisible: state.flyover.visible };},
function (dispatch) {return {
        change: function change(item) {dispatch(_resource.notechatEditor.actions.APPLY({ item: item }));} };},
function (_ref) {var item = _ref.item,change = _ref.change,updating = _ref.updating,creatingNote = _ref.creatingNote,updatingNote = _ref.updatingNote,selectNote = _ref.selectNote,participantPopupVisible = _ref.participantPopupVisible,categoryPopupVisible = _ref.categoryPopupVisible,selectTextArea = _ref.selectTextArea,flyoverVisible = _ref.flyoverVisible;
    var visible = updating && !creatingNote && !updatingNote && !selectNote && !participantPopupVisible && !categoryPopupVisible && !selectTextArea;
    if (updating)
    item.text = !item.text ? '' : item.text;
    return _react.React.createElement("div", { "aria-labelledby": "Geef notitie reactie", className: (0, _style2.default)(!visible ? 'wcag-invisible' : ''), "aria-hidden": !visible },
    _react.React.createElement("div", { className: (0, _style2.default)('notechat-container', 'edit-note', flyoverVisible ? 'flyover' : 'modal') },
    _react.React.createElement("title", null,
    _react.React.createElement("span", { className: (0, _style2.default)('title-text') }, "Reactie bewerken")),
    _react.React.createElement("span", { className: (0, _style2.default)('sub-title-chat') },
    "Reactie",
    _react.React.createElement("span", { className: (0, _style2.default)('important-icon') }, "*")),
    _react.React.createElement("div", { className: (0, _style2.default)('input-text-chat') },
    _react.React.createElement("textarea", { className: (0, _style2.default)('input-text-chat-area'), placeholder: "Type hier uw reactie...", name: "q", ref: "term", "aria-multiline": true, value: item.text, onChange: function onChange(x) {
            item.text = x.target.value;
            change(item);
        } }))));
});
var NoteChatSaveArea = exports.NoteChatSaveArea = (0, _react.PureConnect)('NoteChatSaveArea')(function (state) {return {
        creating: _resource.notechatEditor.selectors.creating(state),
        item: _resource.notechatEditor.selectors.item(state),
        updating: _resource.notechatEditor.selectors.updating(state),
        creatingNote: _resource2.notesEditor.selectors.creating(state),
        updatingNote: _resource2.notesEditor.selectors.updating(state),
        selectNote: state.selection.creating,
        origin: state.notemenu.origin,
        participantPopupVisible: _selectors2.default.visible(state),
        categoryPopupVisible: _selectors4.default.visible(state),
        selectTextArea: state.selection.creating };},
function (dispatch) {return {
        cancel: function cancel() {return dispatch(_resource.notechatEditor.actions.RESET({}));},
        cancelUpdating: function cancelUpdating() {
            dispatch(_resource.notechatEditor.actions.UPDATE_CANCEL({}));
        },
        saveUpdating: function saveUpdating(item) {
            dispatch(_resource.notechatEditor.actions.UPDATE_CONTINUE({ item: item }));
        } };},
function (_ref2) {var updating = _ref2.updating,creatingNote = _ref2.creatingNote,updatingNote = _ref2.updatingNote,selectNote = _ref2.selectNote,item = _ref2.item,saveUpdating = _ref2.saveUpdating,cancelUpdating = _ref2.cancelUpdating,participantPopupVisible = _ref2.participantPopupVisible,categoryPopupVisible = _ref2.categoryPopupVisible,selectTextArea = _ref2.selectTextArea;
    var visible = updating && !creatingNote && !updatingNote && !selectNote && !participantPopupVisible && !categoryPopupVisible && !selectTextArea;
    return _react.React.createElement("div", { className: (0, _style2.default)('bottom-panel', !visible ? 'wcag-invisible' : ''), "aria-hidden": !visible, "aria-labelledby": "Maak een notitie aan" },
    _react.React.createElement("div", { className: (0, _style2.default)('bottom-buttons') },
    _react.React.createElement("div", { className: (0, _style2.default)('buttons-container', participantPopupVisible || categoryPopupVisible ? 'wcag-invisible' : '') },
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Annuleren', "aria-haspopup": false, tabIndex: 0, onKeyDown: function onKeyDown(evt) {
            handleEnters(evt, function () {cancelUpdating();});
        }, onClick: function onClick() {cancelUpdating();} },
    _react.React.createElement("span", null, "Annuleren")),
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', "aria-label": 'Opslaan', "aria-haspopup": false, tabIndex: item.text ? 0 : -1, disabled: !item.text, onKeyDown: function onKeyDown(evt) {
            handleEnters(evt, function () {return saveUpdating(item);});
        }, onClick: function onClick() {return saveUpdating(item);} },
    _react.React.createElement("span", null, "Opslaan")))));
});
function handleEnters(evt, funct) {
    if (evt.key === 'Enter') {
        evt.preventDefault();
        funct();
    }
}

/***/ }),

/***/ 1067:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _getPrototypeOf = __webpack_require__(232);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(105);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(110);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(515);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _inherits2 = __webpack_require__(516);var _inherits3 = _interopRequireDefault(_inherits2);var _react = __webpack_require__(171);var _react2 = _interopRequireDefault(_react);
var _styles = __webpack_require__(1048);var _styles2 = _interopRequireDefault(_styles);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var
DropDownBasic = function (_React$Component) {(0, _inherits3.default)(DropDownBasic, _React$Component);
    function DropDownBasic() {(0, _classCallCheck3.default)(this, DropDownBasic);var _this = (0, _possibleConstructorReturn3.default)(this, (DropDownBasic.__proto__ || (0, _getPrototypeOf2.default)(DropDownBasic)).apply(this,
        arguments));
        _this.items = _this.props.items;
        _this.itemSelection = _this.props.itemSelection;
        _this.showDropDown = _this.props.showDropDown;
        _this.toggleDropDown = _this.props.toggleDropDown;
        _this.prefix = _this.props.prefix;
        _this.value = _this.props.value;
        _this.label = _this.props.label;
        _this.extraclass = _this.props.extraclass;
        _this.onChange = function (e) {
            var selected = _this.props.value ?
            _this.items.qWhere(function (o) {return o.name.toLowerCase() === e.target.value.toLowerCase();}).qFirst() :
            _this.items.qFirst();
            _this.itemSelection(selected ? selected.key : 1);
        };
        _this.onToggle = function () {
            _this.toggleDropDown();
        };return _this;
    }(0, _createClass3.default)(DropDownBasic, [{ key: 'renderOptions', value: function renderOptions()
        {
            var options = this.items.map(function (option) {
                return _react2.default.createElement("option", { key: option.key, value: option.name, className: (0, _styles2.default)(option.statusclass) }, option.name);
            });
            return options;
        } }, { key: 'render', value: function render()
        {var _this2 = this;
            var selectedOption = this.props.value ?
            this.items.qWhere(function (o) {return o.key === _this2.props.value;}).qFirst() :
            this.items.qFirst();
            return _react2.default.createElement("div", { className: (0, _styles2.default)('dropdown-status') },
            _react2.default.createElement("div", { className: (0, _styles2.default)('trigger'), onClick: this.onToggle }, this.props.title),
            _react2.default.createElement("div", { className: (0, _styles2.default)('options-list') },
            _react2.default.createElement("select", { value: selectedOption ? selectedOption.name : '', onChange: this.onChange, className: (0, _styles2.default)(this.extraclass, selectedOption ? this.prefix + selectedOption.key.toString() : this.prefix) }, this.renderOptions())));
        } }]);return DropDownBasic;}(_react2.default.Component);exports.default =

DropDownBasic;

/***/ }),

/***/ 1080:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _setPrototypeOf = __webpack_require__(493);var _setPrototypeOf2 = _interopRequireDefault2(_setPrototypeOf);var _create = __webpack_require__(222);var _create2 = _interopRequireDefault2(_create);var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault2(_typeof2);var _defineProperty = __webpack_require__(161);var _defineProperty2 = _interopRequireDefault2(_defineProperty);var _assign = __webpack_require__(77);var _assign2 = _interopRequireDefault2(_assign);function _interopRequireDefault2(obj) {return obj && obj.__esModule ? obj : { default: obj };}

exports.__esModule = true;

var _extends = _assign2.default || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};

var _createClass = function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;(0, _defineProperty2.default)(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};}();

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { 'default': obj };}

function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError('Cannot call a class as a function');}}

function _inherits(subClass, superClass) {if (typeof superClass !== 'function' && superClass !== null) {throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));}subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;}

var _mapToZero = __webpack_require__(1009);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(992);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(1010);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(1011);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(1012);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(1013);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(171);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1014);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

var Motion = function (_React$Component) {
  _inherits(Motion, _React$Component);

  _createClass(Motion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
      children: _propTypes2['default'].func.isRequired,
      onRest: _propTypes2['default'].func },

    enumerable: true }]);


  function Motion(props) {
    var _this = this;

    _classCallCheck(this, Motion);

    _React$Component.call(this, props);
    this.wasAnimating = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyle = null;

    this.clearUnreadPropStyle = function (destStyle) {
      var dirty = false;
      var _state = _this.state;
      var currentStyle = _state.currentStyle;
      var currentVelocity = _state.currentVelocity;
      var lastIdealStyle = _state.lastIdealStyle;
      var lastIdealVelocity = _state.lastIdealVelocity;

      for (var key in destStyle) {
        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
          continue;
        }

        var styleValue = destStyle[key];
        if (typeof styleValue === 'number') {
          if (!dirty) {
            dirty = true;
            currentStyle = _extends({}, currentStyle);
            currentVelocity = _extends({}, currentVelocity);
            lastIdealStyle = _extends({}, lastIdealStyle);
            lastIdealVelocity = _extends({}, lastIdealVelocity);
          }

          currentStyle[key] = styleValue;
          currentVelocity[key] = 0;
          lastIdealStyle[key] = styleValue;
          lastIdealVelocity[key] = 0;
        }
      }

      if (dirty) {
        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // check if we need to animate in the first place
        var propsStyle = _this.props.style;
        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
          if (_this.wasAnimating && _this.props.onRest) {
            _this.props.onRest();
          }

          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.wasAnimating = false;
          _this.accumulatedTime = 0;
          return;
        }

        _this.wasAnimating = true;

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyle = {};
        var newLastIdealVelocity = {};
        var newCurrentStyle = {};
        var newCurrentVelocity = {};

        for (var key in propsStyle) {
          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
            continue;
          }

          var styleValue = propsStyle[key];
          if (typeof styleValue === 'number') {
            newCurrentStyle[key] = styleValue;
            newCurrentVelocity[key] = 0;
            newLastIdealStyle[key] = styleValue;
            newLastIdealVelocity[key] = 0;
          } else {
            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
            for (var i = 0; i < framesToCatchUp; i++) {
              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              newLastIdealStyleValue = _stepper[0];
              newLastIdealVelocityValue = _stepper[1];
            }

            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            var nextIdealX = _stepper2[0];
            var nextIdealV = _stepper2[1];

            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
            newLastIdealStyle[key] = newLastIdealStyleValue;
            newLastIdealVelocity[key] = newLastIdealVelocityValue;
          }
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyle: newCurrentStyle,
          currentVelocity: newCurrentVelocity,
          lastIdealStyle: newLastIdealStyle,
          lastIdealVelocity: newLastIdealVelocity });


        _this.unreadPropStyle = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  Motion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyle = _props.defaultStyle;
    var style = _props.style;

    var currentStyle = defaultStyle || _stripStyle2['default'](style);
    var currentVelocity = _mapToZero2['default'](currentStyle);
    return {
      currentStyle: currentStyle,
      currentVelocity: currentVelocity,
      lastIdealStyle: currentStyle,
      lastIdealVelocity: currentVelocity };

  };

  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400

  Motion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyle != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyle);
    }

    this.unreadPropStyle = props.style;
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  Motion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyle);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return Motion;
}(_react2['default'].Component);

exports['default'] = Motion;
module.exports = exports['default'];

// after checking for unreadPropStyle != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),

/***/ 1081:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) { // Generated by CoffeeScript 1.12.2
(function () {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if (typeof performance !== "undefined" && performance !== null && performance.now) {
    module.exports = function () {
      return performance.now();
    };
  } else if (typeof process !== "undefined" && process !== null && process.hrtime) {
    module.exports = function () {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function getNanoSeconds() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function () {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function () {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(undefined);

//# sourceMappingURL=performance-now.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1008)))

/***/ }),

/***/ 1082:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(1083);
var invariant = __webpack_require__(1084);
var ReactPropTypesSecret = __webpack_require__(1085);

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
    false,
    'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
    'Use PropTypes.checkPropTypes() to call them. ' +
    'Read more at http://fb.me/use-check-prop-types');

  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim };


  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ 1083:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
               * Copyright (c) 2013-present, Facebook, Inc.
               *
               * This source code is licensed under the MIT license found in the
               * LICENSE file in the root directory of this source tree.
               *
               * 
               */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
   * This function accepts and discards inputs; it has no side effects. This is
   * primarily useful idiomatically for overridable function endpoints which
   * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
   */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),

/***/ 1084:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
               * Use invariant() to assert state which your program assumes to be true.
               *
               * Provide sprintf-style format (only %s is supported) and arguments
               * to provide information about what broke and what you were
               * expecting.
               *
               * The invariant message will be stripped in production, but the invariant
               * will remain to ensure logic does not differ in production.
               */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),

/***/ 1085:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ 1086:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _setPrototypeOf = __webpack_require__(493);var _setPrototypeOf2 = _interopRequireDefault2(_setPrototypeOf);var _create = __webpack_require__(222);var _create2 = _interopRequireDefault2(_create);var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault2(_typeof2);var _defineProperty = __webpack_require__(161);var _defineProperty2 = _interopRequireDefault2(_defineProperty);var _assign = __webpack_require__(77);var _assign2 = _interopRequireDefault2(_assign);function _interopRequireDefault2(obj) {return obj && obj.__esModule ? obj : { default: obj };}

exports.__esModule = true;

var _extends = _assign2.default || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};

var _createClass = function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;(0, _defineProperty2.default)(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};}();

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { 'default': obj };}

function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError('Cannot call a class as a function');}}

function _inherits(subClass, superClass) {if (typeof superClass !== 'function' && superClass !== null) {throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));}subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;}

var _mapToZero = __webpack_require__(1009);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(992);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(1010);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(1011);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(1012);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(1013);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(171);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1014);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
  for (var i = 0; i < currentStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
      return false;
    }
  }
  return true;
}

var StaggeredMotion = function (_React$Component) {
  _inherits(StaggeredMotion, _React$Component);

  _createClass(StaggeredMotion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
      styles: _propTypes2['default'].func.isRequired,
      children: _propTypes2['default'].func.isRequired },

    enumerable: true }]);


  function StaggeredMotion(props) {
    var _this = this;

    _classCallCheck(this, StaggeredMotion);

    _React$Component.call(this, props);
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _state = _this.state;
      var currentStyles = _state.currentStyles;
      var currentVelocities = _state.currentVelocities;
      var lastIdealStyles = _state.lastIdealStyles;
      var lastIdealVelocities = _state.lastIdealVelocities;

      var someDirty = false;
      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i];
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              someDirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
          }
        }
      }

      if (someDirty) {
        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        var destStyles = _this.props.styles(_this.state.lastIdealStyles);

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyles = [];
        var newLastIdealVelocities = [];
        var newCurrentStyles = [];
        var newCurrentVelocities = [];

        for (var i = 0; i < destStyles.length; i++) {
          var destStyle = destStyles[i];
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in destStyle) {
            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
              continue;
            }

            var styleValue = destStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities });


        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  StaggeredMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;

    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
    var currentVelocities = currentStyles.map(function (currentStyle) {
      return _mapToZero2['default'](currentStyle);
    });
    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: currentStyles,
      lastIdealVelocities: currentVelocities };

  };

  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  StaggeredMotion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return StaggeredMotion;
}(_react2['default'].Component);

exports['default'] = StaggeredMotion;
module.exports = exports['default'];

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

// after checking for unreadPropStyles != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),

/***/ 1087:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _setPrototypeOf = __webpack_require__(493);var _setPrototypeOf2 = _interopRequireDefault2(_setPrototypeOf);var _create = __webpack_require__(222);var _create2 = _interopRequireDefault2(_create);var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault2(_typeof2);var _defineProperty = __webpack_require__(161);var _defineProperty2 = _interopRequireDefault2(_defineProperty);var _assign = __webpack_require__(77);var _assign2 = _interopRequireDefault2(_assign);function _interopRequireDefault2(obj) {return obj && obj.__esModule ? obj : { default: obj };}

exports.__esModule = true;

var _extends = _assign2.default || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};

var _createClass = function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;(0, _defineProperty2.default)(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};}();

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { 'default': obj };}

function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError('Cannot call a class as a function');}}

function _inherits(subClass, superClass) {if (typeof superClass !== 'function' && superClass !== null) {throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));}subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;}

var _mapToZero = __webpack_require__(1009);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(992);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(1010);

var _stepper4 = _interopRequireDefault(_stepper3);

var _mergeDiff = __webpack_require__(1088);

var _mergeDiff2 = _interopRequireDefault(_mergeDiff);

var _performanceNow = __webpack_require__(1011);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(1012);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(1013);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(171);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1014);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

// the children function & (potential) styles function asks as param an
// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
// {key: string, data?: any, style: PlainStyle}. However, the way we keep
// internal states doesn't contain such a data structure (check the state and
// TransitionMotionState). So when children function and others ask for such
// data we need to generate them on the fly by combining mergedPropsStyles and
// currentStyles/lastIdealStyles
function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
  // Copy the value to a `const` so that Flow understands that the const won't
  // change and will be non-nullable in the callback below.
  var cUnreadPropStyles = unreadPropStyles;
  if (cUnreadPropStyles == null) {
    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
      return {
        key: mergedPropsStyle.key,
        data: mergedPropsStyle.data,
        style: plainStyles[i] };

    });
  }
  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
    for (var j = 0; j < cUnreadPropStyles.length; j++) {
      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
        return {
          key: cUnreadPropStyles[j].key,
          data: cUnreadPropStyles[j].data,
          style: plainStyles[i] };

      }
    }
    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
  });
}

function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
  if (mergedPropsStyles.length !== destStyles.length) {
    return false;
  }

  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (mergedPropsStyles[i].key !== destStyles[i].key) {
      return false;
    }
  }

  // we have the invariant that mergedPropsStyles and
  // currentStyles/currentVelocities/last* are synced in terms of cells, see
  // mergeAndSync comment for more info
  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
      return false;
    }
  }

  return true;
}

// core key merging logic

// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
// c}, previous current (interpolating) style is {a, b}
// **invariant**: current[i] corresponds to merged[i] in terms of key

// steps:
// turn merged style into {a?, b, c}
//    add c, value of c is destStyles.c
//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
// turn current (interpolating) style from {a, b} into {a?, b, c}
//    maybe remove a
//    certainly add c, value of c is willEnter(c)
// loop over merged and construct new current
// dest doesn't change, that's owner's
function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
    var leavingStyle = willLeave(oldMergedPropsStyle);
    if (leavingStyle == null) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
  });

  var newCurrentStyles = [];
  var newCurrentVelocities = [];
  var newLastIdealStyles = [];
  var newLastIdealVelocities = [];
  for (var i = 0; i < newMergedPropsStyles.length; i++) {
    var newMergedPropsStyleCell = newMergedPropsStyles[i];
    var foundOldIndex = null;
    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
        foundOldIndex = j;
        break;
      }
    }
    // TODO: key search code
    if (foundOldIndex == null) {
      var plainStyle = willEnter(newMergedPropsStyleCell);
      newCurrentStyles[i] = plainStyle;
      newLastIdealStyles[i] = plainStyle;

      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
      newCurrentVelocities[i] = velocity;
      newLastIdealVelocities[i] = velocity;
    } else {
      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
    }
  }

  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
}

var TransitionMotion = function (_React$Component) {
  _inherits(TransitionMotion, _React$Component);

  _createClass(TransitionMotion, null, [{
    key: 'propTypes',
    value: {
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired })),

      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired }))]).
      isRequired,
      children: _propTypes2['default'].func.isRequired,
      willEnter: _propTypes2['default'].func,
      willLeave: _propTypes2['default'].func,
      didLeave: _propTypes2['default'].func },

    enumerable: true },
  {
    key: 'defaultProps',
    value: {
      willEnter: function willEnter(styleThatEntered) {
        return _stripStyle2['default'](styleThatEntered.style);
      },
      // recall: returning null makes the current unmounting TransitionStyle
      // disappear immediately
      willLeave: function willLeave() {
        return null;
      },
      didLeave: function didLeave() {} },

    enumerable: true }]);


  function TransitionMotion(props) {
    var _this = this;

    _classCallCheck(this, TransitionMotion);

    _React$Component.call(this, props);
    this.unmounting = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

      var mergedPropsStyles = _mergeAndSync[0];
      var currentStyles = _mergeAndSync[1];
      var currentVelocities = _mergeAndSync[2];
      var lastIdealStyles = _mergeAndSync[3];
      var lastIdealVelocities = _mergeAndSync[4];

      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i].style;
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
              mergedPropsStyles[i] = {
                key: mergedPropsStyles[i].key,
                data: mergedPropsStyles[i].data,
                style: _extends({}, mergedPropsStyles[i].style) };

            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
            mergedPropsStyles[i].style[key] = styleValue;
          }
        }
      }

      // unlike the other 2 components, we can't detect staleness and optionally
      // opt out of setState here. each style object's data might contain new
      // stuff we're not/cannot compare
      _this.setState({
        currentStyles: currentStyles,
        currentVelocities: currentVelocities,
        mergedPropsStyles: mergedPropsStyles,
        lastIdealStyles: lastIdealStyles,
        lastIdealVelocities: lastIdealVelocities });

    };

    this.startAnimationIfNecessary = function () {
      if (_this.unmounting) {
        return;
      }

      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // https://github.com/chenglou/react-motion/pull/420
        // > if execution passes the conditional if (this.unmounting), then
        // executes async defaultRaf and after that component unmounts and after
        // that the callback of defaultRaf is called, then setState will be called
        // on unmounted component.
        if (_this.unmounting) {
          return;
        }

        var propStyles = _this.props.styles;
        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

        var newMergedPropsStyles = _mergeAndSync2[0];
        var newCurrentStyles = _mergeAndSync2[1];
        var newCurrentVelocities = _mergeAndSync2[2];
        var newLastIdealStyles = _mergeAndSync2[3];
        var newLastIdealVelocities = _mergeAndSync2[4];

        for (var i = 0; i < newMergedPropsStyles.length; i++) {
          var newMergedPropsStyle = newMergedPropsStyles[i].style;
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in newMergedPropsStyle) {
            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
              continue;
            }

            var styleValue = newMergedPropsStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = newLastIdealStyles[i][key];
              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities,
          mergedPropsStyles: newMergedPropsStyles });


        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  TransitionMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;
    var willEnter = _props.willEnter;
    var willLeave = _props.willLeave;
    var didLeave = _props.didLeave;

    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;

    // this is special. for the first time around, we don't have a comparison
    // between last (no last) and current merged props. we'll compute last so:
    // say default is {a, b} and styles (dest style) is {b, c}, we'll
    // fabricate last as {a, b}
    var oldMergedPropsStyles = undefined;
    if (defaultStyles == null) {
      oldMergedPropsStyles = destStyles;
    } else {
      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
        // TODO: key search code
        for (var i = 0; i < destStyles.length; i++) {
          if (destStyles[i].key === defaultStyleCell.key) {
            return destStyles[i];
          }
        }
        return defaultStyleCell;
      });
    }
    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    });
    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    });

    var _mergeAndSync3 = mergeAndSync(
    // Because this is an old-style createReactClass component, Flow doesn't
    // understand that the willEnter and willLeave props have default values
    // and will always be present.
    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
    oldCurrentVelocities);

    var mergedPropsStyles = _mergeAndSync3[0];
    var currentStyles = _mergeAndSync3[1];
    var currentVelocities = _mergeAndSync3[2];
    var lastIdealStyles = _mergeAndSync3[3];
    var lastIdealVelocities = _mergeAndSync3[4];
    // oldLastIdealVelocities really

    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: lastIdealStyles,
      lastIdealVelocities: lastIdealVelocities,
      mergedPropsStyles: mergedPropsStyles };

  };

  // after checking for unreadPropStyles != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)

  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    var styles = props.styles;
    if (typeof styles === 'function') {
      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
    } else {
      this.unreadPropStyles = styles;
    }

    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounting = true;
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  TransitionMotion.prototype.render = function render() {
    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
    var renderedChildren = this.props.children(hydratedStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return TransitionMotion;
}(_react2['default'].Component);

exports['default'] = TransitionMotion;
module.exports = exports['default'];

// list of styles, each containing interpolating values. Part of what's passed
// to children function. Notice that this is
// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
// contains the key & data info (so that we only have a single source of truth
// for these, and to save space). Check the comment for `rehydrateStyles` to
// see how we regenerate the entirety of what's passed to children function

// the array that keeps track of currently rendered stuff! Including stuff
// that you've unmounted but that's still animating. This is where it lives

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

/***/ }),

/***/ 1088:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// core keys merging algorithm. If previous render's keys are [a, b], and the
// next render's [c, b, d], what's the final merged keys and ordering?

// - c and a must both be before b
// - b before d
// - ordering between a and c ambiguous

// this reduces to merging two partially ordered lists (e.g. lists where not
// every item has a definite ordering, like comparing a and c above). For the
// ambiguous ordering we deterministically choose to place the next render's
// item after the previous'; so c after a

// this is called a topological sorting. Except the existing algorithms don't
// work well with js bc of the amount of allocation, and isn't optimized for our
// current use-case bc the runtime is linear in terms of edges (see wiki for
// meaning), which is huge when two lists have many common elements


exports.__esModule = true;
exports['default'] = mergeDiff;

function mergeDiff(prev, next, onRemove) {
  // bookkeeping for easier access of a key's index below. This is 2 allocations +
  // potentially triggering chrome hash map mode for objs (so it might be faster

  var prevKeyIndex = {};
  for (var i = 0; i < prev.length; i++) {
    prevKeyIndex[prev[i].key] = i;
  }
  var nextKeyIndex = {};
  for (var i = 0; i < next.length; i++) {
    nextKeyIndex[next[i].key] = i;
  }

  // first, an overly elaborate way of merging prev and next, eliminating
  // duplicates (in terms of keys). If there's dupe, keep the item in next).
  // This way of writing it saves allocations
  var ret = [];
  for (var i = 0; i < next.length; i++) {
    ret[i] = next[i];
  }
  for (var i = 0; i < prev.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
      // merge in keys that the user desires to kill
      var fill = onRemove(i, prev[i]);
      if (fill != null) {
        ret.push(fill);
      }
    }
  }

  // now all the items all present. Core sorting logic to have the right order
  return ret.sort(function (a, b) {
    var nextOrderA = nextKeyIndex[a.key];
    var nextOrderB = nextKeyIndex[b.key];
    var prevOrderA = prevKeyIndex[a.key];
    var prevOrderB = prevKeyIndex[b.key];

    if (nextOrderA != null && nextOrderB != null) {
      // both keys in next
      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
    } else if (prevOrderA != null && prevOrderB != null) {
      // both keys in prev
      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
    } else if (nextOrderA != null) {
      // key a in next, key b in prev

      // how to determine the order between a and b? We find a "pivot" (term
      // abuse), a key present in both prev and next, that is sandwiched between
      // a and b. In the context of our above example, if we're comparing a and
      // d, b's (the only) pivot
      for (var i = 0; i < next.length; i++) {
        var pivot = next[i].key;
        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
          continue;
        }

        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
          return -1;
        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
          return 1;
        }
      }
      // pluggable. default to: next bigger than prev
      return 1;
    }
    // prevOrderA, nextOrderB
    for (var i = 0; i < next.length; i++) {
      var pivot = next[i].key;
      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
        continue;
      }
      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
        return 1;
      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
        return -1;
      }
    }
    // pluggable. default to: next bigger than prev
    return -1;
  });
}

module.exports = exports['default'];
// to loop through and find a key's index each time), but I no longer care

/***/ }),

/***/ 1089:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _assign = __webpack_require__(77);var _assign2 = _interopRequireDefault2(_assign);function _interopRequireDefault2(obj) {return obj && obj.__esModule ? obj : { default: obj };}

exports.__esModule = true;

var _extends = _assign2.default || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};

exports['default'] = spring;

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { 'default': obj };}

var _presets = __webpack_require__(1045);

var _presets2 = _interopRequireDefault(_presets);

var defaultConfig = _extends({}, _presets2['default'].noWobble, {
  precision: 0.01 });


function spring(val, config) {
  return _extends({}, defaultConfig, config, { val: val });
}

module.exports = exports['default'];

/***/ }),

/***/ 1090:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = reorderKeys;

var hasWarned = false;

function reorderKeys() {
  if (false) {
    if (!hasWarned) {
      hasWarned = true;
      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
    }
  }
}

module.exports = exports['default'];

/***/ }),

/***/ 1091:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _setPrototypeOf = __webpack_require__(493);var _setPrototypeOf2 = _interopRequireDefault2(_setPrototypeOf);var _create = __webpack_require__(222);var _create2 = _interopRequireDefault2(_create);var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault2(_typeof2);function _interopRequireDefault2(obj) {return obj && obj.__esModule ? obj : { default: obj };}

exports.__esModule = true;
exports.default = undefined;

var _class, _temp;

var _react = __webpack_require__(171);

var _propTypes = __webpack_require__(967);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _themrShape = __webpack_require__(1092);

var _themrShape2 = _interopRequireDefault(_themrShape);

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && ((typeof call === 'undefined' ? 'undefined' : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;}

function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));}subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;}

var ThemeProvider = (_temp = _class = function (_Component) {
  _inherits(ThemeProvider, _Component);

  function ThemeProvider() {
    _classCallCheck(this, ThemeProvider);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  ThemeProvider.prototype.getChildContext = function getChildContext() {
    return {
      themr: {
        theme: this.props.theme } };


  };

  ThemeProvider.prototype.render = function render() {
    return _react.Children.only(this.props.children);
  };

  return ThemeProvider;
}(_react.Component), _class.propTypes = {
  children: _propTypes2.default.element.isRequired,
  theme: _propTypes2.default.object.isRequired },
_class.defaultProps = {
  theme: {} },
_class.childContextTypes = {
  themr: _themrShape2.default.isRequired },
_temp);
exports.default = ThemeProvider;

/***/ }),

/***/ 1092:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(967);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

exports.default = _propTypes2.default.shape({
  theme: _propTypes2.default.object.isRequired });

/***/ }),

/***/ 1093:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _keys = __webpack_require__(85);var _keys2 = _interopRequireDefault2(_keys);var _setPrototypeOf = __webpack_require__(493);var _setPrototypeOf2 = _interopRequireDefault2(_setPrototypeOf);var _create = __webpack_require__(222);var _create2 = _interopRequireDefault2(_create);var _assign = __webpack_require__(77);var _assign2 = _interopRequireDefault2(_assign);var _iterator = __webpack_require__(79);var _iterator2 = _interopRequireDefault2(_iterator);var _typeof3 = __webpack_require__(25);var _typeof4 = _interopRequireDefault2(_typeof3);var _symbol = __webpack_require__(69);var _symbol2 = _interopRequireDefault2(_symbol);function _interopRequireDefault2(obj) {return obj && obj.__esModule ? obj : { default: obj };}

exports.__esModule = true;

var _typeof = typeof _symbol2.default === "function" && (0, _typeof4.default)(_iterator2.default) === "symbol" ? function (obj) {return typeof obj === "undefined" ? "undefined" : (0, _typeof4.default)(obj);} : function (obj) {return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, _typeof4.default)(obj);};

var _extends = _assign2.default || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};

exports.themeable = themeable;

var _react = __webpack_require__(171);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(967);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(1094);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _invariant = __webpack_require__(1095);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}

function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof4.default)(call)) === "object" || typeof call === "function") ? call : self;}

function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof4.default)(superClass)));}subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;}

/**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * @typedef {Object.<string, TReactCSSThemrTheme>} TReactCSSThemrTheme
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 */

/**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * @typedef {{}} TReactCSSThemrOptions
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * @property {String|Boolean} [composeTheme=COMPOSE_DEEPLY]
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */

var COMPOSE_DEEPLY = 'deeply';
var COMPOSE_SOFTLY = 'softly';
var DONT_COMPOSE = false;

var DEFAULT_OPTIONS = {
  composeTheme: COMPOSE_DEEPLY,
  mapThemrProps: defaultMapThemrProps };


var THEMR_CONFIG = typeof _symbol2.default !== 'undefined' ? (0, _symbol2.default)('THEMR_CONFIG') : '__REACT_CSS_THEMR_CONFIG__';

/**
                                                                                                                                    * Themr decorator
                                                                                                                                    * @param {String|Number|Symbol} componentName - Component name
                                                                                                                                    * @param {TReactCSSThemrTheme} [localTheme] - Base theme
                                                                                                                                    * @param {{}} [options] - Themr options
                                                                                                                                    * @returns {function(ThemedComponent:Function):Function} - ThemedComponent
                                                                                                                                    */

exports.default = function (componentName, localTheme) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (ThemedComponent) {
    var _class, _temp;

    var _DEFAULT_OPTIONS$opti = _extends({}, DEFAULT_OPTIONS, options),
    optionComposeTheme = _DEFAULT_OPTIONS$opti.composeTheme,
    optionMapThemrProps = _DEFAULT_OPTIONS$opti.mapThemrProps;

    validateComposeOption(optionComposeTheme);

    var config = ThemedComponent[THEMR_CONFIG];
    if (config && config.componentName === componentName) {
      config.localTheme = themeable(config.localTheme, localTheme);
      return ThemedComponent;
    }

    config = {
      componentName: componentName,
      localTheme: localTheme };


    /**
                                 * @property {{wrappedInstance: *}} refs
                                 */
    var Themed = (_temp = _class = function (_Component) {
      _inherits(Themed, _Component);

      function Themed() {
        _classCallCheck(this, Themed);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args)));

        _this.theme_ = _this.calcTheme(_this.props);
        return _this;
      }

      Themed.prototype.getWrappedInstance = function getWrappedInstance() {
        (0, _invariant2.default)(true, 'DEPRECATED: To access the wrapped instance, you have to pass ' + '{ innerRef: fn } and retrieve with a callback ref style.');

        return this.refs.wrappedInstance;
      };

      Themed.prototype.getNamespacedTheme = function getNamespacedTheme(props) {
        var themeNamespace = props.themeNamespace,
        theme = props.theme;

        if (!themeNamespace) return theme;
        if (themeNamespace && !theme) throw new Error('Invalid themeNamespace use in react-css-themr. ' + 'themeNamespace prop should be used only with theme prop.');

        return (0, _keys2.default)(theme).filter(function (key) {
          return key.startsWith(themeNamespace);
        }).reduce(function (result, key) {
          var _extends2;

          return _extends({}, result, (_extends2 = {}, _extends2[removeNamespace(key, themeNamespace)] = theme[key], _extends2));
        }, {});
      };

      Themed.prototype.getThemeNotComposed = function getThemeNotComposed(props) {
        if (props.theme) return this.getNamespacedTheme(props);
        if (config.localTheme) return config.localTheme;
        return this.getContextTheme();
      };

      Themed.prototype.getContextTheme = function getContextTheme() {
        return this.context.themr ? this.context.themr.theme[config.componentName] : {};
      };

      Themed.prototype.getTheme = function getTheme(props) {
        return props.composeTheme === COMPOSE_SOFTLY ? _extends({}, this.getContextTheme(), config.localTheme, this.getNamespacedTheme(props)) : themeable(themeable(this.getContextTheme(), config.localTheme), this.getNamespacedTheme(props));
      };

      Themed.prototype.calcTheme = function calcTheme(props) {
        var composeTheme = props.composeTheme;

        return composeTheme ? this.getTheme(props) : this.getThemeNotComposed(props);
      };

      Themed.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (nextProps.composeTheme !== this.props.composeTheme || nextProps.theme !== this.props.theme || nextProps.themeNamespace !== this.props.themeNamespace) {
          this.theme_ = this.calcTheme(nextProps);
        }
      };

      Themed.prototype.render = function render() {
        return _react2.default.createElement(ThemedComponent, this.props.mapThemrProps(this.props, this.theme_));
      };

      return Themed;
    }(_react.Component), _class.displayName = 'Themed' + ThemedComponent.name, _class.contextTypes = {
      themr: _propTypes2.default.object },
    _class.propTypes = _extends({}, ThemedComponent.propTypes, {
      composeTheme: _propTypes2.default.oneOf([COMPOSE_DEEPLY, COMPOSE_SOFTLY, DONT_COMPOSE]),
      innerRef: _propTypes2.default.func,
      theme: _propTypes2.default.object,
      themeNamespace: _propTypes2.default.string,
      mapThemrProps: _propTypes2.default.func }),
    _class.defaultProps = _extends({}, ThemedComponent.defaultProps, {
      composeTheme: optionComposeTheme,
      mapThemrProps: optionMapThemrProps }),
    _temp);


    Themed[THEMR_CONFIG] = config;

    return (0, _hoistNonReactStatics2.default)(Themed, ThemedComponent);
  };
};

/**
    * Merges passed themes by concatenating string keys and processing nested themes
    *
    * @param {...TReactCSSThemrTheme} themes - Themes
    * @returns {TReactCSSThemrTheme} - Resulting theme
    */


function themeable() {
  for (var _len2 = arguments.length, themes = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    themes[_key2] = arguments[_key2];
  }

  return themes.reduce(function (acc, theme) {
    return merge(acc, theme);
  }, {});
}

/**
   * @param {TReactCSSThemrTheme} [original] - Original theme
   * @param {TReactCSSThemrTheme} [mixin] - Mixin theme
   * @returns {TReactCSSThemrTheme} - resulting theme
   */
function merge() {
  var original = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var mixin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  //make a copy to avoid mutations of nested objects
  //also strip all functions injected by isomorphic-style-loader
  var result = (0, _keys2.default)(original).reduce(function (acc, key) {
    var value = original[key];
    if (typeof value !== 'function') {
      acc[key] = value;
    }
    return acc;
  }, {});

  //traverse mixin keys and merge them to resulting theme
  (0, _keys2.default)(mixin).forEach(function (key) {
    //there's no need to set any defaults here
    var originalValue = result[key];
    var mixinValue = mixin[key];

    switch (typeof mixinValue === 'undefined' ? 'undefined' : _typeof(mixinValue)) {
      case 'object':
        {
          //possibly nested theme object
          switch (typeof originalValue === 'undefined' ? 'undefined' : _typeof(originalValue)) {
            case 'object':
              {
                //exactly nested theme object - go recursive
                result[key] = merge(originalValue, mixinValue);
                break;
              }

            case 'undefined':
              {
                //original does not contain this nested key - just take it as is
                result[key] = mixinValue;
                break;
              }

            default:
              {
                //can't merge an object with a non-object
                throw new Error('You are merging object ' + key + ' with a non-object ' + originalValue);
              }}

          break;
        }

      case 'undefined': //fallthrough - handles accidentally unset values which may come from props
      case 'function':
        {
          //this handles issue when isomorphic-style-loader addes helper functions to css-module
          break; //just skip
        }

      default:
        {
          //plain values
          switch (typeof originalValue === 'undefined' ? 'undefined' : _typeof(originalValue)) {
            case 'object':
              {
                //can't merge a non-object with an object
                throw new Error('You are merging non-object ' + mixinValue + ' with an object ' + key);
              }

            case 'undefined':
              {
                //mixin key is new to original theme - take it as is
                result[key] = mixinValue;
                break;
              }
            case 'function':
              {
                //this handles issue when isomorphic-style-loader addes helper functions to css-module
                break; //just skip
              }

            default:
              {
                //finally we can merge
                result[key] = originalValue.split(' ').concat(mixinValue.split(' ')).filter(function (item, pos, self) {
                  return self.indexOf(item) === pos && item !== '';
                }).join(' ');
                break;
              }}

          break;
        }}

  });

  return result;
}

/**
   * Validates compose option
   *
   * @param {String|Boolean} composeTheme - Compose them option
   * @throws
   * @returns {undefined}
   */
function validateComposeOption(composeTheme) {
  if ([COMPOSE_DEEPLY, COMPOSE_SOFTLY, DONT_COMPOSE].indexOf(composeTheme) === -1) {
    throw new Error('Invalid composeTheme option for react-css-themr. Valid composition options are ' + COMPOSE_DEEPLY + ', ' + COMPOSE_SOFTLY + ' and ' + DONT_COMPOSE + '. The given option was ' + composeTheme);
  }
}

/**
   * Removes namespace from key
   *
   * @param {String} key - Key
   * @param {String} themeNamespace - Theme namespace
   * @returns {String} - Key
   */
function removeNamespace(key, themeNamespace) {
  var capitalized = key.substr(themeNamespace.length);
  return capitalized.slice(0, 1).toLowerCase() + capitalized.slice(1);
}

/**
   * Maps props and theme to an object that will be used to pass down props to the
   * decorated component.
   *
   * @param {Object} ownProps - All props given to the decorated component
   * @param {Object} theme - Calculated then that should be passed down
   * @returns {Object} - Props that will be passed down to the decorated component
   */
function defaultMapThemrProps(ownProps, theme) {
  var composeTheme = ownProps.composeTheme,
  innerRef = ownProps.innerRef,
  themeNamespace = ownProps.themeNamespace,
  mapThemrProps = ownProps.mapThemrProps,
  rest = _objectWithoutProperties(ownProps, ['composeTheme', 'innerRef', 'themeNamespace', 'mapThemrProps']);

  return _extends({}, rest, {
    ref: innerRef,
    theme: theme });

}

/***/ }),

/***/ 1094:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var _getOwnPropertyNames = __webpack_require__(497);var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);var _getOwnPropertySymbols = __webpack_require__(248);var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true };


var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true };


var isGetOwnPropertySymbolsAvailable = typeof _getOwnPropertySymbols2.default === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') {// don't hoist over string (html) components
        var keys = (0, _getOwnPropertyNames2.default)(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat((0, _getOwnPropertySymbols2.default)(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};

/***/ }),

/***/ 1095:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
               * Use invariant() to assert state which your program assumes to be true.
               *
               * Provide sprintf-style format (only %s is supported) and arguments
               * to provide information about what broke and what you were
               * expecting.
               *
               * The invariant message will be stripped in production, but the invariant
               * will remain to ensure logic does not differ in production.
               */

var invariant = function invariant(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
      'Minified exception occurred; use the non-minified dev environment ' +
      'for the full error message and additional helpful warnings.');

    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
      format.replace(/%s/g, function () {return args[argIndex++];}));

      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;

/***/ }),

/***/ 1096:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _keys = __webpack_require__(85);var _keys2 = _interopRequireDefault2(_keys);var _getPrototypeOf = __webpack_require__(232);var _getPrototypeOf2 = _interopRequireDefault2(_getPrototypeOf);var _setPrototypeOf = __webpack_require__(493);var _setPrototypeOf2 = _interopRequireDefault2(_setPrototypeOf);var _create = __webpack_require__(222);var _create2 = _interopRequireDefault2(_create);var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault2(_typeof2);var _assign = __webpack_require__(77);var _assign2 = _interopRequireDefault2(_assign);var _defineProperty2 = __webpack_require__(161);var _defineProperty3 = _interopRequireDefault2(_defineProperty2);function _interopRequireDefault2(obj) {return obj && obj.__esModule ? obj : { default: obj };}

Object.defineProperty(exports, "__esModule", {
  value: true });


var _createClass = function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;(0, _defineProperty3.default)(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};}();

var _extends = _assign2.default || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};

var _react = __webpack_require__(171);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(967);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(658);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames2 = __webpack_require__(993);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactCssThemr = __webpack_require__(994);

var _dissoc = __webpack_require__(1097);

var _dissoc2 = _interopRequireDefault(_dissoc);

var _identifiers = __webpack_require__(995);

var _events = __webpack_require__(1098);

var _events2 = _interopRequireDefault(_events);

var _prefixer = __webpack_require__(1100);

var _prefixer2 = _interopRequireDefault(_prefixer);

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

function _defineProperty(obj, key, value) {if (key in obj) {(0, _defineProperty3.default)(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;}

function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));}subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;}

function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}

var defaults = {
  centered: false,
  className: '',
  multiple: true,
  passthrough: true,
  spread: 2,
  theme: {} };


var rippleFactory = function rippleFactory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _defaults$options = _extends({}, defaults, options),
  defaultCentered = _defaults$options.centered,
  defaultClassName = _defaults$options.className,
  defaultMultiple = _defaults$options.multiple,
  defaultPassthrough = _defaults$options.passthrough,
  defaultSpread = _defaults$options.spread,
  defaultTheme = _defaults$options.theme,
  props = _objectWithoutProperties(_defaults$options, ['centered', 'className', 'multiple', 'passthrough', 'spread', 'theme']);

  return function (ComposedComponent) {
    var RippledComponent = function (_Component) {
      _inherits(RippledComponent, _Component);

      function RippledComponent() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, RippledComponent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RippledComponent.__proto__ || (0, _getPrototypeOf2.default)(RippledComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
          ripples: {} },
        _this.rippleNodes = {}, _this.doRipple = function () {
          return !_this.props.disabled && _this.props.ripple;
        }, _this.handleMouseDown = function (event) {
          if (_this.props.onMouseDown) _this.props.onMouseDown(event);
          if (_this.doRipple()) {
            var _events$getMousePosit = _events2.default.getMousePosition(event),
            x = _events$getMousePosit.x,
            y = _events$getMousePosit.y;

            _this.animateRipple(x, y, false);
          }
        }, _this.handleTouchStart = function (event) {
          if (_this.props.onTouchStart) _this.props.onTouchStart(event);
          if (_this.doRipple()) {
            var _events$getTouchPosit = _events2.default.getTouchPosition(event),
            x = _events$getTouchPosit.x,
            y = _events$getTouchPosit.y;

            _this.animateRipple(x, y, true);
          }
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      _createClass(RippledComponent, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
          // If a new ripple was just added, add a remove event listener to its animation
          if ((0, _keys2.default)(prevState.ripples).length < (0, _keys2.default)(this.state.ripples).length) {
            this.addRippleRemoveEventListener(this.getLastKey());
          }
        } },
      {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          var _this2 = this;

          // Remove document event listeners for ripple if they still exists
          (0, _keys2.default)(this.state.ripples).forEach(function (key) {
            _this2.state.ripples[key].endRipple();
          });
        }

        /**
           * Find out a descriptor object for the ripple element being created depending on
           * the position where the it was triggered and the component's dimensions.
           *
           * @param {Number} x Coordinate x in the viewport where ripple was triggered
           * @param {Number} y Coordinate y in the viewport where ripple was triggered
           * @return {Object} Descriptor element including position and size of the element
           */ },

      {
        key: 'getDescriptor',
        value: function getDescriptor(x, y) {
          var _ReactDOM$findDOMNode = _reactDom2.default.findDOMNode(this).getBoundingClientRect(),
          left = _ReactDOM$findDOMNode.left,
          top = _ReactDOM$findDOMNode.top,
          height = _ReactDOM$findDOMNode.height,
          width = _ReactDOM$findDOMNode.width;

          var _props = this.props,
          centered = _props.rippleCentered,
          spread = _props.rippleSpread;

          return {
            left: centered ? 0 : x - left - width / 2,
            top: centered ? 0 : y - top - height / 2,
            width: width * spread };

        }

        /**
           * Increments and internal counter and returns the next value as a string. It
           * is used to assign key references to new ripple elements.
           *
           * @return {String} Key to be assigned to a ripple.
           */ },

      {
        key: 'getNextKey',
        value: function getNextKey() {
          this.currentCount = this.currentCount ? this.currentCount + 1 : 1;
          return 'ripple' + this.currentCount;
        }

        /**
           * Return the last generated key for a ripple element. When there is only one ripple
           * and to get the reference when a ripple was just created.
           *
           * @return {String} The last generated ripple key.
           */ },

      {
        key: 'getLastKey',
        value: function getLastKey() {
          return 'ripple' + this.currentCount;
        }

        /**
           * Variable to store the ripple references
           */ },

      {
        key: 'rippleShouldTrigger',


        /**
                                     * Determine if a ripple should start depending if its a touch event. For mobile both
                                     * touchStart and mouseDown are launched so in case is touch we should always trigger
                                     * but if its not we should check if a touch was already triggered to decide.
                                     *
                                     * @param {Boolean} isTouch True in case a touch event triggered the ripple false otherwise.
                                     * @return {Boolean} True in case the ripple should trigger or false if it shouldn't.
                                     */
        value: function rippleShouldTrigger(isTouch) {
          var shouldStart = isTouch ? true : !this.touchCache;
          this.touchCache = isTouch;
          return shouldStart;
        }

        /**
           * Start a ripple animation on an specific point with touch or mouse events. First
           * decides if the animation should trigger. If the ripple is multiple or there is no
           * ripple present, it creates a new key. If it's a simple ripple and already exists,
           * it just restarts the current ripple. The animation happens in two state changes
           * to allow triggering via css.
           *
           * @param {Number} x Coordinate X on the screen where animation should start
           * @param {Number} y Coordinate Y on the screen where animation should start
           * @param {Boolean} isTouch Use events from touch or mouse.
           */ },

      {
        key: 'animateRipple',
        value: function animateRipple(x, y, isTouch) {
          var _this3 = this;

          if (this.rippleShouldTrigger(isTouch)) {
            var _getDescriptor = this.getDescriptor(x, y),
            top = _getDescriptor.top,
            left = _getDescriptor.left,
            width = _getDescriptor.width;

            var noRipplesActive = (0, _keys2.default)(this.state.ripples).length === 0;
            var key = this.props.rippleMultiple || noRipplesActive ? this.getNextKey() : this.getLastKey();
            var endRipple = this.addRippleDeactivateEventListener(isTouch, key);
            var initialState = { active: false, restarting: true, top: top, left: left, width: width, endRipple: endRipple };
            var runningState = { active: true, restarting: false };
            var ripples = _extends({}, this.state.ripples, _defineProperty({}, key, initialState));
            this.setState({ ripples: ripples }, function () {
              if (_this3.rippleNodes[key]) _this3.rippleNodes[key].offsetWidth; // eslint-disable-line
              _this3.setState({ ripples: _extends({}, _this3.state.ripples, _defineProperty({}, key, (0, _assign2.default)({}, _this3.state.ripples[key], runningState))) });
            });
          }
        }

        /**
           * Add an event listener to the reference with given key so when the animation transition
           * ends we can be sure that it finished and it can be safely removed from the state.
           * This function is called whenever a new ripple is added to the component.
           *
           * @param {String} rippleKey Is the key of the ripple to add the event.
           */ },

      {
        key: 'addRippleRemoveEventListener',
        value: function addRippleRemoveEventListener(rippleKey) {
          var self = this;
          var rippleNode = this.rippleNodes[rippleKey];
          _events2.default.addEventListenerOnTransitionEnded(rippleNode, function onOpacityEnd(e) {
            if (e.propertyName === 'opacity') {
              if (self.props.onRippleEnded) self.props.onRippleEnded(e);
              _events2.default.removeEventListenerOnTransitionEnded(self.rippleNodes[rippleKey], onOpacityEnd);
              // self.rippleNodes = dissoc(rippleKey, self.rippleNodes);
              delete self.rippleNodes[rippleKey];
              self.setState({ ripples: (0, _dissoc2.default)(rippleKey, self.state.ripples) });
            }
          });
        }

        /**
           * Add an event listener to the document needed to deactivate a ripple and make it dissappear.
           * Deactivation can happen with a touchend or mouseup depending on the trigger type. The
           * ending function is created from a factory function and returned.
           *
           * @param {Boolean} isTouch True in case the trigger was a touch event false otherwise.
           * @param {String} rippleKey It's a key to identify the ripple that should be deactivated.
           * @return {Function} Callback function that deactivates the ripple and removes the listener
           */ },

      {
        key: 'addRippleDeactivateEventListener',
        value: function addRippleDeactivateEventListener(isTouch, rippleKey) {
          var eventType = isTouch ? 'touchend' : 'mouseup';
          var endRipple = this.createRippleDeactivateCallback(eventType, rippleKey);
          document.addEventListener(eventType, endRipple);
          return endRipple;
        }

        /**
           * Generates a function that can be called to deactivate a ripple and remove its finishing
           * event listener. If is generated because we need to store it to be called on unmount in case
           * the ripple is still running.
           *
           * @param {String} eventType Is the event type that can be touchend or mouseup
           * @param {String} rippleKey Is the key representing the ripple
           * @return {Function} Callback function that deactivates the ripple and removes the listener
           */ },

      {
        key: 'createRippleDeactivateCallback',
        value: function createRippleDeactivateCallback(eventType, rippleKey) {
          var self = this;
          return function endRipple() {
            document.removeEventListener(eventType, endRipple);
            self.setState({ ripples: _extends({}, self.state.ripples, _defineProperty({}, rippleKey, (0, _assign2.default)({}, self.state.ripples[rippleKey], { active: false }))) });
          };
        } },
      {
        key: 'renderRipple',
        value: function renderRipple(key, className, _ref2) {
          var _classnames,
          _this4 = this;

          var active = _ref2.active,
          left = _ref2.left,
          restarting = _ref2.restarting,
          top = _ref2.top,
          width = _ref2.width;

          var scale = restarting ? 0 : 1;
          var transform = 'translate3d(' + (-width / 2 + left) + 'px, ' + (-width / 2 + top) + 'px, 0) scale(' + scale + ')';
          var _className = (0, _classnames3.default)(this.props.theme.ripple, (_classnames = {}, _defineProperty(_classnames, this.props.theme.rippleActive, active), _defineProperty(_classnames, this.props.theme.rippleRestarting, restarting), _classnames), className);
          return _react2.default.createElement(
          'span',
          _extends({ key: key, 'data-react-toolbox': 'ripple', className: this.props.theme.rippleWrapper }, props),
          _react2.default.createElement('span', {
            className: _className,
            ref: function ref(node) {
              if (node) _this4.rippleNodes[key] = node;
            },
            style: (0, _prefixer2.default)({ transform: transform }, { width: width, height: width }) }));


        } },
      {
        key: 'render',
        value: function render() {
          var _this5 = this;

          var _props2 = this.props,
          children = _props2.children,
          disabled = _props2.disabled,
          ripple = _props2.ripple,
          onRippleEnded = _props2.onRippleEnded,
          rippleCentered = _props2.rippleCentered,
          rippleClassName = _props2.rippleClassName,
          rippleMultiple = _props2.rippleMultiple,
          rippleSpread = _props2.rippleSpread,
          theme = _props2.theme,
          other = _objectWithoutProperties(_props2, ['children', 'disabled', 'ripple', 'onRippleEnded', 'rippleCentered', 'rippleClassName', 'rippleMultiple', 'rippleSpread', 'theme']);

          var ripples = this.state.ripples;

          var childRipples = (0, _keys2.default)(ripples).map(function (key) {
            return _this5.renderRipple(key, rippleClassName, ripples[key]);
          });
          var childProps = _extends({
            onMouseDown: this.handleMouseDown,
            onTouchStart: this.handleTouchStart },
          other);
          var finalProps = defaultPassthrough ? _extends({}, childProps, { theme: theme, disabled: disabled }) : childProps;

          return !ripple ? _react2.default.createElement(ComposedComponent, finalProps, children) : _react2.default.createElement(ComposedComponent, finalProps, [children, childRipples]);
        } }]);


      return RippledComponent;
    }(_react.Component);

    RippledComponent.propTypes = {
      children: _propTypes2.default.node,
      disabled: _propTypes2.default.bool,
      onMouseDown: _propTypes2.default.func,
      onRippleEnded: _propTypes2.default.func,
      onTouchStart: _propTypes2.default.func,
      ripple: _propTypes2.default.bool,
      rippleCentered: _propTypes2.default.bool,
      rippleClassName: _propTypes2.default.string,
      rippleMultiple: _propTypes2.default.bool,
      rippleSpread: _propTypes2.default.number,
      theme: _propTypes2.default.shape({
        ripple: _propTypes2.default.string,
        rippleActive: _propTypes2.default.string,
        rippleRestarting: _propTypes2.default.string,
        rippleWrapper: _propTypes2.default.string }) };


    RippledComponent.defaultProps = {
      disabled: false,
      ripple: true,
      rippleCentered: defaultCentered,
      rippleClassName: defaultClassName,
      rippleMultiple: defaultMultiple,
      rippleSpread: defaultSpread };



    return (0, _reactCssThemr.themr)(_identifiers.RIPPLE, defaultTheme)(RippledComponent);
  };
};

exports.default = rippleFactory;

/***/ }),

/***/ 1097:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _curry2 = __webpack_require__(996);


/**
                                                           * Returns a new object that does not contain a `prop` property.
                                                           *
                                                           * @func
                                                           * @memberOf R
                                                           * @since v0.10.0
                                                           * @category Object
                                                           * @sig String -> {k: v} -> {k: v}
                                                           * @param {String} prop The name of the property to dissociate
                                                           * @param {Object} obj The object to clone
                                                           * @return {Object} A new object equivalent to the original but without the specified property
                                                           * @see R.assoc
                                                           * @example
                                                           *
                                                           *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
                                                           */
module.exports = _curry2(function dissoc(prop, obj) {
  var result = {};
  for (var p in obj) {
    result[p] = obj[p];
  }
  delete result[prop];
  return result;
});

/***/ }),

/***/ 1098:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _keys3 = __webpack_require__(85);var _keys4 = _interopRequireDefault2(_keys3);function _interopRequireDefault2(obj) {return obj && obj.__esModule ? obj : { default: obj };}

Object.defineProperty(exports, "__esModule", {
  value: true });


var _keys = __webpack_require__(1046);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

exports.default = {
  getMousePosition: function getMousePosition(event) {
    return {
      x: event.pageX - (window.scrollX || window.pageXOffset),
      y: event.pageY - (window.scrollY || window.pageYOffset) };

  },
  getTouchPosition: function getTouchPosition(event) {
    return {
      x: event.touches[0].pageX - (window.scrollX || window.pageXOffset),
      y: event.touches[0].pageY - (window.scrollY || window.pageYOffset) };

  },
  pauseEvent: function pauseEvent(event) {
    event.stopPropagation();
    event.preventDefault();
  },
  addEventsToDocument: function addEventsToDocument(eventMap) {
    (0, _keys4.default)(eventMap).forEach(function (key) {
      document.addEventListener(key, eventMap[key], false);
    });
  },
  removeEventsFromDocument: function removeEventsFromDocument(eventMap) {
    (0, _keys4.default)(eventMap).forEach(function (key) {
      document.removeEventListener(key, eventMap[key], false);
    });
  },
  targetIsDescendant: function targetIsDescendant(event, parent) {
    var node = event.target;
    while (node !== null) {
      if (node === parent) return true;
      node = node.parentNode;
    }
    return false;
  },
  addEventListenerOnTransitionEnded: function addEventListenerOnTransitionEnded(element, fn) {
    var eventName = transitionEventNamesFor(element);
    if (!eventName) return false;
    element.addEventListener(eventName, fn);
    return true;
  },
  removeEventListenerOnTransitionEnded: function removeEventListenerOnTransitionEnded(element, fn) {
    var eventName = transitionEventNamesFor(element);
    if (!eventName) return false;
    element.removeEventListener(eventName, fn);
    return true;
  } };



var TRANSITIONS = {
  transition: 'transitionend',
  OTransition: 'oTransitionEnd',
  MozTransition: 'transitionend',
  WebkitTransition: 'webkitTransitionEnd' };


function transitionEventNamesFor(element) {
  return (0, _keys2.default)(TRANSITIONS).reduce(function (result, transition) {
    return !result && element && element.style[transition] !== undefined ? TRANSITIONS[transition] : result;
  }, null);
}

/***/ }),

/***/ 1099:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _has = __webpack_require__(1047);


module.exports = function () {
  var toString = Object.prototype.toString;
  return toString.call(arguments) === '[object Arguments]' ?
  function _isArguments(x) {return toString.call(x) === '[object Arguments]';} :
  function _isArguments(x) {return _has('callee', x);};
}();

/***/ }),

/***/ 1100:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true });

var WEBKIT = 'Webkit';
var MICROSOFT = 'Ms';

var properties = {
  transform: [WEBKIT, MICROSOFT] };


function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.substr(1);
}

function getPrefixes(property, value) {
  return properties[property].reduce(function (acc, item) {
    acc['' + item + capitalize(property)] = value; // eslint-disable-line no-param-reassign
    return acc;
  }, {});
}

function addPrefixesTo(style, property, value) {
  var vendor = getPrefixes(property, value);
  for (var prefix in vendor) {
    // eslint-disable-line no-restricted-syntax
    if ({}.hasOwnProperty.call(vendor, prefix)) {
      style[prefix] = vendor[prefix]; // eslint-disable-line no-param-reassign
    }
  }

  return style;
}

function prefixer(style) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _style = defaultValue;
  for (var property in style) {
    // eslint-disable-line no-restricted-syntax
    if ({}.hasOwnProperty.call(style, property)) {
      _style[property] = style[property];
      if (properties[property]) {
        addPrefixesTo(_style, property, style[property]);
      }
    }
  }

  return _style;
}

exports.default = prefixer;

/***/ }),

/***/ 1101:
/***/ (function(module, exports, __webpack_require__) {


        // classnames-loader: automatically bind css-modules to classnames
        var classNames = __webpack_require__(492);
        var locals = __webpack_require__(1102);
        var css = classNames.bind(locals);
        for (var style in locals) css[style] = locals[style];
        module.exports = css;
    

/***/ }),

/***/ 1102:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(1103);

if (typeof content === 'string') {
  content = [[module.i, content, '']];
}

var options = {"attributes":{}}

options.insert = "head";
options.singleton = false;

var update = __webpack_require__(491)(content, options);

if (content.locals) {
  module.exports = content.locals;
}


/***/ }),

/***/ 1103:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(undefined);
// imports


// module
exports.push([module.i, "._3_Qn5sxW{pointer-events:auto;z-index:999}._3_Qn5sxW._2aM6Oc_3{background:tranparent}._3_Qn5sxW._2aM6Oc_3 ._2POSGfLq{-webkit-box-shadow:none;box-shadow:none}._3_Qn5sxW:not(._2aM6Oc_3){background:#fdfdfd}._3_Qn5sxW:not(._2aM6Oc_3) ._2POSGfLq{position:absolute;top:0;left:0;width:100%;height:100%;z-index:-1;-webkit-box-shadow:0 3px 10px #00000029 29;box-shadow:0 3px 10px 29 #00000029}.YFAtjaKt._3dWdeEkZ{position:fixed;left:50%;top:0}._3_Qn5sxW._3dWdeEkZ{-webkit-transform:translate(-50%);transform:translate(-50%)}.YFAtjaKt._3QWn448R{position:fixed;left:50%;top:50%}._3_Qn5sxW._3QWn448R{position:absolute;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.YFAtjaKt._1aRNT3MK{position:fixed;top:50%;width:510px;min-height:380px}.YFAtjaKt._1aRNT3MK:not(._2aM6Oc_3){left:50%}.YFAtjaKt._1aRNT3MK._2aM6Oc_3{left:0}._3_Qn5sxW._1aRNT3MK{position:absolute;width:600px;min-height:505px;border-radius:20px;padding:24px 0;-webkit-box-shadow:0 3px 10px rgba(0,0,0,.161);box-shadow:0 3px 10px rgba(0,0,0,.161);overflow:hidden}._3_Qn5sxW._1aRNT3MK:not(._2aM6Oc_3){-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}._3_Qn5sxW._1aRNT3MK._2aM6Oc_3{-webkit-transform:translateY(-50%);transform:translateY(-50%)}.YFAtjaKt.ypTXimJg{position:fixed;top:20%;width:90vw;min-height:90vh}.YFAtjaKt.ypTXimJg._2aM6Oc_3,.YFAtjaKt.ypTXimJg:not(._2aM6Oc_3){left:20%}._3_Qn5sxW.ypTXimJg{position:absolute;width:100%;min-height:100%;border-radius:20px;padding:24px 0;-webkit-box-shadow:0 3px 10px rgba(0,0,0,.161);box-shadow:0 3px 10px rgba(0,0,0,.161)}._3_Qn5sxW.ypTXimJg:not(._2aM6Oc_3){-webkit-transform:translate(-16%,-20%);transform:translate(-16%,-20%);overflow:hidden}._3_Qn5sxW.ypTXimJg._2aM6Oc_3{-webkit-transform:translateY(-50%);transform:translateY(-50%)}.YFAtjaKt._1oXRU2t3{position:fixed;top:50%;width:580px;min-height:380px}.YFAtjaKt._1oXRU2t3:not(._2aM6Oc_3){left:50%}.YFAtjaKt._1oXRU2t3._2aM6Oc_3{left:0}._3_Qn5sxW._1oXRU2t3{position:absolute;width:380px;min-height:380px}._3_Qn5sxW._1oXRU2t3:not(._2aM6Oc_3){-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}._3_Qn5sxW._1oXRU2t3._2aM6Oc_3{-webkit-transform:translateY(-50%);transform:translateY(-50%)}.YFAtjaKt.Sri22plQ{position:fixed;top:50%;width:580px;min-height:180px}.YFAtjaKt.Sri22plQ:not(._2aM6Oc_3){left:50%}.YFAtjaKt.Sri22plQ._2aM6Oc_3{left:0}._3_Qn5sxW.Sri22plQ{position:absolute;width:580px;min-height:180px;border-radius:20px;overflow:hidden}._3_Qn5sxW.Sri22plQ:not(._2aM6Oc_3){-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}._3_Qn5sxW.Sri22plQ._2aM6Oc_3{-webkit-transform:translateY(-50%);transform:translateY(-50%)}._2aGBwYfa{background-color:gray;background-color:rgba(0,0,0,.5);position:fixed;top:0;right:0;bottom:0;left:0;z-index:10}.YFAtjaKt.nOU1bfwu{position:fixed;width:360px;height:505px;right:20px;bottom:70px;border-radius:20px;overflow:hidden;padding:16px 0;-webkit-box-shadow:0 3px 10px rgba(0,0,0,.161);box-shadow:0 3px 10px rgba(0,0,0,.161);background:#fdfdfd}._3_Qn5sxW.nOU1bfwu{width:100%;height:100%;right:0;bottom:0}.YFAtjaKt._8FBIHzer{position:fixed;width:300px;height:80px;right:20px;bottom:430px}._3_Qn5sxW._8FBIHzer{width:300px;height:80px;right:0;bottom:0}.YFAtjaKt._2kteyC4C,.YFAtjaKt.AjxBPDYd{position:fixed;left:0;right:0;top:0;bottom:0;background-color:#c7c7c7;background-color:rgba(0,0,0,.22);z-index:1}._3_Qn5sxW._2kteyC4C,._3_Qn5sxW.AjxBPDYd{position:fixed;width:440px;left:calc(50% - 220px);top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);max-height:80vh}._2uiyF-Au._2kteyC4C,._2uiyF-Au.AjxBPDYd{padding:40px 40px 15px}._1uxo6-zn{visibility:hidden;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";opacity:0;z-index:0}._1QNujoi1{visibility:visible;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";opacity:1;z-index:100}", ""]);

// exports
exports.locals = {
	"component": "_3_Qn5sxW",
	"minimized": "_2aM6Oc_3",
	"shadow": "_2POSGfLq",
	"container": "YFAtjaKt",
	"top": "_3dWdeEkZ",
	"center": "_3QWn448R",
	"center2nd": "_1aRNT3MK",
	"maximized": "ypTXimJg",
	"smallscreen": "_1oXRU2t3",
	"smallsize1": "Sri22plQ",
	"backdrop": "_2aGBwYfa",
	"flyover": "nOU1bfwu",
	"flyover2": "_8FBIHzer",
	"add": "AjxBPDYd",
	"update": "_2kteyC4C",
	"content": "_2uiyF-Au",
	"wcag-invisible": "_1uxo6-zn",
	"wcag-visible": "_1QNujoi1"
};

/***/ }),

/***/ 1104:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(1105);

if (typeof content === 'string') {
  content = [[module.i, content, '']];
}

var options = {"attributes":{}}

options.insert = "head";
options.singleton = false;

var update = __webpack_require__(491)(content, options);

if (content.locals) {
  module.exports = content.locals;
}


/***/ }),

/***/ 1105:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(undefined);
// imports


// module
exports.push([module.i, "._3gULXcMk{top:6px;font-size:12px;line-height:14px;font-weight:700}._2UuKeIPG{display:block;width:100%;background-color:transparent;border:0;text-align:start}._2UuKeIPG div span span:first-child{margin:0 10px;height:10px;width:10px;border-radius:50%;display:inline-block;vertical-align:middle}._2UuKeIPG ._1ODIn7z4{display:inline-block}._2UuKeIPG i{float:right}._3N_vvIdM._1rHDqk0A{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";opacity:1}._3N_vvIdM{display:block;position:absolute;bottom:0;width:90%;border:1px solid #fff;border-radius:.25rem;z-index:9999;-webkit-box-shadow:0 1px 6px rgba(0,0,0,.12),0 1px 4px rgba(0,0,0,.24);box-shadow:0 1px 6px rgba(0,0,0,.12),0 1px 4px rgba(0,0,0,.24)}._3N_vvIdM ._3VNbVmXW{position:absolute;top:5px;right:10px}._3N_vvIdM .yr3q7odk{border-style:none}._3N_vvIdM ._2OT8PEDl{float:right}._3N_vvIdM>ul{list-style-type:none;-webkit-padding-start:0;-moz-padding-start:0;padding-inline-start:0;margin-bottom:0}._3N_vvIdM>ul li{height:29px;padding:0;margin:0;min-width:140px;background-color:#fff;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";opacity:1}._3N_vvIdM>ul li :hover{color:#000;background-color:#d3d3d3;background-color:rgba(33,33,33,.2)}._3N_vvIdM>ul li div span span:first-child{margin:0 10px;height:10px;width:10px;border-radius:50%;display:inline-block;vertical-align:middle}._3N_vvIdM>ul li :last-child{border-bottom:0 none}._1J7kP9Um{border:none}._1J7kP9Um ._3J2b8Szm{font-size:12px;line-height:14px;font-weight:700}._1J7kP9Um ._3DNveXQI ._1B0DEfGn,._1J7kP9Um ._3DNveXQI ._1EN_11uz,._1J7kP9Um ._3DNveXQI ._1pZLpa9W,._1J7kP9Um ._3DNveXQI ._2eHSYMVM,._1J7kP9Um ._3DNveXQI ._2l2n9ma8,._1J7kP9Um ._3DNveXQI ._2PQvPAgg,._1J7kP9Um ._3DNveXQI ._3BqN75Au,._1J7kP9Um ._3DNveXQI ._3iB-Nwsm,._1J7kP9Um ._3DNveXQI ._3Uk0u3Fb,._1J7kP9Um ._3DNveXQI ._3V5IrXDc,._1J7kP9Um ._3DNveXQI ._14lp-NuR,._1J7kP9Um ._3DNveXQI .GguxZeaP{padding:8px 5px;border-radius:4px;font-size:10px;letter-spacing:0;line-height:11px;font-weight:700;border:none;min-width:170px}._1J7kP9Um ._3DNveXQI ._1B0DEfGn,._1J7kP9Um ._3DNveXQI ._14lp-NuR{background:#e8e8e8;color:#414141}._1J7kP9Um ._3DNveXQI ._3BqN75Au,._1J7kP9Um ._3DNveXQI ._3V5IrXDc{background:#b7d6de;color:#005469}._1J7kP9Um ._3DNveXQI ._2l2n9ma8,._1J7kP9Um ._3DNveXQI ._2PQvPAgg{background:#d6d7eb;background:rgba(48,55,157,.2);color:#101676}._1J7kP9Um ._3DNveXQI ._3iB-Nwsm,._1J7kP9Um ._3DNveXQI .GguxZeaP{background:#f3ebcc;background:rgba(195,157,0,.2);color:#a26a00}._1J7kP9Um ._3DNveXQI ._1EN_11uz,._1J7kP9Um ._3DNveXQI ._2eHSYMVM{background:#ccf3e2;background:rgba(0,195,112,.2);color:#007e48}._1J7kP9Um ._3DNveXQI ._1pZLpa9W,._1J7kP9Um ._3DNveXQI ._3Uk0u3Fb{background:#feccd9;background:rgba(249,51,102,.25);color:#c4000b}._2qK-EeyJ{display:block;padding:0;margin:0!important;font-size:16px;color:#212121;background-color:transparent;border:0;border-bottom:1px solid rgba(0,0,0,.12);text-align:start}.b5TDwvzg._1rHDqk0A{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";opacity:1}.b5TDwvzg{display:block;background-color:#fff;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";opacity:0;z-index:9999;-webkit-transition-timing-function:cubic-bezier(.4,0,.2,1);transition-timing-function:cubic-bezier(.4,0,.2,1);-webkit-transition-duration:.35s;transition-duration:.35s;-webkit-transition-property:max-height,-webkit-box-shadow;transition-property:max-height,-webkit-box-shadow;transition-property:max-height,box-shadow;transition-property:max-height,box-shadow,-webkit-box-shadow;-webkit-box-shadow:0 3px 6px rgba(0,0,0,.161);box-shadow:0 3px 6px rgba(0,0,0,.161);z-index:1;position:absolute;right:40px;top:0;border-radius:4px;overflow:hidden}.b5TDwvzg ._2OT8PEDl{float:right}.b5TDwvzg>ul{list-style-type:none;-webkit-padding-start:0;-moz-padding-start:0;padding-inline-start:0;margin:0}.b5TDwvzg>ul li{position:relative;display:block;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:9px 16px;overflow:hidden;font-size:12px;color:#4b55f6;font-weight:700;text-transform:uppercase;line-height:18px;letter-spacing:1.2px;cursor:pointer}", ""]);

// exports
exports.locals = {
	"dropdown-label": "_3gULXcMk",
	"dropdown-button": "_2UuKeIPG",
	"button-div": "_1ODIn7z4",
	"dropdown": "_3N_vvIdM",
	"active": "_1rHDqk0A",
	"cancel-panel": "_3VNbVmXW",
	"cancel-panel-button": "yr3q7odk",
	"style-icon": "_2OT8PEDl",
	"dropdown-status": "_1J7kP9Um",
	"trigger": "_3J2b8Szm",
	"options-list": "_3DNveXQI",
	"status-1": "_14lp-NuR",
	"status-2": "_3V5IrXDc",
	"status-3": "_2l2n9ma8",
	"status-4": "_3iB-Nwsm",
	"status-5": "_1EN_11uz",
	"status-6": "_3Uk0u3Fb",
	"undefined1": "_1B0DEfGn",
	"undefined2": "_3BqN75Au",
	"undefined3": "_2PQvPAgg",
	"undefined4": "GguxZeaP",
	"undefined5": "_2eHSYMVM",
	"undefined6": "_1pZLpa9W",
	"mini-menu-button": "_2qK-EeyJ",
	"minimenu": "b5TDwvzg"
};

/***/ }),

/***/ 1106:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.NoteDetailsControl = exports.NoteDetailsNavigator = undefined;var _reselect = __webpack_require__(221);
var _selectors = __webpack_require__(78);
var _react = __webpack_require__(648);
var _date = __webpack_require__(987);
var _types = __webpack_require__(245);
var _resource = __webpack_require__(162);
var _categoryLabel = __webpack_require__(1049);var _categoryLabel2 = _interopRequireDefault(_categoryLabel);
var _selectors2 = __webpack_require__(1050);
var _resource2 = __webpack_require__(106);
var _miniMenu = __webpack_require__(1003);var _miniMenu2 = _interopRequireDefault(_miniMenu);
var _style = __webpack_require__(650);var _style2 = _interopRequireDefault(_style);
var _NOTES_TOGGLE_NOTEMENU = __webpack_require__(654);var _NOTES_TOGGLE_NOTEMENU2 = _interopRequireDefault(_NOTES_TOGGLE_NOTEMENU);
var _resource3 = __webpack_require__(494);
var _button = __webpack_require__(973);
var _resource4 = __webpack_require__(246);
var _resource5 = __webpack_require__(233);
var _resource6 = __webpack_require__(495);
var _editChat = __webpack_require__(1051);var _editChat2 = _interopRequireDefault(_editChat);
var _resource7 = __webpack_require__(223);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var lasttwochars = 2;
function reselect(fn) {
    return function (state) {return function (param) {return fn(param)(state);};};
}
function mapParticipantName(participantId, allparticipants) {
    var participant = allparticipants.qWhere(function (item) {return participantId === item.id;});
    return participant && participant.qAny() ? participant[0].name + ', ' : '';
}
function mapGroupName(groupId, allparticipantgroups) {
    var group = allparticipantgroups.qWhere(function (item) {return parseInt(groupId) === item.id;});
    return group && group.qAny() ? group[0].name + ', ' : '';
}
var notesEditorCategorySelector = (0, _reselect.createSelector)(reselect(_resource.categoriesResource.selectors.itemById), _resource2.notesEditor.selectors.item, function (itemById, item) {return item ? itemById(item.categoryId) : {} || {};});
var NoteDetailsNavigator = exports.NoteDetailsNavigator = (0, _react.PureConnect)('NoteDetailsNavigator')(function (state) {return {
        creating: _resource2.notesEditor.selectors.creating(state),
        updating: _resource2.notesEditor.selectors.updating(state),
        category: notesEditorCategorySelector(state),
        currentUser: _resource6.useridResource.selectors.items(state),
        allparticipants: _resource4.participantsResource.selectors.items(state).qSelect(function (item) {return item;}),
        allparticipantsgroups: _resource5.usergroupResource.selectors.items(state).qSelect(function (item) {return item;}),
        isMissing: _selectors.selectors.pageId(state) === _resource2.notesEditor.selectors.item(state).pageId && (0, _selectors2.isNoteMissing)(state, _resource2.notesEditor.selectors.item(state).id),
        itemNote: _resource2.notesEditor.selectors.item(state),
        itemSharedNote: _resource3.notesSharedEditor.selectors.item(state),
        itemQuestion: _resource7.questionsEditor.selectors.item(state),
        showMiniMenu: state.notesReducer.showMiniMenu };},
function (dispatch) {return {
        doDelete: function doDelete(item) {
            dispatch((0, _NOTES_TOGGLE_NOTEMENU2.default)({ showMiniMenu: false, itemMiniMenu: undefined }));
            dispatch(_resource2.notesEditor.actions.DELETE({ item: item }));
        },
        doEdit: function doEdit(item) {
            dispatch((0, _NOTES_TOGGLE_NOTEMENU2.default)({ showMiniMenu: false, itemMiniMenu: undefined }));
            dispatch(_resource2.notesEditor.actions.UPDATE({ item: item }));
        },
        toggleMiniMenu: function toggleMiniMenu(showMiniMenu, itemMiniMenu) {
            dispatch((0, _NOTES_TOGGLE_NOTEMENU2.default)({ showMiniMenu: showMiniMenu, itemMiniMenu: undefined }));
        },
        cancelNoteRead: function cancelNoteRead() {return dispatch(_resource2.notesEditor.actions.READ_CANCEL({}));},
        cancelSharedNoteRead: function cancelSharedNoteRead() {return dispatch(_resource3.notesSharedEditor.actions.READ_CANCEL({}));} };},
function (_ref) {var itemNote = _ref.itemNote,itemSharedNote = _ref.itemSharedNote,allparticipants = _ref.allparticipants,allparticipantsgroups = _ref.allparticipantsgroups,category = _ref.category,currentUser = _ref.currentUser,doEdit = _ref.doEdit,cancelNoteRead = _ref.cancelNoteRead,cancelSharedNoteRead = _ref.cancelSharedNoteRead,doDelete = _ref.doDelete,showMiniMenu = _ref.showMiniMenu,toggleMiniMenu = _ref.toggleMiniMenu;
    var item = itemSharedNote && !!(0, _types.isSharedNote)(itemSharedNote) ? itemSharedNote : itemNote;
    var toggle = function toggle() {
        showMiniMenu = !showMiniMenu;
        toggleMiniMenu(showMiniMenu, item);
    };
    var setMiniMenu = function setMiniMenu(showMenu) {
        toggleMiniMenu(showMenu, item);
    };
    var participantid = currentUser.length > 0 ?
    currentUser[0].id :
    '';
    var itms = [{
        name: 'Bewerken', iconName: 'edit', key: '1', functionitem: item, function: function _function(item) {return doEdit(item);} },

    {
        name: 'Verwijderen', iconName: 'delete', key: '2', functionitem: item, function: function _function(item) {return doDelete(item);} }];

    var sharedWithNoOne = !(item && item.noteParticipantsIDs && item.noteParticipantsIDs.length) &&
    !(item && item.noteParticipantGroupIDs && item.noteParticipantGroupIDs.length);
    return _react.React.createElement("div", { className: (0, _style2.default)('details', item.isquestion ? 'wcag-invisible' : '') },
    _react.React.createElement("section", { role: "contentinfo", "aria-label": 'Sluit sectie', className: (0, _style2.default)('content-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('button-container') },
    _react.React.createElement(_button.Btn, { type: "button", className: (0, _style2.default)('btn-icon-text_back', 'icon_arrow-back'), "aria-label": 'Terug gaan', "aria-haspopup": true, tabIndex: 0, onClick: function onClick() {setMiniMenu(false);!!(0, _types.isSharedNote)(itemSharedNote) ? cancelSharedNoteRead() : cancelNoteRead();}, disabled: false },
    _react.React.createElement("span", null, "Terug")),
    _react.React.createElement("div", { className: (0, _style2.default)('menu', participantid !== item.userId ? 'wcag-invisible' : '') },
    _react.React.createElement(_miniMenu2.default, { showMiniMenu: showMiniMenu, toggleMiniMenu: function toggleMiniMenu() {return toggle();}, items: itms })))),
    _react.React.createElement("section", { className: (0, _style2.default)('details-content-container', 'flyover') },
    _react.React.createElement("div", { className: (0, _style2.default)('details-top-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('details-title-container'), onClick: function onClick() {return setMiniMenu(false);} },
    _react.React.createElement("div", { className: (0, _style2.default)('icon-left-container') },
    _react.React.createElement("span", { className: (0, _style2.default)('icon-container', item.isquestion ? 'question' : 'message') })),
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container-top') }, item.isquestion ? 'TECHNISCHE VRAAG' : 'NOTITIE'),
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container-bottom') },
    _react.React.createElement(_date.DateTimeText, { date: item.created }))))),
    _react.React.createElement("div", { className: (0, _style2.default)('middle-container'), onClick: function onClick() {return setMiniMenu(false);} },
    _react.React.createElement("div", { className: (0, _style2.default)('made-by-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container-top') }, "Aangemaakt door"),
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container-bottom') }, mapParticipantName(item.userId, allparticipants))),
    _react.React.createElement("div", { className: (0, _style2.default)('category-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('category-container-top') }, "Categorie"),
    _react.React.createElement("div", { className: (0, _style2.default)('category-container-bottom') },
    _react.React.createElement(_categoryLabel2.default, { color: category && category.color ? category.color : '#efefef', name: category && category.name ? category.name : '' })))),
    sharedWithNoOne ? null :
    _react.React.createElement("div", { className: (0, _style2.default)('middle-shared-container'), onClick: function onClick() {return setMiniMenu(false);} },
    _react.React.createElement("div", { className: (0, _style2.default)('shared-with-label') }, "Gedeeld met"),
    _react.React.createElement("div", { className: (0, _style2.default)('list-of-shared') },
    item && item.noteParticipantsIDs && item.noteParticipantsIDs.length ?
    _react.React.createElement("div", { className: (0, _style2.default)('shared-div') },
    _react.React.createElement("span", { className: (0, _style2.default)('icon-shared') }),
    item.noteParticipantsIDs.map(function (itm) {return mapParticipantName(itm, allparticipants);}).join('').slice(0, -lasttwochars)) :
    null,
    item && item.noteParticipantGroupIDs && item.noteParticipantGroupIDs.length ?
    _react.React.createElement("div", { className: (0, _style2.default)('shared_multiple-div') },
    _react.React.createElement("span", { className: (0, _style2.default)('icon-shared_multiple') }),
    item.noteParticipantGroupIDs.map(function (itm) {return mapGroupName(itm, allparticipantsgroups);}).join('').slice(0, -lasttwochars)) :
    null)),
    _react.React.createElement("div", { className: (0, _style2.default)('bottom-container'), onClick: function onClick() {return setMiniMenu(false);} },
    _react.React.createElement("div", { className: (0, _style2.default)('note-label') }, "Notitie"),
    _react.React.createElement("span", { className: (0, _style2.default)('note-text') }, item.text)),
    _react.React.createElement(_editChat2.default, null)));
});
var NoteDetailsControl = exports.NoteDetailsControl = (0, _react.PureConnect)('NoteDetailsControl')(function (state) {return {
        category: notesEditorCategorySelector(state),
        allparticipants: _resource4.participantsResource.selectors.items(state).qSelect(function (item) {return item;}),
        allparticipantsgroups: _resource5.usergroupResource.selectors.items(state).qSelect(function (item) {return item;}),
        allQuestions: _resource7.questionsResource.selectors.items(state) };},
function (dispatch) {return {};}, function (_ref2) {var item = _ref2.item,itemQuestion = _ref2.itemQuestion,allQuestions = _ref2.allQuestions,allparticipants = _ref2.allparticipants,allparticipantsgroups = _ref2.allparticipantsgroups,category = _ref2.category,koppel = _ref2.koppel,ontkoppel = _ref2.ontkoppel;
    var sharedWithNoOne = !(item && item.noteParticipantsIDs && item.noteParticipantsIDs.length) &&
    !(item && item.noteParticipantGroupIDs && item.noteParticipantGroupIDs.length);
    return _react.React.createElement("div", { className: (0, _style2.default)('details') },
    _react.React.createElement("section", { role: "contentinfo", "aria-label": 'Sluit sectie', className: (0, _style2.default)('content-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('details-top-container'), tabIndex: 0 },
    _react.React.createElement("div", { className: (0, _style2.default)('details-title-container') },
    _react.React.createElement("span", { className: (0, _style2.default)('title-text-action') }, item.isquestion ? 'Technische vraag raadplegen' : 'Notitie raadplegen'),
    _react.React.createElement("div", { className: (0, _style2.default)('icon-left-container') },
    _react.React.createElement("span", { className: (0, _style2.default)('icon-container', item.isquestion ? 'question' : 'message') })),
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container-top') }, item.isquestion ? 'TECHNISCHE VRAAG' : 'NOTITIE'),
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container-bottom') },
    _react.React.createElement(_date.DateTimeText, { date: item.created })))))),
    _react.React.createElement("section", { className: (0, _style2.default)('details-content-container', 'modal') },
    _react.React.createElement("div", { className: (0, _style2.default)('middle-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('made-by-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container-top') }, "Aangemaakt door"),
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container-bottom') }, mapParticipantName(item.userId, allparticipants))),
    _react.React.createElement("div", { className: (0, _style2.default)('category-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('category-container-top') }, "Categorie"),
    _react.React.createElement("div", { className: (0, _style2.default)('category-container-bottom') },
    _react.React.createElement(_categoryLabel2.default, { color: category && category.color ? category.color : '#efefef', name: category && category.name ? category.name : '' })))),
    sharedWithNoOne ? null :
    _react.React.createElement("div", { className: (0, _style2.default)('middle-shared-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('shared-with-label') }, "Gedeeld met"),
    _react.React.createElement("div", { className: (0, _style2.default)('list-of-shared') },
    item && item.noteParticipantsIDs && item.noteParticipantsIDs.length ?
    _react.React.createElement("div", { className: (0, _style2.default)('shared-div') },
    _react.React.createElement("span", { className: (0, _style2.default)('icon-shared') }),
    item.noteParticipantsIDs.map(function (itm) {return mapParticipantName(itm.toString(), allparticipants);}).join('').slice(0, -lasttwochars)) :
    null,
    item && item.noteParticipantGroupIDs && item.noteParticipantGroupIDs.length ?
    _react.React.createElement("div", { className: (0, _style2.default)('shared_multiple-div') },
    _react.React.createElement("span", { className: (0, _style2.default)('icon-shared_multiple') }),
    item.noteParticipantGroupIDs.map(function (itm) {return mapGroupName(itm.toString(), allparticipantsgroups);}).join('').slice(0, -lasttwochars)) :
    null)),
    _react.React.createElement("div", { className: (0, _style2.default)('bottom-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('note-label') }, "Notitie"),
    _react.React.createElement("span", { className: (0, _style2.default)('note-text') }, item.text)),
    _react.React.createElement(_editChat2.default, null)));
});

/***/ }),

/***/ 1107:
/***/ (function(module, exports, __webpack_require__) {


        // classnames-loader: automatically bind css-modules to classnames
        var classNames = __webpack_require__(492);
        var locals = __webpack_require__(1108);
        var css = classNames.bind(locals);
        for (var style in locals) css[style] = locals[style];
        module.exports = css;
    

/***/ }),

/***/ 1108:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(1109);

if (typeof content === 'string') {
  content = [[module.i, content, '']];
}

var options = {"attributes":{}}

options.insert = "head";
options.singleton = false;

var update = __webpack_require__(491)(content, options);

if (content.locals) {
  module.exports = content.locals;
}


/***/ }),

/***/ 1109:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(undefined);
// imports


// module
exports.push([module.i, "._1TmDHBLk{margin-right:8px;height:18px;width:18px;border-radius:50%;display:inline-block;vertical-align:middle}._1TmDHBLk.JzgDOuFN{margin:0 15px;height:15px;width:15px}._2DPQFcfY :not(._2YVRQN3M) ._1TmDHBLk{vertical-align:middle;margin:0 .5em 0 0}._2DPQFcfY._2YVRQN3M ._1TmDHBLk{vertical-align:middle;margin:0 0 0 .5em}._2DPQFcfY .iCaZGdk2{vertical-align:middle}._2DPQFcfY._1_hYwOJK{font-weight:600;display:inline-block}.iCaZGdk2{color:#414141;line-height:16.8px;font-size:12px}", ""]);

// exports
exports.locals = {
	"color": "_1TmDHBLk",
	"big": "JzgDOuFN",
	"component": "_2DPQFcfY",
	"positionright": "_2YVRQN3M",
	"name": "iCaZGdk2",
	"bold": "_1_hYwOJK"
};

/***/ }),

/***/ 1110:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(1111);

if (typeof content === 'string') {
  content = [[module.i, content, '']];
}

var options = {"attributes":{}}

options.insert = "head";
options.singleton = false;

var update = __webpack_require__(491)(content, options);

if (content.locals) {
  module.exports = content.locals;
}


/***/ }),

/***/ 1111:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(undefined);
// imports


// module
exports.push([module.i, "._3yebNbot{display:block;margin-top:4px;padding-top:8px;border-top:1px solid rgba(65,65,65,.22)}._2bYXSfQ8{visibility:hidden;position:absolute;overflow:hidden;clip:rect(0 0 0 0);height:1px;width:1px;margin:-1px;padding:0;border:0}.jFWZC7V6{font-weight:300;color:#404040;color:rgba(0,0,0,.75)}._11atzVWI.-VMhWZV3,._11atzVWI._3jeb0uuS{padding:0 16px 16px}._11atzVWI.-VMhWZV3 title,._11atzVWI._3jeb0uuS title{display:block}._11atzVWI.-VMhWZV3 title .P_4z_PcS,._11atzVWI._3jeb0uuS title .P_4z_PcS{font-size:14px;line-height:18px;letter-spacing:.42px;color:#555;font-weight:700}._11atzVWI.-VMhWZV3 ._1W7uut7-,._11atzVWI._3jeb0uuS ._1W7uut7-{font-size:12px;line-height:16px;font-weight:700;color:#555}._11atzVWI.-VMhWZV3 ._1W7uut7- ._2JJBXiey,._11atzVWI._3jeb0uuS ._1W7uut7- ._2JJBXiey{color:#f36;line-height:20px;font-size:15px;font-weight:700}._11atzVWI ._3qgimi_h{margin-bottom:15px;position:relative}._11atzVWI ._3qgimi_h textarea{width:100%;display:block;padding:8px 30px 8px 16px;border:2px solid #e8e8e8;border-radius:4px;outline:none;font-family:Roboto,sans-serif;line-height:16.8px;min-height:80px}._11atzVWI ._3qgimi_h textarea:focus-visible{border-color:#4b55f6}._11atzVWI ._3qgimi_h textarea::-webkit-input-placeholder{font-style:italic;font-size:12px;line-height:16.8px;color:#a0a0a0;color:rgba(65,65,65,.5);position:relative;top:unset}._11atzVWI ._3qgimi_h textarea:-ms-input-placeholder{font-style:italic;font-size:12px;line-height:16.8px;color:#a0a0a0;color:rgba(65,65,65,.5);position:relative;top:unset}._11atzVWI ._3qgimi_h textarea::placeholder{font-style:italic;font-size:12px;line-height:16.8px;color:#a0a0a0;color:rgba(65,65,65,.5);position:relative;top:unset}._11atzVWI ._3qgimi_h>div>span:last-child{text-align:right;display:block;color:#414141;font-weight:400}._11atzVWI._1csgBxuh ._3qgimi_h textarea{padding:8px 16px}.utqvX58c{font-size:15px;line-height:18px;font-weight:700;margin-bottom:9px}._2WmJRpxy,.utqvX58c{display:block}._3-FKJ_xE{position:absolute!important;top:50%;right:15px;border:none;background:transparent;-webkit-transform:translateY(-50%);transform:translateY(-50%)}._3-FKJ_xE span{background:none!important}._1VH2cvfG{border:1px solid blue;position:relative;height:67px;font-size:xx-small}._1VH2cvfG ._2Jwab2N9 .QJKQCQW7{background:#e8e8e8;display:block;width:21px;height:21px;border-radius:50%;padding:2px;margin:0 auto;float:left}._1VH2cvfG ._2Jwab2N9 .QJKQCQW7:after{font-size:16px;color:#414141;font-family:Material Icons;content:\"\\E7FD\"}._11xWg61A{margin:0 16px}._11xWg61A button:first-child span{border-color:transparent}._11xWg61A button:first-child:hover span{border-color:#4b55f6}._11xWg61A button:last-child{float:right}._2of7yWbh{position:absolute;bottom:0;width:100%;left:0;right:0;-webkit-box-shadow:0 -7px 8px rgba(0,0,0,.1);box-shadow:0 -7px 8px rgba(0,0,0,.1);padding-top:15px;background:#fff;height:67px}._2of7yWbh._1bdyfgnA{position:relative}", ""]);

// exports
exports.locals = {
	"notechat-dit-list-container": "_3yebNbot",
	"wcag-invisible": "_2bYXSfQ8",
	"header": "jFWZC7V6",
	"notechat-container": "_11atzVWI",
	"flyover": "_3jeb0uuS",
	"modal": "-VMhWZV3",
	"title-text": "P_4z_PcS",
	"sub-title-chat": "_1W7uut7-",
	"important-icon": "_2JJBXiey",
	"input-text-chat": "_3qgimi_h",
	"edit-note": "_1csgBxuh",
	"input-label": "utqvX58c",
	"input-text-chat-area": "_2WmJRpxy",
	"span-button-icon-send": "_3-FKJ_xE",
	"chat-attached": "_1VH2cvfG",
	"top-container": "_2Jwab2N9",
	"icon-shared": "QJKQCQW7",
	"buttons-container": "_11xWg61A",
	"bottom-buttons": "_2of7yWbh",
	"not-absolute": "_1bdyfgnA"
};

/***/ }),

/***/ 1112:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.DataListChat = undefined;var _react = __webpack_require__(648);
var _dataitemchat = __webpack_require__(1053);var _dataitemchat2 = _interopRequireDefault(_dataitemchat);
var _resource = __webpack_require__(517);
var _style = __webpack_require__(1116);var _style2 = _interopRequireDefault(_style);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var DataListChat = exports.DataListChat = (0, _react.PureFunctional)('DataListChat')(function (_ref) {var items = _ref.items,participants = _ref.participants,noteId = _ref.noteId,flyoverVisible = _ref.flyoverVisible;
    return _react.React.createElement("div", { className: (0, _style2.default)('data-list-chat', flyoverVisible ? 'flyover-chat-list' : 'modal-chat-list') },
    _react.React.createElement("ul", { className: (0, _style2.default)('data-list-chat-container'), tabIndex: -1 }, items.qWhere(function (itm) {return itm.noteId === noteId && !itm.attached;}).
    sort(function (a, b) {return a.created < b.created ? 1 : -1;}).
    qSelect(function (item) {return _react.React.createElement(_dataitemchat2.default, { key: _resource.notechatResource.fields.key(item).toString(), flyoverVisible: flyoverVisible, item: item, participant: participants.qWhere(function (i) {return i.id === item.userId;}).qFirst() });})));
});

/***/ }),

/***/ 1113:
/***/ (function(module, exports, __webpack_require__) {


        // classnames-loader: automatically bind css-modules to classnames
        var classNames = __webpack_require__(492);
        var locals = __webpack_require__(1114);
        var css = classNames.bind(locals);
        for (var style in locals) css[style] = locals[style];
        module.exports = css;
    

/***/ }),

/***/ 1114:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(1115);

if (typeof content === 'string') {
  content = [[module.i, content, '']];
}

var options = {"attributes":{}}

options.insert = "head";
options.singleton = false;

var update = __webpack_require__(491)(content, options);

if (content.locals) {
  module.exports = content.locals;
}


/***/ }),

/***/ 1115:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(undefined);
// imports


// module
exports.push([module.i, "._2ctaPXag,._2FDRYsX0{position:relative;font-size:12px;white-space:normal;line-height:16.8px}._2ctaPXag,.jWUw6raM{padding-bottom:5px}.jWUw6raM{border-bottom:1px solid rgba(65,65,65,.22);margin-bottom:5px}._3lDVwr9a{display:grid;display:-ms-grid;grid-template-columns:21px 1fr 30px;-ms-grid-columns:21px 1fr 30px;grid-template-rows:auto 100%;-ms-grid-rows:auto 100%;row-gap:4px;-webkit-column-gap:5px;column-gap:5px}._3lDVwr9a ._1BN9lOTl{grid-column:1;-ms-grid-column:1;height:21px}._3lDVwr9a ._1BN9lOTl ._2JrLWo4F{background:#e8e8e8;display:block;width:21px;height:21px;border-radius:50%;padding:0 2px;margin:0 auto}._3lDVwr9a ._1BN9lOTl ._2JrLWo4F:after{font-size:16px;color:#414141;font-family:Material Icons;content:\"\\E7FD\";position:relative;top:2px}._3lDVwr9a ._6kSrOxjD{grid-column:2;-ms-grid-column:2;line-height:2}._3lDVwr9a ._6kSrOxjD ._1HW4pAf6{font-size:12px;line-height:16px;color:#555;font-weight:400}._3lDVwr9a ._3qOy041e{grid-column:3;-ms-grid-column:3;height:21px}._3lDVwr9a ._3qOy041e>div{display:inline-block;width:100%;height:100%}._3lDVwr9a ._3qOy041e button{width:30px;height:30px;top:-5px;background:transparent}._3lDVwr9a ._3qOy041e button span{padding:0;width:100%;height:100%}._2FDRYsX0{display:grid;display:-ms-grid;grid-template-rows:auto auto;grid-template-columns:100%;-ms-grid-rows:auto auto;row-gap:4px;background:#f1f1fe;background:rgba(75,85,246,.08);border-radius:8px;padding:8px;margin-bottom:8px}._2FDRYsX0 ._2LNvYNV0{display:grid;display:-ms-grid;grid-template-rows:21px auto;-ms-grid-rows:21px auto;grid-template-columns:21px 1fr 30px;-ms-grid-columns:21px 1fr 30px;-webkit-column-gap:8px;column-gap:8px;row-gap:6px}._2FDRYsX0 ._2LNvYNV0 .hpYMvCne{display:grid;display:-ms-grid;grid-row:1;-ms-grid-row:1;grid-column:1/4;-ms-grid-column:1;-ms-grid-column-span:3;grid-template-columns:1fr 30px;-ms-grid-columns:1fr 30px;grid-template-rows:21px;-ms-grid-rows:21px}._2FDRYsX0 ._2LNvYNV0 .hpYMvCne .tzGyByJQ{grid-column:1;-ms-grid-column:1;font-weight:700}._2FDRYsX0 ._2LNvYNV0 .hpYMvCne ._3qOy041e{grid-column:2;-ms-grid-column:2}._2FDRYsX0 ._2LNvYNV0 .hpYMvCne ._3qOy041e>div{display:inline-block;width:100%;height:100%}._2FDRYsX0 ._2LNvYNV0 .hpYMvCne ._3qOy041e button{width:30px;height:30px;top:-2px;background:transparent}._2FDRYsX0 ._2LNvYNV0 .hpYMvCne ._3qOy041e button span{padding:0;width:100%;height:100%}._2FDRYsX0 ._2LNvYNV0 .hpYMvCne ._3qOy041e button:hover{background:#fff}._2FDRYsX0 ._2LNvYNV0 ._1BN9lOTl{grid-row:2;-ms-grid-row:2;grid-column:1;-ms-grid-column:1}._2FDRYsX0 ._2LNvYNV0 ._1BN9lOTl ._2JrLWo4F{background:#e8e8e8;display:block;width:21px;height:21px;border-radius:50%;padding:0 2px;margin:0 auto}._2FDRYsX0 ._2LNvYNV0 ._1BN9lOTl ._2JrLWo4F:after{font-size:16px;color:#414141;font-family:Material Icons;content:\"\\E7FD\";position:relative;top:1px;left:1px}._2FDRYsX0 ._2LNvYNV0 ._6kSrOxjD{grid-row:2;-ms-grid-row:2;grid-column:2/4;-ms-grid-column:2;-ms-grid-column-span:2}._2FDRYsX0 ._1f7pyvmq .UwKZ1JkZ{display:inline-block;max-width:100%;overflow:hidden;text-overflow:ellipsis}._1-BC23B0 ._3lDVwr9a ._1BN9lOTl ._2JrLWo4F:after{left:1px}._1YZMnZ0V{grid-row:2;-ms-grid-row:2;padding-right:20px}._1YZMnZ0V .UwKZ1JkZ{line-height:16.8px;font-size:12px;white-space:normal;width:100%;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports
exports.locals = {
	"data-item-chat": "_2ctaPXag",
	"data-item-chat-attached": "_2FDRYsX0",
	"data-item-outer-container": "jWUw6raM",
	"top-container": "_3lDVwr9a",
	"icon-container": "_1BN9lOTl",
	"icon-shared": "_2JrLWo4F",
	"info_container": "_6kSrOxjD",
	"autho-name": "_1HW4pAf6",
	"button-container": "_3qOy041e",
	"attached-top-container": "_2LNvYNV0",
	"attached-info-container": "hpYMvCne",
	"attached-title": "tzGyByJQ",
	"attached-bottom-container": "_1f7pyvmq",
	"text-container_main": "UwKZ1JkZ",
	"modal-chat-item": "_1-BC23B0",
	"bottom-container": "_1YZMnZ0V"
};

/***/ }),

/***/ 1116:
/***/ (function(module, exports, __webpack_require__) {


        // classnames-loader: automatically bind css-modules to classnames
        var classNames = __webpack_require__(492);
        var locals = __webpack_require__(1117);
        var css = classNames.bind(locals);
        for (var style in locals) css[style] = locals[style];
        module.exports = css;
    

/***/ }),

/***/ 1117:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(1118);

if (typeof content === 'string') {
  content = [[module.i, content, '']];
}

var options = {"attributes":{}}

options.insert = "head";
options.singleton = false;

var update = __webpack_require__(491)(content, options);

if (content.locals) {
  module.exports = content.locals;
}


/***/ }),

/***/ 1118:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(undefined);
// imports


// module
exports.push([module.i, "._2MKR0zwd{list-style:none;padding-left:0}._1tNDH3EN{padding:4px 0;margin:0;display:inline-block;width:100%}._1fWMwfpt ._3oMUVxkD{height:80px;display:inline-block;width:100%;background-size:contain;background-repeat:no-repeat}", ""]);

// exports
exports.locals = {
	"data-list-chat-container": "_2MKR0zwd",
	"data-list-chat-data-list-chat-container": "_1tNDH3EN",
	"no-items-container": "_1fWMwfpt",
	"img-container": "_3oMUVxkD"
};

/***/ }),

/***/ 1119:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.QuestionDetailsControl = exports.QuestionDetailsNavigator = undefined;var _selectors = __webpack_require__(78);
var _react = __webpack_require__(648);
var _date = __webpack_require__(987);
var _types = __webpack_require__(245);
var _resource = __webpack_require__(106);
var _miniMenu = __webpack_require__(1003);var _miniMenu2 = _interopRequireDefault(_miniMenu);
var _style = __webpack_require__(1004);var _style2 = _interopRequireDefault(_style);
var _button = __webpack_require__(973);
var _resource2 = __webpack_require__(246);
var _resource3 = __webpack_require__(233);
var _editChat = __webpack_require__(1051);var _editChat2 = _interopRequireDefault(_editChat);
var _resource4 = __webpack_require__(223);
var _resource5 = __webpack_require__(495);
var _selectors2 = __webpack_require__(1050);
var _resource6 = __webpack_require__(494);
var _NOTES_TOGGLE_NOTEMENU = __webpack_require__(654);var _NOTES_TOGGLE_NOTEMENU2 = _interopRequireDefault(_NOTES_TOGGLE_NOTEMENU);
var _authcheck = __webpack_require__(518);
var _resource7 = __webpack_require__(517);
var _resource8 = __webpack_require__(234);
var _QUESTION_MAXIMIZE = __webpack_require__(657);var _QUESTION_MAXIMIZE2 = _interopRequireDefault(_QUESTION_MAXIMIZE);
var _selectors3 = __webpack_require__(986);var _selectors4 = _interopRequireDefault(_selectors3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
function mapParticipantName(participantId, allparticipants) {
    var participant = allparticipants.qWhere(function (item) {return participantId === item.id;});
    return participant && participant.qAny() ? participant[0].name + ', ' : '';
}
var QuestionDetailsNavigator = exports.QuestionDetailsNavigator = (0, _react.PureConnect)('QuestionDetailsNavigator')(function (state) {return {
        creating: _resource.notesEditor.selectors.creating(state),
        updating: _resource.notesEditor.selectors.updating(state),
        currentUser: _resource5.useridResource.selectors.items(state),
        usergroups: _resource3.usergroupResource.selectors.items(state),
        allparticipants: _resource2.participantsResource.selectors.items(state).qSelect(function (item) {return item;}),
        allparticipantsgroups: _resource3.usergroupResource.selectors.items(state).qSelect(function (item) {return item;}),
        isMissing: _selectors.selectors.pageId(state) === _resource.notesEditor.selectors.item(state).pageId && (0, _selectors2.isNoteMissing)(state, _resource.notesEditor.selectors.item(state).id),
        itemNote: _resource.notesEditor.selectors.item(state),
        itemSharedNote: _resource6.notesSharedEditor.selectors.item(state),
        itemQuestion: _resource4.questionsEditor.selectors.item(state),
        allChats: _resource7.notechatResource.selectors.items(state),
        showMiniMenu: state.notesReducer.showMiniMenu,
        beheer: _resource8.beheerResource.selectors.items(state) };},
function (dispatch) {return {
        doDelete: function doDelete(item) {
            dispatch((0, _NOTES_TOGGLE_NOTEMENU2.default)({ showMiniMenu: false, itemMiniMenu: undefined }));
            dispatch(_resource.notesEditor.actions.DELETE({ item: item }));
        },
        doEdit: function doEdit(item) {
            dispatch((0, _NOTES_TOGGLE_NOTEMENU2.default)({ showMiniMenu: false, itemMiniMenu: undefined }));
            dispatch(_resource.notesEditor.actions.UPDATE({ item: item }));
        },
        toggleMiniMenu: function toggleMiniMenu(showMiniMenu, itemMiniMenu) {
            dispatch((0, _NOTES_TOGGLE_NOTEMENU2.default)({ showMiniMenu: showMiniMenu, itemMiniMenu: undefined }));
        },
        cancelNoteRead: function cancelNoteRead() {return dispatch(_resource.notesEditor.actions.READ_CANCEL({}));},
        cancelSharedNoteRead: function cancelSharedNoteRead() {return dispatch(_resource6.notesSharedEditor.actions.READ_CANCEL({}));} };},
function (_ref) {var itemNote = _ref.itemNote,itemSharedNote = _ref.itemSharedNote,itemQuestion = _ref.itemQuestion,allChats = _ref.allChats,allparticipants = _ref.allparticipants,allparticipantsgroups = _ref.allparticipantsgroups,usergroups = _ref.usergroups,currentUser = _ref.currentUser,doEdit = _ref.doEdit,cancelNoteRead = _ref.cancelNoteRead,cancelSharedNoteRead = _ref.cancelSharedNoteRead,doDelete = _ref.doDelete,showMiniMenu = _ref.showMiniMenu,toggleMiniMenu = _ref.toggleMiniMenu,beheer = _ref.beheer;
    var item = itemSharedNote && !!(0, _types.isSharedNote)(itemSharedNote) ? itemSharedNote : itemNote;
    var toggle = function toggle() {
        showMiniMenu = !showMiniMenu;
        toggleMiniMenu(showMiniMenu, item);
    };
    var setMiniMenu = function setMiniMenu(showMenu) {
        toggleMiniMenu(showMenu, item);
    };
    var currentUserId = currentUser.length > 0 ? currentUser[0].id : '';
    var admin = beheer && beheer.qAny() && beheer.qFirst();
    var status = _authcheck.statusNieuw;
    var canChange = false;
    if (itemQuestion) {
        status = itemQuestion.status ? itemQuestion.status : _authcheck.statusNieuw;
        canChange = !!itemQuestion && (0, _authcheck.canChangeQuestion)(_authcheck.statusses, status, currentUserId, usergroups, admin);
    }
    var disableDelete = (allChats ? allChats.qWhere(function (itm) {return itemQuestion.id === itm.noteId && itm.userId !== currentUserId;}).qAny() : false) ||
    itemNote && itemNote.userId !== currentUserId ||
    itemQuestion && itemQuestion.status && itemQuestion.status > _authcheck.statusNieuw;
    var itms = canChange && !disableDelete ?
    [{
        name: 'Bewerken', iconName: 'edit', key: '1', functionitem: item, function: function _function(item) {return doEdit(item);} },

    {
        name: 'Verwijderen', iconName: 'delete', key: '2', functionitem: item, function: function _function(item) {return doDelete(item);} }] :
    !disableDelete ?
    [
    {
        name: 'Verwijderen', iconName: 'delete', key: '2', functionitem: item, function: function _function(item) {return doDelete(item);} }] :

    canChange ?
    [{
        name: 'Bewerken', iconName: 'edit', key: '1', functionitem: item, function: function _function(item) {return doEdit(item);} }] :
    null;
    var status = itemQuestion && itemQuestion.status ? itemQuestion.status : _authcheck.statusNieuw;
    return _react.React.createElement("div", { className: (0, _style2.default)('details', item.isquestion ? '' : 'wcag-invisible') },
    _react.React.createElement("section", { role: "contentinfo", "aria-label": 'Sluit sectie', className: (0, _style2.default)('content-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('button-container') },
    _react.React.createElement(_button.Btn, { type: "button", className: (0, _style2.default)('btn-icon-text_back', 'icon_arrow-back'), "aria-label": 'Terug gaan', "aria-haspopup": true, tabIndex: 0, onClick: function onClick() {setMiniMenu(false);!!(0, _types.isSharedNote)(itemSharedNote) ? cancelSharedNoteRead() : cancelNoteRead();}, disabled: false },
    _react.React.createElement("span", null, "Terug")),
    _react.React.createElement("div", { className: (0, _style2.default)('menu', itms && itms.length ? '' : 'wcag-invisible') },
    _react.React.createElement(_miniMenu2.default, { showMiniMenu: showMiniMenu, toggleMiniMenu: function toggleMiniMenu() {return toggle();}, items: itms })))),
    _react.React.createElement("section", { className: (0, _style2.default)('details-content-container', 'flyover') },
    _react.React.createElement("div", { className: (0, _style2.default)('details-top-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('details-title-container'), onClick: function onClick() {return setMiniMenu(false);} },
    _react.React.createElement("div", { className: (0, _style2.default)('icon-left-container') },
    _react.React.createElement("span", { className: (0, _style2.default)('icon-container', item.isquestion ? 'question' : 'message') })),
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container-top') }, item.isquestion ? 'TECHNISCHE VRAAG' : 'NOTITIE'),
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container-bottom') },
    _react.React.createElement(_date.DateTimeText, { date: item.created }))))),
    _react.React.createElement("div", { className: (0, _style2.default)('middle-container'), onClick: function onClick() {return setMiniMenu(false);} },
    _react.React.createElement("div", { className: (0, _style2.default)('made-by-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container-top') }, "Aangemaakt door"),
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container-bottom') }, mapParticipantName(item.userId, allparticipants))),
    _react.React.createElement("div", { className: (0, _style2.default)('status-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('status-container-top') }, "Status"),
    _react.React.createElement("div", { id: 'id-ref-' + item.id, className: (0, _style2.default)('status-list', 'status' + status.toString()) },
    _react.React.createElement("span", { className: (0, _style2.default)('status-list-text') }, (0, _authcheck.getStatusString)(status)))),
    _react.React.createElement("div", { className: (0, _style2.default)('practicioner-container', !(0, _authcheck.showPracticionerViewModus)(status) ? 'wcag-invisible' : '') },
    _react.React.createElement("div", { className: (0, _style2.default)('practicioner-container-top') }, "Behandelaar"),
    _react.React.createElement("div", { id: 'id-ref-beh-' + item.id, className: (0, _style2.default)('cls-practicioner') },
    _react.React.createElement("span", { className: (0, _style2.default)('practicioner-text') }, (0, _authcheck.getPracticioner)(allparticipants, itemQuestion.practicionerId))))),
    (0, _authcheck.showFaction)(status, item.userId, currentUserId, allparticipantsgroups) ?
    _react.React.createElement("div", { className: (0, _style2.default)('middle-shared-container'), onClick: function onClick() {return setMiniMenu(false);} },
    _react.React.createElement("div", { className: (0, _style2.default)('shared-with-label') }, "Fractie"),
    _react.React.createElement("div", { className: (0, _style2.default)('list-of-shared') }, (0, _authcheck.factionOfNote)(item, allparticipantsgroups))) :
    null,
    _react.React.createElement("div", { className: (0, _style2.default)('bottom-container'), onClick: function onClick() {return setMiniMenu(false);} },
    _react.React.createElement("div", { className: (0, _style2.default)('note-label') }, "Vraag"),
    _react.React.createElement("span", { className: (0, _style2.default)('note-text') }, item.text)),
    _react.React.createElement("div", { className: (0, _style2.default)('bottom-answer-container', !(0, _authcheck.showAnswer)(status, currentUserId, usergroups) ? 'wcag-invisible' : '') },
    _react.React.createElement("div", { className: (0, _style2.default)('answer-label') }, "Antwoord vanuit Concern"),
    _react.React.createElement("span", { className: (0, _style2.default)('answer-text') }, itemQuestion.antwoordConcern)),
    _react.React.createElement(_editChat2.default, null)));
});
var QuestionDetailsControl = exports.QuestionDetailsControl = (0, _react.PureConnect)('NoteDetailsControl')(function (state) {return {
        currentUser: _resource5.useridResource.selectors.items(state),
        usergroups: _resource3.usergroupResource.selectors.items(state),
        allparticipants: _resource2.participantsResource.selectors.items(state).qSelect(function (item) {return item;}),
        allparticipantsgroups: _resource3.usergroupResource.selectors.items(state).qSelect(function (item) {return item;}),
        ismaximized: _selectors4.default.ismaximized(state) };},
function (dispatch) {return {
        maximize: function maximize(maximized) {return dispatch((0, _QUESTION_MAXIMIZE2.default)({ maximized: maximized }));} };},
function (_ref2) {var item = _ref2.item,itemQuestion = _ref2.itemQuestion,currentUser = _ref2.currentUser,usergroups = _ref2.usergroups,allparticipants = _ref2.allparticipants,allparticipantsgroups = _ref2.allparticipantsgroups,ismaximized = _ref2.ismaximized,maximize = _ref2.maximize;
    var status = itemQuestion && itemQuestion.status ? itemQuestion.status : _authcheck.statusNieuw;
    var currentUserId = currentUser.length > 0 ? currentUser[0].id : '';
    return _react.React.createElement("div", { className: (0, _style2.default)('details') },
    _react.React.createElement("section", { role: "contentinfo", "aria-label": 'Sluit sectie', className: (0, _style2.default)('content-container') },
    _react.React.createElement("span", { className: (0, _style2.default)('expand_button-container') },
    _react.React.createElement("button", { type: "button", className: (0, _style2.default)('btn', 'icon-btn', !ismaximized ? 'expand' : 'collapse'), onClick: function onClick() {maximize(!ismaximized);} },
    _react.React.createElement("span", { className: (0, _style2.default)('arrow-expand-icon') }))),
    _react.React.createElement("div", { className: (0, _style2.default)('details-top-container'), tabIndex: 0 },
    _react.React.createElement("div", { className: (0, _style2.default)('details-title-container') },
    _react.React.createElement("span", { className: (0, _style2.default)('title-text-action') }, 'Technische vraag raadplegen'),
    _react.React.createElement("div", { className: (0, _style2.default)('icon-left-container') },
    _react.React.createElement("span", { className: (0, _style2.default)('icon-container', 'question') })),
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container-top') }, item.isquestion ? 'TECHNISCHE VRAAG' : 'NOTITIE'),
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container-bottom') },
    _react.React.createElement(_date.DateTimeText, { date: item.created })))))),
    _react.React.createElement("section", { className: (0, _style2.default)('details-content-container', 'modal', !ismaximized ? 'normal' : 'maximized') },
    _react.React.createElement("div", { className: (0, _style2.default)('middle-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('made-by-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container-top') }, "Aangemaakt door"),
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container-bottom') },
    _react.React.createElement("span", { className: (0, _style2.default)('created-text') }, mapParticipantName(item.userId, allparticipants)))),
    _react.React.createElement("div", { className: (0, _style2.default)('status-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('status-container-top') }, "Status"),
    _react.React.createElement("div", { id: 'id-ref-' + item.id, className: (0, _style2.default)('status-list', 'status' + status.toString()) },
    _react.React.createElement("span", { className: (0, _style2.default)('status-list-text') }, (0, _authcheck.getStatusString)(status)))),
    _react.React.createElement("div", { className: (0, _style2.default)('practicioner-container', !(0, _authcheck.showPracticionerViewModus)(status) ? 'wcag-invisible' : '') },
    _react.React.createElement("div", { className: (0, _style2.default)('practicioner-container-top') }, "Behandelaar"),
    _react.React.createElement("div", { id: 'id-ref-beh-' + item.id, className: (0, _style2.default)('practicioner-container-bottom') },
    _react.React.createElement("span", { className: (0, _style2.default)('practicioner-text') }, (0, _authcheck.getPracticioner)(allparticipants, itemQuestion.practicionerId))))),
    (0, _authcheck.showFaction)(status, item.userId, currentUserId, allparticipantsgroups) ?
    _react.React.createElement("div", { className: (0, _style2.default)('middle-shared-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('shared-with-label') }, "Fractie"),
    _react.React.createElement("div", { className: (0, _style2.default)('list-of-shared') }, (0, _authcheck.factionOfNote)(item, allparticipantsgroups))) :
    null,
    _react.React.createElement("div", { className: (0, _style2.default)('bottom-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('note-label') }, "Vraag"),
    _react.React.createElement("span", { className: (0, _style2.default)('note-text') }, item.text)),
    _react.React.createElement("div", { className: (0, _style2.default)('bottom-answer-container', !(0, _authcheck.showAnswer)(itemQuestion.status, currentUserId, usergroups) ? 'wcag-invisible' : '') },
    _react.React.createElement("div", { className: (0, _style2.default)('answer-label') }, "Antwoord vanuit Concern"),
    _react.React.createElement("span", { className: (0, _style2.default)('answer-text') }, itemQuestion.antwoordConcern)),
    _react.React.createElement(_editChat2.default, null)));
});

/***/ }),

/***/ 1120:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(1121);

if (typeof content === 'string') {
  content = [[module.i, content, '']];
}

var options = {"attributes":{}}

options.insert = "head";
options.singleton = false;

var update = __webpack_require__(491)(content, options);

if (content.locals) {
  module.exports = content.locals;
}


/***/ }),

/***/ 1121:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(undefined);
// imports


// module
exports.push([module.i, "._2IHXB4tt{padding:1px;background:#fff;border:2px solid transparent;border-radius:100px}._2IHXB4tt,._2IHXB4tt span{-webkit-transition:all .5s ease-in-out;transition:all .5s ease-in-out}._2IHXB4tt span{padding:9px 16px 8px;background:#4b55f6;font-size:12px;line-height:18px;letter-spacing:1.2px;text-align:center;color:#fff;display:inline-block;border-radius:100px;font-weight:700;text-transform:uppercase}._2IHXB4tt:hover span{background:#30379d}._2IHXB4tt:focus{border-color:#30379d;outline:none}._2IHXB4tt:focus span{background:#30379d}._2IHXB4tt._1rfhRKGR{cursor:not-allowed}._2IHXB4tt._1rfhRKGR span{background:#f4f4f8;color:#6e6e77}._2IHXB4tt._1XOF12Zl{display:inline-block;width:40px;height:40px;border-radius:100%;background:#4b55f6;color:#fff;margin-right:8px}._2IHXB4tt.YOjnK1NG span{background:#fff;color:#4b55f6;border:1px solid #4b55f6;letter-spacing:.36px}._2IHXB4tt.YOjnK1NG:hover span{background:#f4f4f8}._2IHXB4tt.YOjnK1NG:focus{border-color:#30379d}._2IHXB4tt.YOjnK1NG._1rfhRKGR{cursor:not-allowed}._2IHXB4tt.YOjnK1NG._1rfhRKGR span{color:#6e6e77;border-color:#6e6e77;background:#f4f4f8}._2IHXB4tt._3GPg_DpT span{background:#fff;color:#4b55f6;border:1px solid #4b55f6}._2IHXB4tt._3GPg_DpT span:before{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";margin-right:3px;vertical-align:middle;display:inline-block}._2IHXB4tt._3GPg_DpT:hover span{background:#f4f4f8}._2IHXB4tt._3GPg_DpT:focus{border-color:#30379d}._2IHXB4tt._3GPg_DpT._1rfhRKGR{cursor:not-allowed}._2IHXB4tt._3GPg_DpT._1rfhRKGR span{color:#6e6e77;border-color:#6e6e77;background:#f4f4f8}._2IHXB4tt._12SRTnN9 span{background:transparent;color:#414141;letter-spacing:.36px}._2IHXB4tt._12SRTnN9:hover span{background:#f4f4f8}._2IHXB4tt._12SRTnN9:focus{border-color:#30379d}._2IHXB4tt._12SRTnN9:focus span{background:#f4f4f8}._2IHXB4tt._12SRTnN9._1rfhRKGR{cursor:not-allowed}._2IHXB4tt._12SRTnN9._1rfhRKGR span{background:#f4f4f8;color:#6e6e77}.ak7TDC9R{color:#4b55f6;letter-spacing:.42px;line-height:19px;font-size:14px;text-transform:uppercase;padding:6px 8px;position:relative;border:none;background:transparent;font-weight:700}.ak7TDC9R.TvIZ7-Rq:before{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";content:\"\\E5C4\";color:#4b55f6;font-size:28px;margin-right:6px;width:24px;vertical-align:middle}._2M-yvijl{width:100%;border-radius:4px;background:#fff;border:2px solid #fff;padding:6px 40px 6px 16px;text-align:left;position:relative;outline-color:#4b55f6}._2M-yvijl,._2M-yvijl span{display:inline-block}._2M-yvijl span.v3WCNpCC{font-size:12px;line-height:16px;font-weight:300;color:#414141;padding:10px 34px 10px 8px;font-style:italic;white-space:normal}._2M-yvijl span._29zrylGb{position:absolute;top:50%;right:16px;float:right;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:24px;height:24px}._2M-yvijl span._29zrylGb:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle;color:#4b55f6}._2M-yvijl span._29zrylGb.PZk6_EV8:after{content:\"\\E5CF\"}._2M-yvijl span._29zrylGb._8IoWpBrN:after{content:\"\\E5CE\"}._2M-yvijl:focus{outline-color:#4b55f6}._2IHXB4tt.EnNDbFZH{border-radius:50%;width:40px;height:40px;position:relative}._2IHXB4tt.EnNDbFZH span{border-radius:50%;font-size:16px;background:transparent;width:34px;height:34px;padding:5px;margin:0;-webkit-box-shadow:none;box-shadow:none}._2IHXB4tt.EnNDbFZH span,._2IHXB4tt.EnNDbFZH span:after{color:#4b55f6;display:inline-block;position:relative}._2IHXB4tt.EnNDbFZH span:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\"}._2IHXB4tt.EnNDbFZH:hover span{background:#f4f4f8}._2IHXB4tt.EnNDbFZH:focus{border-color:#4b55f6}._2IHXB4tt.EnNDbFZH:focus span{background:#f4f4f8}._2IHXB4tt.EnNDbFZH._1rfhRKGR span{background:#f4f4f8;color:#6e6e77}._2IHXB4tt.EnNDbFZH._2ppakuQo span:after{content:\"\\E7FD\"}._2IHXB4tt.EnNDbFZH._14PA95qU span:after{content:\"\\F233\"}._2IHXB4tt.EnNDbFZH._1-6FWuD2 span:after{content:\"\\F1CF\"}._2IHXB4tt.EnNDbFZH._190ddDhq span:after{content:\"\\F1CE\";font-family:Material Icons Outlined}._2IHXB4tt.EnNDbFZH._2-rJHExv span:after{content:\"\\EAAA\";font-family:Material Icons Outlined}._2IHXB4tt.EnNDbFZH._3PTvJDP9 span:after{content:\"\\E86C\";font-family:Material Icons Outlined}._2IHXB4tt.EnNDbFZH._2p4s-2wp span:after{content:\"\\E876\"}._2IHXB4tt.EnNDbFZH._305hbG2j span:after{content:\"\\E835\";font-family:Material Icons Outlined}._2IHXB4tt.EnNDbFZH._1OXfjzta span:after{content:\"\\E834\"}._2IHXB4tt.EnNDbFZH._2VD4Fs7O span:after{content:\"\\E5CF\"}._2IHXB4tt.EnNDbFZH.Z4dcpLmh span:after{content:\"\\E5CE\"}._2IHXB4tt.EnNDbFZH._3f3aT28S span:after{content:\"\\E5CD\"}._2IHXB4tt.EnNDbFZH.Jm9LvZP_ span:after{content:\"\\E0C6\"}._2IHXB4tt.EnNDbFZH.Lci2nCDL span:after{content:\"\\E5D4\"}._2IHXB4tt.EnNDbFZH._2BRZ84m2 span:after{content:\"\\E880\"}._2IHXB4tt.EnNDbFZH._1jJQGGlq span:after{content:\"\\EF4F\";font-family:Material Icons Outlined}._2IHXB4tt.EnNDbFZH._2C7-_z2I span:after{content:\"\\E87D\"}._2IHXB4tt.EnNDbFZH._3yEnrgJj span:after{content:\"\\E87E\";font-family:Material Icons Outlined}._2IHXB4tt.EnNDbFZH._32epA_hY span:after{content:\"\\E41A\"}._2IHXB4tt.EnNDbFZH._2hvdptfj span:after{content:\"\\E8B6\"}._2IHXB4tt.EnNDbFZH._1Flb2Piu span:after{content:\"\\E0B7\"}._2IHXB4tt.EnNDbFZH._1MVqkWFP span:after{content:\"\\E150\"}._2IHXB4tt.EnNDbFZH._3OyqaHYW span:after{content:\"\\E150\";font-family:Material Icons Outlined}._2IHXB4tt.EnNDbFZH._3GXGABcz span:after{content:\"\\E145\"}._2IHXB4tt.EnNDbFZH._1O0TU-Qd span:after{content:\"\\E836\"}._2IHXB4tt.EnNDbFZH._jzB_Z-9 span:after{content:\"\\E837\"}._2IHXB4tt.EnNDbFZH._38qHVWO_ span:after{content:\"\\E163\"}._2IHXB4tt.EnNDbFZH._2NYMtRFp span:after{content:\"\\E0B7\";font-family:Material Icons Outlined}._2IHXB4tt.EnNDbFZH.-RQIzFOc span:after{content:\"\\E872\";font-family:Material Icons Outlined}._2IHXB4tt.EnNDbFZH._3_4HCTRm span:after{content:\"\\E5C4\"}._2IHXB4tt.EnNDbFZH._1Kb0p6Xg span:after{content:\"\\E5C8\"}._2IHXB4tt.EnNDbFZH._1Y82M5Pc,._2IHXB4tt.EnNDbFZH.NR7FU5x-{background:transparent;border-radius:0;color:#414141;padding:0;height:28px;width:28px}._2IHXB4tt.EnNDbFZH._1Y82M5Pc span,._2IHXB4tt.EnNDbFZH.NR7FU5x- span{padding:0;height:24px;width:24px}._2IHXB4tt.EnNDbFZH._1Y82M5Pc span:after,._2IHXB4tt.EnNDbFZH.NR7FU5x- span:after{color:#414141}._2IHXB4tt.EnNDbFZH._1Y82M5Pc._177idt5c,._2IHXB4tt.EnNDbFZH._1Y82M5Pc._177idt5c span:after,._2IHXB4tt.EnNDbFZH.NR7FU5x-._177idt5c,._2IHXB4tt.EnNDbFZH.NR7FU5x-._177idt5c span:after{color:#4b55f6}._2IHXB4tt.EnNDbFZH.NR7FU5x- span:after{content:\"\\E8EF\"}._2IHXB4tt.EnNDbFZH._1Y82M5Pc span:after{content:\"\\E9B0\"}._2IHXB4tt._1nXSCGSp{position:relative;padding:0;border:none;border-radius:0}._2IHXB4tt._1nXSCGSp span{color:#4b55f6;font-size:16px;background:transparent;display:inline-block;width:24px;height:24px;position:relative;margin:0;-webkit-box-shadow:none;box-shadow:none;padding:0;padding:5px}._2IHXB4tt._1nXSCGSp span:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";font-size:14px;font-weight:700}._2IHXB4tt._1nXSCGSp:hover span{background:#f4f4f8}._2IHXB4tt._1nXSCGSp.Lci2nCDL span:after{content:\"\\E5D4\"}._1ZB220wg ._1fLFNtVv{display:none}._1ZB220wg ._1fLFNtVv+._2fhjrDXH{display:inline-block}._1ZB220wg ._1fLFNtVv+._2fhjrDXH:before{content:\"\\E835\";font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle}._1ZB220wg ._1fLFNtVv:checked+._2fhjrDXH:before{content:\"\\E834\"}._1ZB220wg span{padding-left:14px}._3acm-0pA{display:block}._3acm-0pA input[type=radio]{position:absolute;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";opacity:0}._3acm-0pA input[type=radio]+._1Oq0rx6U:before{content:\"\\E836\";font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle}._3acm-0pA input[type=radio]+._1Oq0rx6U span{padding-left:14px;font-size:12px;line-height:16px;color:#414141;font-weight:400}._3acm-0pA input[type=radio]:checked+._1Oq0rx6U:before{content:\"\\E837\"}._3acm-0pA input[type=radio]+._1Oq0rx6U:empty:before{margin-right:0}.wlhY764Z{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\"}.LH4ewUxq ._1gEDsCl6{background-color:#30379d}._3JU4GB8n._3grORDFm,._3JU4GB8n._3grORDFm div:first-child{background-color:transparent}._3JU4GB8n._3grORDFm div:first-child span:first-child{background-color:aqua}._3JU4GB8n._3grORDFm div:first-child span:nth-child(2){color:transparent}._10otrZOx{width:100%;float:left}._1ftv-YBD{background-color:#f0f0f0}._1JZCCRhg{cursor:pointer}._1Me6NtQ3{background-color:#d1d8e0;color:#000}.mL1mk4Uz{background-color:#768ca4;color:#fff}._1TJk-9Zu{cursor:pointer}._38DFdKj-{background-color:#b4ffda;color:#000}._3xupnNF5{background-color:#455f33;color:#fff}.bgiyGHje{font-weight:300;color:#404040;color:rgba(0,0,0,.75)}.bjHhKJRE{position:absolute;top:-3px;right:16px}._2xI8gIzP,._23Oylkqc{margin:0}.SXxke3kr{font-weight:300;padding:.5em 0;white-space:pre-wrap;word-wrap:break-word}._3l5JXPdL{font-weight:600;display:inline-block}._5g1A9WVg{color:#966;white-space:normal}._1GpiuZYl{vertical-align:text-bottom}.RowhSu_F{display:block;overflow-y:none;padding:0 16px}.RowhSu_F ._2FHRYRJ3{color:#fff;background-color:#607d8b;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;font-size:14px;line-height:20px;padding:20px;text-align:center;text-transform:uppercase;font-weight:500}.RowhSu_F ._3HJw_RmH,.RowhSu_F ._3NythL0j{margin-bottom:15px}.RowhSu_F ._3HJw_RmH textarea,.RowhSu_F ._3NythL0j textarea{width:100%;display:block;padding:16px;border:2px solid #e8e8e8;border-radius:4px;outline:none;font-family:Roboto,sans-serif;line-height:16.8px;overflow:hidden}.RowhSu_F ._3HJw_RmH textarea:focus-visible,.RowhSu_F ._3NythL0j textarea:focus-visible{border-color:#4b55f6}.RowhSu_F ._3HJw_RmH>div>span:last-child,.RowhSu_F ._3NythL0j>div>span:last-child{text-align:right;display:block;color:#414141;font-weight:400}.RowhSu_F ._3HJw_RmH._1Wgp7o30,.RowhSu_F ._3NythL0j._1Wgp7o30{overflow-y:auto;max-height:290px}.RowhSu_F ._3NythL0j._2HLCKvHY,.RowhSu_F ._3NythL0j._2HLCKvHY>div>span:last-child{color:red}.RowhSu_F button{margin-bottom:16px}.LzMgtXUq{display:block;overflow-y:none}.LzMgtXUq ._2FHRYRJ3{color:#fff;background-color:#607d8b;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;font-size:14px;line-height:20px;padding:20px;text-align:center;text-transform:uppercase;font-weight:500}.LzMgtXUq ._3HJw_RmH{margin-bottom:15px}.LzMgtXUq ._3HJw_RmH textarea{width:100%;display:block;padding:16px;border:2px solid #e8e8e8;border-radius:4px;outline:none;font-family:Roboto,sans-serif;line-height:16.8px}.LzMgtXUq ._3HJw_RmH textarea:focus-visible{border-color:#4b55f6}.LzMgtXUq ._3HJw_RmH>div>span:last-child{text-align:right;display:block;color:#414141;font-weight:400}.LzMgtXUq ._3NythL0j._2HLCKvHY,.LzMgtXUq ._3NythL0j._2HLCKvHY>div>span:last-child{color:red}.LzMgtXUq button{margin-bottom:16px}._157T5rvq{position:relative;font-weight:400;color:#414141;font-size:12px}._157T5rvq ._1OqUp0_w{padding:0 16px;display:inline-block;width:100%}._157T5rvq ._1OqUp0_w ._3SbpN7F8{margin-bottom:8px}._2KMm0hHp{width:100%;position:relative;display:inline-block}._2KMm0hHp ._1cr0G0SA{display:block}._2KMm0hHp ._1cr0G0SA .sFQIV9-L{position:relative;display:block;font-size:14px;line-height:18px;letter-spacing:.42px;font-weight:700;margin-bottom:8px}._206GMd-w{padding:0 16px;overflow:hidden;overflow-y:auto;padding-bottom:16px}._206GMd-w,._206GMd-w._1o69w0ci{max-height:340px}._206GMd-w._1o69w0ci._3XTC5vcw,._206GMd-w._3XTC5vcw{max-height:unset}._206GMd-w._1Wgp7o30{max-height:373px}._206GMd-w ._2H3n5V0m{margin:8px 0;display:grid;display:-ms-grid;grid-template-columns:1fr 1fr 1fr;-ms-grid-columns:1fr 1fr 1fr}._206GMd-w ._2H3n5V0m ._3q3B5CRy{grid-column:1;-ms-grid-column:1;display:block}._206GMd-w ._2H3n5V0m ._3q3B5CRy ._2Cb6oj4g{display:block;font-weight:700;line-height:16px;margin-bottom:4px}._206GMd-w ._2H3n5V0m ._3q3B5CRy ._37m1xUeK{display:block;line-height:16px;margin-top:6px}._206GMd-w ._2H3n5V0m ._11XbvYiP,._206GMd-w ._2H3n5V0m .rIQLoF44{grid-column:2;-ms-grid-column:2;display:block}._206GMd-w ._2H3n5V0m ._11XbvYiP ._3-I4N09v,._206GMd-w ._2H3n5V0m ._11XbvYiP ._27ExuQPL,._206GMd-w ._2H3n5V0m .rIQLoF44 ._3-I4N09v,._206GMd-w ._2H3n5V0m .rIQLoF44 ._27ExuQPL{display:block;font-weight:700;line-height:16px;margin-bottom:4px}._206GMd-w ._2H3n5V0m ._11XbvYiP ._39Wn_ODf,._206GMd-w ._2H3n5V0m .rIQLoF44 ._39Wn_ODf{display:block;line-height:16px}._206GMd-w ._2H3n5V0m ._11XbvYiP ._39Wn_ODf>span>span:first-child,._206GMd-w ._2H3n5V0m .rIQLoF44 ._39Wn_ODf>span>span:first-child{width:11px;height:11px}._206GMd-w ._2H3n5V0m ._3jAYob0u{grid-column:3;-ms-grid-column:3;display:block}._206GMd-w ._2H3n5V0m ._3jAYob0u ._1uett8_5{display:block;font-weight:700;line-height:16px;margin-bottom:4px}._206GMd-w ._2H3n5V0m ._3jAYob0u ._3V8sujiH{display:block;line-height:16px;margin-top:6px}._206GMd-w ._1eMFkKHj,._206GMd-w ._1MCPSEfr,._206GMd-w ._3ZX8OPP1{display:block;margin-bottom:16px}._206GMd-w ._1eMFkKHj,._206GMd-w ._11H1o5IV{padding:0}._206GMd-w ._2YflRNyz ._30BaeF3L{line-height:16px;font-weight:700}._206GMd-w ._2YflRNyz .yNenrWWP ._1_ASf7V-,._206GMd-w ._2YflRNyz .yNenrWWP ._3kSxeCfs{display:block;margin-right:0}._206GMd-w ._2YflRNyz .yNenrWWP ._1_ASf7V- span,._206GMd-w ._2YflRNyz .yNenrWWP ._3kSxeCfs span{background:#e8e8e8;display:inline-block;width:21px;height:21px;border-radius:50%;padding:2px;margin:0 8px 0 0}._206GMd-w ._2YflRNyz .yNenrWWP ._1_ASf7V- span:after,._206GMd-w ._2YflRNyz .yNenrWWP ._3kSxeCfs span:after{font-size:16px;left:1px}._206GMd-w ._2grIgPRf{margin:8px 0 0;padding-bottom:8px;white-space:normal;border-bottom:1px solid rgba(65,65,65,.22);display:inline-block;width:100%}._206GMd-w ._2grIgPRf ._-9kZZIv9{font-weight:700;line-height:16px;margin-bottom:4px}._206GMd-w ._2grIgPRf ._2Acr48UW{display:block;line-height:16.8px}.ZUz7bl3M{position:absolute;bottom:0;width:100%;left:0;right:0;-webkit-box-shadow:0 -7px 8px rgba(0,0,0,.1);box-shadow:0 -7px 8px rgba(0,0,0,.1);padding-top:15px;background:#fff;height:67px}.ZUz7bl3M._1YT66ELy{position:relative}._1R_KgvS-{visibility:hidden;position:absolute;overflow:hidden;clip:rect(0 0 0 0);height:1px;width:1px;margin:-1px;padding:0;border:0}.yNenrWWP{display:block;white-space:normal}.yNenrWWP ._1_ASf7V-,.yNenrWWP ._3kSxeCfs{display:inline-block;margin-right:16px;line-height:22px;letter-spacing:.42px;font-size:14px}.yNenrWWP ._1_ASf7V- ._2cm30oqB,.yNenrWWP ._1_ASf7V- ._129EYS4B,.yNenrWWP ._3kSxeCfs ._2cm30oqB,.yNenrWWP ._3kSxeCfs ._129EYS4B{display:inline-block;margin-right:6px;background:transparent;height:24px;vertical-align:middle}.yNenrWWP ._1_ASf7V- ._2cm30oqB:after,.yNenrWWP ._1_ASf7V- ._129EYS4B:after,.yNenrWWP ._3kSxeCfs ._2cm30oqB:after,.yNenrWWP ._3kSxeCfs ._129EYS4B:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";color:#414141}.yNenrWWP ._1_ASf7V- ._2cm30oqB:after,.yNenrWWP ._3kSxeCfs ._2cm30oqB:after{content:\"\\E7FD\"}.yNenrWWP ._1_ASf7V- ._129EYS4B:after,.yNenrWWP ._3kSxeCfs ._129EYS4B:after{content:\"\\F233\"}._2pgYMmfA{background:transparent;float:left;height:47px;position:relative}._2pgYMmfA ._3iu9xafw{font-size:16px;background-color:#eef9f0;display:inline-block;border-radius:12px;color:#124612;width:47px;height:47px;text-align:center;position:relative}._2pgYMmfA ._3iu9xafw:after{color:#5eb670;font-size:20px;font-family:Material Icons;content:\"\\E0C6\";padding:11px;position:absolute;left:0;right:0}._2pgYMmfA ._1Flb2Piu{font-size:16px;background-color:#eaf5ff;display:inline-block;border-radius:12px;color:#eaf5ff;width:47px;height:47px;text-align:center;position:relative}._2pgYMmfA ._1Flb2Piu:after{color:#5e87b6;font-family:Material Icons;content:\"\\E0B7\";font-size:20px;padding:11px;position:absolute;left:0;right:0}._3kZIaPQb{float:left;padding-left:16px;width:calc(100% - 47px);vertical-align:middle;top:9px;position:relative}._3kZIaPQb ._2Cb6oj4g,._3kZIaPQb ._37m1xUeK{display:block;font-size:12px;color:#414141;line-height:16px}._3kZIaPQb ._2Cb6oj4g{font-weight:700}._3kZIaPQb ._37m1xUeK{font-style:italic;font-weight:300}.dAeiBU3E title{display:grid;display:-ms-grid;grid-template-columns:47px 1fr;-ms-grid-columns:47px 1fr;-webkit-column-gap:16px;column-gap:16px;width:100%;font-size:12px;font-weight:700;line-height:16px;color:#414141;position:relative;margin-bottom:12px;padding:0 16px}.dAeiBU3E title .gJQJ7vtA{width:47px;height:47px;background:transparent;border-radius:12px;grid-column:1;text-align:center}.dAeiBU3E title .gJQJ7vtA:before{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle;-webkit-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;font-size:20px}.dAeiBU3E title .gJQJ7vtA[data-icon=icon_message-text]{background:#eaf5ff}.dAeiBU3E title .gJQJ7vtA[data-icon=icon_message-text]:before{content:\"\\E0B7\";color:#5e87b6}.dAeiBU3E title .gJQJ7vtA[data-icon=icon_comment-question]{background:#eef9f0}.dAeiBU3E title .gJQJ7vtA[data-icon=icon_comment-question]:before{content:\"\\E0C6\";color:#5eb670}.dAeiBU3E title ._1PnOQo3F{padding:15px 0}.dAeiBU3E ._3I5qlwx8{font-size:12px;line-height:16px;color:#414141;display:block;margin-bottom:4px;font-weight:700}.dAeiBU3E ._3I5qlwx8 .acF8tqUe{display:inline-block;color:#f36;font-weight:700;font-size:17px;position:relative;top:0}.dAeiBU3E ._3Dubx563{padding:16px}._12p-4OsO{position:absolute;bottom:0;width:100%;left:0;right:0;-webkit-box-shadow:0 -7px 8px rgba(0,0,0,.1);box-shadow:0 -7px 8px rgba(0,0,0,.1);padding-top:15px;background:#fff;height:67px}._3zlqrg0U{margin:0 16px}._3zlqrg0U button:first-child span{border-color:transparent}._3zlqrg0U button:first-child:hover span{border-color:#4b55f6}._3zlqrg0U button:last-child{float:right}._3EcCC9-6{position:absolute;right:20px;z-index:1}._1N3tiZWO,.KhMc459o{white-space:normal}.KhMc459o{display:block;position:relative;padding:16px;color:#414141;font-weight:400;border-radius:20px}.KhMc459o ._1iulNH5M{display:block;font-size:18px;letter-spacing:.54px;line-height:18px;font-weight:700;margin-bottom:8px}.KhMc459o ._2vaXJfI5 p{font-size:14px;line-height:19.6px;letter-spacing:0;margin-bottom:10px;color:#414141}.KhMc459o ._2vaXJfI5 p.C813C8Zr{font-weight:500}.LH4ewUxq,.VMGr6jpM{position:relative;margin-bottom:6px}._2qJffCKX{z-index:1001;position:absolute;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";opacity:1;bottom:calc(50% - 100px);left:calc(50% - 100px);background-color:#e0e0e0;padding:10px;border:1px solid #000}._3qu2-ZV8 ._353Bptkh{margin-top:16px;font-size:12px;line-height:14px;font-weight:700;margin-bottom:8px}._3qu2-ZV8 ._2k80InwF{border-radius:4px;display:block;background:#e8e8e8;padding:16px;font-style:italic;margin-bottom:8px;white-space:normal}.JldN5CAq{padding:8px 5px;border-radius:4px;letter-spacing:0;border:2px solid #e8e8e8;min-width:170px}._4mRPA304,.JldN5CAq{font-size:10px;line-height:11px;font-weight:700}._4mRPA304{display:table-cell;vertical-align:middle;padding:5px 8px;text-transform:uppercase;border-radius:4px}._31R456kU._1I4EqIJH span{background:#e8e8e8;color:#414141}._31R456kU._17F9uM9- span{background:#b7d6de;color:#005469}._31R456kU._3qTZlk3r span{background:#d6d7eb;background:rgba(48,55,157,.2);color:#101676}._31R456kU._2o4aioaI span{background:#f3ebcc;background:rgba(195,157,0,.2);color:#a26a00}._31R456kU._2pJFYWEp span{background:#ccf3e2;background:rgba(0,195,112,.2);color:#007e48}._31R456kU._3VMEttLq span{background:#feccd9;background:rgba(249,51,102,.25);color:#c4000b}", ""]);

// exports
exports.locals = {
	"btn": "_2IHXB4tt",
	"disabled": "_1rfhRKGR",
	"user-btn": "_1XOF12Zl",
	"secondary-btn": "YOjnK1NG",
	"secondary-button_icon": "_3GPg_DpT",
	"ghost-btn": "_12SRTnN9",
	"btn-icon-text_back": "ak7TDC9R",
	"icon_arrow-back": "TvIZ7-Rq",
	"btn-type-dropdown": "_2M-yvijl",
	"default-header": "v3WCNpCC",
	"icon": "_29zrylGb",
	"icon_chevron-down": "PZk6_EV8",
	"icon_chevron-up": "_8IoWpBrN",
	"icon-btn": "EnNDbFZH",
	"account": "_2ppakuQo",
	"account_group": "_14PA95qU",
	"collapse": "_1-6FWuD2",
	"expand": "_190ddDhq",
	"arrow_right": "_2-rJHExv",
	"check_circle": "_3PTvJDP9",
	"check": "_2p4s-2wp",
	"checkbox_blank": "_305hbG2j",
	"checkbox_marked": "_1OXfjzta",
	"chevron_down": "_2VD4Fs7O",
	"chevron_up": "Z4dcpLmh",
	"close": "_3f3aT28S",
	"comment_question": "Jm9LvZP_",
	"dots_vertical": "Lci2nCDL",
	"file_document_box": "_2BRZ84m2",
	"filter": "_1jJQGGlq",
	"heart": "_2C7-_z2I",
	"heart_outline": "_3yEnrgJj",
	"loading": "_32epA_hY",
	"magnify": "_2hvdptfj",
	"message": "_1Flb2Piu",
	"pencil": "_1MVqkWFP",
	"pencil_outline": "_3OyqaHYW",
	"plus": "_3GXGABcz",
	"radiobox_blank": "_1O0TU-Qd",
	"radiobox_marked": "_jzB_Z-9",
	"icon-send": "_38qHVWO_",
	"tooltip_text_outline": "_2NYMtRFp",
	"trash_can_outline": "-RQIzFOc",
	"icon_arrow-left": "_3_4HCTRm",
	"icon_arrow-right": "_1Kb0p6Xg",
	"list": "NR7FU5x-",
	"tile": "_1Y82M5Pc",
	"active": "_177idt5c",
	"list-item-icon-btn": "_1nXSCGSp",
	"default-checkbox-div": "_1ZB220wg",
	"default-checkbox": "_1fLFNtVv",
	"checkmark": "_2fhjrDXH",
	"radio": "_3acm-0pA",
	"radio-label": "_1Oq0rx6U",
	"material-icons": "wlhY764Z",
	"question-status-container": "LH4ewUxq",
	"dropdown": "_1gEDsCl6",
	"app": "_3JU4GB8n",
	"minimized": "_3grORDFm",
	"note-details": "_10otrZOx",
	"submit-btn": "_1ftv-YBD",
	"highlight": "_1JZCCRhg",
	"highlight-normal": "_1Me6NtQ3",
	"highlight-active": "mL1mk4Uz",
	"highlight-shared": "_1TJk-9Zu",
	"highlight-normal-shared": "_38DFdKj-",
	"highlight-active-shared": "_3xupnNF5",
	"header": "bgiyGHje",
	"menu": "bjHhKJRE",
	"category": "_2xI8gIzP",
	"lastmodified": "_23Oylkqc",
	"content": "SXxke3kr",
	"name-label": "_3l5JXPdL",
	"warning": "_5g1A9WVg",
	"warning-icon": "_1GpiuZYl",
	"note-container": "RowhSu_F",
	"title": "_2FHRYRJ3",
	"input-answer-container": "_3HJw_RmH",
	"input-text-notitie": "_3NythL0j",
	"flyover": "_1Wgp7o30",
	"alert-max-chars": "_2HLCKvHY",
	"answer-container": "LzMgtXUq",
	"details": "_157T5rvq",
	"content-container": "_1OqUp0_w",
	"button-container": "_3SbpN7F8",
	"details-top-container": "_2KMm0hHp",
	"details-title-container": "_1cr0G0SA",
	"title-text-action": "sFQIV9-L",
	"details-content-container": "_206GMd-w",
	"modal": "_1o69w0ci",
	"maximized": "_3XTC5vcw",
	"middle-container": "_2H3n5V0m",
	"made-by-container": "_3q3B5CRy",
	"text-created-container-top": "_2Cb6oj4g",
	"text-created-container-bottom": "_37m1xUeK",
	"category-container": "rIQLoF44",
	"status-container": "_11XbvYiP",
	"category-container-top": "_27ExuQPL",
	"status-container-top": "_3-I4N09v",
	"category-container-bottom": "_39Wn_ODf",
	"practicioner-container": "_3jAYob0u",
	"practicioner-container-top": "_1uett8_5",
	"practicioner-container-bottom": "_3V8sujiH",
	"edit-category-container": "_3ZX8OPP1",
	"edit-question-container": "_1eMFkKHj",
	"edit-shared-container": "_1MCPSEfr",
	"edit-note-container": "_11H1o5IV",
	"middle-shared-container": "_2YflRNyz",
	"shared-with-label": "_30BaeF3L",
	"list-of-shared": "yNenrWWP",
	"shared-div": "_1_ASf7V-",
	"shared_multiple-div": "_3kSxeCfs",
	"bottom-container": "_2grIgPRf",
	"note-label": "_-9kZZIv9",
	"note-text": "_2Acr48UW",
	"bottom-buttons-container": "ZUz7bl3M",
	"not-absolute": "_1YT66ELy",
	"wcag-invisible": "_1R_KgvS-",
	"icon-shared": "_2cm30oqB",
	"icon-shared_multiple": "_129EYS4B",
	"icon-left-container": "_2pgYMmfA",
	"question": "_3iu9xafw",
	"text-created-container": "_3kZIaPQb",
	"create_note": "dAeiBU3E",
	"title-icon": "gJQJ7vtA",
	"title-text": "_1PnOQo3F",
	"sub-title": "_3I5qlwx8",
	"important-icon": "acF8tqUe",
	"koppel-button-container": "_3Dubx563",
	"bottom-panel": "_12p-4OsO",
	"buttons-container": "_3zlqrg0U",
	"expand_button-container": "_3EcCC9-6",
	"text-content": "_1N3tiZWO",
	"warning-container": "KhMc459o",
	"warning-title": "_1iulNH5M",
	"warning-content": "_2vaXJfI5",
	"medium": "C813C8Zr",
	"question-practicioner-container": "VMGr6jpM",
	"notes-batch-delete-dialog": "_2qJffCKX",
	"bottom-answer-container": "_3qu2-ZV8",
	"answer-label": "_353Bptkh",
	"answer-text": "_2k80InwF",
	"practicioner-class": "JldN5CAq",
	"status-list-text": "_4mRPA304",
	"status-list": "_31R456kU",
	"status1": "_1I4EqIJH",
	"status2": "_17F9uM9-",
	"status3": "_3qTZlk3r",
	"status4": "_2o4aioaI",
	"status5": "_2pJFYWEp",
	"status6": "_3VMEttLq"
};

/***/ }),

/***/ 1122:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.NotesSaveArea = exports.ModalNotesEditLayout = undefined;__webpack_require__(76);
var _react = __webpack_require__(648);
var _input = __webpack_require__(990);var _input2 = _interopRequireDefault(_input);
var _types = __webpack_require__(245);
var _resource = __webpack_require__(106);
var _style = __webpack_require__(650);var _style2 = _interopRequireDefault(_style);
var _selectors = __webpack_require__(649);var _selectors2 = _interopRequireDefault(_selectors);
var _selectors3 = __webpack_require__(977);var _selectors4 = _interopRequireDefault(_selectors3);
var _selectors5 = __webpack_require__(981);var _selectors6 = _interopRequireDefault(_selectors5);
var _resource2 = __webpack_require__(246);
var _UPDATE_BUTTON_NO = __webpack_require__(519);var _UPDATE_BUTTON_NO2 = _interopRequireDefault(_UPDATE_BUTTON_NO);
var _SHOW = __webpack_require__(656);var _SHOW2 = _interopRequireDefault(_SHOW);
var _SHOW3 = __webpack_require__(655);var _SHOW4 = _interopRequireDefault(_SHOW3);
var _selectors7 = __webpack_require__(975);var _selectors8 = _interopRequireDefault(_selectors7);
var _selectors9 = __webpack_require__(651);var _selectors10 = _interopRequireDefault(_selectors9);
var _resource3 = __webpack_require__(233);
var _NOTES_INITIALIZE = __webpack_require__(546);var _NOTES_INITIALIZE2 = _interopRequireDefault(_NOTES_INITIALIZE);
var _button = __webpack_require__(973);
var _input3 = __webpack_require__(1019);
var _date = __webpack_require__(987);
var _resource4 = __webpack_require__(517);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var maxNoteTextLength = 3000;
var minLinesVisible = 3;
var maxLinesVisible = 75;exports.default =
(0, _react.PureConnect)('FlyoverNotesEditLayout')(function (state) {return {
        creating: _resource.notesEditor.selectors.creating(state),
        item: _resource.notesEditor.selectors.item(state),
        updating: _resource.notesEditor.selectors.updating(state),
        updatingNoteChat: _resource4.notechatEditor.selectors.updating(state),
        selectNote: state.selection.creating,
        user: _selectors2.default.user(state),
        allparticipants: _resource2.participantsResource.selectors.items(state).qSelect(function (item) {return item;}),
        allparticipantsgroups: _resource3.usergroupResource.selectors.items(state).qSelect(function (item) {return item;}),
        origin: state.notemenu.origin,
        participantPopupVisible: _selectors4.default.visible(state),
        categoryPopupVisible: _selectors6.default.visible(state),
        selectTextArea: state.selection.creating,
        screenSmall: _selectors8.default.small(state),
        initialized: state.notesReducer.initialize,
        flyoverVisible: state.flyover.visible };},
function (dispatch) {return {
        change: function change(item) {dispatch(_resource.notesEditor.actions.APPLY({ item: item }));},
        showCategorySelectPopUp: function showCategorySelectPopUp() {dispatch((0, _SHOW2.default)({}));},
        showParticipantPopUp: function showParticipantPopUp() {dispatch((0, _SHOW4.default)({ itemno: -1 }));},
        updateButtonFocus: function updateButtonFocus(buttonNr, origin, itm) {
            dispatch((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: buttonNr, origin: origin, buttonAction: undefined, lasttoucheditem: itm }));
        },
        initialize: function initialize(_initialize) {return dispatch((0, _NOTES_INITIALIZE2.default)({ initialize: _initialize }));} };},
function (_ref) {var flyoverVisible = _ref.flyoverVisible,creating = _ref.creating,updating = _ref.updating,updatingNoteChat = _ref.updatingNoteChat,selectNote = _ref.selectNote,item = _ref.item,initialized = _ref.initialized,change = _ref.change,showCategorySelectPopUp = _ref.showCategorySelectPopUp,showParticipantPopUp = _ref.showParticipantPopUp,allparticipants = _ref.allparticipants,allparticipantsgroups = _ref.allparticipantsgroups,participantPopupVisible = _ref.participantPopupVisible,categoryPopupVisible = _ref.categoryPopupVisible,selectTextArea = _ref.selectTextArea;
    var isquestion = (0, _types.isQuestion)(item);
    var visible = flyoverVisible && (creating || updating) && !isquestion && !updatingNoteChat && !selectNote && !participantPopupVisible && !categoryPopupVisible && !selectTextArea;
    var maxlines = maxLinesVisible;
    var selection = document.querySelector('.text-container textarea');
    if (visible && selection && initialized) {
        maxlines = countLines(selection, maxlines);
    }
    var input = _react.React.createElement(_input2.default, { type: "text", name: "note", rows: maxlines, value: item.text, maxLength: maxNoteTextLength, multiline: true, className: 'text-container', onChange: function onChange(value) {return change({ text: value });}, floating: true });
    return _react.React.createElement("div", { className: (0, _style2.default)('create_note', !visible ? 'wcag-invisible' : '', 'fields-container'), "aria-hidden": !visible, "aria-labelledby": "Maak een notitie aan" },
    _react.React.createElement("title", null,
    _react.React.createElement("span", { className: (0, _style2.default)('title-icon'), "data-icon": 'icon_message-text' }),
    _react.React.createElement("span", { className: (0, _style2.default)('title-text') }, 'NOTITIE')),
    _react.React.createElement("div", { className: (0, _style2.default)('note-container') },
    _react.React.createElement("span", { className: (0, _style2.default)('sub-title') },
    "Uw notitie",
    _react.React.createElement("span", { className: (0, _style2.default)('important-icon') }, "*")),
    _react.React.createElement("div", { id: "note", className: (0, _style2.default)('input-text-notitie', item && item.text && item.text.length >= maxNoteTextLength ? 'alert-max-chars' : '', flyoverVisible ? 'flyover' : '') }, input),
    _react.React.createElement("span", { className: (0, _style2.default)('sub-title') }, "Categorie"),
    item.categoryId ? _react.React.createElement(_input3.Category, { categoryId: item.categoryId }) : null,
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Categorie selectie', "aria-haspopup": false, tabIndex: 0, onClick: function onClick() {if (!categoryPopupVisible) {
                showCategorySelectPopUp();
            }} },
    _react.React.createElement("span", null, item.categoryId ? 'WIJZIGEN' : 'SELECTEER')),
    _react.React.createElement("span", { className: (0, _style2.default)('sub-title') }, "Notitie delen"),
    _react.React.createElement("div", { className: (0, _style2.default)('list-of-shared') },
    item && item.noteParticipantsIDs && item.noteParticipantsIDs.length ?
    item.noteParticipantsIDs.map(function (itm) {return _react.React.createElement("div", { key: itm, className: (0, _style2.default)('shared-div') },
        _react.React.createElement("span", { className: (0, _style2.default)('icon-shared') }),
        mapParticipantName(itm, allparticipants));}) :
    null,
    item && item.noteParticipantGroupIDs && item.noteParticipantGroupIDs.length ?
    item.noteParticipantGroupIDs.map(function (itm) {return _react.React.createElement("div", { key: itm, className: (0, _style2.default)('shared_multiple-div') },
        _react.React.createElement("span", { className: (0, _style2.default)('icon-shared_multiple') }),
        mapGroupName(itm, allparticipantsgroups));}) :
    null),
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Notities delen met', "aria-haspopup": false, onClick: function onClick() {if (!participantPopupVisible) {
                showParticipantPopUp();
            }}, tabIndex: 0 },
    _react.React.createElement("span", null, item && item.noteParticipantsIDs && item.noteParticipantsIDs.length || item && item.noteParticipantGroupIDs && item.noteParticipantGroupIDs.length ? 'WIJZIGEN' : 'SELECTEER'))));
});
var ModalNotesEditLayout = exports.ModalNotesEditLayout = (0, _react.PureConnect)('ModalNotesEditLayout')(function (state) {return {
        creating: _resource.notesEditor.selectors.creating(state),
        item: _resource.notesEditor.selectors.item(state),
        updating: _resource.notesEditor.selectors.updating(state),
        updatingNoteChat: _resource4.notechatEditor.selectors.updating(state),
        selectNote: state.selection.creating,
        user: _selectors2.default.user(state),
        allparticipants: _resource2.participantsResource.selectors.items(state).qSelect(function (item) {return item;}),
        allparticipantsgroups: _resource3.usergroupResource.selectors.items(state).qSelect(function (item) {return item;}),
        origin: state.notemenu.origin,
        participantPopupVisible: _selectors4.default.visible(state),
        categoryPopupVisible: _selectors6.default.visible(state),
        selectTextArea: state.selection.creating,
        screenSmall: _selectors8.default.small(state),
        initialized: state.notesReducer.initialize,
        flyoverVisible: state.flyover.visible };},
function (dispatch) {return {
        change: function change(item) {dispatch(_resource.notesEditor.actions.APPLY({ item: item }));},
        showCategorySelectPopUp: function showCategorySelectPopUp() {dispatch((0, _SHOW2.default)({}));},
        showParticipantPopUp: function showParticipantPopUp() {dispatch((0, _SHOW4.default)({ itemno: -1 }));},
        updateButtonFocus: function updateButtonFocus(buttonNr, origin, itm) {
            dispatch((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: buttonNr, origin: origin, buttonAction: undefined, lasttoucheditem: itm }));
        },
        initialize: function initialize(_initialize2) {return dispatch((0, _NOTES_INITIALIZE2.default)({ initialize: _initialize2 }));} };},
function (_ref2) {var creating = _ref2.creating,updating = _ref2.updating,updatingNoteChat = _ref2.updatingNoteChat,flyoverVisible = _ref2.flyoverVisible,selectNote = _ref2.selectNote,item = _ref2.item,initialized = _ref2.initialized,initialize = _ref2.initialize,change = _ref2.change,showCategorySelectPopUp = _ref2.showCategorySelectPopUp,showParticipantPopUp = _ref2.showParticipantPopUp,allparticipants = _ref2.allparticipants,allparticipantsgroups = _ref2.allparticipantsgroups,participantPopupVisible = _ref2.participantPopupVisible,categoryPopupVisible = _ref2.categoryPopupVisible,selectTextArea = _ref2.selectTextArea;
    var isquestion = (0, _types.isQuestion)(item);
    var visible = !flyoverVisible && (creating || updating) && !isquestion && !updatingNoteChat && !selectNote && !participantPopupVisible && !categoryPopupVisible && !selectTextArea;
    var maxlines = maxLinesVisible;
    var selection = document.querySelector('.text-container textarea');
    if (visible && selection && initialized) {
        maxlines = countLines(selection, maxlines);
    }
    var input = _react.React.createElement(_input2.default, { type: "text", name: "note", rows: maxlines, value: item.text, maxLength: maxNoteTextLength, multiline: true, className: 'text-container', onChange: function onChange(value) {return change({ text: value });}, floating: true });
    return _react.React.createElement("div", { className: (0, _style2.default)('create_note', 'details', !visible ? 'wcag-invisible' : '', 'fields-container'), "aria-hidden": !visible, "aria-labelledby": "Maak een notitie aan" },
    _react.React.createElement("section", { role: "content-info", className: (0, _style2.default)('content-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('details-top-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('details-title-container') },
    _react.React.createElement("span", { className: (0, _style2.default)('title-text-action') }, 'Notitie wijzigen'),
    _react.React.createElement("div", { className: (0, _style2.default)('icon-left-container') },
    _react.React.createElement("span", { className: (0, _style2.default)('icon-container', 'message') })),
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container-top') }, 'NOTITIE'),
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container-bottom') },
    _react.React.createElement(_date.DateTimeText, { date: item.created })))))),
    _react.React.createElement("section", { className: (0, _style2.default)('details-content-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('middle-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('made-by-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container-top') }, "Aangemaakt door"),
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container-bottom') }, mapParticipantName(item.userId, allparticipants)))),
    _react.React.createElement("div", { className: (0, _style2.default)('edit-category-container') },
    _react.React.createElement("span", { className: (0, _style2.default)('sub-title') }, "Categorie"),
    item.categoryId ? _react.React.createElement(_input3.Category, { extraClassNames: 'edit-selected-category', categoryId: item.categoryId }) : null,
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Categorie selectie', "aria-haspopup": false, tabIndex: 0, onClick: function onClick() {if (!categoryPopupVisible) {
                showCategorySelectPopUp();
            }} },
    _react.React.createElement("span", null, item.categoryId ? 'WIJZIGEN' : 'SELECTEER'))),
    _react.React.createElement("div", { className: (0, _style2.default)('edit-shared-container') },
    _react.React.createElement("span", { className: (0, _style2.default)('sub-title') }, "Notitie delen"),
    _react.React.createElement("div", { className: (0, _style2.default)('list-of-shared') },
    item && item.noteParticipantsIDs && item.noteParticipantsIDs.length ?
    item.noteParticipantsIDs.map(function (itm) {return _react.React.createElement("div", { key: itm, className: (0, _style2.default)('shared-div') },
        _react.React.createElement("span", { className: (0, _style2.default)('icon-shared') }),
        mapParticipantName(itm, allparticipants));}) :
    null,
    item && item.noteParticipantGroupIDs && item.noteParticipantGroupIDs.length ?
    item.noteParticipantGroupIDs.map(function (itm) {return _react.React.createElement("div", { key: itm, className: (0, _style2.default)('shared_multiple-div') },
        _react.React.createElement("span", { className: (0, _style2.default)('icon-shared_multiple') }),
        mapGroupName(itm, allparticipantsgroups));}) :
    null),
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Notities delen met', "aria-haspopup": false, onClick: function onClick() {if (!participantPopupVisible) {
                showParticipantPopUp();
            }}, tabIndex: 0 },
    _react.React.createElement("span", null, item && item.noteParticipantsIDs && item.noteParticipantsIDs.length || item && item.noteParticipantGroupIDs && item.noteParticipantGroupIDs.length ? 'WIJZIGEN' : 'SELECTEER'))),
    _react.React.createElement("div", { className: (0, _style2.default)('note-container', 'edit-note-container') },
    _react.React.createElement("span", { className: (0, _style2.default)('sub-title') },
    "Uw notitie",
    _react.React.createElement("span", { className: (0, _style2.default)('important-icon') }, "*")),
    _react.React.createElement("div", { id: "note", className: (0, _style2.default)('input-text-notitie', item && item.text && item.text.length >= maxNoteTextLength ? 'alert-max-chars' : '') }, input))));
});
var NotesSaveArea = exports.NotesSaveArea = (0, _react.PureConnect)('NotesSaveArea')(function (state) {return {
        creating: _resource.notesEditor.selectors.creating(state),
        item: _resource.notesEditor.selectors.item(state),
        updating: _resource.notesEditor.selectors.updating(state),
        updatingNoteChat: _resource4.notechatEditor.selectors.updating(state),
        selectNote: state.selection.creating,
        user: _selectors2.default.user(state),
        allparticipants: _resource2.participantsResource.selectors.items(state).qSelect(function (item) {return item;}),
        allparticipantsgroups: _resource3.usergroupResource.selectors.items(state).qSelect(function (item) {return item;}),
        origin: state.notemenu.origin,
        participantPopupVisible: _selectors4.default.visible(state),
        categoryPopupVisible: _selectors6.default.visible(state),
        selectTextArea: state.selection.creating,
        screenSmall: _selectors8.default.small(state),
        isminimized: _selectors10.default.isminimized(state) };},
function (dispatch) {return {
        cancel: function cancel() {return dispatch(_resource.notesEditor.actions.RESET({}));},
        cancelCreating: function cancelCreating() {
            dispatch(_resource.notesEditor.actions.CREATE_CANCEL({}));
        },
        cancelUpdating: function cancelUpdating() {
            dispatch(_resource.notesEditor.actions.UPDATE_CANCEL({}));
        },
        saveCreating: function saveCreating(item, user) {
            item = fixNoteDevelopmentJsonServer(item, true);
            dispatch(_resource.notesEditor.actions.CREATE_CONTINUE({ item: item }));
        },
        saveUpdating: function saveUpdating(item, user) {
            item = fixNoteDevelopmentJsonServer(item, false);
            dispatch(_resource.notesEditor.actions.UPDATE_CONTINUE({ item: item }));
        } };},
function (_ref3) {var creating = _ref3.creating,updating = _ref3.updating,updatingNoteChat = _ref3.updatingNoteChat,selectNote = _ref3.selectNote,item = _ref3.item,user = _ref3.user,saveCreating = _ref3.saveCreating,cancelCreating = _ref3.cancelCreating,saveUpdating = _ref3.saveUpdating,cancelUpdating = _ref3.cancelUpdating,participantPopupVisible = _ref3.participantPopupVisible,categoryPopupVisible = _ref3.categoryPopupVisible,selectTextArea = _ref3.selectTextArea;
    var visible = (creating || updating) && !(0, _types.isQuestion)(item) && !updatingNoteChat && !selectNote && !participantPopupVisible && !categoryPopupVisible && !selectTextArea;
    return _react.React.createElement("div", { className: (0, _style2.default)('bottom-panel', !visible ? 'wcag-invisible' : ''), "aria-hidden": !visible, "aria-labelledby": "Maak een notitie aan" },
    _react.React.createElement("div", { className: (0, _style2.default)('bottom-buttons') },
    _react.React.createElement("div", { className: (0, _style2.default)('buttons-container', participantPopupVisible || categoryPopupVisible ? 'wcag-invisible' : '') },
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Annuleren', "aria-haspopup": false, tabIndex: 0, onKeyDown: function onKeyDown(evt) {
            handleEnters(evt, creating ?
            function () {cancelCreating();} :
            function () {cancelUpdating();});
        }, onClick: creating ?
        function () {cancelCreating();} :
        function () {cancelUpdating();} },
    _react.React.createElement("span", null, "Annuleren")),
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', "aria-label": 'Opslaan', "aria-haspopup": false, tabIndex: item.text ? 0 : -1, disabled: !item.text, onKeyDown: function onKeyDown(evt) {
            handleEnters(evt, creating ?
            function () {return saveCreating(item, user);} :
            function () {return saveUpdating(item, user);});
        }, onClick: creating ?
        function () {return saveCreating(item, user);} :
        function () {return saveUpdating(item, user);} },
    _react.React.createElement("span", null, "Opslaan")))));
});
function mapParticipantName(participantId, allparticipants) {
    var participant = allparticipants.qWhere(function (item) {return participantId === item.id;});
    return participant && participant.qAny() ? '' + participant[0].name : '';
}
function mapGroupName(groupId, allparticipantgroups) {
    var group = allparticipantgroups.qWhere(function (item) {return parseInt(groupId) === item.id;});
    return group && group.qAny() ? '' + group[0].name : '';
}
function countLines(textarea, max) {
    var buffer = null;
    if (buffer == null) {
        buffer = document.createElement('textarea');
        buffer.style.border = 'none';
        buffer.style.height = '0';
        buffer.style.overflow = 'hidden';
        buffer.style.padding = '0';
        buffer.style.position = 'absolute';
        buffer.style.left = '0';
        buffer.style.top = '0';
        buffer.style.zIndex = '-1';
        buffer.rows = max;
        document.body.appendChild(buffer);
    }
    var cs = window.getComputedStyle(textarea, '');
    var pl = parseInt(cs.paddingLeft);
    var pr = parseInt(cs.paddingRight);
    var lh = parseInt(cs.lineHeight);
    if (isNaN(lh))
    lh = parseInt(cs.fontSize);
    buffer.style.width = textarea.clientWidth - pl - pr + 'px';
    buffer.style.font = cs.font;
    buffer.style.letterSpacing = cs.letterSpacing;
    buffer.style.whiteSpace = cs.whiteSpace;
    buffer.style.wordBreak = cs.wordBreak;
    buffer.style.wordSpacing = cs.wordSpacing;
    buffer.style.wordWrap = cs.wordWrap;
    buffer.value = textarea.value;
    var result = Math.floor(buffer.scrollHeight / lh);
    if (result === 0)
    result = 1;
    if (result <= minLinesVisible) {
        return minLinesVisible;
    } else
    if (result > minLinesVisible && result < maxLinesVisible) {
        return result + 1;
    } else
    {
        return maxLinesVisible;
    }
}
function fixNoteDevelopmentJsonServer(item, create) {
    return item;
}
function handleEnters(evt, funct) {
    if (evt.key === 'Enter') {
        evt.preventDefault();
        funct();
    }
}

/***/ }),

/***/ 1123:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _getPrototypeOf = __webpack_require__(232);var _getPrototypeOf2 = _interopRequireDefault2(_getPrototypeOf);var _setPrototypeOf = __webpack_require__(493);var _setPrototypeOf2 = _interopRequireDefault2(_setPrototypeOf);var _create = __webpack_require__(222);var _create2 = _interopRequireDefault2(_create);var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault2(_typeof2);var _defineProperty2 = __webpack_require__(161);var _defineProperty3 = _interopRequireDefault2(_defineProperty2);var _assign = __webpack_require__(77);var _assign2 = _interopRequireDefault2(_assign);function _interopRequireDefault2(obj) {return obj && obj.__esModule ? obj : { default: obj };}

Object.defineProperty(exports, "__esModule", {
  value: true });

exports.Input = exports.inputFactory = undefined;

var _extends = _assign2.default || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};

var _createClass = function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;(0, _defineProperty3.default)(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};}();

var _react = __webpack_require__(171);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(967);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames4 = __webpack_require__(993);

var _classnames5 = _interopRequireDefault(_classnames4);

var _reactCssThemr = __webpack_require__(994);

var _utils = __webpack_require__(1124);

var _identifiers = __webpack_require__(995);

var _FontIcon = __webpack_require__(988);

var _FontIcon2 = _interopRequireDefault(_FontIcon);

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

function _defineProperty(obj, key, value) {if (key in obj) {(0, _defineProperty3.default)(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}

function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;}

function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));}subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;}

var factory = function factory(FontIcon) {
  var Input = function (_React$Component) {
    _inherits(Input, _React$Component);

    function Input() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Input);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Input.__proto__ || (0, _getPrototypeOf2.default)(Input)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (event) {
        var _this$props = _this.props,
        onChange = _this$props.onChange,
        multiline = _this$props.multiline,
        maxLength = _this$props.maxLength;

        var valueFromEvent = event.target.value;

        // Trim value to maxLength if that exists (only on multiline inputs).
        // Note that this is still required even tho we have the onKeyPress filter
        // because the user could paste smt in the textarea.
        var haveToTrim = multiline && maxLength && event.target.value.length > maxLength;
        var value = haveToTrim ? valueFromEvent.substr(0, maxLength) : valueFromEvent;

        // propagate to to store and therefore to the input
        if (onChange) onChange(value, event);
      }, _this.handleAutoresize = function () {
        var element = _this.inputNode;
        var rows = _this.props.rows;

        if (typeof rows === 'number' && !isNaN(rows)) {
          element.style.height = null;
        } else {
          // compute the height difference between inner height and outer height
          var style = getComputedStyle(element, null);
          var heightOffset = style.boxSizing === 'content-box' ? -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom)) : parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);

          // resize the input to its content size
          element.style.height = 'auto';
          element.style.height = element.scrollHeight + heightOffset + 'px';
        }
      }, _this.handleKeyPress = function (event) {
        // prevent insertion of more characters if we're a multiline input
        // and maxLength exists
        var _this$props2 = _this.props,
        multiline = _this$props2.multiline,
        maxLength = _this$props2.maxLength,
        onKeyPress = _this$props2.onKeyPress;

        if (multiline && maxLength) {
          // check if smt is selected, in which case the newly added charcter would
          // replace the selected characters, so the length of value doesn't actually
          // increase.
          var isReplacing = event.target.selectionEnd - event.target.selectionStart;
          var value = event.target.value;

          if (!isReplacing && value.length === maxLength) {
            event.preventDefault();
            event.stopPropagation();
            return undefined;
          }
        }

        if (onKeyPress) onKeyPress(event);
        return undefined;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Input, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.props.multiline) {
          window.addEventListener('resize', this.handleAutoresize);
          this.handleAutoresize();
        }
      } },
    {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (!this.props.multiline && nextProps.multiline) {
          window.addEventListener('resize', this.handleAutoresize);
        } else if (this.props.multiline && !nextProps.multiline) {
          window.removeEventListener('resize', this.handleAutoresize);
        }
      } },
    {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        // resize the textarea, if nessesary
        if (this.props.multiline) this.handleAutoresize();
      } },
    {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.props.multiline) window.removeEventListener('resize', this.handleAutoresize);
      } },
    {
      key: 'blur',
      value: function blur() {
        this.inputNode.blur();
      } },
    {
      key: 'focus',
      value: function focus() {
        this.inputNode.focus();
      } },
    {
      key: 'render',
      value: function render() {
        var _classnames2,
        _this2 = this;

        var _props = this.props,
        children = _props.children,
        defaultValue = _props.defaultValue,
        disabled = _props.disabled,
        error = _props.error,
        floating = _props.floating,
        hint = _props.hint,
        icon = _props.icon,
        name = _props.name,
        labelText = _props.label,
        maxLength = _props.maxLength,
        multiline = _props.multiline,
        required = _props.required,
        role = _props.role,
        theme = _props.theme,
        type = _props.type,
        value = _props.value,
        onKeyPress = _props.onKeyPress,
        _props$rows = _props.rows,
        rows = _props$rows === undefined ? 1 : _props$rows,
        others = _objectWithoutProperties(_props, ['children', 'defaultValue', 'disabled', 'error', 'floating', 'hint', 'icon', 'name', 'label', 'maxLength', 'multiline', 'required', 'role', 'theme', 'type', 'value', 'onKeyPress', 'rows']);

        var length = maxLength && value ? value.length : 0;
        var labelClassName = (0, _classnames5.default)(theme.label, _defineProperty({}, theme.fixed, !floating));

        var className = (0, _classnames5.default)(theme.input, (_classnames2 = {}, _defineProperty(_classnames2, theme.disabled, disabled), _defineProperty(_classnames2, theme.errored, error), _defineProperty(_classnames2, theme.hidden, type === 'hidden'), _defineProperty(_classnames2, theme.withIcon, icon), _classnames2), this.props.className);

        var valuePresent = (0, _utils.isValuePresent)(value) || (0, _utils.isValuePresent)(defaultValue);

        var inputElementProps = _extends({}, others, {
          className: (0, _classnames5.default)(theme.inputElement, _defineProperty({}, theme.filled, valuePresent)),
          onChange: this.handleChange,
          ref: function ref(node) {
            _this2.inputNode = node;
          },
          role: role,
          name: name,
          defaultValue: defaultValue,
          disabled: disabled,
          required: required,
          type: type,
          value: value });

        if (!multiline) {
          inputElementProps.maxLength = maxLength;
          inputElementProps.onKeyPress = onKeyPress;
        } else {
          inputElementProps.rows = rows;
          inputElementProps.onKeyPress = this.handleKeyPress;
        }

        return _react2.default.createElement(
        'div',
        { 'data-react-toolbox': 'input', className: className },
        _react2.default.createElement(multiline ? 'textarea' : 'input', inputElementProps),
        icon ? _react2.default.createElement(FontIcon, { className: theme.icon, value: icon }) : null,
        _react2.default.createElement('span', { className: theme.bar }),
        labelText ? _react2.default.createElement(
        'label',
        { className: labelClassName },
        labelText,
        required ? _react2.default.createElement(
        'span',
        { className: theme.required },
        ' * ') :
        null) :
        null,
        hint ? _react2.default.createElement(
        'span',
        { hidden: labelText, className: theme.hint },
        hint) :
        null,
        error ? _react2.default.createElement(
        'span',
        { className: theme.error },
        error) :
        null,
        maxLength ? _react2.default.createElement(
        'span',
        { className: theme.counter },
        length,
        '/',
        maxLength) :
        null,
        children);

      } }]);


    return Input;
  }(_react2.default.Component);

  Input.propTypes = {
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    defaultValue: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    error: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    floating: _propTypes2.default.bool,
    hint: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    maxLength: _propTypes2.default.number,
    multiline: _propTypes2.default.bool,
    name: _propTypes2.default.string,
    onBlur: _propTypes2.default.func,
    onChange: _propTypes2.default.func,
    onFocus: _propTypes2.default.func,
    onKeyPress: _propTypes2.default.func,
    required: _propTypes2.default.bool,
    role: _propTypes2.default.string,
    rows: _propTypes2.default.number,
    theme: _propTypes2.default.shape({
      bar: _propTypes2.default.string,
      counter: _propTypes2.default.string,
      disabled: _propTypes2.default.string,
      error: _propTypes2.default.string,
      errored: _propTypes2.default.string,
      hidden: _propTypes2.default.string,
      hint: _propTypes2.default.string,
      icon: _propTypes2.default.string,
      input: _propTypes2.default.string,
      inputElement: _propTypes2.default.string,
      required: _propTypes2.default.string,
      withIcon: _propTypes2.default.string }),

    type: _propTypes2.default.string,
    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.object, _propTypes2.default.string]) };

  Input.defaultProps = {
    className: '',
    hint: '',
    disabled: false,
    floating: true,
    multiline: false,
    required: false,
    role: 'input',
    type: 'text' };



  return Input;
};

var Input = factory(_FontIcon2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.INPUT)(Input);
exports.inputFactory = factory;
exports.Input = Input;

/***/ }),

/***/ 1124:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _stringify = __webpack_require__(247);var _stringify2 = _interopRequireDefault2(_stringify);function _interopRequireDefault2(obj) {return obj && obj.__esModule ? obj : { default: obj };}

Object.defineProperty(exports, "__esModule", {
  value: true });

exports.isValuePresent = exports.getAnimationModule = exports.removeNamespace = exports.transformKeys = exports.prepareValueForInput = exports.inputTypeForPrototype = exports.cloneObject = exports.getViewport = exports.round = exports.range = exports.angle360FromPositions = exports.angleFromPositions = undefined;

var _assoc = __webpack_require__(1125);

var _assoc2 = _interopRequireDefault(_assoc);

var _compose = __webpack_require__(1126);

var _compose2 = _interopRequireDefault(_compose);

var _keys = __webpack_require__(1046);

var _keys2 = _interopRequireDefault(_keys);

var _reduce = __webpack_require__(1055);

var _reduce2 = _interopRequireDefault(_reduce);

var _pickBy = __webpack_require__(1136);

var _pickBy2 = _interopRequireDefault(_pickBy);

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var angleFromPositions = exports.angleFromPositions = function angleFromPositions(cx, cy, ex, ey) {
  var theta = Math.atan2(ey - cy, ex - cx) + Math.PI / 2;
  return theta * 180 / Math.PI;
};

var angle360FromPositions = exports.angle360FromPositions = function angle360FromPositions(cx, cy, ex, ey) {
  var angle = angleFromPositions(cx, cy, ex, ey);
  return angle < 0 ? 360 + angle : angle;
};

var range = exports.range = function range() {
  var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var stop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var _start = 0,
  _stop = start;

  if (stop !== null) {
    _start = start;
    _stop = stop;
  }
  var length = Math.max(Math.ceil((_stop - _start) / step), 0);
  var _range = Array(length);

  for (var idx = 0; idx < length; idx += 1, _start += step) {
    _range[idx] = _start;
  }

  return _range;
};

var round = exports.round = function round(number, decimals) {
  if (!isNaN(parseFloat(number)) && isFinite(number)) {
    var decimalPower = Math.pow(10, decimals);
    return Math.round(parseFloat(number) * decimalPower) / decimalPower;
  }
  return NaN;
};

var getViewport = exports.getViewport = function getViewport() {
  return {
    height: window.innerHeight || document.documentElement.offsetHeight,
    width: window.innerWidth || document.documentElement.offsetWidth };

};

var cloneObject = exports.cloneObject = function cloneObject(object) {
  return JSON.parse((0, _stringify2.default)(object));
};

var inputTypeForPrototype = exports.inputTypeForPrototype = function inputTypeForPrototype(prototype) {
  if (prototype === Date) return 'date';
  if (prototype === Number) return 'number';
  if (prototype === Boolean) return 'checkbox';
  return 'text';
};

var prepareValueForInput = exports.prepareValueForInput = function prepareValueForInput(value, type) {
  if (type === 'date') return new Date(value).toISOString().slice(0, 10);
  if (type === 'checkbox') {
    return value ? 'on' : '';
  }
  return value;
};

var transformKeys = exports.transformKeys = function transformKeys(fn) {
  return function (obj) {
    var addTransformedKey = function addTransformedKey(result, key) {
      return (0, _assoc2.default)(fn(key), obj[key], result);
    };
    return (0, _reduce2.default)(addTransformedKey, {}, (0, _keys2.default)(obj));
  };
};

var removeNamespace = exports.removeNamespace = function removeNamespace(namespace) {
  return function (key) {
    var capitalized = key.substr(namespace.length);
    return capitalized.slice(0, 1).toLowerCase() + capitalized.slice(1);
  };
};

var getAnimationModule = exports.getAnimationModule = function getAnimationModule(animation, theme) {
  return (0, _compose2.default)(transformKeys(removeNamespace(animation)), (0, _pickBy2.default)(function (v, k) {
    return k.startsWith(animation);
  }))(theme);
};

var isValuePresent = exports.isValuePresent = function isValuePresent(value) {
  return value !== null && value !== undefined && value !== '' && !(typeof value === 'number' && isNaN(value));
};

/***/ }),

/***/ 1125:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _curry3 = __webpack_require__(1016);


/**
                                                           * Makes a shallow clone of an object, setting or overriding the specified
                                                           * property with the given value. Note that this copies and flattens prototype
                                                           * properties onto the new object as well. All non-primitive properties are
                                                           * copied by reference.
                                                           *
                                                           * @func
                                                           * @memberOf R
                                                           * @since v0.8.0
                                                           * @category Object
                                                           * @sig String -> a -> {k: v} -> {k: v}
                                                           * @param {String} prop The property name to set
                                                           * @param {*} val The new value
                                                           * @param {Object} obj The object to clone
                                                           * @return {Object} A new object equivalent to the original except for the changed property.
                                                           * @see R.dissoc
                                                           * @example
                                                           *
                                                           *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
                                                           */
module.exports = _curry3(function assoc(prop, val, obj) {
  var result = {};
  for (var p in obj) {
    result[p] = obj[p];
  }
  result[prop] = val;
  return result;
});

/***/ }),

/***/ 1126:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var pipe = __webpack_require__(1127);
var reverse = __webpack_require__(1135);


/**
                                     * Performs right-to-left function composition. The rightmost function may have
                                     * any arity; the remaining functions must be unary.
                                     *
                                     * **Note:** The result of compose is not automatically curried.
                                     *
                                     * @func
                                     * @memberOf R
                                     * @since v0.1.0
                                     * @category Function
                                     * @sig ((y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)) -> ((a, b, ..., n) -> z)
                                     * @param {...Function} ...functions The functions to compose
                                     * @return {Function}
                                     * @see R.pipe
                                     * @example
                                     *
                                     *      var classyGreeting = (firstName, lastName) => "The name's " + lastName + ", " + firstName + " " + lastName
                                     *      var yellGreeting = R.compose(R.toUpper, classyGreeting);
                                     *      yellGreeting('James', 'Bond'); //=> "THE NAME'S BOND, JAMES BOND"
                                     *
                                     *      R.compose(Math.abs, R.add(1), R.multiply(2))(-4) //=> 7
                                     *
                                     * @symb R.compose(f, g, h)(a, b) = f(g(h(a, b)))
                                     */
module.exports = function compose() {
  if (arguments.length === 0) {
    throw new Error('compose requires at least one argument');
  }
  return pipe.apply(this, reverse(arguments));
};

/***/ }),

/***/ 1127:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _arity = __webpack_require__(1054);
var _pipe = __webpack_require__(1128);
var reduce = __webpack_require__(1055);
var tail = __webpack_require__(1133);


/**
                               * Performs left-to-right function composition. The leftmost function may have
                               * any arity; the remaining functions must be unary.
                               *
                               * In some libraries this function is named `sequence`.
                               *
                               * **Note:** The result of pipe is not automatically curried.
                               *
                               * @func
                               * @memberOf R
                               * @since v0.1.0
                               * @category Function
                               * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
                               * @param {...Function} functions
                               * @return {Function}
                               * @see R.compose
                               * @example
                               *
                               *      var f = R.pipe(Math.pow, R.negate, R.inc);
                               *
                               *      f(3, 4); // -(3^4) + 1
                               * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
                               */
module.exports = function pipe() {
  if (arguments.length === 0) {
    throw new Error('pipe requires at least one argument');
  }
  return _arity(arguments[0].length,
  reduce(_pipe, arguments[0], tail(arguments)));
};

/***/ }),

/***/ 1128:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
module.exports = function _pipe(f, g) {
  return function () {
    return g.call(this, f.apply(this, arguments));
  };
};

/***/ }),

/***/ 1129:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _iterator = __webpack_require__(79);var _iterator2 = _interopRequireDefault(_iterator);var _symbol = __webpack_require__(69);var _symbol2 = _interopRequireDefault(_symbol);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _xwrap = __webpack_require__(1130);
var bind = __webpack_require__(1131);
var isArrayLike = __webpack_require__(1132);


module.exports = function () {
  function _arrayReduce(xf, acc, list) {
    var idx = 0;
    var len = list.length;
    while (idx < len) {
      acc = xf['@@transducer/step'](acc, list[idx]);
      if (acc && acc['@@transducer/reduced']) {
        acc = acc['@@transducer/value'];
        break;
      }
      idx += 1;
    }
    return xf['@@transducer/result'](acc);
  }

  function _iterableReduce(xf, acc, iter) {
    var step = iter.next();
    while (!step.done) {
      acc = xf['@@transducer/step'](acc, step.value);
      if (acc && acc['@@transducer/reduced']) {
        acc = acc['@@transducer/value'];
        break;
      }
      step = iter.next();
    }
    return xf['@@transducer/result'](acc);
  }

  function _methodReduce(xf, acc, obj) {
    return xf['@@transducer/result'](obj.reduce(bind(xf['@@transducer/step'], xf), acc));
  }

  var symIterator = typeof _symbol2.default !== 'undefined' ? _iterator2.default : '@@iterator';
  return function _reduce(fn, acc, list) {
    if (typeof fn === 'function') {
      fn = _xwrap(fn);
    }
    if (isArrayLike(list)) {
      return _arrayReduce(fn, acc, list);
    }
    if (typeof list.reduce === 'function') {
      return _methodReduce(fn, acc, list);
    }
    if (list[symIterator] != null) {
      return _iterableReduce(fn, acc, list[symIterator]());
    }
    if (typeof list.next === 'function') {
      return _iterableReduce(fn, acc, list);
    }
    throw new TypeError('reduce: list must be array or iterable');
  };
}();

/***/ }),

/***/ 1130:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
module.exports = function () {
  function XWrap(fn) {
    this.f = fn;
  }
  XWrap.prototype['@@transducer/init'] = function () {
    throw new Error('init not implemented on XWrap');
  };
  XWrap.prototype['@@transducer/result'] = function (acc) {return acc;};
  XWrap.prototype['@@transducer/step'] = function (acc, x) {
    return this.f(acc, x);
  };

  return function _xwrap(fn) {return new XWrap(fn);};
}();

/***/ }),

/***/ 1131:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _arity = __webpack_require__(1054);
var _curry2 = __webpack_require__(996);


/**
                                              * Creates a function that is bound to a context.
                                              * Note: `R.bind` does not provide the additional argument-binding capabilities of
                                              * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
                                              *
                                              * @func
                                              * @memberOf R
                                              * @since v0.6.0
                                              * @category Function
                                              * @category Object
                                              * @sig (* -> *) -> {*} -> (* -> *)
                                              * @param {Function} fn The function to bind to context
                                              * @param {Object} thisObj The context to bind `fn` to
                                              * @return {Function} A function that will execute in the context of `thisObj`.
                                              * @see R.partial
                                              * @example
                                              *
                                              *      var log = R.bind(console.log, console);
                                              *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
                                              *      // logs {a: 2}
                                              * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
                                              */
module.exports = _curry2(function bind(fn, thisObj) {
  return _arity(fn.length, function () {
    return fn.apply(thisObj, arguments);
  });
});

/***/ }),

/***/ 1132:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _curry1 = __webpack_require__(985);
var _isArray = __webpack_require__(1056);
var _isString = __webpack_require__(1057);


/**
                                                  * Tests whether or not an object is similar to an array.
                                                  *
                                                  * @func
                                                  * @memberOf R
                                                  * @since v0.5.0
                                                  * @category Type
                                                  * @category List
                                                  * @sig * -> Boolean
                                                  * @param {*} x The object to test.
                                                  * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
                                                  * @deprecated since v0.23.0
                                                  * @example
                                                  *
                                                  *      R.isArrayLike([]); //=> true
                                                  *      R.isArrayLike(true); //=> false
                                                  *      R.isArrayLike({}); //=> false
                                                  *      R.isArrayLike({length: 10}); //=> false
                                                  *      R.isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
                                                  */
module.exports = _curry1(function isArrayLike(x) {
  if (_isArray(x)) {return true;}
  if (!x) {return false;}
  if ((typeof x === 'undefined' ? 'undefined' : (0, _typeof3.default)(x)) !== 'object') {return false;}
  if (_isString(x)) {return false;}
  if (x.nodeType === 1) {return !!x.length;}
  if (x.length === 0) {return true;}
  if (x.length > 0) {
    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
  }
  return false;
});

/***/ }),

/***/ 1133:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _checkForMethod = __webpack_require__(1058);
var _curry1 = __webpack_require__(985);
var slice = __webpack_require__(1134);


/**
                                 * Returns all but the first element of the given list or string (or object
                                 * with a `tail` method).
                                 *
                                 * Dispatches to the `slice` method of the first argument, if present.
                                 *
                                 * @func
                                 * @memberOf R
                                 * @since v0.1.0
                                 * @category List
                                 * @sig [a] -> [a]
                                 * @sig String -> String
                                 * @param {*} list
                                 * @return {*}
                                 * @see R.head, R.init, R.last
                                 * @example
                                 *
                                 *      R.tail([1, 2, 3]);  //=> [2, 3]
                                 *      R.tail([1, 2]);     //=> [2]
                                 *      R.tail([1]);        //=> []
                                 *      R.tail([]);         //=> []
                                 *
                                 *      R.tail('abc');  //=> 'bc'
                                 *      R.tail('ab');   //=> 'b'
                                 *      R.tail('a');    //=> ''
                                 *      R.tail('');     //=> ''
                                 */
module.exports = _curry1(_checkForMethod('tail', slice(1, Infinity)));

/***/ }),

/***/ 1134:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _checkForMethod = __webpack_require__(1058);
var _curry3 = __webpack_require__(1016);


/**
                                              * Returns the elements of the given list or string (or object with a `slice`
                                              * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
                                              *
                                              * Dispatches to the `slice` method of the third argument, if present.
                                              *
                                              * @func
                                              * @memberOf R
                                              * @since v0.1.4
                                              * @category List
                                              * @sig Number -> Number -> [a] -> [a]
                                              * @sig Number -> Number -> String -> String
                                              * @param {Number} fromIndex The start index (inclusive).
                                              * @param {Number} toIndex The end index (exclusive).
                                              * @param {*} list
                                              * @return {*}
                                              * @example
                                              *
                                              *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
                                              *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
                                              *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
                                              *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
                                              *      R.slice(0, 3, 'ramda');                     //=> 'ram'
                                              */
module.exports = _curry3(_checkForMethod('slice', function slice(fromIndex, toIndex, list) {
  return Array.prototype.slice.call(list, fromIndex, toIndex);
}));

/***/ }),

/***/ 1135:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _curry1 = __webpack_require__(985);
var _isString = __webpack_require__(1057);


/**
                                                  * Returns a new list or string with the elements or characters in reverse
                                                  * order.
                                                  *
                                                  * @func
                                                  * @memberOf R
                                                  * @since v0.1.0
                                                  * @category List
                                                  * @sig [a] -> [a]
                                                  * @sig String -> String
                                                  * @param {Array|String} list
                                                  * @return {Array|String}
                                                  * @example
                                                  *
                                                  *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
                                                  *      R.reverse([1, 2]);     //=> [2, 1]
                                                  *      R.reverse([1]);        //=> [1]
                                                  *      R.reverse([]);         //=> []
                                                  *
                                                  *      R.reverse('abc');      //=> 'cba'
                                                  *      R.reverse('ab');       //=> 'ba'
                                                  *      R.reverse('a');        //=> 'a'
                                                  *      R.reverse('');         //=> ''
                                                  */
module.exports = _curry1(function reverse(list) {
  return _isString(list) ? list.split('').reverse().join('') :
  Array.prototype.slice.call(list, 0).reverse();
});

/***/ }),

/***/ 1136:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _curry2 = __webpack_require__(996);


/**
                                                           * Returns a partial copy of an object containing only the keys that satisfy
                                                           * the supplied predicate.
                                                           *
                                                           * @func
                                                           * @memberOf R
                                                           * @since v0.8.0
                                                           * @category Object
                                                           * @sig (v, k -> Boolean) -> {k: v} -> {k: v}
                                                           * @param {Function} pred A predicate to determine whether or not a key
                                                           *        should be included on the output object.
                                                           * @param {Object} obj The object to copy from
                                                           * @return {Object} A new object with only properties that satisfy `pred`
                                                           *         on it.
                                                           * @see R.pick, R.filter
                                                           * @example
                                                           *
                                                           *      var isUpperCase = (val, key) => key.toUpperCase() === key;
                                                           *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
                                                           */
module.exports = _curry2(function pickBy(test, obj) {
  var result = {};
  for (var prop in obj) {
    if (test(obj[prop], prop, obj)) {
      result[prop] = obj[prop];
    }
  }
  return result;
});

/***/ }),

/***/ 1137:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(1138);

if (typeof content === 'string') {
  content = [[module.i, content, '']];
}

var options = {"attributes":{}}

options.insert = "head";
options.singleton = false;

var update = __webpack_require__(491)(content, options);

if (content.locals) {
  module.exports = content.locals;
}


/***/ }),

/***/ 1138:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(undefined);
// imports


// module
exports.push([module.i, ":root{--palette-red-50:#ffebee;--palette-red-100:#ffcdd2;--palette-red-200:#ef9a9a;--palette-red-300:#e57373;--palette-red-400:#ef5350;--palette-red-500:#f44336;--palette-red-600:#e53935;--palette-red-700:#d32f2f;--palette-red-800:#c62828;--palette-red-900:#b71c1c;--palette-red-a100:#ff8a80;--palette-red-a200:#ff5252;--palette-red-a400:#ff1744;--palette-red-a700:#d50000;--palette-pink-50:#fce4ec;--palette-pink-100:#f8bbd0;--palette-pink-200:#f48fb1;--palette-pink-300:#f06292;--palette-pink-400:#ec407a;--palette-pink-500:#e91e63;--palette-pink-600:#d81b60;--palette-pink-700:#c2185b;--palette-pink-800:#ad1457;--palette-pink-900:#880e4f;--palette-pink-a100:#ff80ab;--palette-pink-a200:#ff4081;--palette-pink-a400:#f50057;--palette-pink-a700:#c51162;--palette-purple-50:#f3e5f5;--palette-purple-100:#e1bee7;--palette-purple-200:#ce93d8;--palette-purple-300:#ba68c8;--palette-purple-400:#ab47bc;--palette-purple-500:#9c27b0;--palette-purple-600:#8e24aa;--palette-purple-700:#7b1fa2;--palette-purple-800:#6a1b9a;--palette-purple-900:#4a148c;--palette-purple-a100:#ea80fc;--palette-purple-a200:#e040fb;--palette-purple-a400:#d500f9;--palette-purple-a700:#a0f;--palette-deep-purple-50:#ede7f6;--palette-deep-purple-100:#d1c4e9;--palette-deep-purple-200:#b39ddb;--palette-deep-purple-300:#9575cd;--palette-deep-purple-400:#7e57c2;--palette-deep-purple-500:#673ab7;--palette-deep-purple-600:#5e35b1;--palette-deep-purple-700:#512da8;--palette-deep-purple-800:#4527a0;--palette-deep-purple-900:#311b92;--palette-deep-purple-a100:#b388ff;--palette-deep-purple-a200:#7c4dff;--palette-deep-purple-a400:#651fff;--palette-deep-purple-a700:#6200ea;--palette-indigo-50:#e8eaf6;--palette-indigo-100:#c5cae9;--palette-indigo-200:#9fa8da;--palette-indigo-300:#7986cb;--palette-indigo-400:#5c6bc0;--palette-indigo-500:#3f51b5;--palette-indigo-600:#3949ab;--palette-indigo-700:#303f9f;--palette-indigo-800:#283593;--palette-indigo-900:#1a237e;--palette-indigo-a100:#8c9eff;--palette-indigo-a200:#536dfe;--palette-indigo-a400:#3d5afe;--palette-indigo-a700:#304ffe;--palette-blue-50:#e3f2fd;--palette-blue-100:#bbdefb;--palette-blue-200:#90caf9;--palette-blue-300:#64b5f6;--palette-blue-400:#42a5f5;--palette-blue-500:#2196f3;--palette-blue-600:#1e88e5;--palette-blue-700:#1976d2;--palette-blue-800:#1565c0;--palette-blue-900:#0d47a1;--palette-blue-a100:#82b1ff;--palette-blue-a200:#448aff;--palette-blue-a400:#2979ff;--palette-blue-a700:#2962ff;--palette-light-blue-50:#e1f5fe;--palette-light-blue-100:#b3e5fc;--palette-light-blue-200:#81d4fa;--palette-light-blue-300:#4fc3f7;--palette-light-blue-400:#29b6f6;--palette-light-blue-500:#03a9f4;--palette-light-blue-600:#039be5;--palette-light-blue-700:#0288d1;--palette-light-blue-800:#0277bd;--palette-light-blue-900:#01579b;--palette-light-blue-a100:#80d8ff;--palette-light-blue-a200:#40c4ff;--palette-light-blue-a400:#00b0ff;--palette-light-blue-a700:#0091ea;--palette-cyan-50:#e0f7fa;--palette-cyan-100:#b2ebf2;--palette-cyan-200:#80deea;--palette-cyan-300:#4dd0e1;--palette-cyan-400:#26c6da;--palette-cyan-500:#00bcd4;--palette-cyan-600:#00acc1;--palette-cyan-700:#0097a7;--palette-cyan-800:#00838f;--palette-cyan-900:#006064;--palette-cyan-a100:#84ffff;--palette-cyan-a200:#18ffff;--palette-cyan-a400:#00e5ff;--palette-cyan-a700:#00b8d4;--palette-teal-50:#e0f2f1;--palette-teal-100:#b2dfdb;--palette-teal-200:#80cbc4;--palette-teal-300:#4db6ac;--palette-teal-400:#26a69a;--palette-teal-500:#009688;--palette-teal-600:#00897b;--palette-teal-700:#00796b;--palette-teal-800:#00695c;--palette-teal-900:#004d40;--palette-teal-a100:#a7ffeb;--palette-teal-a200:#64ffda;--palette-teal-a400:#1de9b6;--palette-teal-a700:#00bfa5;--palette-green-50:#e8f5e9;--palette-green-100:#c8e6c9;--palette-green-200:#a5d6a7;--palette-green-300:#81c784;--palette-green-400:#66bb6a;--palette-green-500:#4caf50;--palette-green-600:#43a047;--palette-green-700:#388e3c;--palette-green-800:#2e7d32;--palette-green-900:#1b5e20;--palette-green-a100:#b9f6ca;--palette-green-a200:#69f0ae;--palette-green-a400:#00e676;--palette-green-a700:#00c853;--palette-light-green-50:#f1f8e9;--palette-light-green-100:#dcedc8;--palette-light-green-200:#c5e1a5;--palette-light-green-300:#aed581;--palette-light-green-400:#9ccc65;--palette-light-green-500:#8bc34a;--palette-light-green-600:#7cb342;--palette-light-green-700:#689f38;--palette-light-green-800:#558b2f;--palette-light-green-900:#33691e;--palette-light-green-a100:#ccff90;--palette-light-green-a200:#b2ff59;--palette-light-green-a400:#76ff03;--palette-light-green-a700:#64dd17;--palette-lime-50:#f9fbe7;--palette-lime-100:#f0f4c3;--palette-lime-200:#e6ee9c;--palette-lime-300:#dce775;--palette-lime-400:#d4e157;--palette-lime-500:#cddc39;--palette-lime-600:#c0ca33;--palette-lime-700:#afb42b;--palette-lime-800:#9e9d24;--palette-lime-900:#827717;--palette-lime-a100:#f4ff81;--palette-lime-a200:#eeff41;--palette-lime-a400:#c6ff00;--palette-lime-a700:#aeea00;--palette-yellow-50:#fffde7;--palette-yellow-100:#fff9c4;--palette-yellow-200:#fff59d;--palette-yellow-300:#fff176;--palette-yellow-400:#ffee58;--palette-yellow-500:#ffeb3b;--palette-yellow-600:#fdd835;--palette-yellow-700:#fbc02d;--palette-yellow-800:#f9a825;--palette-yellow-900:#f57f17;--palette-yellow-a100:#ffff8d;--palette-yellow-a200:#ff0;--palette-yellow-a400:#ffea00;--palette-yellow-a700:#ffd600;--palette-amber-50:#fff8e1;--palette-amber-100:#ffecb3;--palette-amber-200:#ffe082;--palette-amber-300:#ffd54f;--palette-amber-400:#ffca28;--palette-amber-500:#ffc107;--palette-amber-600:#ffb300;--palette-amber-700:#ffa000;--palette-amber-800:#ff8f00;--palette-amber-900:#ff6f00;--palette-amber-a100:#ffe57f;--palette-amber-a200:#ffd740;--palette-amber-a400:#ffc400;--palette-amber-a700:#ffab00;--palette-orange-50:#fff3e0;--palette-orange-100:#ffe0b2;--palette-orange-200:#ffcc80;--palette-orange-300:#ffb74d;--palette-orange-400:#ffa726;--palette-orange-500:#ff9800;--palette-orange-600:#fb8c00;--palette-orange-700:#f57c00;--palette-orange-800:#ef6c00;--palette-orange-900:#e65100;--palette-orange-a100:#ffd180;--palette-orange-a200:#ffab40;--palette-orange-a400:#ff9100;--palette-orange-a700:#ff6d00;--palette-deep-orange-50:#fbe9e7;--palette-deep-orange-100:#ffccbc;--palette-deep-orange-200:#ffab91;--palette-deep-orange-300:#ff8a65;--palette-deep-orange-400:#ff7043;--palette-deep-orange-500:#ff5722;--palette-deep-orange-600:#f4511e;--palette-deep-orange-700:#e64a19;--palette-deep-orange-800:#d84315;--palette-deep-orange-900:#bf360c;--palette-deep-orange-a100:#ff9e80;--palette-deep-orange-a200:#ff6e40;--palette-deep-orange-a400:#ff3d00;--palette-deep-orange-a700:#dd2c00;--palette-brown-50:#efebe9;--palette-brown-100:#d7ccc8;--palette-brown-200:#bcaaa4;--palette-brown-300:#a1887f;--palette-brown-400:#8d6e63;--palette-brown-500:#795548;--palette-brown-600:#6d4c41;--palette-brown-700:#5d4037;--palette-brown-800:#4e342e;--palette-brown-900:#3e2723;--palette-grey-50:#fafafa;--palette-grey-100:#f5f5f5;--palette-grey-200:#eee;--palette-grey-300:#e0e0e0;--palette-grey-400:#bdbdbd;--palette-grey-500:#9e9e9e;--palette-grey-600:#757575;--palette-grey-700:#616161;--palette-grey-800:#424242;--palette-grey-900:#212121;--palette-blue-grey-50:#eceff1;--palette-blue-grey-100:#cfd8dc;--palette-blue-grey-200:#b0bec5;--palette-blue-grey-300:#90a4ae;--palette-blue-grey-400:#78909c;--palette-blue-grey-500:#607d8b;--palette-blue-grey-600:#546e7a;--palette-blue-grey-700:#455a64;--palette-blue-grey-800:#37474f;--palette-blue-grey-900:#263238;--color-black:#000;--color-white:#fff;--color-dark-contrast:var(--color-white);--color-light-contrast:var(--color-black);--color-divider:var(--palette-grey-200);--color-background:var(--color-white);--color-text:var(--palette-grey-900);--color-text-secondary:var(--palette-grey-600);--color-primary:var(--palette-indigo-500);--color-primary-dark:var(--palette-indigo-700);--color-accent:var(--palette-pink-a200);--color-accent-dark:var(--palette-pink-700);--color-primary-contrast:var(--color-dark-contrast);--color-accent-contrast:var(--color-dark-contrast);--unit:10px;--preferred-font:\"Roboto\",\"Helvetica\",\"Arial\",sans-serif;--font-size:calc(1.6 * var(--unit));--font-size-tiny:calc(1.2 * var(--unit));--font-size-small:calc(1.4 * var(--unit));--font-size-normal:var(--font-size);--font-size-big:calc(1.8 * var(--unit));--font-weight-thin:300;--font-weight-normal:400;--font-weight-semi-bold:500;--font-weight-bold:700;--shadow-2p:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12);--shadow-3p:0 3px 4px 0 rgba(0,0,0,.14),0 3px 3px -2px rgba(0,0,0,.2),0 1px 8px 0 rgba(0,0,0,.12);--shadow-4p:0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12),0 2px 4px -1px rgba(0,0,0,.2);--shadow-6p:0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12),0 3px 5px -1px rgba(0,0,0,.2);--shadow-8p:0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12),0 5px 5px -3px rgba(0,0,0,.2);--shadow-16p:0 16px 24px 2px rgba(0,0,0,.14),0 6px 30px 5px rgba(0,0,0,.12),0 8px 10px -5px rgba(0,0,0,.2);--shadow-key-umbra-opacity:0.2;--shadow-key-penumbra-opacity:0.14;--shadow-ambient-shadow-opacity:0.12;--zdepth-shadow-1:0 1px 6px rgba(0,0,0,.12),0 1px 4px rgba(0,0,0,.24);--zdepth-shadow-2:0 3px 10px rgba(0,0,0,.16),0 3px 10px rgba(0,0,0,.23);--zdepth-shadow-3:0 10px 30px rgba(0,0,0,.19),0 6px 10px rgba(0,0,0,.23);--zdepth-shadow-4:0 14px 45px rgba(0,0,0,.25),0 10px 18px rgba(0,0,0,.22);--zdepth-shadow-5:0 19px 60px rgba(0,0,0,.3),0 15px 20px rgba(0,0,0,.22);--animation-duration:0.35s;--animation-delay:calc(var(--animation-duration) / 5);--animation-curve-fast-out-slow-in:cubic-bezier(0.4,0,0.2,1);--animation-curve-linear-out-slow-in:cubic-bezier(0,0,0.2,1);--animation-curve-fast-out-linear-in:cubic-bezier(0.4,0,1,1);--animation-curve-default:var(--animation-curve-fast-out-slow-in);--z-index-highest:300;--z-index-higher:200;--z-index-high:100;--z-index-normal:1;--z-index-low:-100;--z-index-lower:-200;--input-padding:calc(2 * var(--unit));--input-field-padding:calc(0.8 * var(--unit));--input-field-font-size:calc(1.6 * var(--unit));--input-field-height:calc(var(--input-field-padding) * 2 + var(--input-field-font-size) * 1.4);--input-label-font-size:calc(1.2 * var(--unit));--input-focus-label-top:calc(0.6 * var(--unit));--input-text-background-color:transparent;--input-text-label-color:color(var(--color-text) a(26%));--input-text-input-element-color:var(--color-text);--input-text-bottom-border-color:color(var(--color-text) a(12%));--input-text-highlight-color:var(--color-primary);--input-text-disabled-color:var(--input-text-bottom-border-color);--input-text-disabled-text-color:var(--input-text-label-color);--input-text-error-color:#de3226;--input-text-required-color:#de3226;--input-underline-height:calc(2 * var(--unit));--input-icon-font-size:calc(2.4 * var(--unit));--input-icon-size:calc(2 * var(--input-icon-font-size));--input-icon-offset:calc(1.6 * var(--unit));--input-icon-right-space:calc(2 * var(--unit));--input-chevron-offset:calc(0.8 * var(--unit));--input-hint-opacity:1}.input{padding:var(--input-padding) 0;position:relative;font-family:var(--preferred-font)}.input,.input *,.input :after,.input :before{box-sizing:border-box;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;text-size-adjust:100%}.input *,.input :after,.input :before{-webkit-touch-callout:none}.input.withIcon{margin-left:calc(var(--input-icon-size) + var(--input-icon-right-space))}.icon{color:var(--input-text-label-color);display:block;font-size:var(--input-icon-font-size)!important;height:var(--input-icon-size);left:calc(-1 * (var(--input-icon-size) + var(--input-icon-right-space)));line-height:var(--input-icon-size)!important;position:absolute;text-align:center;top:var(--input-icon-offset);transition:color var(--animation-duration) var(--animation-curve-default);width:var(--input-icon-size)}.inputElement{background-color:var(--input-text-background-color);border-bottom:1px solid var(--input-text-bottom-border-color);border-left:0;border-radius:0;border-right:0;border-top:0;color:var(--input-text-input-element-color);display:block;font-size:var(--input-field-font-size);outline:none;padding:var(--input-field-padding) 0;width:100%}.inputElement:required{box-shadow:none}.inputElement:focus:not([disabled]):not([readonly])~.label:not(.fixed){color:var(--input-text-highlight-color)}.inputElement:focus:not([disabled]):not([readonly])~.label>.required{color:var(--input-text-required-color)}.inputElement:focus:not([disabled]):not([readonly])~.hint{display:block;opacity:var(--input-hint-opacity)}.inputElement:focus:not([disabled]):not([readonly])~.icon{color:var(--input-text-highlight-color)}.inputElement:focus:not([disabled]):not([readonly]).filled~.hint{opacity:0}.inputElement.filled~.label:not(.fixed),.inputElement:focus:not([disabled]):not([readonly])~.label:not(.fixed),.inputElement[type=date]~.label:not(.fixed),.inputElement[type=time]~.label:not(.fixed){font-size:var(--input-label-font-size);top:var(--input-focus-label-top)}.inputElement.filled~.hint,.inputElement.filled~.label.fixed{display:none}.label{color:var(--input-text-label-color);font-size:var(--input-field-font-size);left:0;line-height:var(--input-field-font-size);pointer-events:none;position:absolute;top:calc(var(--input-padding) + 1.5 * var(--input-field-padding));transition-duration:var(--animation-duration);transition-property:top,font-size,color;transition-timing-function:var(--animation-curve-default)}.label.fixed~.hint{display:none}.hint{color:var(--input-text-label-color);font-size:var(--input-field-font-size);left:0;line-height:var(--input-field-font-size);opacity:var(--input-hint-opacity);pointer-events:none;position:absolute;top:calc(var(--input-padding) + 1.5 * var(--input-field-padding));transition-duration:var(--animation-duration);transition-property:opacity;transition-timing-function:var(--animation-curve-default)}.counter,.error{color:var(--input-text-error-color);font-size:var(--input-label-font-size);line-height:var(--input-underline-height);margin-bottom:calc(-1 * var(--input-underline-height))}.counter{color:var(--input-text-label-color);position:absolute;right:0}.disabled>.inputElement{border-bottom-style:dashed;color:var(--input-text-disabled-text-color)}.errored{padding-bottom:0}.errored>.inputElement{border-bottom-color:var(--input-text-error-color);margin-top:1px}.errored>.counter,.errored>.label{color:var(--input-text-error-color)}.errored>.label>.required{color:var(--input-text-required-color)}.hidden{display:none}", ""]);

// exports


/***/ }),

/***/ 1139:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });__webpack_require__(76);
var _reselect = __webpack_require__(221);
var _resource = __webpack_require__(163);
var _resource2 = __webpack_require__(106);
var recentCategoryIds = (0, _reselect.createSelector)(_resource2.notesResource.selectors.items, _resource.bookmarksResource.selectors.items, function (notes, bookmarks) {
    return [].concat(notes.qSelect(function (x) {return { id: x.categoryId, lastEdited: new Date(x.lastEdited).getTime() };}), bookmarks.qSelect(function (x) {return { id: x.categoryId, lastEdited: new Date(x.lastEdited).getTime() };})).
    sort(function (a, b) {return b.lastEdited - a.lastEdited;}).qDistinct(function (x) {return x.id;});
});exports.default =
{
    mostUsed: recentCategoryIds };

/***/ }),

/***/ 1140:
/***/ (function(module, exports, __webpack_require__) {


        // classnames-loader: automatically bind css-modules to classnames
        var classNames = __webpack_require__(492);
        var locals = __webpack_require__(1141);
        var css = classNames.bind(locals);
        for (var style in locals) css[style] = locals[style];
        module.exports = css;
    

/***/ }),

/***/ 1141:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(1142);

if (typeof content === 'string') {
  content = [[module.i, content, '']];
}

var options = {"attributes":{}}

options.insert = "head";
options.singleton = false;

var update = __webpack_require__(491)(content, options);

if (content.locals) {
  module.exports = content.locals;
}


/***/ }),

/***/ 1142:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(undefined);
// imports


// module
exports.push([module.i, "._2x5FSqw2{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\"}.rfWl0TNo{padding:1px;background:#fff;border:2px solid transparent;border-radius:100px}.rfWl0TNo,.rfWl0TNo span{-webkit-transition:all .5s ease-in-out;transition:all .5s ease-in-out}.rfWl0TNo span{padding:9px 16px 8px;background:#4b55f6;font-size:12px;line-height:18px;letter-spacing:1.2px;text-align:center;color:#fff;display:inline-block;border-radius:100px;font-weight:700;text-transform:uppercase}.rfWl0TNo:hover span{background:#30379d}.rfWl0TNo:focus{border-color:#30379d;outline:none}.rfWl0TNo:focus span{background:#30379d}.rfWl0TNo._2YGW1YXG{cursor:not-allowed}.rfWl0TNo._2YGW1YXG span{background:#f4f4f8;color:#6e6e77}.rfWl0TNo._1SzKdC3l{display:inline-block;width:40px;height:40px;border-radius:100%;background:#4b55f6;color:#fff;margin-right:8px}.rfWl0TNo.GH0OTYb_ span{background:#fff;color:#4b55f6;border:1px solid #4b55f6;letter-spacing:.36px}.rfWl0TNo.GH0OTYb_:hover span{background:#f4f4f8}.rfWl0TNo.GH0OTYb_:focus{border-color:#30379d}.rfWl0TNo.GH0OTYb_._2YGW1YXG{cursor:not-allowed}.rfWl0TNo.GH0OTYb_._2YGW1YXG span{color:#6e6e77;border-color:#6e6e77;background:#f4f4f8}.rfWl0TNo._1uF1xiFf span{background:#fff;color:#4b55f6;border:1px solid #4b55f6}.rfWl0TNo._1uF1xiFf span:before{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";margin-right:3px;vertical-align:middle;display:inline-block}.rfWl0TNo._1uF1xiFf:hover span{background:#f4f4f8}.rfWl0TNo._1uF1xiFf:focus{border-color:#30379d}.rfWl0TNo._1uF1xiFf._2YGW1YXG{cursor:not-allowed}.rfWl0TNo._1uF1xiFf._2YGW1YXG span{color:#6e6e77;border-color:#6e6e77;background:#f4f4f8}.rfWl0TNo._29EV6YHF span{background:transparent;color:#414141;letter-spacing:.36px}.rfWl0TNo._29EV6YHF:hover span{background:#f4f4f8}.rfWl0TNo._29EV6YHF:focus{border-color:#30379d}.rfWl0TNo._29EV6YHF:focus span{background:#f4f4f8}.rfWl0TNo._29EV6YHF._2YGW1YXG{cursor:not-allowed}.rfWl0TNo._29EV6YHF._2YGW1YXG span{background:#f4f4f8;color:#6e6e77}.VKtOiimH{color:#4b55f6;letter-spacing:.42px;line-height:19px;font-size:14px;text-transform:uppercase;padding:6px 8px;position:relative;border:none;background:transparent;font-weight:700}.VKtOiimH.xuA9P37k:before{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";content:\"\\E5C4\";color:#4b55f6;font-size:28px;margin-right:6px;width:24px;vertical-align:middle}.wUJf5GMr{width:100%;border-radius:4px;background:#fff;border:2px solid #fff;padding:6px 40px 6px 16px;text-align:left;position:relative;outline-color:#4b55f6}.wUJf5GMr,.wUJf5GMr span{display:inline-block}.wUJf5GMr span._3Ftsc2rp{font-size:12px;line-height:16px;font-weight:300;color:#414141;padding:10px 34px 10px 8px;font-style:italic;white-space:normal}.wUJf5GMr span.O_QIw6Nv{position:absolute;top:50%;right:16px;float:right;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:24px;height:24px}.wUJf5GMr span.O_QIw6Nv:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle;color:#4b55f6}.wUJf5GMr span.O_QIw6Nv._2KU3K_Co:after{content:\"\\E5CF\"}.wUJf5GMr span.O_QIw6Nv._2Y5dWObI:after{content:\"\\E5CE\"}.wUJf5GMr:focus{outline-color:#4b55f6}.rfWl0TNo._1QiSDfn0{border-radius:50%;width:40px;height:40px;position:relative}.rfWl0TNo._1QiSDfn0 span{border-radius:50%;font-size:16px;background:transparent;width:34px;height:34px;padding:5px;margin:0;-webkit-box-shadow:none;box-shadow:none}.rfWl0TNo._1QiSDfn0 span,.rfWl0TNo._1QiSDfn0 span:after{color:#4b55f6;display:inline-block;position:relative}.rfWl0TNo._1QiSDfn0 span:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\"}.rfWl0TNo._1QiSDfn0:hover span{background:#f4f4f8}.rfWl0TNo._1QiSDfn0:focus{border-color:#4b55f6}.rfWl0TNo._1QiSDfn0:focus span{background:#f4f4f8}.rfWl0TNo._1QiSDfn0._2YGW1YXG span{background:#f4f4f8;color:#6e6e77}.rfWl0TNo._1QiSDfn0._3QQ0b845 span:after{content:\"\\E7FD\"}.rfWl0TNo._1QiSDfn0._3Wup2ftf span:after{content:\"\\F233\"}.rfWl0TNo._1QiSDfn0._1DfJCsmz span:after{content:\"\\F1CF\"}.rfWl0TNo._1QiSDfn0._1AFqJanb span:after{content:\"\\F1CE\";font-family:Material Icons Outlined}.rfWl0TNo._1QiSDfn0._1GFhV_z1 span:after{content:\"\\EAAA\";font-family:Material Icons Outlined}.rfWl0TNo._1QiSDfn0._3X9RztJd span:after{content:\"\\E86C\";font-family:Material Icons Outlined}.rfWl0TNo._1QiSDfn0._29F-3dKk span:after{content:\"\\E876\"}.rfWl0TNo._1QiSDfn0.eEK9OGxa span:after{content:\"\\E835\";font-family:Material Icons Outlined}.rfWl0TNo._1QiSDfn0._1YOfZCnY span:after{content:\"\\E834\"}.rfWl0TNo._1QiSDfn0.Px3SEi0e span:after{content:\"\\E5CF\"}.rfWl0TNo._1QiSDfn0._1X8WneZP span:after{content:\"\\E5CE\"}.rfWl0TNo._1QiSDfn0._6Nnb2qTu span:after{content:\"\\E5CD\"}.rfWl0TNo._1QiSDfn0._2Is6GeGS span:after{content:\"\\E0C6\"}.rfWl0TNo._1QiSDfn0._1X9cboMZ span:after{content:\"\\E5D4\"}.rfWl0TNo._1QiSDfn0._3aWD7mqz span:after{content:\"\\E880\"}.rfWl0TNo._1QiSDfn0._1vRUwLpJ span:after{content:\"\\EF4F\";font-family:Material Icons Outlined}.rfWl0TNo._1QiSDfn0.DNQWRPXe span:after{content:\"\\E87D\"}.rfWl0TNo._1QiSDfn0.cuNayX-5 span:after{content:\"\\E87E\";font-family:Material Icons Outlined}.rfWl0TNo._1QiSDfn0._2zOZb1Dl span:after{content:\"\\E41A\"}.rfWl0TNo._1QiSDfn0._2ljXgNF8 span:after{content:\"\\E8B6\"}.rfWl0TNo._1QiSDfn0._18vQxi8i span:after{content:\"\\E0B7\"}.rfWl0TNo._1QiSDfn0.r1nUo43X span:after{content:\"\\E150\"}.rfWl0TNo._1QiSDfn0._1LFoEIk_ span:after{content:\"\\E150\";font-family:Material Icons Outlined}.rfWl0TNo._1QiSDfn0._ovdmRq9 span:after{content:\"\\E145\"}.rfWl0TNo._1QiSDfn0._3jjIDAYm span:after{content:\"\\E836\"}.rfWl0TNo._1QiSDfn0.DnV7oSvp span:after{content:\"\\E837\"}.rfWl0TNo._1QiSDfn0._1ClGA47H span:after{content:\"\\E163\"}.rfWl0TNo._1QiSDfn0._11r-hW1D span:after{content:\"\\E0B7\";font-family:Material Icons Outlined}.rfWl0TNo._1QiSDfn0._2DrEoxiW span:after{content:\"\\E872\";font-family:Material Icons Outlined}.rfWl0TNo._1QiSDfn0.SEOi3x5D span:after{content:\"\\E5C4\"}.rfWl0TNo._1QiSDfn0._24-pJniw span:after{content:\"\\E5C8\"}.rfWl0TNo._1QiSDfn0._1_cOOjTv,.rfWl0TNo._1QiSDfn0._1h9TjUI5{background:transparent;border-radius:0;color:#555;padding:0;height:28px;width:28px}.rfWl0TNo._1QiSDfn0._1_cOOjTv span,.rfWl0TNo._1QiSDfn0._1h9TjUI5 span{padding:0;height:24px;width:24px}.rfWl0TNo._1QiSDfn0._1_cOOjTv span:after,.rfWl0TNo._1QiSDfn0._1h9TjUI5 span:after{color:#555}.rfWl0TNo._1QiSDfn0._1_cOOjTv._1mNuOO5k,.rfWl0TNo._1QiSDfn0._1_cOOjTv._1mNuOO5k span:after,.rfWl0TNo._1QiSDfn0._1h9TjUI5._1mNuOO5k,.rfWl0TNo._1QiSDfn0._1h9TjUI5._1mNuOO5k span:after{color:#4b55f6}.rfWl0TNo._1QiSDfn0._1_cOOjTv span:after{content:\"\\E8EF\"}.rfWl0TNo._1QiSDfn0._1h9TjUI5 span:after{content:\"\\E9B0\"}.rfWl0TNo._2FMmXQjJ{position:relative;padding:0;border:none;border-radius:0}.rfWl0TNo._2FMmXQjJ span{color:#4b55f6;font-size:16px;background:transparent;display:inline-block;width:24px;height:24px;position:relative;margin:0;-webkit-box-shadow:none;box-shadow:none;padding:0;padding:5px}.rfWl0TNo._2FMmXQjJ span:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";font-size:14px;font-weight:700}.rfWl0TNo._2FMmXQjJ:hover span{background:#f4f4f8}.rfWl0TNo._2FMmXQjJ._1X9cboMZ span:after{content:\"\\E5D4\"}._3nUlwz41 .TgwbwqUA{display:none}._3nUlwz41 .TgwbwqUA+._2rX9NpuV{display:inline-block}._3nUlwz41 .TgwbwqUA+._2rX9NpuV:before{content:\"\\E835\";font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle}._3nUlwz41 .TgwbwqUA:checked+._2rX9NpuV:before{content:\"\\E834\"}._3nUlwz41 span{padding-left:14px}._1dA_tlXK{display:block}._1dA_tlXK input[type=radio]{position:absolute;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";opacity:0}._1dA_tlXK input[type=radio]+._3fUCRJT7:before{content:\"\\E836\";font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle}._1dA_tlXK input[type=radio]+._3fUCRJT7 span{padding-left:14px;font-size:12px;line-height:16px;color:#414141;font-weight:400}._1dA_tlXK input[type=radio]:checked+._3fUCRJT7:before{content:\"\\E837\"}._1dA_tlXK input[type=radio]+._3fUCRJT7:empty:before{margin-right:0}.APDu2RXy{position:relative;display:block;padding:16px;width:100%;-webkit-box-shadow:0 0 10px rgba(0,0,0,.1);box-shadow:0 0 10px rgba(0,0,0,.1);border-radius:12px;border:1px solid #e6e6e6;border:1px solid rgba(0,0,0,.1);overflow:hidden;text-overflow:ellipsis;background:#fff;-webkit-box-shadow:0 0 10px #0000001a 1a;box-shadow:0 0 10px 1a #0000001a;margin:0 0 8px}.IMN6Uy0E{font-size:14px;display:block;height:45px;padding:4px 0;margin:10px 0;color:#555;border-bottom:2px solid rgba(0,0,0,.2)}._3075rQSZ{top:50%;right:0;-webkit-transform:translateY(-50%);transform:translateY(-50%);color:#ccc;color:rgba(0,0,0,.2)}._2veK3gUo,._3075rQSZ{position:absolute}._2veK3gUo{font-size:14px;line-height:14px;top:10px;left:0;-webkit-transition-timing-function:cubic-bezier(.4,0,.2,1);transition-timing-function:cubic-bezier(.4,0,.2,1);-webkit-transition-duration:.2s;transition-duration:.2s;-webkit-transition-property:top,font-size,color;transition-property:top,font-size,color;pointer-events:none}._1ObZaEAa~._2veK3gUo{top:4px}._1twIhlCY{font-size:12px;font-weight:700;line-height:16px;display:block;width:100%;color:#414141;letter-spacing:0;margin-bottom:4px;margin-top:16px}._3LOheOZE{font-weight:300;line-height:24px;padding:16px;-webkit-transition:background .3s ease;transition:background .3s ease;margin-bottom:8px;background-color:#fff;border-radius:12px;border:2px solid transparent;-webkit-box-shadow:0 0 10px #0000001A 1a;box-shadow:0 0 10px 1a #0000001A;margin-left:2px}._3Lni1ArU{position:absolute;right:40px;bottom:40px}._2xox096H{position:absolute;top:5px;right:10px}._8tjUu1sN{overflow-y:auto;max-height:340px}.a9Czzvve{padding:40px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._3LOheOZE:hover{cursor:pointer}._3l-iWzwT{display:block}._2NYEsDtz{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";opacity:0}._20_FSMJn{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";opacity:1}._1xSM0sKX{visibility:hidden;position:absolute;overflow:hidden;clip:rect(0 0 0 0);height:1px;width:1px;margin:-1px;padding:0;border:0}._1i1oBQxu{font-size:16px;width:40px;height:40px;margin:0;padding:0;color:#26c6da!important;padding:0!important;border-radius:50%}._3BinViSA span{font-size:22px!important;vertical-align:middle}._2PzfkWbw{padding:0 16px 16px}._2PzfkWbw ._3Mb10Pzs{display:block;width:100%;margin-bottom:8px}._2PzfkWbw ._12-wLp3a{font-weight:700;line-height:18px;letter-spacing:.42px;color:#414141;font-size:14px}._31DQwmtb{position:relative;padding:9px 16px}._31DQwmtb ._3Mb10Pzs ._1uF1xiFf span{font-weight:700}._31DQwmtb ._3Mb10Pzs ._1uF1xiFf span._3YCt5RqZ:before{content:\"\\E145\";position:relative;top:-1px;left:-5px}.ppSVQt0E{max-width:275px}", ""]);

// exports
exports.locals = {
	"material-icons": "_2x5FSqw2",
	"btn": "rfWl0TNo",
	"disabled": "_2YGW1YXG",
	"user-btn": "_1SzKdC3l",
	"secondary-btn": "GH0OTYb_",
	"secondary-button_icon": "_1uF1xiFf",
	"ghost-btn": "_29EV6YHF",
	"btn-icon-text_back": "VKtOiimH",
	"icon_arrow-back": "xuA9P37k",
	"btn-type-dropdown": "wUJf5GMr",
	"default-header": "_3Ftsc2rp",
	"icon": "O_QIw6Nv",
	"icon_chevron-down": "_2KU3K_Co",
	"icon_chevron-up": "_2Y5dWObI",
	"icon-btn": "_1QiSDfn0",
	"account": "_3QQ0b845",
	"account_group": "_3Wup2ftf",
	"collapse": "_1DfJCsmz",
	"expand": "_1AFqJanb",
	"arrow_right": "_1GFhV_z1",
	"check_circle": "_3X9RztJd",
	"check": "_29F-3dKk",
	"checkbox_blank": "eEK9OGxa",
	"checkbox_marked": "_1YOfZCnY",
	"chevron_down": "Px3SEi0e",
	"chevron_up": "_1X8WneZP",
	"close": "_6Nnb2qTu",
	"comment_question": "_2Is6GeGS",
	"dots_vertical": "_1X9cboMZ",
	"file_document_box": "_3aWD7mqz",
	"filter": "_1vRUwLpJ",
	"heart": "DNQWRPXe",
	"heart_outline": "cuNayX-5",
	"loading": "_2zOZb1Dl",
	"magnify": "_2ljXgNF8",
	"message": "_18vQxi8i",
	"pencil": "r1nUo43X",
	"pencil_outline": "_1LFoEIk_",
	"plus": "_ovdmRq9",
	"radiobox_blank": "_3jjIDAYm",
	"radiobox_marked": "DnV7oSvp",
	"icon-send": "_1ClGA47H",
	"tooltip_text_outline": "_11r-hW1D",
	"trash_can_outline": "_2DrEoxiW",
	"icon_arrow-left": "SEOi3x5D",
	"icon_arrow-right": "_24-pJniw",
	"list": "_1_cOOjTv",
	"tile": "_1h9TjUI5",
	"active": "_1mNuOO5k",
	"list-item-icon-btn": "_2FMmXQjJ",
	"default-checkbox-div": "_3nUlwz41",
	"default-checkbox": "TgwbwqUA",
	"checkmark": "_2rX9NpuV",
	"radio": "_1dA_tlXK",
	"radio-label": "_3fUCRJT7",
	"wrapped": "APDu2RXy",
	"component": "IMN6Uy0E",
	"arrow": "_3075rQSZ",
	"label": "_2veK3gUo",
	"filled": "_1ObZaEAa",
	"section-title": "_1twIhlCY",
	"item": "_3LOheOZE",
	"add-panel": "_3Lni1ArU",
	"cancel-panel": "_2xox096H",
	"scroll": "_8tjUu1sN",
	"busy": "a9Czzvve",
	"popupCategorySelectPopup": "_3l-iWzwT",
	"opacity-0": "_2NYEsDtz",
	"opacity-1": "_20_FSMJn",
	"wcag-invisible": "_1xSM0sKX",
	"btn-additional": "_1i1oBQxu",
	"icon-btn-additional": "_3BinViSA",
	"content-container": "_2PzfkWbw",
	"button-container": "_3Mb10Pzs",
	"sub-title": "_12-wLp3a",
	"bottom-container": "_31DQwmtb",
	"icon-plus": "_3YCt5RqZ",
	"edit-selected-category": "ppSVQt0E"
};

/***/ }),

/***/ 1143:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.NoteDeleteAreaSave = exports.NoteDeleteArea = undefined;__webpack_require__(76);
var _react = __webpack_require__(648);
var _resource = __webpack_require__(106);
var _style = __webpack_require__(650);var _style2 = _interopRequireDefault(_style);
var _types = __webpack_require__(245);
var _button = __webpack_require__(973);
var _NOTE_DELETE_WITH_CHAT = __webpack_require__(668);var _NOTE_DELETE_WITH_CHAT2 = _interopRequireDefault(_NOTE_DELETE_WITH_CHAT);
var _resource2 = __webpack_require__(223);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var NoteDeleteArea = exports.NoteDeleteArea = (0, _react.PureConnect)('NoteDeleteArea')(function (state) {return {
        deleting: _resource.notesEditor.selectors.deleting(state),
        item: _resource.notesEditor.selectors.item(state),
        allQuestions: _resource2.questionsResource.selectors.items(state) };},
function (dispatch) {return {};}, function (_ref) {var deleting = _ref.deleting,item = _ref.item,allQuestions = _ref.allQuestions;
    var isquestion = (0, _types.isQuestion)(item);
    return _react.React.createElement("div", { className: (0, _style2.default)(!deleting ? 'wcag-invisible' : '', 'warning'), "aria-hidden": !deleting, "aria-labelledby": isquestion ? 'Verwijder vraag' : 'Verwijder notitie' },
    _react.React.createElement("div", { className: (0, _style2.default)('warning-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('warning-title') },
    isquestion ? 'Vraag' : 'Notitie',
    " verwijderen"),
    _react.React.createElement("div", { className: (0, _style2.default)('warning-content') },
    _react.React.createElement("p", null,
    "U staat op het punt een ",
    isquestion ? 'vraag' : 'notitie',
    " te verwijderen.",
    isquestion ? '' : 'Als de notitie is gedeeld met personen en/of groepen zal deze ook verdwijnen uit hun archief.'),
    _react.React.createElement("p", { className: (0, _style2.default)('medium') }, "Deze actie kunt u niet ongedaan maken."))));
});exports.default =
NoteDeleteArea;
var NoteDeleteAreaSave = exports.NoteDeleteAreaSave = (0, _react.PureConnect)('NoteDeleteAreaSave')(function (state) {return {
        deleting: _resource.notesEditor.selectors.deleting(state),
        item: _resource.notesEditor.selectors.item(state),
        allQuestions: _resource2.questionsResource.selectors.items(state),
        origin: state.notemenu.origin };},
function (dispatch) {return {
        cancelDelete: function cancelDelete(item, allQuestions) {
            dispatch(_resource.notesEditor.actions.DELETE_CANCEL({ item: item }));
            dispatch(_resource.notesEditor.actions.READ({ item: item }));
            var readquestion = false;
            if ((0, _types.isQuestion)(item)) {
                var current = allQuestions.qWhere(function (x) {return x.noteId === item.id;}).qFirst();
                if (current) {
                    dispatch(_resource2.questionsEditor.actions.READ({ item: current }));
                    readquestion = true;
                }
            }
            if ((0, _types.isQuestion)(item) && !readquestion) {
                dispatch(_resource2.questionsEditor.actions.READ_CANCEL({}));
            }
        },
        saveDelete: function saveDelete(item) {return dispatch((0, _NOTE_DELETE_WITH_CHAT2.default)({ item: item }));} };},
function (_ref2) {var deleting = _ref2.deleting,item = _ref2.item,allQuestions = _ref2.allQuestions,cancelDelete = _ref2.cancelDelete,saveDelete = _ref2.saveDelete;
    return _react.React.createElement("div", { className: (0, _style2.default)(!deleting ? 'wcag-invisible' : '', 'fields-container'), "aria-hidden": !deleting, "aria-labelledby": "Verwijder notitie" },
    _react.React.createElement("div", { className: (0, _style2.default)('bottom-buttons-container', 'not-absolute') },
    _react.React.createElement("div", { className: (0, _style2.default)('buttons-container', !deleting ? 'wcag-invisible' : '') },
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Annuleren', "aria-haspopup": false, tabIndex: 0, onKeyDown: function onKeyDown(evt) {return cancelDelete(item, allQuestions);}, onClick: function onClick(evt) {return cancelDelete(item, allQuestions);} },
    _react.React.createElement("span", null, "Annuleren")),
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', "aria-label": 'Verwijderen', "aria-haspopup": false, tabIndex: item.text ? 0 : -1, disabled: !item.text, onKeyDown: function onKeyDown(evt) {return saveDelete(item);}, onClick: function onClick(evt) {return saveDelete(item);} },
    _react.React.createElement("span", null, "Verwijderen")))));
});

/***/ }),

/***/ 1144:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = [
'#FF062C', '#FF0062', '#ECBFEC', '#7432BB', '#3550B9',
'#00B447', '#BFE6E1', '#00C1D6', '#00ADF8', '#BFE5FD',
'#68C73A', '#C6DE03', '#FFFABF', '#FFBD00', '#FF8F00',
'#FF5C06', '#5858FF', '#0653FF'];

/***/ }),

/***/ 1145:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(1146);

if (typeof content === 'string') {
  content = [[module.i, content, '']];
}

var options = {"attributes":{}}

options.insert = "head";
options.singleton = false;

var update = __webpack_require__(491)(content, options);

if (content.locals) {
  module.exports = content.locals;
}


/***/ }),

/***/ 1146:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(undefined);
// imports


// module
exports.push([module.i, "._15OGamnB{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\"}._10eNu8vU{padding:1px;background:#fff;border:2px solid transparent;border-radius:100px}._10eNu8vU,._10eNu8vU span{-webkit-transition:all .5s ease-in-out;transition:all .5s ease-in-out}._10eNu8vU span{padding:9px 16px 8px;background:#4b55f6;font-size:12px;line-height:18px;letter-spacing:1.2px;text-align:center;color:#fff;display:inline-block;border-radius:100px;font-weight:700;text-transform:uppercase}._10eNu8vU:hover span{background:#30379d}._10eNu8vU:focus{border-color:#30379d;outline:none}._10eNu8vU:focus span{background:#30379d}._10eNu8vU._1qIlKMcu{cursor:not-allowed}._10eNu8vU._1qIlKMcu span{background:#f4f4f8;color:#6e6e77}._10eNu8vU._7ucLlPpp{display:inline-block;width:40px;height:40px;border-radius:100%;background:#4b55f6;color:#fff;margin-right:8px}._10eNu8vU._3_46ERkm span{background:#fff;color:#4b55f6;border:1px solid #4b55f6;letter-spacing:.36px}._10eNu8vU._3_46ERkm:hover span{background:#f4f4f8}._10eNu8vU._3_46ERkm:focus{border-color:#30379d}._10eNu8vU._3_46ERkm._1qIlKMcu{cursor:not-allowed}._10eNu8vU._3_46ERkm._1qIlKMcu span{color:#6e6e77;border-color:#6e6e77;background:#f4f4f8}._10eNu8vU._1rkwappd span{background:#fff;color:#4b55f6;border:1px solid #4b55f6}._10eNu8vU._1rkwappd span:before{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";margin-right:3px;vertical-align:middle;display:inline-block}._10eNu8vU._1rkwappd:hover span{background:#f4f4f8}._10eNu8vU._1rkwappd:focus{border-color:#30379d}._10eNu8vU._1rkwappd._1qIlKMcu{cursor:not-allowed}._10eNu8vU._1rkwappd._1qIlKMcu span{color:#6e6e77;border-color:#6e6e77;background:#f4f4f8}._10eNu8vU._3-QKD0yr span{background:transparent;color:#414141;letter-spacing:.36px}._10eNu8vU._3-QKD0yr:hover span{background:#f4f4f8}._10eNu8vU._3-QKD0yr:focus{border-color:#30379d}._10eNu8vU._3-QKD0yr:focus span{background:#f4f4f8}._10eNu8vU._3-QKD0yr._1qIlKMcu{cursor:not-allowed}._10eNu8vU._3-QKD0yr._1qIlKMcu span{background:#f4f4f8;color:#6e6e77}.ebGgq0ZK{color:#4b55f6;letter-spacing:.42px;line-height:19px;font-size:14px;text-transform:uppercase;padding:6px 8px;position:relative;border:none;background:transparent;font-weight:700}.ebGgq0ZK._3XVB59nB:before{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";content:\"\\E5C4\";color:#4b55f6;font-size:28px;margin-right:6px;width:24px;vertical-align:middle}._3OCCI0x1{width:100%;border-radius:4px;background:#fff;border:2px solid #fff;padding:6px 40px 6px 16px;text-align:left;position:relative;outline-color:#4b55f6}._3OCCI0x1,._3OCCI0x1 span{display:inline-block}._3OCCI0x1 span._151ikEm_{font-size:12px;line-height:16px;font-weight:300;color:#414141;padding:10px 34px 10px 8px;font-style:italic;white-space:normal}._3OCCI0x1 span._3d2UcKfg{position:absolute;top:50%;right:16px;float:right;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:24px;height:24px}._3OCCI0x1 span._3d2UcKfg:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle;color:#4b55f6}._3OCCI0x1 span._3d2UcKfg._1HuvehWI:after{content:\"\\E5CF\"}._3OCCI0x1 span._3d2UcKfg._3OJXQN8m:after{content:\"\\E5CE\"}._3OCCI0x1:focus{outline-color:#4b55f6}._10eNu8vU._2DUMaNA3{border-radius:50%;width:40px;height:40px;position:relative}._10eNu8vU._2DUMaNA3 span{border-radius:50%;font-size:16px;background:transparent;width:34px;height:34px;padding:5px;margin:0;-webkit-box-shadow:none;box-shadow:none}._10eNu8vU._2DUMaNA3 span,._10eNu8vU._2DUMaNA3 span:after{color:#4b55f6;display:inline-block;position:relative}._10eNu8vU._2DUMaNA3 span:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\"}._10eNu8vU._2DUMaNA3:hover span{background:#f4f4f8}._10eNu8vU._2DUMaNA3:focus{border-color:#4b55f6}._10eNu8vU._2DUMaNA3:focus span{background:#f4f4f8}._10eNu8vU._2DUMaNA3._1qIlKMcu span{background:#f4f4f8;color:#6e6e77}._10eNu8vU._2DUMaNA3.DHS1NvGd span:after{content:\"\\E7FD\"}._10eNu8vU._2DUMaNA3.rhx-6Iri span:after{content:\"\\F233\"}._10eNu8vU._2DUMaNA3._1r2mgDpN span:after{content:\"\\F1CF\"}._10eNu8vU._2DUMaNA3._17cmXtTB span:after{content:\"\\F1CE\";font-family:Material Icons Outlined}._10eNu8vU._2DUMaNA3.o3JJpKsm span:after{content:\"\\EAAA\";font-family:Material Icons Outlined}._10eNu8vU._2DUMaNA3._1TqlSomA span:after{content:\"\\E86C\";font-family:Material Icons Outlined}._10eNu8vU._2DUMaNA3.g9uYzRFj span:after{content:\"\\E876\"}._10eNu8vU._2DUMaNA3._8BFA5yOx span:after{content:\"\\E835\";font-family:Material Icons Outlined}._10eNu8vU._2DUMaNA3._3WwKb224 span:after{content:\"\\E834\"}._10eNu8vU._2DUMaNA3._1xOd-s61 span:after{content:\"\\E5CF\"}._10eNu8vU._2DUMaNA3._2k5xwQR3 span:after{content:\"\\E5CE\"}._10eNu8vU._2DUMaNA3._28e7D_9U span:after{content:\"\\E5CD\"}._10eNu8vU._2DUMaNA3._1GSudhya span:after{content:\"\\E0C6\"}._10eNu8vU._2DUMaNA3.vO0GgEyE span:after{content:\"\\E5D4\"}._10eNu8vU._2DUMaNA3.ZZMrFxGF span:after{content:\"\\E880\"}._10eNu8vU._2DUMaNA3.hU3EoODa span:after{content:\"\\EF4F\";font-family:Material Icons Outlined}._10eNu8vU._2DUMaNA3._34H43EzQ span:after{content:\"\\E87D\"}._10eNu8vU._2DUMaNA3._2btVIT6g span:after{content:\"\\E87E\";font-family:Material Icons Outlined}._10eNu8vU._2DUMaNA3._1QhW8ol5 span:after{content:\"\\E41A\"}._10eNu8vU._2DUMaNA3._2JZJFOem span:after{content:\"\\E8B6\"}._10eNu8vU._2DUMaNA3._2d8rwvOK span:after{content:\"\\E0B7\"}._10eNu8vU._2DUMaNA3._2o4kTLTl span:after{content:\"\\E150\"}._10eNu8vU._2DUMaNA3._164T5_7w span:after{content:\"\\E150\";font-family:Material Icons Outlined}._10eNu8vU._2DUMaNA3._213UAKuU span:after{content:\"\\E145\"}._10eNu8vU._2DUMaNA3._3vnTgryR span:after{content:\"\\E836\"}._10eNu8vU._2DUMaNA3._3rcU7QAl span:after{content:\"\\E837\"}._10eNu8vU._2DUMaNA3._2WpM0Oqe span:after{content:\"\\E163\"}._10eNu8vU._2DUMaNA3._3wepraie span:after{content:\"\\E0B7\";font-family:Material Icons Outlined}._10eNu8vU._2DUMaNA3._3TtGuuwM span:after{content:\"\\E872\";font-family:Material Icons Outlined}._10eNu8vU._2DUMaNA3._1TdlCONt span:after{content:\"\\E5C4\"}._10eNu8vU._2DUMaNA3._2lnpbb1M span:after{content:\"\\E5C8\"}._10eNu8vU._2DUMaNA3._2ck92naB,._10eNu8vU._2DUMaNA3._15IBQzNQ{background:transparent;border-radius:0;color:#414141;padding:0;height:28px;width:28px}._10eNu8vU._2DUMaNA3._2ck92naB span,._10eNu8vU._2DUMaNA3._15IBQzNQ span{padding:0;height:24px;width:24px}._10eNu8vU._2DUMaNA3._2ck92naB span:after,._10eNu8vU._2DUMaNA3._15IBQzNQ span:after{color:#414141}._10eNu8vU._2DUMaNA3._2ck92naB._10R9azU0,._10eNu8vU._2DUMaNA3._2ck92naB._10R9azU0 span:after,._10eNu8vU._2DUMaNA3._15IBQzNQ._10R9azU0,._10eNu8vU._2DUMaNA3._15IBQzNQ._10R9azU0 span:after{color:#4b55f6}._10eNu8vU._2DUMaNA3._15IBQzNQ span:after{content:\"\\E8EF\"}._10eNu8vU._2DUMaNA3._2ck92naB span:after{content:\"\\E9B0\"}._10eNu8vU.TevxFAZC{position:relative;padding:0;border:none;border-radius:0}._10eNu8vU.TevxFAZC span{color:#4b55f6;font-size:16px;background:transparent;display:inline-block;width:24px;height:24px;position:relative;margin:0;-webkit-box-shadow:none;box-shadow:none;padding:0;padding:5px}._10eNu8vU.TevxFAZC span:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";font-size:14px;font-weight:700}._10eNu8vU.TevxFAZC:hover span{background:#f4f4f8}._10eNu8vU.TevxFAZC.vO0GgEyE span:after{content:\"\\E5D4\"}._22n90Fj- .gHcYsaCb{display:none}._22n90Fj- .gHcYsaCb+._2AqRekvO{display:inline-block}._22n90Fj- .gHcYsaCb+._2AqRekvO:before{content:\"\\E835\";font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle}._22n90Fj- .gHcYsaCb:checked+._2AqRekvO:before{content:\"\\E834\"}._22n90Fj- span{padding-left:14px}.eAg3Y41K{display:block}.eAg3Y41K input[type=radio]{position:absolute;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";opacity:0}.eAg3Y41K input[type=radio]+._1Z3GqTP8:before{content:\"\\E836\";font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle}.eAg3Y41K input[type=radio]+._1Z3GqTP8 span{padding-left:14px;font-size:12px;line-height:16px;color:#414141;font-weight:400}.eAg3Y41K input[type=radio]:checked+._1Z3GqTP8:before{content:\"\\E837\"}.eAg3Y41K input[type=radio]+._1Z3GqTP8:empty:before{margin-right:0}._3Ed7SzIY{background-color:#f0f0f0}._3lnq61S9{font-size:14px;font-weight:300;display:block;padding:0 10px;color:#555}._3T3zEjXx{font-weight:500}.IGTg_nEp{display:inline-block;width:10px;height:10px;margin:0 10px;vertical-align:middle;border-radius:50%}.IGTg_nEp._3JX_wTA9{width:15px;height:15px;margin:0 15px}._2Z5kiGe_{position:relative;display:block;cursor:pointer}._2O1Pn2Ew{position:absolute;top:50%;right:0;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.wDyOnwMy{font-size:12px;font-weight:500;padding:20px 15px 0;text-transform:uppercase;color:gray;color:rgba(0,0,0,.5)}._1iaKQXIp,.wDyOnwMy{line-height:24px}._1iaKQXIp{font-weight:300;padding:15px;border-top:1px solid rgba(0,0,0,.1)}._3fxnyI-X{position:absolute;right:40px;bottom:40px}._4v0-FiZd{position:absolute;top:5px;right:10px}._3F74xXXx{overflow-y:auto;max-height:400px}._1X6oWuXn{color:#fff;background-color:#607d8b;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;font-size:14px;line-height:20px;padding:20px;text-align:center;text-transform:uppercase;font-weight:500}._2dGhL8O5{color:#f36;font-weight:700;font-size:15px;line-height:20px;position:relative}._2837UpBK{color:#414141;font-size:12px}._2837UpBK ._2fpE13dL{display:inline-block;width:100%;padding:0 16px;position:relative}._2837UpBK ._2fpE13dL ._3jmcUcoe{display:block;font-size:14px;font-weight:700;letter-spacing:.42px;line-height:18px;margin-bottom:12px}._2837UpBK ._2fpE13dL ._1-hq8VrK{display:block;line-height:16px;Font-weight:bold;margin-bottom:4px}._2837UpBK ._2fpE13dL ._1Z9lUFfY{display:block;width:100%;position:relative;margin-bottom:3px}._2837UpBK ._2fpE13dL ._1Z9lUFfY input{border-radius:4px;border:2px solid #e8e8e8;display:block;background:#fff;padding:16px;line-height:16.8px;font-weight:400;width:100%}._2837UpBK ._2fpE13dL ._1Z9lUFfY input:focus-visible{outline-color:#4b55f6}._2837UpBK ._2fpE13dL ._1Z9lUFfY span:last-child{display:block;text-align:right;line-height:16.8px;font-weight:400}._2837UpBK ._1La6aYHu .vdcKBop4{line-height:16px;font-weight:700;display:block;padding:0 16px;margin-bottom:19px}._2837UpBK ._1La6aYHu ._2sM88aMu{padding:0 16px 16px;display:block;width:100%;white-space:normal;max-height:275px;overflow:hidden;overflow-y:auto}._2837UpBK ._1La6aYHu ._2sM88aMu .eAg3Y41K{display:inline-block;width:50px;height:50px;border:2px solid transparent;margin:5px 10px 5px 0;border-radius:50%;vertical-align:top;padding:3px}._2837UpBK ._1La6aYHu ._2sM88aMu .eAg3Y41K ._3jk7rx58{display:inline-block;width:100%;height:100%;border-radius:50%}._2837UpBK ._1La6aYHu ._2sM88aMu .eAg3Y41K input:checked+span{display:block}._2837UpBK ._1La6aYHu ._2sM88aMu .eAg3Y41K input{display:none}._2837UpBK ._1La6aYHu ._2sM88aMu .eAg3Y41K span{line-height:40px;width:40px;height:40px;text-align:center;color:#fff;border-radius:50%}._2837UpBK ._1La6aYHu ._2sM88aMu .eAg3Y41K:hover{border-color:#4b55f6}._2fpkDZsw{position:absolute;bottom:0;width:100%;left:0;right:0;-webkit-box-shadow:0 -7px 8px rgba(0,0,0,.1);box-shadow:0 -7px 8px rgba(0,0,0,.1);padding-top:15px;background:#fff;height:67px}._2fpkDZsw._3JJ1bxr-{position:relative}._2fpkDZsw ._3IuV-ZIw{margin:0 16px}._2fpkDZsw ._3IuV-ZIw button:first-child span{border-color:transparent}._2fpkDZsw ._3IuV-ZIw button:first-child:hover span{border-color:#4b55f6}._2fpkDZsw ._3IuV-ZIw button:last-child,._2zPsqXdp{float:right}._2zPsqXdp{display:block}._2zPsqXdp button{font-size:14px}._26CIC16j{visibility:hidden;clip:rect(0 0 0 0)}._3lKDZfTw,._26CIC16j{position:absolute;overflow:hidden;height:1px;width:1px;margin:-1px;padding:0;border:0}._3lKDZfTw{clip:rect(0,0,0,0);white-space:nowrap}._3PdH_-Hz{display:block;position:relative;padding:16px;color:#414141;font-weight:400;white-space:normal}._3PdH_-Hz ._2t76Z6UD{display:block;font-size:18px;letter-spacing:.54px;line-height:18px;font-weight:700;margin-bottom:8px}._3PdH_-Hz .PlX70wn1 p{font-size:14px;line-height:19.6px;letter-spacing:0;margin-bottom:10px;color:#414141}._3PdH_-Hz .PlX70wn1 p._2Eq16qUZ{font-weight:500}", ""]);

// exports
exports.locals = {
	"material-icons": "_15OGamnB",
	"btn": "_10eNu8vU",
	"disabled": "_1qIlKMcu",
	"user-btn": "_7ucLlPpp",
	"secondary-btn": "_3_46ERkm",
	"secondary-button_icon": "_1rkwappd",
	"ghost-btn": "_3-QKD0yr",
	"btn-icon-text_back": "ebGgq0ZK",
	"icon_arrow-back": "_3XVB59nB",
	"btn-type-dropdown": "_3OCCI0x1",
	"default-header": "_151ikEm_",
	"icon": "_3d2UcKfg",
	"icon_chevron-down": "_1HuvehWI",
	"icon_chevron-up": "_3OJXQN8m",
	"icon-btn": "_2DUMaNA3",
	"account": "DHS1NvGd",
	"account_group": "rhx-6Iri",
	"collapse": "_1r2mgDpN",
	"expand": "_17cmXtTB",
	"arrow_right": "o3JJpKsm",
	"check_circle": "_1TqlSomA",
	"check": "g9uYzRFj",
	"checkbox_blank": "_8BFA5yOx",
	"checkbox_marked": "_3WwKb224",
	"chevron_down": "_1xOd-s61",
	"chevron_up": "_2k5xwQR3",
	"close": "_28e7D_9U",
	"comment_question": "_1GSudhya",
	"dots_vertical": "vO0GgEyE",
	"file_document_box": "ZZMrFxGF",
	"filter": "hU3EoODa",
	"heart": "_34H43EzQ",
	"heart_outline": "_2btVIT6g",
	"loading": "_1QhW8ol5",
	"magnify": "_2JZJFOem",
	"message": "_2d8rwvOK",
	"pencil": "_2o4kTLTl",
	"pencil_outline": "_164T5_7w",
	"plus": "_213UAKuU",
	"radiobox_blank": "_3vnTgryR",
	"radiobox_marked": "_3rcU7QAl",
	"icon-send": "_2WpM0Oqe",
	"tooltip_text_outline": "_3wepraie",
	"trash_can_outline": "_3TtGuuwM",
	"icon_arrow-left": "_1TdlCONt",
	"icon_arrow-right": "_2lnpbb1M",
	"list": "_15IBQzNQ",
	"tile": "_2ck92naB",
	"active": "_10R9azU0",
	"list-item-icon-btn": "TevxFAZC",
	"default-checkbox-div": "_22n90Fj-",
	"default-checkbox": "gHcYsaCb",
	"checkmark": "_2AqRekvO",
	"radio": "eAg3Y41K",
	"radio-label": "_1Z3GqTP8",
	"submit-btn": "_3Ed7SzIY",
	"label": "_3lnq61S9",
	"name-label": "_3T3zEjXx",
	"color": "IGTg_nEp",
	"big": "_3JX_wTA9",
	"component": "_2Z5kiGe_",
	"arrow": "_2O1Pn2Ew",
	"section": "wDyOnwMy",
	"item": "_1iaKQXIp",
	"add-panel": "_3fxnyI-X",
	"cancel-panel": "_4v0-FiZd",
	"scroll": "_3F74xXXx",
	"title": "_1X6oWuXn",
	"belangrijk": "_2dGhL8O5",
	"fields-container": "_2837UpBK",
	"categorie-naam": "_2fpE13dL",
	"categorie-titel": "_3jmcUcoe",
	"categorie-input-label": "_1-hq8VrK",
	"categorie-search": "_1Z9lUFfY",
	"radios": "_1La6aYHu",
	"radios-label": "vdcKBop4",
	"radios-container": "_2sM88aMu",
	"colored-radio": "_3jk7rx58",
	"bottom-panel": "_2fpkDZsw",
	"not-absolute": "_3JJ1bxr-",
	"buttons-container": "_3IuV-ZIw",
	"button-aria": "_2zPsqXdp",
	"wcag-invisible": "_26CIC16j",
	"sr-only": "_3lKDZfTw",
	"warning-container": "_3PdH_-Hz",
	"warning-title": "_2t76Z6UD",
	"warning-content": "PlX70wn1",
	"medium": "_2Eq16qUZ"
};

/***/ }),

/***/ 1147:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _defineProperty2 = __webpack_require__(225);var _defineProperty3 = _interopRequireDefault(_defineProperty2);var _getPrototypeOf = __webpack_require__(232);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(105);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(110);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(515);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _inherits2 = __webpack_require__(516);var _inherits3 = _interopRequireDefault(_inherits2);var _react = __webpack_require__(171);var _react2 = _interopRequireDefault(_react);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var
ExtendProps = function (_React$Component) {(0, _inherits3.default)(ExtendProps, _React$Component);function ExtendProps() {(0, _classCallCheck3.default)(this, ExtendProps);return (0, _possibleConstructorReturn3.default)(this, (ExtendProps.__proto__ || (0, _getPrototypeOf2.default)(ExtendProps)).apply(this, arguments));}(0, _createClass3.default)(ExtendProps, [{ key: 'render', value: function render()
        {
            var arialabel = this.props.arialabel;
            var childArray = [this.props.children];
            return childArray !== undefined && childArray.length === 1 ?
            _react2.default.cloneElement(_react2.default.Children.only(this.props.children), (0, _defineProperty3.default)({}, 'aria-label', arialabel)) :
            this.props.children;
        } }]);return ExtendProps;}(_react2.default.Component);exports.default = ExtendProps;

/***/ }),

/***/ 1148:
/***/ (function(module, exports, __webpack_require__) {


        // classnames-loader: automatically bind css-modules to classnames
        var classNames = __webpack_require__(492);
        var locals = __webpack_require__(1149);
        var css = classNames.bind(locals);
        for (var style in locals) css[style] = locals[style];
        module.exports = css;
    

/***/ }),

/***/ 1149:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(1150);

if (typeof content === 'string') {
  content = [[module.i, content, '']];
}

var options = {"attributes":{}}

options.insert = "head";
options.singleton = false;

var update = __webpack_require__(491)(content, options);

if (content.locals) {
  module.exports = content.locals;
}


/***/ }),

/***/ 1150:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(undefined);
// imports


// module
exports.push([module.i, "._2IBabILS{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\"}.v2PHo0cb{padding:1px;background:#fff;border:2px solid transparent;border-radius:100px}.v2PHo0cb,.v2PHo0cb span{-webkit-transition:all .5s ease-in-out;transition:all .5s ease-in-out}.v2PHo0cb span{padding:9px 16px 8px;background:#4b55f6;font-size:12px;line-height:18px;letter-spacing:1.2px;text-align:center;color:#fff;display:inline-block;border-radius:100px;font-weight:700;text-transform:uppercase}.v2PHo0cb:hover span{background:#30379d}.v2PHo0cb:focus{border-color:#30379d;outline:none}.v2PHo0cb:focus span{background:#30379d}.v2PHo0cb.XgEn0k97{cursor:not-allowed}.v2PHo0cb.XgEn0k97 span{background:#f4f4f8;color:#6e6e77}.v2PHo0cb._3cxtidgc{display:inline-block;width:40px;height:40px;border-radius:100%;background:#4b55f6;color:#fff;margin-right:8px}.v2PHo0cb._2zEdrZ1X span{background:#fff;color:#4b55f6;border:1px solid #4b55f6;letter-spacing:.36px}.v2PHo0cb._2zEdrZ1X:hover span{background:#f4f4f8}.v2PHo0cb._2zEdrZ1X:focus{border-color:#30379d}.v2PHo0cb._2zEdrZ1X.XgEn0k97{cursor:not-allowed}.v2PHo0cb._2zEdrZ1X.XgEn0k97 span{color:#6e6e77;border-color:#6e6e77;background:#f4f4f8}.v2PHo0cb.BdUtdd5W span{background:#fff;color:#4b55f6;border:1px solid #4b55f6}.v2PHo0cb.BdUtdd5W span:before{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";margin-right:3px;vertical-align:middle;display:inline-block}.v2PHo0cb.BdUtdd5W:hover span{background:#f4f4f8}.v2PHo0cb.BdUtdd5W:focus{border-color:#30379d}.v2PHo0cb.BdUtdd5W.XgEn0k97{cursor:not-allowed}.v2PHo0cb.BdUtdd5W.XgEn0k97 span{color:#6e6e77;border-color:#6e6e77;background:#f4f4f8}.v2PHo0cb.hAJFfYb4 span{background:transparent;color:#414141;letter-spacing:.36px}.v2PHo0cb.hAJFfYb4:hover span{background:#f4f4f8}.v2PHo0cb.hAJFfYb4:focus{border-color:#30379d}.v2PHo0cb.hAJFfYb4:focus span{background:#f4f4f8}.v2PHo0cb.hAJFfYb4.XgEn0k97{cursor:not-allowed}.v2PHo0cb.hAJFfYb4.XgEn0k97 span{background:#f4f4f8;color:#6e6e77}.OU692p5i{color:#4b55f6;letter-spacing:.42px;line-height:19px;font-size:14px;text-transform:uppercase;padding:6px 8px;position:relative;border:none;background:transparent;font-weight:700}.OU692p5i._99ZQJ4PG:before{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";content:\"\\E5C4\";color:#4b55f6;font-size:28px;margin-right:6px;width:24px;vertical-align:middle}._27spsOtv{width:100%;border-radius:4px;background:#fff;border:2px solid #fff;padding:6px 40px 6px 16px;text-align:left;position:relative;outline-color:#4b55f6}._27spsOtv,._27spsOtv span{display:inline-block}._27spsOtv span._20PF0viH{font-size:12px;line-height:16px;font-weight:300;color:#414141;padding:10px 34px 10px 8px;font-style:italic;white-space:normal}._27spsOtv span.y_pvz5cE{position:absolute;top:50%;right:16px;float:right;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:24px;height:24px}._27spsOtv span.y_pvz5cE:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle;color:#4b55f6}._27spsOtv span.y_pvz5cE._2Yn_FmEW:after{content:\"\\E5CF\"}._27spsOtv span.y_pvz5cE._3Gjn8WsK:after{content:\"\\E5CE\"}._27spsOtv:focus{outline-color:#4b55f6}.v2PHo0cb._1HMRwzFu{border-radius:50%;width:40px;height:40px;position:relative}.v2PHo0cb._1HMRwzFu span{border-radius:50%;font-size:16px;background:transparent;width:34px;height:34px;padding:5px;margin:0;-webkit-box-shadow:none;box-shadow:none}.v2PHo0cb._1HMRwzFu span,.v2PHo0cb._1HMRwzFu span:after{color:#4b55f6;display:inline-block;position:relative}.v2PHo0cb._1HMRwzFu span:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\"}.v2PHo0cb._1HMRwzFu:hover span{background:#f4f4f8}.v2PHo0cb._1HMRwzFu:focus{border-color:#4b55f6}.v2PHo0cb._1HMRwzFu:focus span{background:#f4f4f8}.v2PHo0cb._1HMRwzFu.XgEn0k97 span{background:#f4f4f8;color:#6e6e77}.v2PHo0cb._1HMRwzFu._2AsN-sJO span:after{content:\"\\E7FD\"}.v2PHo0cb._1HMRwzFu.F52LENsp span:after{content:\"\\F233\"}.v2PHo0cb._1HMRwzFu._3Pn4gT5v span:after{content:\"\\F1CF\"}.v2PHo0cb._1HMRwzFu.heueYkZB span:after{content:\"\\F1CE\";font-family:Material Icons Outlined}.v2PHo0cb._1HMRwzFu._2x25tET7 span:after{content:\"\\EAAA\";font-family:Material Icons Outlined}.v2PHo0cb._1HMRwzFu.R7-GsWVp span:after{content:\"\\E86C\";font-family:Material Icons Outlined}.v2PHo0cb._1HMRwzFu._1NRpx6Eb span:after{content:\"\\E876\"}.v2PHo0cb._1HMRwzFu._1s6bIwKS span:after{content:\"\\E835\";font-family:Material Icons Outlined}.v2PHo0cb._1HMRwzFu._1dSwjzB4 span:after{content:\"\\E834\"}.v2PHo0cb._1HMRwzFu.uOHC3PhU span:after{content:\"\\E5CF\"}.v2PHo0cb._1HMRwzFu._1nKOdfui span:after{content:\"\\E5CE\"}.v2PHo0cb._1HMRwzFu._3TueXrIq span:after{content:\"\\E5CD\"}.v2PHo0cb._1HMRwzFu._3RcYPzK8 span:after{content:\"\\E0C6\"}.v2PHo0cb._1HMRwzFu._30bOBQmp span:after{content:\"\\E5D4\"}.v2PHo0cb._1HMRwzFu._17uEI9zC span:after{content:\"\\E880\"}.v2PHo0cb._1HMRwzFu.sRkIZ3Jo span:after{content:\"\\EF4F\";font-family:Material Icons Outlined}.v2PHo0cb._1HMRwzFu._2FK1lsdt span:after{content:\"\\E87D\"}.v2PHo0cb._1HMRwzFu._1bWkqkLm span:after{content:\"\\E87E\";font-family:Material Icons Outlined}.v2PHo0cb._1HMRwzFu._27hF5Xh1 span:after{content:\"\\E41A\"}.v2PHo0cb._1HMRwzFu._2lP6mlYS span:after{content:\"\\E8B6\"}.v2PHo0cb._1HMRwzFu._1obZQlu_ span:after{content:\"\\E0B7\"}.v2PHo0cb._1HMRwzFu.o87VcP4- span:after{content:\"\\E150\"}.v2PHo0cb._1HMRwzFu._3-jPHvWU span:after{content:\"\\E150\";font-family:Material Icons Outlined}.v2PHo0cb._1HMRwzFu._2itMrX9h span:after{content:\"\\E145\"}.v2PHo0cb._1HMRwzFu._33eQORPW span:after{content:\"\\E836\"}.v2PHo0cb._1HMRwzFu._2bc2rG98 span:after{content:\"\\E837\"}.v2PHo0cb._1HMRwzFu._1Oo7sMfW span:after{content:\"\\E163\"}.v2PHo0cb._1HMRwzFu._2APSWAdL span:after{content:\"\\E0B7\";font-family:Material Icons Outlined}.v2PHo0cb._1HMRwzFu._1zN6qn7j span:after{content:\"\\E872\";font-family:Material Icons Outlined}.v2PHo0cb._1HMRwzFu._333eWZMW span:after{content:\"\\E5C4\"}.v2PHo0cb._1HMRwzFu._211VGFJz span:after{content:\"\\E5C8\"}.v2PHo0cb._1HMRwzFu._2Qr3M707,.v2PHo0cb._1HMRwzFu._3qno3lWL{background:transparent;border-radius:0;color:#555;padding:0;height:28px;width:28px}.v2PHo0cb._1HMRwzFu._2Qr3M707 span,.v2PHo0cb._1HMRwzFu._3qno3lWL span{padding:0;height:24px;width:24px}.v2PHo0cb._1HMRwzFu._2Qr3M707 span:after,.v2PHo0cb._1HMRwzFu._3qno3lWL span:after{color:#555}.v2PHo0cb._1HMRwzFu._2Qr3M707._25RXsoXa,.v2PHo0cb._1HMRwzFu._2Qr3M707._25RXsoXa span:after,.v2PHo0cb._1HMRwzFu._3qno3lWL._25RXsoXa,.v2PHo0cb._1HMRwzFu._3qno3lWL._25RXsoXa span:after{color:#4b55f6}.v2PHo0cb._1HMRwzFu._2Qr3M707 span:after{content:\"\\E8EF\"}.v2PHo0cb._1HMRwzFu._3qno3lWL span:after{content:\"\\E9B0\"}.v2PHo0cb._3vdQUOi4{position:relative;padding:0;border:none;border-radius:0}.v2PHo0cb._3vdQUOi4 span{color:#4b55f6;font-size:16px;background:transparent;display:inline-block;width:24px;height:24px;position:relative;margin:0;-webkit-box-shadow:none;box-shadow:none;padding:0;padding:5px}.v2PHo0cb._3vdQUOi4 span:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";font-size:14px;font-weight:700}.v2PHo0cb._3vdQUOi4:hover span{background:#f4f4f8}.v2PHo0cb._3vdQUOi4._30bOBQmp span:after{content:\"\\E5D4\"}._26rGAODW ._26mE6T5b{display:none}._26rGAODW ._26mE6T5b+._1f4ENwpQ{display:inline-block}._26rGAODW ._26mE6T5b+._1f4ENwpQ:before{content:\"\\E835\";font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle}._26rGAODW ._26mE6T5b:checked+._1f4ENwpQ:before{content:\"\\E834\"}._26rGAODW span{padding-left:14px}._3zAPvjm0{display:block}._3zAPvjm0 input[type=radio]{position:absolute;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";opacity:0}._3zAPvjm0 input[type=radio]+._2swkBePv:before{content:\"\\E836\";font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle}._3zAPvjm0 input[type=radio]+._2swkBePv span{padding-left:14px;font-size:12px;line-height:16px;color:#414141;font-weight:400}._3zAPvjm0 input[type=radio]:checked+._2swkBePv:before{content:\"\\E837\"}._3zAPvjm0 input[type=radio]+._2swkBePv:empty:before{margin-right:0}._17PhmSNx{padding:0 16px 16px;overflow-y:auto;width:100%;max-height:375px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._1rxJwCPK,._17PhmSNx{display:block;position:relative}._1rxJwCPK{padding-left:35px;font-size:12px}._1rxJwCPK input{position:absolute;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";opacity:0;cursor:pointer;height:0;width:0}._3pg19Tng ._2Qr3M707{padding:0 16px;white-space:normal;border-bottom:2px solid #f4f4f8}._1f4ENwpQ{position:absolute;top:0;left:0;height:25px;width:25px}._1f4ENwpQ:after{content:\"\\E835\";font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\"}input:checked~._1f4ENwpQ:after{content:\"\\E834\"}._2AVFwGbj{overflow-x:auto;white-space:nowrap}.YIdIV-5Z~.S-aBvKO0{top:4px}._20fgQZpP{font-size:12px;font-weight:500;line-height:24px;padding:20px 15px 0;text-transform:uppercase}._122ymPg7{padding:16px;position:relative;-webkit-transition:background .3s ease;transition:background .3s ease;background:#fff;color:#414141}._122ymPg7:hover{background:#f8f9fe}._122ymPg7:last-child{border-radius:0 0 4px 4px}._3dRcRrIj{visibility:hidden;position:absolute;overflow:hidden;clip:rect(0 0 0 0);height:1px;width:1px;margin:-1px;padding:0;border:0}.XYor26TR{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";opacity:0}._38fa63GH{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";opacity:1}._3UTL98Kc{font-size:12px;line-height:16px;color:#414141;padding:10px 34px 10px 8px;display:inline-block;background:#f8f9fe;border-radius:4px;margin:3px 12px 3px 0;position:relative;font-weight:400}._3UTL98Kc ._3TueXrIq:after{content:\"\\E5CD\";color:#4b55f6;font-family:Material Icons;font-style:normal;font-weight:700;font-size:16px;line-height:1;vertical-align:middle;position:absolute;right:12px}._17PhmSNx{font-weight:400}._17PhmSNx .nzR62fpW ._28F_roYO{display:inline-block;border-top:2px solid #f4f4f8;border-bottom:2px solid #f4f4f8;width:100%;background:#fff;position:relative}._17PhmSNx .nzR62fpW ._28F_roYO ._3jTNIwXw{width:40px;height:45px;position:absolute;left:0}._17PhmSNx .nzR62fpW ._28F_roYO ._3jTNIwXw:before{content:\"\\E8B6\";font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle;left:12px;position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);color:#414141}._17PhmSNx .nzR62fpW ._28F_roYO input{display:inline-block;background:transparent;position:relative;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";opacity:1;cursor:pointer;padding-left:40px;height:45px;width:100%;border:2px solid transparent;border-radius:4px}._17PhmSNx .nzR62fpW ._28F_roYO input:focus-visible{border-color:#4b55f6;outline:none}._3lWjtO6l{padding:0 16px}._3lWjtO6l .WLLHOjwd{display:block;width:100%;margin-bottom:8px}._3lWjtO6l ._2MfUafbT{font-weight:700;line-height:18px;letter-spacing:.42px;color:#414141;font-size:14px}._2OBpcqqV,.AxyiQ6i-{font-weight:700;letter-spacing:.36px;line-height:40px;display:block;margin-bottom:4px;font-size:12px}._1fxYs8zS{margin-bottom:45px}", ""]);

// exports
exports.locals = {
	"material-icons": "_2IBabILS",
	"btn": "v2PHo0cb",
	"disabled": "XgEn0k97",
	"user-btn": "_3cxtidgc",
	"secondary-btn": "_2zEdrZ1X",
	"secondary-button_icon": "BdUtdd5W",
	"ghost-btn": "hAJFfYb4",
	"btn-icon-text_back": "OU692p5i",
	"icon_arrow-back": "_99ZQJ4PG",
	"btn-type-dropdown": "_27spsOtv",
	"default-header": "_20PF0viH",
	"icon": "y_pvz5cE",
	"icon_chevron-down": "_2Yn_FmEW",
	"icon_chevron-up": "_3Gjn8WsK",
	"icon-btn": "_1HMRwzFu",
	"account": "_2AsN-sJO",
	"account_group": "F52LENsp",
	"collapse": "_3Pn4gT5v",
	"expand": "heueYkZB",
	"arrow_right": "_2x25tET7",
	"check_circle": "R7-GsWVp",
	"check": "_1NRpx6Eb",
	"checkbox_blank": "_1s6bIwKS",
	"checkbox_marked": "_1dSwjzB4",
	"chevron_down": "uOHC3PhU",
	"chevron_up": "_1nKOdfui",
	"close": "_3TueXrIq",
	"comment_question": "_3RcYPzK8",
	"dots_vertical": "_30bOBQmp",
	"file_document_box": "_17uEI9zC",
	"filter": "sRkIZ3Jo",
	"heart": "_2FK1lsdt",
	"heart_outline": "_1bWkqkLm",
	"loading": "_27hF5Xh1",
	"magnify": "_2lP6mlYS",
	"message": "_1obZQlu_",
	"pencil": "o87VcP4-",
	"pencil_outline": "_3-jPHvWU",
	"plus": "_2itMrX9h",
	"radiobox_blank": "_33eQORPW",
	"radiobox_marked": "_2bc2rG98",
	"icon-send": "_1Oo7sMfW",
	"tooltip_text_outline": "_2APSWAdL",
	"trash_can_outline": "_1zN6qn7j",
	"icon_arrow-left": "_333eWZMW",
	"icon_arrow-right": "_211VGFJz",
	"list": "_2Qr3M707",
	"tile": "_3qno3lWL",
	"active": "_25RXsoXa",
	"list-item-icon-btn": "_3vdQUOi4",
	"default-checkbox-div": "_26rGAODW",
	"default-checkbox": "_26mE6T5b",
	"checkmark": "_1f4ENwpQ",
	"radio": "_3zAPvjm0",
	"radio-label": "_2swkBePv",
	"container": "_17PhmSNx",
	"selection-container": "_1rxJwCPK",
	"top": "_3pg19Tng",
	"div-label": "_2AVFwGbj",
	"filled": "YIdIV-5Z",
	"label": "S-aBvKO0",
	"section": "_20fgQZpP",
	"item": "_122ymPg7",
	"wcag-invisible": "_3dRcRrIj",
	"opacity-0": "XYor26TR",
	"opacity-1": "_38fa63GH",
	"selection-list": "_3UTL98Kc",
	"input-search-div": "nzR62fpW",
	"input-search": "_28F_roYO",
	"icon-search": "_3jTNIwXw",
	"content-container": "_3lWjtO6l",
	"button-container": "WLLHOjwd",
	"sub-title": "_2MfUafbT",
	"share-with-groups": "AxyiQ6i-",
	"share-with-persons": "_2OBpcqqV",
	"fields-container": "_1fxYs8zS"
};

/***/ }),

/***/ 1151:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });__webpack_require__(76);
var _reselect = __webpack_require__(221);
var _resource = __webpack_require__(246);
var _types = __webpack_require__(245);
var _selectors = __webpack_require__(977);var _selectors2 = _interopRequireDefault(_selectors);
var _resource2 = __webpack_require__(233);
var _authcheck = __webpack_require__(518);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
function wildcardMatcher(searchTerm) {
    if (searchTerm) {
        var term = searchTerm;
        term = term.replace(/[\\]/g, '\\\\');
        term = term.replace(/[\.\?\{\}\[\]\^\$]/g, function (x) {return '\\' + x;});
        term = term.replace(/\*/g, function (x) {return '.*';});
        term = term.replace(/\s+/g, ' ');
        term = term.split(' ').qSelect(function (x) {return '(?=.*' + x + ')';}).join('');
        var rx = new RegExp(term, 'i');
        return function (text) {return rx.test(text);};
    } else
    {
        return function (text) {return true;};
    }
}
var searchTermMatcherSelector = (0, _reselect.createSelector)(_selectors2.default.searchTermParticipantSelector, wildcardMatcher);exports.default =
{
    ParticipantSelector: (0, _reselect.createSelector)(_resource.participantsResource.selectors.items, searchTermMatcherSelector, function (items, searchTermMatcher) {
        return items.qWhere(function (x) {return (0, _types.isParticipant)(x) && searchTermMatcher(x.name);});
    }),
    AllParticipantSelector: (0, _reselect.createSelector)(_resource.participantsResource.selectors.items, function (items) {
        return items.qWhere(function (x) {return (0, _types.isParticipant)(x);});
    }),
    FactionParticipantSelector: (0, _reselect.createSelector)(_resource2.usergroupEditor.selectors.item, _resource.participantsResource.selectors.items, _resource2.usergroupResource.selectors.items, searchTermMatcherSelector, function (item, items, usergroups, searchTermMatcher) {
        var current = usergroups.qFirst(function (x) {return x.id === item.id;});
        return items.qWhere(function (x) {return (0, _types.isParticipant)(x) && (
            !usergroups.qAny(function (ug) {return ug.type === _authcheck.typeFactions && ug.userIDs.includes(x.id.toString());}) ||
            !!current && current.userIDs.includes(x.id.toString())) &&
            searchTermMatcher(x.name);});
    }) };

/***/ }),

/***/ 1152:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });__webpack_require__(76);
var _reselect = __webpack_require__(221);
var _types = __webpack_require__(245);
var _resource = __webpack_require__(233);
var _selectors = __webpack_require__(977);var _selectors2 = _interopRequireDefault(_selectors);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
function wildcardMatcherUserGroup(searchTerm) {
    if (searchTerm) {
        var term = searchTerm;
        term = term.replace(/[\\]/g, '\\\\');
        term = term.replace(/[\.\?\{\}\[\]\^\$]/g, function (x) {return '\\' + x;});
        term = term.replace(/\*/g, function (x) {return '.*';});
        term = term.replace(/\s+/g, ' ');
        term = term.split(' ').qSelect(function (x) {return '(?=.*' + x + ')';}).join('');
        var rx = new RegExp(term, 'i');
        return function (text) {return rx.test(text);};
    } else
    {
        return function (text) {return true;};
    }
}
var searchTermUsergroupMatcherSelector = (0, _reselect.createSelector)(_selectors2.default.searchTermUsergroupSelector, wildcardMatcherUserGroup);exports.default =
{
    UsergroupSelector: (0, _reselect.createSelector)(_resource.usergroupResource.selectors.items, searchTermUsergroupMatcherSelector, function (items, wildcardMatcherUserGroup) {
        return items.qWhere(function (x) {return !(0, _types.isParticipant)(x) && wildcardMatcherUserGroup(x.name);});
    }),
    AllUsergroupSelector: (0, _reselect.createSelector)(_resource.usergroupResource.selectors.items, function (items) {
        return items.qWhere(function (x) {return !(0, _types.isParticipant)(x);});
    }) };

/***/ }),

/***/ 1153:
/***/ (function(module, exports, __webpack_require__) {


        // classnames-loader: automatically bind css-modules to classnames
        var classNames = __webpack_require__(492);
        var locals = __webpack_require__(1154);
        var css = classNames.bind(locals);
        for (var style in locals) css[style] = locals[style];
        module.exports = css;
    

/***/ }),

/***/ 1154:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(1155);

if (typeof content === 'string') {
  content = [[module.i, content, '']];
}

var options = {"attributes":{}}

options.insert = "head";
options.singleton = false;

var update = __webpack_require__(491)(content, options);

if (content.locals) {
  module.exports = content.locals;
}


/***/ }),

/***/ 1155:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(undefined);
// imports


// module
exports.push([module.i, "._12vzlHm-{padding:1px;background:#fff;border:2px solid transparent;border-radius:100px}._12vzlHm-,._12vzlHm- span{-webkit-transition:all .5s ease-in-out;transition:all .5s ease-in-out}._12vzlHm- span{padding:9px 16px 8px;background:#4b55f6;font-size:12px;line-height:18px;letter-spacing:1.2px;text-align:center;color:#fff;display:inline-block;border-radius:100px;font-weight:700;text-transform:uppercase}._12vzlHm-:hover span{background:#30379d}._12vzlHm-:focus{border-color:#30379d;outline:none}._12vzlHm-:focus span{background:#30379d}._12vzlHm-._1PO1U71R{cursor:not-allowed}._12vzlHm-._1PO1U71R span{background:#f4f4f8;color:#6e6e77}._12vzlHm-._3isH_1tU{display:inline-block;width:40px;height:40px;border-radius:100%;background:#4b55f6;color:#fff;margin-right:8px}._12vzlHm-._5YInMIiL span{background:#fff;color:#4b55f6;border:1px solid #4b55f6;letter-spacing:.36px}._12vzlHm-._5YInMIiL:hover span{background:#f4f4f8}._12vzlHm-._5YInMIiL:focus{border-color:#30379d}._12vzlHm-._5YInMIiL._1PO1U71R{cursor:not-allowed}._12vzlHm-._5YInMIiL._1PO1U71R span{color:#6e6e77;border-color:#6e6e77;background:#f4f4f8}._12vzlHm-._3okJ-ihN span{background:#fff;color:#4b55f6;border:1px solid #4b55f6}._12vzlHm-._3okJ-ihN span:before{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";margin-right:3px;vertical-align:middle;display:inline-block}._12vzlHm-._3okJ-ihN:hover span{background:#f4f4f8}._12vzlHm-._3okJ-ihN:focus{border-color:#30379d}._12vzlHm-._3okJ-ihN._1PO1U71R{cursor:not-allowed}._12vzlHm-._3okJ-ihN._1PO1U71R span{color:#6e6e77;border-color:#6e6e77;background:#f4f4f8}._12vzlHm-._35e1VgvD span{background:transparent;color:#414141;letter-spacing:.36px}._12vzlHm-._35e1VgvD:hover span{background:#f4f4f8}._12vzlHm-._35e1VgvD:focus{border-color:#30379d}._12vzlHm-._35e1VgvD:focus span{background:#f4f4f8}._12vzlHm-._35e1VgvD._1PO1U71R{cursor:not-allowed}._12vzlHm-._35e1VgvD._1PO1U71R span{background:#f4f4f8;color:#6e6e77}.Lf1xwLGN{color:#4b55f6;letter-spacing:.42px;line-height:19px;font-size:14px;text-transform:uppercase;padding:6px 8px;position:relative;border:none;background:transparent;font-weight:700}.Lf1xwLGN.ixGn6QET:before{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";content:\"\\E5C4\";color:#4b55f6;font-size:28px;margin-right:6px;width:24px;vertical-align:middle}._2uPc7SeH{width:100%;border-radius:4px;background:#fff;border:2px solid #fff;padding:6px 40px 6px 16px;text-align:left;position:relative;outline-color:#4b55f6}._2uPc7SeH,._2uPc7SeH span{display:inline-block}._2uPc7SeH span._2hn7cbRs{font-size:12px;line-height:16px;font-weight:300;color:#414141;padding:10px 34px 10px 8px;font-style:italic;white-space:normal}._2uPc7SeH span.bv8iWugp{position:absolute;top:50%;right:16px;float:right;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:24px;height:24px}._2uPc7SeH span.bv8iWugp:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle;color:#4b55f6}._2uPc7SeH span.bv8iWugp._3nLxNeCa:after{content:\"\\E5CF\"}._2uPc7SeH span.bv8iWugp._2YMZ2jeL:after{content:\"\\E5CE\"}._2uPc7SeH:focus{outline-color:#4b55f6}._12vzlHm-._2RLFBOMO{border-radius:50%;width:40px;height:40px;position:relative}._12vzlHm-._2RLFBOMO span{border-radius:50%;font-size:16px;background:transparent;width:34px;height:34px;padding:5px;margin:0;-webkit-box-shadow:none;box-shadow:none}._12vzlHm-._2RLFBOMO span,._12vzlHm-._2RLFBOMO span:after{color:#4b55f6;display:inline-block;position:relative}._12vzlHm-._2RLFBOMO span:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\"}._12vzlHm-._2RLFBOMO:hover span{background:#f4f4f8}._12vzlHm-._2RLFBOMO:focus{border-color:#4b55f6}._12vzlHm-._2RLFBOMO:focus span{background:#f4f4f8}._12vzlHm-._2RLFBOMO._1PO1U71R span{background:#f4f4f8;color:#6e6e77}._12vzlHm-._2RLFBOMO._3UoDKQ60 span:after{content:\"\\E7FD\"}._12vzlHm-._2RLFBOMO._3SuMEhxX span:after{content:\"\\F233\"}._12vzlHm-._2RLFBOMO._37sAMVFg span:after{content:\"\\F1CF\"}._12vzlHm-._2RLFBOMO._3tjGMzoV span:after{content:\"\\F1CE\";font-family:Material Icons Outlined}._12vzlHm-._2RLFBOMO._3iolt4SI span:after{content:\"\\EAAA\";font-family:Material Icons Outlined}._12vzlHm-._2RLFBOMO._5sqN-pp1 span:after{content:\"\\E86C\";font-family:Material Icons Outlined}._12vzlHm-._2RLFBOMO._3ZqmAC1R span:after{content:\"\\E876\"}._12vzlHm-._2RLFBOMO.g_XKdYJo span:after{content:\"\\E835\";font-family:Material Icons Outlined}._12vzlHm-._2RLFBOMO.BI6ypNnd span:after{content:\"\\E834\"}._12vzlHm-._2RLFBOMO._3soDXcuW span:after{content:\"\\E5CF\"}._12vzlHm-._2RLFBOMO._2At3KhLY span:after{content:\"\\E5CE\"}._12vzlHm-._2RLFBOMO.jOgdFqzD span:after{content:\"\\E5CD\"}._12vzlHm-._2RLFBOMO._3xv7a0KZ span:after{content:\"\\E0C6\"}._12vzlHm-._2RLFBOMO._1YDr2VMW span:after{content:\"\\E5D4\"}._12vzlHm-._2RLFBOMO._3bfJB4XQ span:after{content:\"\\E880\"}._12vzlHm-._2RLFBOMO._3W8bHa1O span:after{content:\"\\EF4F\";font-family:Material Icons Outlined}._12vzlHm-._2RLFBOMO._3RzhpmNI span:after{content:\"\\E87D\"}._12vzlHm-._2RLFBOMO.J8l01KZi span:after{content:\"\\E87E\";font-family:Material Icons Outlined}._12vzlHm-._2RLFBOMO._3ZTjObSx span:after{content:\"\\E41A\"}._12vzlHm-._2RLFBOMO._11DMbGLI span:after{content:\"\\E8B6\"}._12vzlHm-._2RLFBOMO._3wjfhb6G span:after{content:\"\\E0B7\"}._12vzlHm-._2RLFBOMO._3e7LXcdo span:after{content:\"\\E150\"}._12vzlHm-._2RLFBOMO._3lOeMDM2 span:after{content:\"\\E150\";font-family:Material Icons Outlined}._12vzlHm-._2RLFBOMO._2a0qYPBz span:after{content:\"\\E145\"}._12vzlHm-._2RLFBOMO._2QuukcBR span:after{content:\"\\E836\"}._12vzlHm-._2RLFBOMO.u5_eS6mR span:after{content:\"\\E837\"}._12vzlHm-._2RLFBOMO.Wb_i_F0l span:after{content:\"\\E163\"}._12vzlHm-._2RLFBOMO._3pk8Hp7K span:after{content:\"\\E0B7\";font-family:Material Icons Outlined}._12vzlHm-._2RLFBOMO._1mjWAg_v span:after{content:\"\\E872\";font-family:Material Icons Outlined}._12vzlHm-._2RLFBOMO._27kiYR5t span:after{content:\"\\E5C4\"}._12vzlHm-._2RLFBOMO._3daFbw_s span:after{content:\"\\E5C8\"}._12vzlHm-._2RLFBOMO._1_6k20Gq,._12vzlHm-._2RLFBOMO._1UQq9Ce_{background:transparent;border-radius:0;color:#555;padding:0;height:28px;width:28px}._12vzlHm-._2RLFBOMO._1_6k20Gq span,._12vzlHm-._2RLFBOMO._1UQq9Ce_ span{padding:0;height:24px;width:24px}._12vzlHm-._2RLFBOMO._1_6k20Gq span:after,._12vzlHm-._2RLFBOMO._1UQq9Ce_ span:after{color:#555}._12vzlHm-._2RLFBOMO._1_6k20Gq.Od0rhYXR,._12vzlHm-._2RLFBOMO._1_6k20Gq.Od0rhYXR span:after,._12vzlHm-._2RLFBOMO._1UQq9Ce_.Od0rhYXR,._12vzlHm-._2RLFBOMO._1UQq9Ce_.Od0rhYXR span:after{color:#4b55f6}._12vzlHm-._2RLFBOMO._1UQq9Ce_ span:after{content:\"\\E8EF\"}._12vzlHm-._2RLFBOMO._1_6k20Gq span:after{content:\"\\E9B0\"}._12vzlHm-._1qGxD2Qt{position:relative;padding:0;border:none;border-radius:0}._12vzlHm-._1qGxD2Qt span{color:#4b55f6;font-size:16px;background:transparent;display:inline-block;width:24px;height:24px;position:relative;margin:0;-webkit-box-shadow:none;box-shadow:none;padding:0;padding:5px}._12vzlHm-._1qGxD2Qt span:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";font-size:14px;font-weight:700}._12vzlHm-._1qGxD2Qt:hover span{background:#f4f4f8}._12vzlHm-._1qGxD2Qt._1YDr2VMW span:after{content:\"\\E5D4\"}.oI164yjV ._1bu0_vry{display:none}.oI164yjV ._1bu0_vry+._1iLecci4{display:inline-block}.oI164yjV ._1bu0_vry+._1iLecci4:before{content:\"\\E835\";font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle}.oI164yjV ._1bu0_vry:checked+._1iLecci4:before{content:\"\\E834\"}.oI164yjV span{padding-left:14px}.CJ33rFrk{display:block}.CJ33rFrk input[type=radio]{position:absolute;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";opacity:0}.CJ33rFrk input[type=radio]+._39AtjnaX:before{content:\"\\E836\";font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle}.CJ33rFrk input[type=radio]+._39AtjnaX span{padding-left:14px;font-size:12px;line-height:16px;color:#414141;font-weight:400}.CJ33rFrk input[type=radio]:checked+._39AtjnaX:before{content:\"\\E837\"}.CJ33rFrk input[type=radio]+._39AtjnaX:empty:before{margin-right:0}._2wx88B6Z{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\"}.jOW35Q0S{background:#fff;border-radius:4px;-webkit-box-shadow:0 0 20px #4B55F614 14;box-shadow:0 0 20px 14 #4B55F614}._2vdGeLAy,.jOW35Q0S{overflow:hidden}._2vdGeLAy._3lhlIbAP{overflow:visible}.jOW35Q0S._3Yk7odFe{margin-bottom:20px;padding:15px;background-color:#fff}._292ABmqH._3Yk7odFe{margin-right:-15px;margin-left:-15px}._6MNOLHO8{visibility:hidden}.IEx0I_Lr{font-weight:700;font-size:12px;line-height:16px;color:#414141;margin-bottom:8px}._2StCRk56{display:inline-block;overflow-x:auto;width:100%}", ""]);

// exports
exports.locals = {
	"btn": "_12vzlHm-",
	"disabled": "_1PO1U71R",
	"user-btn": "_3isH_1tU",
	"secondary-btn": "_5YInMIiL",
	"secondary-button_icon": "_3okJ-ihN",
	"ghost-btn": "_35e1VgvD",
	"btn-icon-text_back": "Lf1xwLGN",
	"icon_arrow-back": "ixGn6QET",
	"btn-type-dropdown": "_2uPc7SeH",
	"default-header": "_2hn7cbRs",
	"icon": "bv8iWugp",
	"icon_chevron-down": "_3nLxNeCa",
	"icon_chevron-up": "_2YMZ2jeL",
	"icon-btn": "_2RLFBOMO",
	"account": "_3UoDKQ60",
	"account_group": "_3SuMEhxX",
	"collapse": "_37sAMVFg",
	"expand": "_3tjGMzoV",
	"arrow_right": "_3iolt4SI",
	"check_circle": "_5sqN-pp1",
	"check": "_3ZqmAC1R",
	"checkbox_blank": "g_XKdYJo",
	"checkbox_marked": "BI6ypNnd",
	"chevron_down": "_3soDXcuW",
	"chevron_up": "_2At3KhLY",
	"close": "jOgdFqzD",
	"comment_question": "_3xv7a0KZ",
	"dots_vertical": "_1YDr2VMW",
	"file_document_box": "_3bfJB4XQ",
	"filter": "_3W8bHa1O",
	"heart": "_3RzhpmNI",
	"heart_outline": "J8l01KZi",
	"loading": "_3ZTjObSx",
	"magnify": "_11DMbGLI",
	"message": "_3wjfhb6G",
	"pencil": "_3e7LXcdo",
	"pencil_outline": "_3lOeMDM2",
	"plus": "_2a0qYPBz",
	"radiobox_blank": "_2QuukcBR",
	"radiobox_marked": "u5_eS6mR",
	"icon-send": "Wb_i_F0l",
	"tooltip_text_outline": "_3pk8Hp7K",
	"trash_can_outline": "_1mjWAg_v",
	"icon_arrow-left": "_27kiYR5t",
	"icon_arrow-right": "_3daFbw_s",
	"list": "_1UQq9Ce_",
	"tile": "_1_6k20Gq",
	"active": "Od0rhYXR",
	"list-item-icon-btn": "_1qGxD2Qt",
	"default-checkbox-div": "oI164yjV",
	"default-checkbox": "_1bu0_vry",
	"checkmark": "_1iLecci4",
	"radio": "CJ33rFrk",
	"radio-label": "_39AtjnaX",
	"material-icons": "_2wx88B6Z",
	"component": "jOW35Q0S",
	"content": "_2vdGeLAy",
	"opened": "_3lhlIbAP",
	"border": "_3Yk7odFe",
	"header": "_292ABmqH",
	"wcag-invisible": "_6MNOLHO8",
	"current_page-header": "IEx0I_Lr",
	"selected-container": "_2StCRk56"
};

/***/ }),

/***/ 1156:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.QuestionSaveArea = exports.ModalQuestionEditLayout = exports.FlyoverQuestionEditLayout = undefined;__webpack_require__(76);
var _react = __webpack_require__(648);
var _input = __webpack_require__(990);var _input2 = _interopRequireDefault(_input);
var _types = __webpack_require__(245);
var _resource = __webpack_require__(106);
var _style = __webpack_require__(1004);var _style2 = _interopRequireDefault(_style);
var _selectors = __webpack_require__(649);var _selectors2 = _interopRequireDefault(_selectors);
var _selectors3 = __webpack_require__(977);var _selectors4 = _interopRequireDefault(_selectors3);
var _selectors5 = __webpack_require__(981);var _selectors6 = _interopRequireDefault(_selectors5);
var _selectors7 = __webpack_require__(986);var _selectors8 = _interopRequireDefault(_selectors7);
var _selectors9 = __webpack_require__(78);
var _resource2 = __webpack_require__(246);
var _UPDATE_BUTTON_NO = __webpack_require__(519);var _UPDATE_BUTTON_NO2 = _interopRequireDefault(_UPDATE_BUTTON_NO);
var _selectors10 = __webpack_require__(975);var _selectors11 = _interopRequireDefault(_selectors10);
var _selectors12 = __webpack_require__(651);var _selectors13 = _interopRequireDefault(_selectors12);

var _resource3 = __webpack_require__(233);
var _button = __webpack_require__(973);
var _date = __webpack_require__(987);
var _resource4 = __webpack_require__(517);
var _resource5 = __webpack_require__(223);
var _OPEN_DROPDOWN_STATUS = __webpack_require__(662);var _OPEN_DROPDOWN_STATUS2 = _interopRequireDefault(_OPEN_DROPDOWN_STATUS);
var _authcheck = __webpack_require__(518);
var _resource6 = __webpack_require__(495);
var _dropdownbasic = __webpack_require__(1067);var _dropdownbasic2 = _interopRequireDefault(_dropdownbasic);
var _QUESTION_LINK = __webpack_require__(663);var _QUESTION_LINK2 = _interopRequireDefault(_QUESTION_LINK);




var _QUESTION_SAVE = __webpack_require__(550);var _QUESTION_SAVE2 = _interopRequireDefault(_QUESTION_SAVE);
var _QUESTION_SHOWLINKS = __webpack_require__(664);var _QUESTION_SHOWLINKS2 = _interopRequireDefault(_QUESTION_SHOWLINKS);
var _QUESTION_MAXIMIZE = __webpack_require__(657);var _QUESTION_MAXIMIZE2 = _interopRequireDefault(_QUESTION_MAXIMIZE);
var _selectors14 = __webpack_require__(986);var _selectors15 = _interopRequireDefault(_selectors14);
var _OPEN_DROPDOWN_PRACTICIONER = __webpack_require__(702);var _OPEN_DROPDOWN_PRACTICIONER2 = _interopRequireDefault(_OPEN_DROPDOWN_PRACTICIONER);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var maxNoteTextLength = 3000;var minLinesVisible = 3;var maxLinesVisible = 75;
var FlyoverQuestionEditLayout = exports.FlyoverQuestionEditLayout = (0, _react.PureConnect)('FlyoverQuestionEditLayout')(function (state) {return {
        creating: _resource.notesEditor.selectors.creating(state),
        item: _resource.notesEditor.selectors.item(state),
        itemQuestionDB: _resource5.questionsEditor.selectors.item(state),
        itemQuestion: _selectors8.default.questionItemSelector(state),
        updating: _resource.notesEditor.selectors.updating(state),
        updatingNoteChat: _resource4.notechatEditor.selectors.updating(state),
        selectNote: state.selection.creating,
        user: _selectors2.default.user(state),
        usergroups: _resource3.usergroupResource.selectors.items(state),
        allparticipants: _resource2.participantsResource.selectors.items(state).qSelect(function (item) {return item;}),
        currentUser: _resource6.useridResource.selectors.items(state),
        origin: state.notemenu.origin,
        participantPopupVisible: _selectors4.default.visible(state),
        categoryPopupVisible: _selectors6.default.visible(state),
        dropdownStatusOpen: _selectors8.default.open(state),
        dropdownopenPracticioner: _selectors8.default.opendropdownPracticioner(state),
        selectTextArea: state.selection.creating,
        screenSmall: _selectors11.default.small(state),
        initialized: state.notesReducer.initialize,
        flyoverVisible: state.flyover.visible };},
function (dispatch) {return {
        change: function change(item) {dispatch(_resource.notesEditor.actions.APPLY({ item: item }));},
        changeQuestion: function changeQuestion(item) {return dispatch(_resource5.questionsEditor.actions.APPLY({ item: item }));},
        updateButtonFocus: function updateButtonFocus(buttonNr, origin, itm) {
            dispatch((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: buttonNr, origin: origin, buttonAction: undefined, lasttoucheditem: itm }));
        },
        showDropdownStatus: function showDropdownStatus(dropdownStatusOpen) {return dispatch((0, _OPEN_DROPDOWN_STATUS2.default)({ dropdownopen: dropdownStatusOpen }));} };},
function (_ref) {var flyoverVisible = _ref.flyoverVisible,creating = _ref.creating,updating = _ref.updating,updatingNoteChat = _ref.updatingNoteChat,selectNote = _ref.selectNote,item = _ref.item,itemQuestionDB = _ref.itemQuestionDB,itemQuestion = _ref.itemQuestion,initialized = _ref.initialized,change = _ref.change,participantPopupVisible = _ref.participantPopupVisible,categoryPopupVisible = _ref.categoryPopupVisible,selectTextArea = _ref.selectTextArea,changeQuestion = _ref.changeQuestion,showDropdownStatus = _ref.showDropdownStatus,dropdownStatusOpen = _ref.dropdownStatusOpen,dropdownopenPracticioner = _ref.dropdownopenPracticioner,usergroups = _ref.usergroups,currentUser = _ref.currentUser,allparticipants = _ref.allparticipants;
    var isquestion = (0, _types.isQuestion)(item);
    var visible = flyoverVisible && (creating || updating) && isquestion && !updatingNoteChat && !selectNote && !participantPopupVisible && !categoryPopupVisible && !selectTextArea;
    var maxlines = maxLinesVisible;
    var selection = document.querySelector('.text-container textarea');
    if (visible && selection && initialized) {
        maxlines = countLines(selection, maxlines);
    }
    var currentUserid = currentUser.length > 0 ? currentUser[0].id : '';
    var statusitems = (0, _authcheck.statussesallowed)(_authcheck.statusses, itemQuestionDB.status, currentUserid, usergroups).map(function (status) {
        var dropDownItem = {
            key: status.id,
            name: status.name.toUpperCase(),
            statusclass: 'status-' + status.id.toString(),
            prefix: 'status-' };

        return dropDownItem;
    });
    var StatusSelectie = _react.React.createElement(_dropdownbasic2.default, { title: 'Status', value: itemQuestionDB.status, items: statusitems, prefix: 'status-', extraclass: 'status-class', toggleDropDown: function toggleDropDown(key) {showDropdownStatus(!dropdownStatusOpen);}, itemSelection: function itemSelection(key) {itemQuestionDB.status = key;changeQuestion(itemQuestionDB);} });
    var practicionersitems = [{
        key: -1,
        name: 'Kies...',
        statusclass: 'practicioner-',
        prefix: 'practicioner-' }].
    concat((0, _authcheck.practicioners)(allparticipants, usergroups).map(function (practicioner) {
        var dropDownItem = {
            key: practicioner.key,
            name: practicioner.name,
            statusclass: 'practicioner-' + practicioner.id,
            prefix: 'practicioner-' };

        return dropDownItem;
    }));
    var BehandelaarSelectie = _react.React.createElement(_dropdownbasic2.default, { title: 'Behandelaar', value: allparticipants && allparticipants.qFirst(function (us) {return us.id === itemQuestionDB.practicionerId;}) ? allparticipants.qFirst(function (us) {return us.id === itemQuestionDB.practicionerId;}).key : -1, items: practicionersitems, prefix: 'practicioner-', extraclass: (0, _style2.default)('practicioner-class'), toggleDropDown: function toggleDropDown(key) {showDropdownStatus(!dropdownopenPracticioner);}, itemSelection: function itemSelection(key) {
            var practicionerId = allparticipants && allparticipants.qFirst(function (us) {return us.key === key;}) && allparticipants.qFirst(function (us) {return us.key === key;}).id;
            if (practicionerId) {
                itemQuestionDB.practicionerId = practicionerId;
                changeQuestion(itemQuestionDB);
            } else
            {
                itemQuestionDB.practicionerId = undefined;
                changeQuestion(itemQuestionDB);
            }
        } });
    var input = _react.React.createElement(_input2.default, { disabled: !!(0, _types.isSharedNote)(item), type: "text", name: "note", rows: maxlines, value: item.text, maxLength: maxNoteTextLength, multiline: true, className: 'text-container', onChange: function onChange(value) {return change({ text: value });}, floating: true });
    var inputAntwoordConcern = _react.React.createElement(_input2.default, { disabled: !(0, _authcheck.canAnswer)(_authcheck.statusses, itemQuestionDB.status, currentUserid, usergroups), type: "text", name: "antwoordConcern", rows: maxlines, value: itemQuestionDB.antwoordConcern ? itemQuestionDB.antwoordConcern : '', maxLength: maxNoteTextLength, multiline: true, className: 'text-container', onChange: function onChange(valueAntwoord) {return changeQuestion({ antwoordConcern: valueAntwoord });}, floating: true });
    return _react.React.createElement("div", { className: (0, _style2.default)('create_note', !visible ? 'wcag-invisible' : '', 'fields-container'), "aria-hidden": !visible, "aria-labelledby": "Stel een vraag" },
    _react.React.createElement("title", null,
    _react.React.createElement("span", { className: (0, _style2.default)('title-icon'), "data-icon": 'icon_comment-question' }),
    _react.React.createElement("span", { className: (0, _style2.default)('title-text') }, 'TECHNISCHE VRAAG')),
    _react.React.createElement("div", { className: (0, _style2.default)('note-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('question-status-container') + ' question-status-container' },
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container-bottom') }, StatusSelectie)),
    _react.React.createElement("div", { className: (0, _style2.default)('question-practicioner-container', !(0, _authcheck.showPracticioner)(itemQuestionDB.status, currentUserid, usergroups) ? 'wcag-invisible' : '') + ' question-practicioner-container' },
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container-bottom') }, BehandelaarSelectie)),
    _react.React.createElement("span", { className: (0, _style2.default)('sub-title') },
    "Uw vraag test",
    _react.React.createElement("span", { className: (0, _style2.default)('important-icon') }, "*")),
    _react.React.createElement("div", { id: "note", className: (0, _style2.default)('input-text-notitie', item && item.text && item.text.length >= maxNoteTextLength ? 'alert-max-chars' : '', flyoverVisible ? 'flyover' : '') }, input),
    _react.React.createElement("div", { className: (0, _style2.default)('answer-container', 'edit-question-container', !(0, _authcheck.showAnswer)(itemQuestionDB.status, currentUserid, usergroups) ? 'wcag-invisible' : '') },
    _react.React.createElement("span", { className: (0, _style2.default)('sub-title') },
    "Antwoord vanuit Concern",
    _react.React.createElement("span", { className: (0, _style2.default)('important-icon') }, "*")),
    _react.React.createElement("div", { id: "note", className: (0, _style2.default)('input-answer-container', item && itemQuestionDB.antwoordConcern && itemQuestionDB.antwoordConcern.length >= maxNoteTextLength ? 'alert-max-chars' : '') }, inputAntwoordConcern))));
});
var ModalQuestionEditLayout = exports.ModalQuestionEditLayout = (0, _react.PureConnect)('ModalQuestionEditLayout')(function (state) {return {
        creating: _resource.notesEditor.selectors.creating(state),
        item: _resource.notesEditor.selectors.item(state),
        itemQuestionDB: _resource5.questionsEditor.selectors.item(state),
        updating: _resource.notesEditor.selectors.updating(state),
        updatingNoteChat: _resource4.notechatEditor.selectors.updating(state),
        selectNote: state.selection.creating,
        user: _selectors2.default.user(state),
        usergroups: _resource3.usergroupResource.selectors.items(state),
        currentUser: _resource6.useridResource.selectors.items(state),
        allparticipants: _resource2.participantsResource.selectors.items(state).qSelect(function (item) {return item;}),
        allparticipantsgroups: _resource3.usergroupResource.selectors.items(state).qSelect(function (item) {return item;}),
        origin: state.notemenu.origin,
        participantPopupVisible: _selectors4.default.visible(state),
        categoryPopupVisible: _selectors6.default.visible(state),
        dropdownStatusOpen: _selectors8.default.open(state),
        dropdownopenPracticioner: _selectors8.default.opendropdownPracticioner(state),
        selectTextArea: state.selection.creating,
        screenSmall: _selectors11.default.small(state),
        initialized: state.notesReducer.initialize,
        flyoverVisible: state.flyover.visible,
        allQuestions: _resource5.questionsResource.selectors.items(state),
        linking: _selectors8.default.linking(state),
        showlinks: _selectors8.default.showlinks(state),
        ismaximized: _selectors15.default.ismaximized(state) };},
function (dispatch) {return {
        change: function change(item) {dispatch(_resource.notesEditor.actions.APPLY({ item: item }));},
        changeQuestion: function changeQuestion(item) {return dispatch(_resource5.questionsEditor.actions.APPLY({ item: item }));},
        updateButtonFocus: function updateButtonFocus(buttonNr, origin, itm) {
            dispatch((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: buttonNr, origin: origin, buttonAction: undefined, lasttoucheditem: itm }));
        },
        showDropdownStatus: function showDropdownStatus(dropdownStatusOpen) {return dispatch((0, _OPEN_DROPDOWN_STATUS2.default)({ dropdownopen: dropdownStatusOpen }));},
        showDropdownPracticioner: function showDropdownPracticioner(dropdownopenPracticioner) {return dispatch((0, _OPEN_DROPDOWN_PRACTICIONER2.default)({ dropdownopenPracticioner: dropdownopenPracticioner }));},
        koppel: function koppel(item) {
            dispatch((0, _QUESTION_LINK2.default)({ linkvisible: true, linkitem: item }));
        },
        toonlinks: function toonlinks(item) {
            dispatch((0, _QUESTION_SHOWLINKS2.default)({ showlinks: true, showitem: item }));
        },
        maximize: function maximize(maximized) {return dispatch((0, _QUESTION_MAXIMIZE2.default)({ maximized: maximized }));} };},
function (_ref2) {var creating = _ref2.creating,updating = _ref2.updating,updatingNoteChat = _ref2.updatingNoteChat,allQuestions = _ref2.allQuestions,flyoverVisible = _ref2.flyoverVisible,selectNote = _ref2.selectNote,item = _ref2.item,itemQuestionDB = _ref2.itemQuestionDB,user = _ref2.user,usergroups = _ref2.usergroups,currentUser = _ref2.currentUser,initialized = _ref2.initialized,change = _ref2.change,allparticipants = _ref2.allparticipants,participantPopupVisible = _ref2.participantPopupVisible,categoryPopupVisible = _ref2.categoryPopupVisible,selectTextArea = _ref2.selectTextArea,changeQuestion = _ref2.changeQuestion,showDropdownStatus = _ref2.showDropdownStatus,dropdownStatusOpen = _ref2.dropdownStatusOpen,dropdownopenPracticioner = _ref2.dropdownopenPracticioner,koppel = _ref2.koppel,linking = _ref2.linking,toonlinks = _ref2.toonlinks,showlinks = _ref2.showlinks,ismaximized = _ref2.ismaximized,maximize = _ref2.maximize;
    var koppelen = item && itemQuestionDB && item.id === itemQuestionDB.noteId && !itemQuestionDB.parentId;
    var ontkoppelen = item && itemQuestionDB && item.id === itemQuestionDB.noteId && !!itemQuestionDB.parentId;
    var isquestion = (0, _types.isQuestion)(item);
    var visible = !flyoverVisible && (creating || updating) && isquestion && !updatingNoteChat && !selectNote && !participantPopupVisible && !categoryPopupVisible && !selectTextArea && !linking && !showlinks;
    var maxlines = maxLinesVisible;
    var selection = document.querySelector('.text-container textarea');
    if (visible && selection && initialized) {
        maxlines = countLines(selection, maxlines);
    }
    var currentUserid = currentUser.length > 0 ? currentUser[0].id : '';
    var statusitems = (0, _authcheck.statussesallowed)(_authcheck.statusses, itemQuestionDB.status, currentUserid, usergroups).map(function (status) {
        var dropDownItem = {
            key: status.id,
            name: status.name.toUpperCase(),
            statusclass: 'status-' + status.id.toString(),
            prefix: 'status-' };

        return dropDownItem;
    });
    var StatusSelectie = _react.React.createElement(_dropdownbasic2.default, { title: 'Status', value: itemQuestionDB.status, items: statusitems, prefix: 'status-', extraclass: 'status-class', toggleDropDown: function toggleDropDown(key) {showDropdownStatus(!dropdownStatusOpen);}, itemSelection: function itemSelection(key) {itemQuestionDB.status = key;changeQuestion(itemQuestionDB);} });
    var practicionersitems = [{
        key: -1,
        name: 'Kies...',
        statusclass: 'practicioner-',
        prefix: 'practicioner-' }].
    concat((0, _authcheck.practicioners)(allparticipants, usergroups).map(function (practicioner) {
        var dropDownItem = {
            key: practicioner.key,
            name: practicioner.name,
            statusclass: 'practicioner-' + practicioner.id,
            prefix: 'practicioner-' };

        return dropDownItem;
    }));
    var BehandelaarSelectie = _react.React.createElement(_dropdownbasic2.default, { title: 'Behandelaar', value: allparticipants && allparticipants.qFirst(function (us) {return us.id === itemQuestionDB.practicionerId;}) ? allparticipants.qFirst(function (us) {return us.id === itemQuestionDB.practicionerId;}).key : -1, items: practicionersitems, prefix: 'practicioner-', extraclass: (0, _style2.default)('practicioner-class'), toggleDropDown: function toggleDropDown(key) {showDropdownStatus(!dropdownopenPracticioner);}, itemSelection: function itemSelection(key) {
            var practicionerId = allparticipants && allparticipants.qFirst(function (us) {return us.key === key;}) && allparticipants.qFirst(function (us) {return us.key === key;}).id;
            if (practicionerId) {
                itemQuestionDB.practicionerId = practicionerId;
                changeQuestion(itemQuestionDB);
            } else
            {
                itemQuestionDB.practicionerId = undefined;
                changeQuestion(itemQuestionDB);
            }
        } });
    var input = _react.React.createElement(_input2.default, { disabled: !!(0, _types.isSharedNote)(item), type: "text", name: "note", rows: maxlines, value: item.text, maxLength: maxNoteTextLength, multiline: true, className: 'text-container', onChange: function onChange(value) {return change({ text: value });}, floating: true });
    var inputAntwoordConcern = _react.React.createElement(_input2.default, { disabled: !(0, _authcheck.canAnswer)(_authcheck.statusses, itemQuestionDB.status, currentUserid, usergroups), type: "text", name: "antwoordConcern", rows: maxlines, value: itemQuestionDB.antwoordConcern ? itemQuestionDB.antwoordConcern : '', maxLength: maxNoteTextLength, multiline: true, className: 'text-container', onChange: function onChange(valueAntwoord) {return changeQuestion({ antwoordConcern: valueAntwoord });}, floating: true });
    var haschildren = false;
    var amountofchildren = 0;
    if (allQuestions) {
        var itemQuestion = allQuestions.qFirst(function (o) {return o.noteId === item.id;});
        if (itemQuestion) {
            haschildren = allQuestions.qWhere(function (x) {return !!x.parentId;}).map(function (d) {return d.parentId;}).qAny(function (c) {return c === itemQuestion.noteId;});
            amountofchildren = allQuestions.qWhere(function (x) {return !!x.parentId && x.parentId === itemQuestion.noteId;}).length;
        }
    }
    return _react.React.createElement("div", { className: (0, _style2.default)('create_note', 'details', !visible ? 'wcag-invisible' : '', 'fields-container'), "aria-hidden": !visible, "aria-labelledby": "Maak een technische vraag aan" },
    _react.React.createElement("div", null,
    _react.React.createElement("span", { className: (0, _style2.default)('expand_button-container') },
    _react.React.createElement("button", { type: "button", className: (0, _style2.default)('btn', 'icon-btn', !ismaximized ? 'expand' : 'collapse'), onClick: function onClick() {maximize(!ismaximized);} },
    _react.React.createElement("span", { className: (0, _style2.default)('arrow-expand-icon') })))),
    _react.React.createElement("section", { role: "content-info", className: (0, _style2.default)('content-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('details-top-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('details-title-container') },
    _react.React.createElement("span", { className: (0, _style2.default)('title-text-action') }, 'Technische vraag wijzigen'),
    _react.React.createElement("div", { className: (0, _style2.default)('icon-left-container') },
    _react.React.createElement("span", { className: (0, _style2.default)('icon-container', 'question') })),
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container-top') }, 'TECHNISCHE VRAAG'),
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container-bottom') },
    _react.React.createElement(_date.DateTimeText, { date: item.created })))))),
    _react.React.createElement("section", { className: (0, _style2.default)('details-content-container', !ismaximized ? '' : 'maximized') },
    isquestion && !haschildren ?
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Koppelen', "aria-haspopup": false, tabIndex: 0, disabled: false, onKeyDown: function onKeyDown(evt) {
            handleEnters(evt, koppelen ?
            function () {return koppel(itemQuestionDB);} :
            function () {itemQuestionDB.parentId = undefined;return changeQuestion(itemQuestionDB);});
        }, onClick: koppelen ?
        function () {return koppel(itemQuestionDB);} :
        function () {itemQuestionDB.parentId = undefined;return changeQuestion(itemQuestionDB);} },
    _react.React.createElement("span", null, koppelen ? 'KOPPEL TECHNISCHE VRAAG' : ontkoppelen ? 'ONTKOPPEL TECHNISCHE VRAAG' : '')) :
    isquestion && haschildren && amountofchildren > 0 ?
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Toon links', "aria-haspopup": false, tabIndex: 0, disabled: false, onKeyDown: function onKeyDown(evt) {return handleEnters(evt, function () {return toonlinks(itemQuestionDB);});}, onClick: function onClick() {return toonlinks(itemQuestionDB);} },
    _react.React.createElement("span", null,
    " BEKIJK GEKOPPELDE VRAGEN (",
    amountofchildren,
    ")")) :
    null,
    _react.React.createElement("div", { className: (0, _style2.default)('middle-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('made-by-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container-top') }, "Aangemaakt door"),
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container-bottom') }, mapParticipantName(item.userId, allparticipants))),
    _react.React.createElement("div", { className: (0, _style2.default)('question-status-container') + ' question-status-container' },
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container-bottom') }, StatusSelectie)),
    _react.React.createElement("div", { className: (0, _style2.default)('question-practicioner-container', !(0, _authcheck.showPracticioner)(itemQuestionDB.status, currentUserid, usergroups) ? 'wcag-invisible' : '') + ' question-practicioner-container' },
    _react.React.createElement("div", { className: (0, _style2.default)('text-created-container-bottom') }, BehandelaarSelectie))),
    _react.React.createElement("div", { className: (0, _style2.default)('note-container', 'edit-note-container') },
    _react.React.createElement("span", { className: (0, _style2.default)('sub-title') },
    "Uw technische vraag",
    _react.React.createElement("span", { className: (0, _style2.default)('important-icon') }, "*")),
    _react.React.createElement("div", { id: "note", className: (0, _style2.default)('input-text-notitie', item && item.text && item.text.length >= maxNoteTextLength ? 'alert-max-chars' : '') }, input)),
    _react.React.createElement("div", { className: (0, _style2.default)('answer-container', 'edit-question-container', !(0, _authcheck.showAnswer)(itemQuestionDB.status, currentUserid, usergroups) ? 'wcag-invisible' : '') },
    _react.React.createElement("span", { className: (0, _style2.default)('sub-title') },
    "Antwoord vanuit Concern",
    _react.React.createElement("span", { className: (0, _style2.default)('important-icon') }, "*")),
    _react.React.createElement("div", { id: "note", className: (0, _style2.default)('input-answer-container', item && itemQuestionDB.antwoordConcern && itemQuestionDB.antwoordConcern.length >= maxNoteTextLength ? 'alert-max-chars' : '') }, inputAntwoordConcern))));
});
var QuestionSaveArea = exports.QuestionSaveArea = (0, _react.PureConnect)('QuestionSaveArea')(function (state) {return {
        creating: _resource.notesEditor.selectors.creating(state),
        updating: _resource.notesEditor.selectors.updating(state),
        linking: _selectors8.default.linking(state),
        creatingQuestion: _resource5.questionsEditor.selectors.creating(state),
        updatingQuestion: _resource5.questionsEditor.selectors.updating(state),
        item: _resource.notesEditor.selectors.item(state),
        itemQuestionDB: _resource5.questionsEditor.selectors.item(state),
        updatingNoteChat: _resource4.notechatEditor.selectors.updating(state),
        selectNote: state.selection.creating,
        user: _selectors2.default.user(state),
        allparticipants: _resource2.participantsResource.selectors.items(state).qSelect(function (item) {return item;}),
        allparticipantsgroups: _resource3.usergroupResource.selectors.items(state).qSelect(function (item) {return item;}),
        origin: state.notemenu.origin,
        participantPopupVisible: _selectors4.default.visible(state),
        categoryPopupVisible: _selectors6.default.visible(state),
        selectTextArea: state.selection.creating,
        screenSmall: _selectors11.default.small(state),
        isminimized: _selectors13.default.isminimized(state),
        documentId: _selectors9.selectors.docId(state),
        showlinks: _selectors8.default.showlinks(state) };},
function (dispatch) {return {
        cancel: function cancel() {
            dispatch(_resource.notesEditor.actions.RESET({}));
            dispatch(_resource5.questionsEditor.actions.RESET({}));
        },
        cancelCreating: function cancelCreating() {
            dispatch(_resource.notesEditor.actions.CREATE_CANCEL({}));
            dispatch(_resource5.questionsEditor.actions.CREATE_CANCEL({}));
        },
        cancelUpdating: function cancelUpdating(updatingQuestion) {
            dispatch(_resource.notesEditor.actions.UPDATE_CANCEL({}));
            if (updatingQuestion) {
                dispatch(_resource5.questionsEditor.actions.UPDATE_CANCEL({}));
            } else
            {
                dispatch(_resource5.questionsEditor.actions.CREATE_CANCEL({}));
            }
        },
        saveCreating: function saveCreating(item, itemQuestionDB, documentId) {
            item = fixNoteDevelopmentJsonServer(item, true);
            dispatch(_resource.notesEditor.actions.CREATE_CONTINUE({ item: item }));
        },
        saveUpdating: function saveUpdating(item, itemQuestionDB, documentId, creatingQuestion, updatingQuestion) {
            item = fixNoteDevelopmentJsonServer(item, false);
            if (!!(0, _types.isSharedNote)(item)) {
                dispatch(_resource.notesEditor.actions.UPDATE_CANCEL({ item: item }));
                dispatch((0, _QUESTION_SAVE2.default)({ saveitem: itemQuestionDB }));
            } else
            {
                dispatch(_resource.notesEditor.actions.UPDATE_CONTINUE({ item: item }));
            }
        } };},
function (_ref3) {var creating = _ref3.creating,updating = _ref3.updating,creatingQuestion = _ref3.creatingQuestion,updatingQuestion = _ref3.updatingQuestion,updatingNoteChat = _ref3.updatingNoteChat,selectNote = _ref3.selectNote,item = _ref3.item,itemQuestionDB = _ref3.itemQuestionDB,documentId = _ref3.documentId,saveCreating = _ref3.saveCreating,cancelCreating = _ref3.cancelCreating,saveUpdating = _ref3.saveUpdating,cancelUpdating = _ref3.cancelUpdating,participantPopupVisible = _ref3.participantPopupVisible,categoryPopupVisible = _ref3.categoryPopupVisible,selectTextArea = _ref3.selectTextArea,linking = _ref3.linking,showlinks = _ref3.showlinks;
    var visible = (creating || updating) && item.isquestion && !updatingNoteChat && !selectNote && !participantPopupVisible && !categoryPopupVisible && !selectTextArea && !linking && !showlinks;
    return _react.React.createElement("div", { className: (0, _style2.default)('bottom-panel', !visible ? 'wcag-invisible' : ''), "aria-hidden": !visible, "aria-labelledby": "Maak een notitie aan" },
    _react.React.createElement("div", { className: (0, _style2.default)('bottom-buttons') },
    _react.React.createElement("div", { className: (0, _style2.default)('buttons-container', participantPopupVisible || categoryPopupVisible ? 'wcag-invisible' : '') },
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Annuleren', "aria-haspopup": false, tabIndex: 0, onKeyDown: function onKeyDown(evt) {
            handleEnters(evt, creating && !updating ?
            function () {cancelCreating();} :
            function () {cancelUpdating(updatingQuestion);});
        }, onClick: creating && !updating ?
        function () {cancelCreating();} :
        function () {cancelUpdating(updatingQuestion);} },
    _react.React.createElement("span", null, "Annuleren")),
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', "aria-label": 'Opslaan', "aria-haspopup": false, tabIndex: item.text ? 0 : -1, disabled: !item.text, onKeyDown: function onKeyDown(evt) {
            handleEnters(evt, creating && !updating ?
            function () {return saveCreating(item, itemQuestionDB, documentId);} :
            function () {return saveUpdating(item, itemQuestionDB, documentId, creatingQuestion, updatingQuestion);});
        }, onClick: creating && !updating ?
        function () {return saveCreating(item, itemQuestionDB, documentId);} :
        function () {return saveUpdating(item, itemQuestionDB, documentId, updatingQuestion, updatingQuestion);} },
    _react.React.createElement("span", null, "Opslaan")))));
});
function mapParticipantName(participantId, allparticipants) {
    var participant = allparticipants.qWhere(function (item) {return participantId === item.id;});
    return participant && participant.qAny() ? '' + participant[0].name : '';
}
function countLines(textarea, max) {
    var buffer = null;
    if (buffer == null) {
        buffer = document.createElement('textarea');
        buffer.style.border = 'none';
        buffer.style.height = '0';
        buffer.style.overflow = 'hidden';
        buffer.style.padding = '0';
        buffer.style.position = 'absolute';
        buffer.style.left = '0';
        buffer.style.top = '0';
        buffer.style.zIndex = '-1';
        buffer.rows = max;
        document.body.appendChild(buffer);
    }
    var cs = window.getComputedStyle(textarea, '');
    var pl = parseInt(cs.paddingLeft);
    var pr = parseInt(cs.paddingRight);
    var lh = parseInt(cs.lineHeight);
    if (isNaN(lh))
    lh = parseInt(cs.fontSize);
    buffer.style.width = textarea.clientWidth - pl - pr + 'px';
    buffer.style.font = cs.font;
    buffer.style.letterSpacing = cs.letterSpacing;
    buffer.style.whiteSpace = cs.whiteSpace;
    buffer.style.wordBreak = cs.wordBreak;
    buffer.style.wordSpacing = cs.wordSpacing;
    buffer.style.wordWrap = cs.wordWrap;
    buffer.value = textarea.value;
    var result = Math.floor(buffer.scrollHeight / lh);
    if (result === 0)
    result = 1;
    if (result <= minLinesVisible) {
        return minLinesVisible;
    } else
    if (result > minLinesVisible && result < maxLinesVisible) {
        return result + 1;
    } else
    {
        return maxLinesVisible;
    }
}
function fixNoteDevelopmentJsonServer(item, create) {
    return item;
}
function handleEnters(evt, funct) {
    if (evt.key === 'Enter') {
        evt.preventDefault();
        funct();
    }
}

/***/ }),

/***/ 1183:
/***/ (function(module, exports, __webpack_require__) {


        // classnames-loader: automatically bind css-modules to classnames
        var classNames = __webpack_require__(492);
        var locals = __webpack_require__(1333);
        var css = classNames.bind(locals);
        for (var style in locals) css[style] = locals[style];
        module.exports = css;
    

/***/ }),

/***/ 1327:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _getPrototypeOf = __webpack_require__(232);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(105);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(110);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(515);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _inherits2 = __webpack_require__(516);var _inherits3 = _interopRequireDefault(_inherits2);var _defineProperty = __webpack_require__(161);var _defineProperty2 = _interopRequireDefault(_defineProperty);var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);var _getOwnPropertyDescriptor = __webpack_require__(652);var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);





var _react = __webpack_require__(648);
var _MEASURED = __webpack_require__(736);var _MEASURED2 = _interopRequireDefault(_MEASURED);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {var c = arguments.length,r = c < 3 ? target : desc === null ? desc = (0, _getOwnPropertyDescriptor2.default)(target, key) : desc,d;if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeof3.default)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;}return c > 3 && r && (0, _defineProperty2.default)(target, key, r), r;};
var WindowComponent = function (_Component) {(0, _inherits3.default)(WindowComponent, _Component);
    function WindowComponent() {(0, _classCallCheck3.default)(this, WindowComponent);var _this = (0, _possibleConstructorReturn3.default)(this, (WindowComponent.__proto__ || (0, _getPrototypeOf2.default)(WindowComponent)).apply(this,
        arguments));
        _this._last = { scrollLeft: 0, scrollTop: 0, width: 0, height: 0 };
        _this.queueUpdate = window.requestAnimationFrame ?
        function () {
            if (!_this._timer) {
                window.requestAnimationFrame(_this.onUpdate);
            }
        } :
        function () {
            if (!_this._timer) {
                window.setTimeout(_this.onUpdate);
            }
        };
        _this.onUpdate = function () {
            _this._timer = null;var
            _scrollingElement = _this._scrollingElement;
            var next = {
                height: window.innerHeight,
                scrollLeft: _scrollingElement.scrollLeft,
                scrollTop: _scrollingElement.scrollTop,
                width: window.innerWidth };

            var last = _this._last;
            if (next.scrollTop !== last.scrollTop ||
            next.scrollLeft !== last.scrollLeft ||
            next.width !== last.width ||
            next.height !== last.height) {
                _this._last = next;
                _this.props.update(next);
            }
        };return _this;
    }(0, _createClass3.default)(WindowComponent, [{ key: "componentDidMount", value: function componentDidMount()
        {
            this._scrollingElement = document.scrollingElement || document.documentElement;
            window.addEventListener('load', this.queueUpdate);
            window.addEventListener('resize', this.queueUpdate);
            window.addEventListener('scroll', this.queueUpdate);
            this.onUpdate();
        } }, { key: "componentWillUnmount", value: function componentWillUnmount()
        {
            window.removeEventListener('load', this.queueUpdate);
            window.removeEventListener('resize', this.queueUpdate);
            window.removeEventListener('scroll', this.queueUpdate);
        } }, { key: "render", value: function render()
        {
            return null;
        } }]);return WindowComponent;}(_react.Component);

WindowComponent = __decorate([
(0, _react.Connect)(null, function (dispatch) {return {
        update: function update(dim) {return dispatch((0, _MEASURED2.default)(dim));} };})],

WindowComponent);exports.default =
WindowComponent;

/***/ }),

/***/ 1328:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.NotesEditModal = undefined;__webpack_require__(76);
var _react = __webpack_require__(648);
var _index = __webpack_require__(979);
var _types = __webpack_require__(245);
var _resource = __webpack_require__(106);
var _style = __webpack_require__(650);var _style2 = _interopRequireDefault(_style);
var _selectors = __webpack_require__(649);var _selectors2 = _interopRequireDefault(_selectors);
var _selectors3 = __webpack_require__(651);var _selectors4 = _interopRequireDefault(_selectors3);
var _selectors5 = __webpack_require__(977);var _selectors6 = _interopRequireDefault(_selectors5);
var _selectors7 = __webpack_require__(981);var _selectors8 = _interopRequireDefault(_selectors7);
var _resource2 = __webpack_require__(246);
var _noteEditArea = __webpack_require__(1122);
var _UPDATE_BUTTON_NO = __webpack_require__(519);var _UPDATE_BUTTON_NO2 = _interopRequireDefault(_UPDATE_BUTTON_NO);
var _focuslockext = __webpack_require__(978);var _focuslockext2 = _interopRequireDefault(_focuslockext);
var _selectors9 = __webpack_require__(975);var _selectors10 = _interopRequireDefault(_selectors9);
var _NOTES_MINIMIZE = __webpack_require__(713);var _NOTES_MINIMIZE2 = _interopRequireDefault(_NOTES_MINIMIZE);
var _input = __webpack_require__(1019);
var _categoryEditArea = __webpack_require__(1064);var _categoryEditArea2 = _interopRequireDefault(_categoryEditArea);
var _input2 = __webpack_require__(1017);var _input3 = _interopRequireDefault(_input2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var NotesEditModal = exports.NotesEditModal = (0, _react.PureConnect)('NotesEditModal')(function (state) {return {
        creating: _resource.notesEditor.selectors.creating(state),
        updating: _resource.notesEditor.selectors.updating(state),
        item: _resource.notesEditor.selectors.item(state),
        user: _selectors2.default.user(state),
        userparticipant: _resource2.participantsResource.selectors.items(state).qFirst(function (itm) {return itm.isUser;}),
        origin: state.notemenu.origin,
        participantPopupVisible: _selectors6.default.visible(state),
        categoryPopupVisible: _selectors8.default.visible(state),
        screenSmall: _selectors10.default.small(state),
        isminimized: _selectors4.default.isminimized(state),
        flyoverVisible: state.flyover.visible };},
function (dispatch) {return {
        cancel: function cancel() {return dispatch(_resource.notesEditor.actions.RESET({}));},
        cancelCreating: function cancelCreating() {
            dispatch(_resource.notesEditor.actions.CREATE_CANCEL({}));
        },
        cancelUpdating: function cancelUpdating() {
            dispatch(_resource.notesEditor.actions.UPDATE_CANCEL({}));
        },
        updateButtonFocus: function updateButtonFocus(buttonNr, origin, itm) {
            dispatch((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: buttonNr, origin: origin, buttonAction: undefined, lasttoucheditem: itm }));
        },
        minimize: function minimize(minimized) {return dispatch((0, _NOTES_MINIMIZE2.default)({ minimized: minimized }));} };},
function (_ref) {var flyoverVisible = _ref.flyoverVisible,creating = _ref.creating,updating = _ref.updating,item = _ref.item,isminimized = _ref.isminimized,origin = _ref.origin,screenSmall = _ref.screenSmall,updateButtonFocus = _ref.updateButtonFocus,cancelCreating = _ref.cancelCreating,cancelUpdating = _ref.cancelUpdating,minimize = _ref.minimize,participantPopupVisible = _ref.participantPopupVisible,categoryPopupVisible = _ref.categoryPopupVisible;
    var isquestion = (0, _types.isQuestion)(item);
    return _react.React.createElement(_index.Modal, { onEscKeyDown: !participantPopupVisible && !categoryPopupVisible ?
        creating ? function () {return cancelCreating();} : function () {return cancelUpdating();} : function () {}, visible: !flyoverVisible && (creating || updating) && !isquestion, type: screenSmall ? 'smallscreen' : 'center2nd', backdrop: true, minimized: isminimized, header: _react.React.createElement("div", { className: (0, _style2.default)('app') }) },
    _react.React.createElement("div", { className: (0, _style2.default)(!creating && !updating || isminimized ? 'wcag-invisible' : '', 'fields-container'), "aria-hidden": !(creating || updating) || isminimized, "aria-labelledby": "Maak een notitie aan" },
    _react.React.createElement(_focuslockext2.default, { disabled: !(creating || updating) },
    _react.React.createElement(_noteEditArea.ModalNotesEditLayout, null),
    _react.React.createElement(_noteEditArea.NotesSaveArea, null),
    _react.React.createElement(_input.CategoryPopupSelection, { mode: "edit" }),
    _react.React.createElement(_categoryEditArea2.default, null),
    _react.React.createElement(_input3.default, null))));
});

/***/ }),

/***/ 1329:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.NotesInspectButtons = undefined;__webpack_require__(76);
var _react = __webpack_require__(648);
var _index = __webpack_require__(979);
var _types = __webpack_require__(245);
var _resource = __webpack_require__(106);
var _style = __webpack_require__(650);var _style2 = _interopRequireDefault(_style);
var _selectors = __webpack_require__(649);var _selectors2 = _interopRequireDefault(_selectors);
var _selectors3 = __webpack_require__(651);var _selectors4 = _interopRequireDefault(_selectors3);
var _selectors5 = __webpack_require__(986);var _selectors6 = _interopRequireDefault(_selectors5);
var _selectors7 = __webpack_require__(977);var _selectors8 = _interopRequireDefault(_selectors7);
var _selectors9 = __webpack_require__(981);var _selectors10 = _interopRequireDefault(_selectors9);
var _resource2 = __webpack_require__(246);
var _focuslockext = __webpack_require__(978);var _focuslockext2 = _interopRequireDefault(_focuslockext);
var _selectors11 = __webpack_require__(975);var _selectors12 = _interopRequireDefault(_selectors11);
var _NOTES_INSPECT = __webpack_require__(544);var _NOTES_INSPECT2 = _interopRequireDefault(_NOTES_INSPECT);
var _details = __webpack_require__(1106);
var _button = __webpack_require__(973);
var _editChatArea = __webpack_require__(1066);
var _resource3 = __webpack_require__(517);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
(0, _react.PureConnect)('NotesInspectModal')(function (state) {return {
        user: _selectors2.default.user(state),
        userparticipant: _resource2.participantsResource.selectors.items(state).qFirst(function (itm) {return itm.isUser;}),
        participantPopupVisible: _selectors8.default.visible(state),
        categoryPopupVisible: _selectors10.default.visible(state),
        updating: _resource3.notechatEditor.selectors.updating(state),
        creatingNote: _resource.notesEditor.selectors.creating(state),
        updatingNote: _resource.notesEditor.selectors.updating(state),
        selectNote: state.selection.creating,
        selectTextArea: state.selection.creating,
        screenSmall: _selectors12.default.small(state),
        isminimized: _selectors4.default.isminimized(state),
        flyoverVisible: state.flyover.visible,
        inspectItem: _selectors4.default.inspect(state),
        inspectQuestion: _selectors6.default.inspect(state) };},
function (dispatch) {return {
        cancelInspect: function cancelInspect() {return dispatch((0, _NOTES_INSPECT2.default)({ item: undefined }));},
        doinspect: function doinspect(item) {return dispatch((0, _NOTES_INSPECT2.default)({ item: item }));} };},
function (_ref) {var flyoverVisible = _ref.flyoverVisible,inspectItem = _ref.inspectItem,inspectQuestion = _ref.inspectQuestion,isminimized = _ref.isminimized,screenSmall = _ref.screenSmall,cancelInspect = _ref.cancelInspect,updating = _ref.updating,creatingNote = _ref.creatingNote,updatingNote = _ref.updatingNote,selectNote = _ref.selectNote,participantPopupVisible = _ref.participantPopupVisible,categoryPopupVisible = _ref.categoryPopupVisible,selectTextArea = _ref.selectTextArea;
    var visibleChatUpdate = updating && !creatingNote && !updatingNote && !selectNote && !participantPopupVisible && !categoryPopupVisible && !selectTextArea;
    var inspecting = !!inspectItem && !inspectItem.isquestion;
    return _react.React.createElement(_index.Modal, { onEscKeyDown: function onEscKeyDown() {return cancelInspect();}, visible: !flyoverVisible && inspecting, type: screenSmall ? 'smallscreen' : 'center2nd', backdrop: true, minimized: isminimized, header: _react.React.createElement("div", { className: (0, _style2.default)('app') }) },
    _react.React.createElement("div", { className: (0, _style2.default)(!inspecting || isminimized ? 'wcag-invisible' : '', 'fields-container'), "aria-hidden": !inspecting || isminimized, "aria-labelledby": "Maak een notitie aan" },
    _react.React.createElement(_focuslockext2.default, { disabled: !inspecting },
    _react.React.createElement("div", { className: (0, _style2.default)('note-details', !flyoverVisible && !visibleChatUpdate && inspectItem && !inspectItem.isquestion ? '' : 'wcag-invisible') },
    _react.React.createElement(_details.NoteDetailsControl, { item: inspectItem, itemQuestion: inspectQuestion }),
    _react.React.createElement(NotesInspectButtons, { item: inspectItem })),
    _react.React.createElement("div", { className: (0, _style2.default)('chat-details', !flyoverVisible && visibleChatUpdate && inspectItem ? '' : 'wcag-invisible') },
    _react.React.createElement(_editChatArea.NoteChatEditArea, null),
    _react.React.createElement(_editChatArea.NoteChatSaveArea, null)))));
});
var NotesInspectButtons = exports.NotesInspectButtons = (0, _react.PureConnect)('NotesInspectButtons')(function (state) {return {
        origin: state.notemenu.origin,
        screenSmall: _selectors12.default.small(state),
        isminimized: _selectors4.default.isminimized(state),
        inspectItem: _selectors4.default.inspect(state),
        flyoverVisible: state.flyover.visible };},
function (dispatch) {return {
        cancelInspect: function cancelInspect() {return dispatch((0, _NOTES_INSPECT2.default)({ item: undefined }));},
        editNote: function editNote(item) {
            dispatch((0, _NOTES_INSPECT2.default)({ item: undefined }));
            dispatch(_resource.notesEditor.actions.UPDATE({ item: item }));
        } };},
function (_ref2) {var inspectItem = _ref2.inspectItem,editNote = _ref2.editNote,flyoverVisible = _ref2.flyoverVisible,cancelInspect = _ref2.cancelInspect;
    var visible = !flyoverVisible && !!inspectItem && !inspectItem.isQuestion;
    var isShared = (0, _types.isSharedNote)(inspectItem);
    return _react.React.createElement("div", { className: (0, _style2.default)('bottom-panel', !visible ? 'wcag-invisible' : ''), "aria-hidden": !visible, "aria-labelledby": "Sluit het inzien scherm" },
    _react.React.createElement("div", { className: (0, _style2.default)('buttons-container', !visible ? 'wcag-invisible' : '') },
    isShared ? null :
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Bewerken', "aria-haspopup": false, tabIndex: 0, disabled: false, onKeyDown: function onKeyDown(evt) {handleEnters(evt, function () {return editNote(inspectItem);});}, onClick: function onClick() {return editNote(inspectItem);} },
    _react.React.createElement("span", null, "Bewerken")),
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', "aria-label": 'Sluiten', "aria-haspopup": false, tabIndex: 0, onKeyDown: function onKeyDown(evt) {
            handleEnters(evt, function () {cancelInspect();});
        }, onClick: function onClick() {cancelInspect();} },
    _react.React.createElement("span", null, "Sluiten"))));
});
function handleEnters(evt, funct) {
    if (evt.key === 'Enter') {
        evt.preventDefault();
        funct();
    }
}

/***/ }),

/***/ 1330:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.NotesBatchDeleteAreaSave = exports.NotesBatchDeleteArea = undefined;__webpack_require__(76);
var _react = __webpack_require__(648);
var _resource = __webpack_require__(106);
var _style = __webpack_require__(650);var _style2 = _interopRequireDefault(_style);
var _button = __webpack_require__(973);
var _modal = __webpack_require__(979);
var _focuslockext = __webpack_require__(978);var _focuslockext2 = _interopRequireDefault(_focuslockext);
var _NOTES_DELETE_BATCH = __webpack_require__(556);var _NOTES_DELETE_BATCH2 = _interopRequireDefault(_NOTES_DELETE_BATCH);
var _NOTES_DELETE_BATCH_CANCEL = __webpack_require__(715);var _NOTES_DELETE_BATCH_CANCEL2 = _interopRequireDefault(_NOTES_DELETE_BATCH_CANCEL);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
(0, _react.PureConnect)('NotesBatchDeleteModal')(function (state) {return {
        deleting: !!state.notesReducer.batchdelete };},
function (dispatch) {return {
        onCancel: function onCancel() {dispatch((0, _NOTES_DELETE_BATCH_CANCEL2.default)({ items: undefined, batchdelete: false }));} };},
function (_ref) {var deleting = _ref.deleting,onCancel = _ref.onCancel;
    return _react.React.createElement(_modal.Modal, { onEscKeyDown: onCancel, visible: deleting, type: "smallsize1", backdrop: true },
    _react.React.createElement("div", { className: (0, _style2.default)(!deleting ? 'wcag-invisible' : '', 'fields-container'), "aria-hidden": !deleting, "aria-labelledby": "Verwijder notitie" },
    _react.React.createElement(_focuslockext2.default, { disabled: !deleting },
    _react.React.createElement(NotesBatchDeleteArea, null),
    _react.React.createElement(NotesBatchDeleteAreaSave, null))));
});
var NotesBatchDeleteArea = exports.NotesBatchDeleteArea = (0, _react.PureConnect)('NotesBatchDeleteArea')(function (state) {return {
        deleting: !!state.notesReducer.batchdelete,
        items: state.notesReducer.items };},
function (dispatch) {return {};}, function (_ref2) {var deleting = _ref2.deleting,items = _ref2.items;
    return _react.React.createElement("div", { className: (0, _style2.default)(!deleting ? 'wcag-invisible' : '', 'warning'), "aria-hidden": !deleting, "aria-labelledby": "Verwijder notitie" },
    _react.React.createElement("div", { className: (0, _style2.default)('warning-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('warning-title') }, "Notitie verwijderen"),
    _react.React.createElement("div", { className: (0, _style2.default)('warning-content') },
    _react.React.createElement("p", null,
    "U staat op het punt ",
    _react.React.createElement("span", { className: (0, _style2.default)('name-label') },
    items.length,
    " notities"),
    " te verwijderen. Als deze notities zijn gedeeld met personen en/of groepen zullen deze ook verdwijnen uit hun archief."),
    _react.React.createElement("p", { className: (0, _style2.default)('medium') }, "Deze actie kunt u niet ongedaan maken."))));
});
var NotesBatchDeleteAreaSave = exports.NotesBatchDeleteAreaSave = (0, _react.PureConnect)('NotesBatchDeleteAreaSave')(function (state) {return {
        deleting: !!state.notesReducer.batchdelete,
        items: state.notesReducer.items,
        origin: state.notemenu.origin };},
function (dispatch) {return {
        onCancel: function onCancel() {dispatch((0, _NOTES_DELETE_BATCH_CANCEL2.default)({ items: undefined, batchdelete: false }));},
        onSave: function onSave(items) {return dispatch((0, _NOTES_DELETE_BATCH2.default)({ items: items }));},
        onDelete: function onDelete(item) {return dispatch(_resource.notesEditor.actions.DELETE_CONTINUE({ item: item }));} };},
function (_ref3) {var deleting = _ref3.deleting,items = _ref3.items,onCancel = _ref3.onCancel,onSave = _ref3.onSave;
    return _react.React.createElement("div", { className: (0, _style2.default)(!deleting ? 'wcag-invisible' : '', 'fields-container'), "aria-hidden": !deleting, "aria-labelledby": "Verwijder notitie" },
    _react.React.createElement("div", { className: (0, _style2.default)('bottom-buttons-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('buttons-container', !deleting ? 'wcag-invisible' : '') },
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Annuleren', "aria-haspopup": false, tabIndex: 0, onKeyDown: function onKeyDown(evt) {return onCancel();}, onClick: function onClick(evt) {return onCancel();} },
    _react.React.createElement("span", null, "Annuleren")),
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', "aria-label": 'Verwijderen', "aria-haspopup": false, tabIndex: 0, disabled: false, onKeyDown: function onKeyDown(evt) {return onSave(items);}, onClick: function onClick(evt) {return onSave(items);} },
    _react.React.createElement("span", null, "Verwijderen")))));
});

/***/ }),

/***/ 1331:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });__webpack_require__(76);
var _react = __webpack_require__(648);
var _resource = __webpack_require__(106);
var _index = __webpack_require__(979);
var _UPDATE_BUTTON_NO = __webpack_require__(519);var _UPDATE_BUTTON_NO2 = _interopRequireDefault(_UPDATE_BUTTON_NO);
var _style = __webpack_require__(650);var _style2 = _interopRequireDefault(_style);
var _noteDeleteArea = __webpack_require__(1143);var _noteDeleteArea2 = _interopRequireDefault(_noteDeleteArea);

var _NOTE_DELETE_WITH_CHAT = __webpack_require__(668);var _NOTE_DELETE_WITH_CHAT2 = _interopRequireDefault(_NOTE_DELETE_WITH_CHAT);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
(0, _react.PureConnect)('NotesDeleteModal')(function (state) {return {
        deleting: _resource.notesEditor.selectors.deleting(state),
        item: _resource.notesEditor.selectors.item(state),
        origin: state.notemenu.origin,
        flyoverVisible: state.flyover.visible };},
function (dispatch) {return {
        cancelDelete: function cancelDelete() {return dispatch(_resource.notesEditor.actions.DELETE_CANCEL({}));},
        saveDelete: function saveDelete(item) {return dispatch((0, _NOTE_DELETE_WITH_CHAT2.default)({ item: item }));},
        setFocus: function setFocus(buttonNr, origin) {
            dispatch((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: buttonNr,
                origin: origin,
                buttonAction: _UPDATE_BUTTON_NO.itemButtonTypeActionDeleteItem }));
        } };},
function (_ref) {var deleting = _ref.deleting,flyoverVisible = _ref.flyoverVisible,item = _ref.item,cancelDelete = _ref.cancelDelete,saveDelete = _ref.saveDelete,setFocus = _ref.setFocus,origin = _ref.origin;
    return _react.React.createElement(_index.Modal, { onEscKeyDown: cancelDelete, visible: !flyoverVisible && deleting, type: "smallsize1", backdrop: true }, !flyoverVisible && deleting ?
    _react.React.createElement("div", { className: (0, _style2.default)(!deleting ? 'wcag-invisible' : '', 'fields-container'), "aria-hidden": !deleting, "aria-labelledby": "Verwijder notitie" },
    _react.React.createElement(_noteDeleteArea2.default, null),
    _react.React.createElement(_noteDeleteArea.NoteDeleteAreaSave, null)) : null);
});

/***/ }),

/***/ 1332:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.BookmarksDeleteAreaSave = exports.BookmarksDeleteArea = undefined;__webpack_require__(76);
var _react = __webpack_require__(648);
var _modal = __webpack_require__(979);
var _focuslockext = __webpack_require__(978);var _focuslockext2 = _interopRequireDefault(_focuslockext);
var _resource = __webpack_require__(163);
var _style = __webpack_require__(1183);var _style2 = _interopRequireDefault(_style);
var _button = __webpack_require__(973);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
(0, _react.PureConnect)('BookmarksBatchDeleteModal')(function (state) {return {
        deleting: _resource.bookmarksBatch.selectors.deleting(state),
        items: _resource.bookmarksBatch.selectors.sourceItems(state) };},
function (dispatch) {return {
        onCancel: function onCancel() {return dispatch(_resource.bookmarksBatch.actions.DELETE_CANCEL({}));},
        onSave: function onSave(items) {return dispatch(_resource.bookmarksBatch.actions.DELETE_CONTINUE({ items: items }));} };},
function (_ref) {var deleting = _ref.deleting,items = _ref.items,onCancel = _ref.onCancel,onSave = _ref.onSave;
    return _react.React.createElement(_modal.Modal, { onEscKeyDown: onCancel, visible: deleting, type: "smallsize1", backdrop: true },
    _react.React.createElement("div", { className: (0, _style2.default)(!deleting ? 'wcag-invisible' : '', 'fields-container'), "aria-hidden": !deleting, "aria-labelledby": "Verwijder favorieten" },
    _react.React.createElement(_focuslockext2.default, { disabled: !deleting },
    _react.React.createElement(BookmarksDeleteArea, null),
    _react.React.createElement(BookmarksDeleteAreaSave, null))));
});
var BookmarksDeleteArea = exports.BookmarksDeleteArea = (0, _react.PureConnect)('BookmarksDeleteArea')(function (state) {return {
        deleting: _resource.bookmarksBatch.selectors.deleting(state),
        items: _resource.bookmarksBatch.selectors.sourceItems(state) };},
function (dispatch) {return {};}, function (_ref2) {var deleting = _ref2.deleting,items = _ref2.items;
    return _react.React.createElement("div", { className: (0, _style2.default)(!deleting ? 'wcag-invisible' : '', 'warning'), "aria-hidden": !deleting, "aria-labelledby": "Verwijder notitie" },
    _react.React.createElement("div", { className: (0, _style2.default)('warning-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('warning-title') }, "Favorieten verwijderen"),
    _react.React.createElement("div", { className: (0, _style2.default)('warning-content') },
    _react.React.createElement("p", null,
    "U staat op het punt ",
    _react.React.createElement("span", { className: (0, _style2.default)('name-label') },
    items.length,
    " favorieten"),
    " te verwijderen."),
    _react.React.createElement("p", { className: (0, _style2.default)('medium') }, "Deze actie kunt u niet ongedaan maken."))));
});
var BookmarksDeleteAreaSave = exports.BookmarksDeleteAreaSave = (0, _react.PureConnect)('BookmarksDeleteAreaSave')(function (state) {return {
        deleting: _resource.bookmarksBatch.selectors.deleting(state),
        items: _resource.bookmarksBatch.selectors.sourceItems(state),
        origin: state.notemenu.origin };},
function (dispatch) {return {
        onCancel: function onCancel() {return dispatch(_resource.bookmarksBatch.actions.DELETE_CANCEL({}));},
        onSave: function onSave(items) {return dispatch(_resource.bookmarksBatch.actions.DELETE_CONTINUE({ items: items }));} };},
function (_ref3) {var deleting = _ref3.deleting,items = _ref3.items,onCancel = _ref3.onCancel,onSave = _ref3.onSave;
    return _react.React.createElement("div", { className: (0, _style2.default)(!deleting ? 'wcag-invisible' : '', 'fields-container'), "aria-hidden": !deleting, "aria-labelledby": "Verwijder notitie" },
    _react.React.createElement("div", { className: (0, _style2.default)('buttons-container', !deleting ? 'wcag-invisible' : '') },
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Annuleren', "aria-haspopup": false, tabIndex: 0, onKeyDown: function onKeyDown(evt) {return onCancel();}, onClick: function onClick(evt) {return onCancel();} },
    _react.React.createElement("span", null, "Annuleren")),
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', "aria-label": 'Verwijderen', "aria-haspopup": false, tabIndex: 0, disabled: false, onKeyDown: function onKeyDown(evt) {onSave(items);}, onClick: function onClick() {onSave(items);} },
    _react.React.createElement("span", null, "Verwijderen"))));
});

/***/ }),

/***/ 1333:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(1334);

if (typeof content === 'string') {
  content = [[module.i, content, '']];
}

var options = {"attributes":{}}

options.insert = "head";
options.singleton = false;

var update = __webpack_require__(491)(content, options);

if (content.locals) {
  module.exports = content.locals;
}


/***/ }),

/***/ 1334:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(undefined);
// imports


// module
exports.push([module.i, "._1N9l8WX7{background-color:#f0f0f0}._2hdNxdT2{font-weight:600;display:inline-block}._2IG5m4Nm{margin:40px}._3izPjtMr{display:block;float:right}._3izPjtMr button{font-size:14px}._18BHh1d8{visibility:hidden}._1GfeTIE2{z-index:1001;position:absolute;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";opacity:1;bottom:calc(50% - 100px);left:calc(50% - 100px);background-color:#e0e0e0;padding:10px;border:1px solid #000}._20pYVPXC{display:block;position:relative;padding:16px;color:#414141;font-weight:400;white-space:normal}._20pYVPXC ._3ELFm5fj{display:block;font-size:18px;letter-spacing:.54px;line-height:18px;font-weight:700;margin-bottom:8px}._20pYVPXC .K77Vj6Ou p{font-size:14px;line-height:19.6px;letter-spacing:0;margin-bottom:10px;color:#414141}._20pYVPXC .K77Vj6Ou p.EVitaOFF{font-weight:500}", ""]);

// exports
exports.locals = {
	"submit-btn": "_1N9l8WX7",
	"name-label": "_2hdNxdT2",
	"fields-container": "_2IG5m4Nm",
	"button-aria": "_3izPjtMr",
	"wcag-invisible": "_18BHh1d8",
	"bookmarks-batch-edit-modal": "_1GfeTIE2",
	"warning-container": "_20pYVPXC",
	"warning-title": "_3ELFm5fj",
	"warning-content": "K77Vj6Ou",
	"medium": "EVitaOFF"
};

/***/ }),

/***/ 1335:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });__webpack_require__(76);
var _react = __webpack_require__(648);
var _Button = __webpack_require__(1062);var _Button2 = _interopRequireDefault(_Button);
var _input = __webpack_require__(990);var _input2 = _interopRequireDefault(_input);
var _input3 = __webpack_require__(1019);var _input4 = _interopRequireDefault(_input3);
var _resource = __webpack_require__(163);
var _index = __webpack_require__(979);
var _reactFocusLock = __webpack_require__(991);var _reactFocusLock2 = _interopRequireDefault(_reactFocusLock);
var _style = __webpack_require__(1183);var _style2 = _interopRequireDefault(_style);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var maxBookmarkNameLength = 500;exports.default =
(0, _react.PureConnect)('BookmarksEditModal')(function (state) {return {
        creating: _resource.bookmarksEditor.selectors.creating(state),
        item: _resource.bookmarksEditor.selectors.item(state),
        updating: _resource.bookmarksEditor.selectors.updating(state) };},
function (dispatch) {return {
        cancel: function cancel() {return dispatch(_resource.bookmarksEditor.actions.RESET({}));},
        cancelCreating: function cancelCreating() {return dispatch(_resource.bookmarksEditor.actions.CREATE_CANCEL({}));},
        cancelUpdating: function cancelUpdating() {return dispatch(_resource.bookmarksEditor.actions.UPDATE_CANCEL({}));},
        change: function change(item) {return dispatch(_resource.bookmarksEditor.actions.APPLY({ item: item }));},
        saveCreating: function saveCreating(item) {return dispatch(_resource.bookmarksEditor.actions.CREATE_CONTINUE({ item: item }));},
        saveUpdating: function saveUpdating(item) {return dispatch(_resource.bookmarksEditor.actions.UPDATE_CONTINUE({ item: item }));} };},
function (_ref) {var creating = _ref.creating,updating = _ref.updating,item = _ref.item,change = _ref.change,saveCreating = _ref.saveCreating,cancelCreating = _ref.cancelCreating,saveUpdating = _ref.saveUpdating,cancelUpdating = _ref.cancelUpdating;
    var onCancel = creating ? cancelCreating : cancelUpdating;
    var onSave = creating ? function () {return saveCreating(item);} : function () {return saveUpdating(item);};
    return _react.React.createElement(_index.Modal, { onEscKeyDown: onCancel, visible: creating || updating, type: "center2nd", backdrop: true, header: _react.React.createElement("div", { className: (0, _style2.default)('title') }, updating ? 'Favoriet bewerken' : 'Favoriet toevoegen') },
    _react.React.createElement("div", { className: (0, _style2.default)(!(creating || updating) ? 'wcag-invisible' : '', 'fields-container'), "aria-hidden": !(creating || updating), "aria-labelledby": updating ? 'Bewerk favoriet' : 'Voeg favoriet toe' },
    _react.React.createElement(_reactFocusLock2.default, { disabled: !(creating || updating) },
    _react.React.createElement(_input2.default, { type: "text", label: "Typ hier uw notitie", name: "name", value: item.name, maxLength: maxBookmarkNameLength, multiline: true, onChange: function onChange(value) {return change({ name: value });}, floating: true }),
    _react.React.createElement(_input4.default, { categoryId: item.categoryId, onChange: function onChange(c) {change({ categoryId: c ? c.id : undefined });}, onAbort: function onAbort() {}, mode: "edit", label: "Categorie" }),
    _react.React.createElement("div", { className: (0, _style2.default)('button-aria', !(creating || updating) ? 'wcag-invisible' : '') },
    _react.React.createElement(_Button2.default, { onClick: onCancel }, "Annuleren"),
    _react.React.createElement(_Button2.default, { onClick: onSave }, "Opslaan")))));
});

/***/ }),

/***/ 1336:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.CategoriesBatchDeleteButtons = exports.CategoriesBatchDeleteArea = undefined;__webpack_require__(76);
var _react = __webpack_require__(648);
var _resource = __webpack_require__(162);
var _style = __webpack_require__(1020);var _style2 = _interopRequireDefault(_style);
var _button = __webpack_require__(973);
var _modal = __webpack_require__(979);
var _focuslockext = __webpack_require__(978);var _focuslockext2 = _interopRequireDefault(_focuslockext);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
(0, _react.PureConnect)('CategoriesBatchDeleteModal')(function (state) {return {
        deleting: _resource.categoriesBatch.selectors.deleting(state),
        items: _resource.categoriesBatch.selectors.sourceItems(state) };},
function (dispatch) {return {
        onCancel: function onCancel() {return dispatch(_resource.categoriesBatch.actions.DELETE_CANCEL({}));},
        onSave: function onSave(items) {return dispatch(_resource.categoriesBatch.actions.DELETE_CONTINUE({ items: items }));} };},
function (_ref) {var deleting = _ref.deleting,items = _ref.items,onCancel = _ref.onCancel,onSave = _ref.onSave;
    return _react.React.createElement(_modal.Modal, { onEscKeyDown: onCancel, visible: deleting, type: "smallsize1", backdrop: true },
    _react.React.createElement("div", { className: (0, _style2.default)(!deleting ? 'wcag-invisible' : '', 'fields-container'), "aria-hidden": !deleting, "aria-labelledby": 'Verwijder categorie\xEBn' },
    _react.React.createElement(_focuslockext2.default, { disabled: !deleting },
    _react.React.createElement(CategoriesBatchDeleteArea, null),
    _react.React.createElement(CategoriesBatchDeleteButtons, null))));
});
var CategoriesBatchDeleteArea = exports.CategoriesBatchDeleteArea = (0, _react.PureConnect)('CategoriesBatchDeleteArea')(function (state) {return {
        deleting: _resource.categoriesBatch.selectors.deleting(state),
        items: _resource.categoriesBatch.selectors.sourceItems(state) };},
function (dispatch) {return {};}, function (_ref2) {var deleting = _ref2.deleting,items = _ref2.items;
    return _react.React.createElement("div", { className: (0, _style2.default)(!deleting ? 'wcag-invisible' : '', 'warning'), "aria-hidden": !deleting, "aria-labelledby": 'Verwijder categorie\xEBn' },
    _react.React.createElement("div", { className: (0, _style2.default)('warning-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('warning-title') }, 'Categorie\xEBn verwijderen'),
    _react.React.createElement("div", { className: (0, _style2.default)('warning-content') },
    _react.React.createElement("p", null,
    "U staat op het punt ",
    _react.React.createElement("span", { className: (0, _style2.default)('name-label') },
    items.length,
    " categorie",
    items.length > 1 ? 'ën' : ''),
    " te verwijderen."),
    _react.React.createElement("p", { className: (0, _style2.default)('medium') }, "Deze actie kunt u niet ongedaan maken."))));
});
var CategoriesBatchDeleteButtons = exports.CategoriesBatchDeleteButtons = (0, _react.PureConnect)('CategoriesBatchDeleteButtons')(function (state) {return {
        deleting: _resource.categoriesBatch.selectors.deleting(state),
        items: _resource.categoriesBatch.selectors.sourceItems(state) };},
function (dispatch) {return {
        onCancel: function onCancel() {return dispatch(_resource.categoriesBatch.actions.DELETE_CANCEL({}));},
        onSave: function onSave(items) {return dispatch(_resource.categoriesBatch.actions.DELETE_CONTINUE({ items: items }));} };},
function (_ref3) {var deleting = _ref3.deleting,items = _ref3.items,onCancel = _ref3.onCancel,onSave = _ref3.onSave;
    return _react.React.createElement("div", { className: (0, _style2.default)('bottom-panel', 'not-absolutely', !deleting ? 'wcag-invisible' : '', 'fields-container'), "aria-hidden": !deleting, "aria-labelledby": "Verwijder notitie" },
    _react.React.createElement("div", { className: (0, _style2.default)('bottom-buttons-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('buttons-container', !deleting ? 'wcag-invisible' : '') },
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Annuleren van het verwijderen', "aria-haspopup": false, tabIndex: 0, onKeyDown: function onKeyDown(evt) {return onCancel();}, onClick: function onClick(evt) {return onCancel();} },
    _react.React.createElement("span", null, "Annuleren")),
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', "aria-label": 'Verwijderen van categorieën', "aria-haspopup": false, tabIndex: 0, disabled: false, onKeyDown: function onKeyDown(evt) {return onSave(items);}, onClick: function onClick(evt) {return onSave(items);} },
    _react.React.createElement("span", null, "Verwijderen")))));
});

/***/ }),

/***/ 1337:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.CategorieDeleteButtons = exports.CategorieDeleteArea = undefined;__webpack_require__(76);
var _react = __webpack_require__(648);
var _resource = __webpack_require__(162);
var _style = __webpack_require__(1020);var _style2 = _interopRequireDefault(_style);
var _modal = __webpack_require__(979);
var _focuslockext = __webpack_require__(978);var _focuslockext2 = _interopRequireDefault(_focuslockext);
var _button = __webpack_require__(973);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var defaultLimitTextLength = 40;
var limitText = function limitText(text) {
    if (text) {
        text = text.replace(/[\s\t\r\n]+/g, ' ');
        if (text.length > defaultLimitTextLength) {
            text = text.substring(0, defaultLimitTextLength) + '...';
        }
    }
    return text;
};exports.default =
(0, _react.PureConnect)('CategoryDeleteModal')(function (state) {return {
        deleting: _resource.categoriesEditor.selectors.deleting(state),
        item: _resource.categoriesEditor.selectors.item(state) };},
function (dispatch) {return {
        cancelDelete: function cancelDelete() {return dispatch(_resource.categoriesEditor.actions.DELETE_CANCEL({}));},
        saveDelete: function saveDelete(item) {return dispatch(_resource.categoriesEditor.actions.DELETE_CONTINUE({ item: item }));} };},
function (_ref) {var deleting = _ref.deleting,item = _ref.item,cancelDelete = _ref.cancelDelete,saveDelete = _ref.saveDelete;
    return _react.React.createElement(_modal.Modal, { onEscKeyDown: cancelDelete, visible: deleting, type: "smallsize1", backdrop: true },
    _react.React.createElement("div", { className: (0, _style2.default)(!deleting ? 'wcag-invisible' : '', 'fields-container'), "aria-hidden": !deleting, "aria-labelledby": "Verwijder categorie" },
    _react.React.createElement(_focuslockext2.default, { disabled: !deleting },
    _react.React.createElement(CategorieDeleteArea, null),
    _react.React.createElement(CategorieDeleteButtons, null))));
});
var CategorieDeleteArea = exports.CategorieDeleteArea = (0, _react.PureConnect)('CategorieDeleteArea')(function (state) {return {
        deleting: _resource.categoriesEditor.selectors.deleting(state),
        item: _resource.categoriesEditor.selectors.item(state) };},
function (dispatch) {return {};}, function (_ref2) {var deleting = _ref2.deleting,item = _ref2.item;
    return _react.React.createElement("div", { className: (0, _style2.default)(!deleting ? 'wcag-invisible' : '', 'warning'), "aria-hidden": !deleting, "aria-labelledby": 'Verwijder categorie\xEBn' },
    _react.React.createElement("div", { className: (0, _style2.default)('warning-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('warning-title') }, "Categorie verwijderen"),
    _react.React.createElement("div", { className: (0, _style2.default)('warning-content') },
    _react.React.createElement("p", null,
    "U staat op het punt categorie ",
    _react.React.createElement("span", { className: (0, _style2.default)('name-label') }, limitText(item.name)),
    " te verwijderen."),
    _react.React.createElement("p", { className: (0, _style2.default)('medium') }, "Deze actie kunt u niet ongedaan maken."))));
});
var CategorieDeleteButtons = exports.CategorieDeleteButtons = (0, _react.PureConnect)('CategorieDeleteButtons')(function (state) {return {
        deleting: _resource.categoriesEditor.selectors.deleting(state),
        item: _resource.categoriesEditor.selectors.item(state) };},
function (dispatch) {return {
        cancelDelete: function cancelDelete() {return dispatch(_resource.categoriesEditor.actions.DELETE_CANCEL({}));},
        saveDelete: function saveDelete(item) {return dispatch(_resource.categoriesEditor.actions.DELETE_CONTINUE({ item: item }));} };},
function (_ref3) {var deleting = _ref3.deleting,item = _ref3.item,cancelDelete = _ref3.cancelDelete,saveDelete = _ref3.saveDelete;
    return _react.React.createElement("div", { className: (0, _style2.default)('bottom-panel', 'not-absolute', !deleting ? 'wcag-invisible' : '', 'fields-container'), "aria-hidden": !deleting, "aria-labelledby": "Verwijder categorie" },
    _react.React.createElement("div", { className: (0, _style2.default)('bottom-buttons-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('buttons-container', !deleting ? 'wcag-invisible' : '') },
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Annuleren van het verwijderen', "aria-haspopup": false, tabIndex: 0, onKeyDown: function onKeyDown(evt) {return cancelDelete();}, onClick: function onClick(evt) {return cancelDelete();} },
    _react.React.createElement("span", null, "Annuleren")),
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', "aria-label": 'Verwijderen van categorie', "aria-haspopup": false, tabIndex: 0, disabled: false, onKeyDown: function onKeyDown(evt) {return saveDelete(item);}, onClick: function onClick(evt) {return saveDelete(item);} },
    _react.React.createElement("span", null, "Verwijderen")))));
});

/***/ }),

/***/ 1338:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });__webpack_require__(76);
var _reselect = __webpack_require__(221);
var _react = __webpack_require__(648);
var _resource = __webpack_require__(162);
var _style = __webpack_require__(1020);var _style2 = _interopRequireDefault(_style);
var _selectors = __webpack_require__(975);var _selectors2 = _interopRequireDefault(_selectors);
var _modal = __webpack_require__(979);
var _focuslockext = __webpack_require__(978);var _focuslockext2 = _interopRequireDefault(_focuslockext);
var _categoryEditArea = __webpack_require__(1064);var _categoryEditArea2 = _interopRequireDefault(_categoryEditArea);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var isValidSelector = (0, _reselect.createSelector)(_resource.categoriesEditor.selectors.item, function (item) {return item.name && item.color;});exports.default =
(0, _react.PureConnect)('CategoryEditModal')(function (state) {return {
        creating: _resource.categoriesEditor.selectors.creating(state),
        isValid: isValidSelector(state),
        item: _resource.categoriesEditor.selectors.item(state),
        updating: _resource.categoriesEditor.selectors.updating(state),
        origin: state.notemenu.origin,
        screenSmall: _selectors2.default.small(state),
        flyoverVisible: state.flyover.visible };},
function (dispatch) {return {
        cancelCreating: function cancelCreating() {return dispatch(_resource.categoriesEditor.actions.CREATE_CANCEL({}));},
        cancelUpdating: function cancelUpdating() {return dispatch(_resource.categoriesEditor.actions.UPDATE_CANCEL({}));} };},
function (_ref) {var creating = _ref.creating,updating = _ref.updating,flyoverVisible = _ref.flyoverVisible,screenSmall = _ref.screenSmall,cancelCreating = _ref.cancelCreating,cancelUpdating = _ref.cancelUpdating;
    var onCancel = creating ? cancelCreating : cancelUpdating;
    return _react.React.createElement(_modal.Modal, { onEscKeyDown: function onEscKeyDown() {return onCancel();}, visible: !flyoverVisible && (creating || updating), type: screenSmall ? 'smallscreen' : 'center2nd', backdrop: true, header: _react.React.createElement("div", { className: (0, _style2.default)('app') }) },
    _react.React.createElement("div", { className: (0, _style2.default)(!(creating || updating) ? 'wcag-invisible' : '', 'fields-container'), "aria-hidden": !(creating || updating), "aria-labelledby": "Wijzig een categorie" },
    _react.React.createElement(_focuslockext2.default, { disabled: !(creating || updating) },
    _react.React.createElement("div", { className: (0, _style2.default)('note-details', !flyoverVisible && (creating || updating) ? '' : 'wcag-invisible') },
    _react.React.createElement(_categoryEditArea2.default, null),
    _react.React.createElement(_categoryEditArea.CategoriesEditAreaButtons, null)))));
});

/***/ }),

/***/ 1339:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.UsergroupEditModalButtons = undefined;__webpack_require__(76);
var _react = __webpack_require__(648);
var _index = __webpack_require__(979);
var _input = __webpack_require__(990);var _input2 = _interopRequireDefault(_input);
var _input3 = __webpack_require__(1017);
var _resource = __webpack_require__(233);
var _style = __webpack_require__(1059);var _style2 = _interopRequireDefault(_style);
var _selectors = __webpack_require__(977);var _selectors2 = _interopRequireDefault(_selectors);
var _resource2 = __webpack_require__(246);
var _UPDATE_BUTTON_NO = __webpack_require__(519);var _UPDATE_BUTTON_NO2 = _interopRequireDefault(_UPDATE_BUTTON_NO);

var _SHOW = __webpack_require__(655);var _SHOW2 = _interopRequireDefault(_SHOW);
var _focuslockext = __webpack_require__(978);var _focuslockext2 = _interopRequireDefault(_focuslockext);
var _selectors3 = __webpack_require__(975);var _selectors4 = _interopRequireDefault(_selectors3);
var _selectors5 = __webpack_require__(649);var _selectors6 = _interopRequireDefault(_selectors5);
var _button = __webpack_require__(973);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var maxNameLength = 200;exports.default =
(0, _react.PureConnect)('UsergroupEditModal')(function (state) {return {
        creating: _resource.usergroupEditor.selectors.creating(state),
        item: _resource.usergroupEditor.selectors.item(state),
        updating: _resource.usergroupEditor.selectors.updating(state),
        origin: state.notemenu.origin,
        participantPopupVisible: _selectors2.default.visible(state),
        screenSmall: _selectors4.default.small(state),
        accountmng: _selectors6.default.accountmanager(state) };},
function (dispatch) {return {
        cancel: function cancel() {return dispatch(_resource.usergroupEditor.actions.RESET({}));},
        cancelCreating: function cancelCreating() {
            dispatch(_resource.usergroupEditor.actions.CREATE_CANCEL({}));
        },
        cancelUpdating: function cancelUpdating() {
            dispatch(_resource.usergroupEditor.actions.UPDATE_CANCEL({}));
        },
        change: function change(item) {dispatch(_resource.usergroupEditor.actions.APPLY({ item: item }));},
        saveCreating: function saveCreating(item) {
            dispatch(_resource.usergroupEditor.actions.CREATE_CONTINUE({ item: item }));
        },
        saveUpdating: function saveUpdating(item) {
            dispatch(_resource.usergroupEditor.actions.UPDATE_CONTINUE({ item: item }));
        },
        showParticipantPopUp: function showParticipantPopUp() {dispatch((0, _SHOW2.default)({ itemno: -1 }));},
        updateButtonFocus: function updateButtonFocus(buttonNr, origin, itm) {
            dispatch((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: buttonNr, origin: origin, buttonAction: undefined, lasttoucheditem: itm }));
        },
        deleteUsergroup: function deleteUsergroup(item) {return dispatch(_resource.usergroupEditor.actions.DELETE({ item: item }));} };},
function (_ref) {var creating = _ref.creating,updating = _ref.updating,item = _ref.item,origin = _ref.origin,screenSmall = _ref.screenSmall,accountmng = _ref.accountmng,updateButtonFocus = _ref.updateButtonFocus,deleteUsergroup = _ref.deleteUsergroup,change = _ref.change,saveCreating = _ref.saveCreating,cancelCreating = _ref.cancelCreating,saveUpdating = _ref.saveUpdating,cancelUpdating = _ref.cancelUpdating,showParticipantPopUp = _ref.showParticipantPopUp,participantPopupVisible = _ref.participantPopupVisible;
    var onSelect = function onSelect(item) {
        item.allTenantUsers = !item.allTenantUsers;
        change(item);
    };
    return _react.React.createElement(_index.Modal, { onEscKeyDown: !participantPopupVisible ?
        creating ? function () {return cancelCreating();} : function () {return cancelUpdating();} : function () {}, visible: (creating || updating) && item && !item.type, type: screenSmall ? 'smallscreen' : 'center2nd', backdrop: true, header: _react.React.createElement("div", { className: (0, _style2.default)('usergroup-title') }, updating ? 'Groep bewerken' : 'Groep toevoegen') },
    _react.React.createElement("div", { className: (0, _style2.default)(!creating && !updating ? 'wcag-invisible' : '', 'fields-container'), "aria-hidden": !(creating || updating), "aria-labelledby": "Maak een gebruikersgroep aan" },
    _react.React.createElement(_focuslockext2.default, { disabled: !(creating || updating) },
    _react.React.createElement("div", { className: (0, _style2.default)('usergroup-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('input-naam-gebruikersgroep') },
    _react.React.createElement("span", { className: (0, _style2.default)('input-label') },
    "Groep",
    _react.React.createElement("span", { className: (0, _style2.default)('star') }, "*")),
    _react.React.createElement(_input2.default, { className: (0, _style2.default)('usergroup-input'), type: "text", name: "name", value: item.name, maxLength: maxNameLength, multiline: true, onChange: function onChange(value) {return change({ name: value });}, floating: true })),
    _react.React.createElement("div", { className: (0, _style2.default)('default-checkbox-div', 'check-box-selection', !accountmng ? 'wcag-invisible' : ''), tabIndex: -1 },
    _react.React.createElement("input", { type: "checkbox", className: (0, _style2.default)('default-checkbox'), tabIndex: -1, checked: item.allTenantUsers || false, onChange: function onChange() {return onSelect(item);}, "aria-hidden": true }),
    _react.React.createElement("div", { role: "checkbox", className: (0, _style2.default)('checkmark'), "aria-checked": item.allTenantUsers ? 'true' : 'false', tabIndex: 0, onKeyPress: function onKeyPress(ev) {if (ev.key === 'Enter') {
                onSelect(item);
            }}, onClick: function onClick() {return onSelect(item);} }),
    _react.React.createElement("span", null, "Organisatiebreed toegankelijk"))),
    _react.React.createElement(_input3.ParticipantSelectionForUsergroups, { selectedparticipantsIDs: item.userIDs, selectedparticipantgroupIDs: [], participantPopupVisible: participantPopupVisible, onChange: function onChange(c) {
            change({ userIDs: c ? c : undefined });
        }, onChangeParticipantGroups: function onChangeParticipantGroups(d) {
            change({ particpantgroupIDs: d ? d : undefined });
        }, onAbort: function onAbort() {updateButtonFocus(_UPDATE_BUTTON_NO.buttonUsergroupEditenDeelnemers, origin, item);}, onSave: function onSave() {updateButtonFocus(_UPDATE_BUTTON_NO.buttonUsergroupEditenDeelnemers, origin, item);}, label: '' }),
    _react.React.createElement("div", { className: (0, _style2.default)('content-buttons-container') },
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Verwijder groep', "aria-haspopup": false, tabIndex: 0, onKeyDown: function onKeyDown(evt) {
            handleEnters(evt, function () {return deleteUsergroup(item);});
        }, onClick: function onClick() {return deleteUsergroup(item);} },
    _react.React.createElement("span", null, "VERWIJDER GROEP"))),
    _react.React.createElement(UsergroupEditModalButtons, null))));
});
var UsergroupEditModalButtons = exports.UsergroupEditModalButtons = (0, _react.PureConnect)('UsergroupEditModalButtons')(function (state) {return {
        creating: _resource.usergroupEditor.selectors.creating(state),
        item: _resource.usergroupEditor.selectors.item(state),
        updating: _resource.usergroupEditor.selectors.updating(state),
        usergroupowner: _resource2.participantsResource.selectors.items(state).qFirst(function (itm) {return itm.isUser;}),
        origin: state.notemenu.origin,
        selectNote: state.selection.creating,
        participantPopupVisible: _selectors2.default.visible(state),
        screenSmall: _selectors4.default.small(state) };},
function (dispatch) {return {
        cancel: function cancel() {return dispatch(_resource.usergroupEditor.actions.RESET({}));},
        cancelCreating: function cancelCreating() {
            dispatch(_resource.usergroupEditor.actions.CREATE_CANCEL({}));
        },
        cancelUpdating: function cancelUpdating() {
            dispatch(_resource.usergroupEditor.actions.UPDATE_CANCEL({}));
        },
        change: function change(item) {dispatch(_resource.usergroupEditor.actions.APPLY({ item: item }));},
        saveCreating: function saveCreating(item) {
            item = fixNoteDevelopmentJsonServer(item, true);
            dispatch(_resource.usergroupEditor.actions.CREATE_CONTINUE({ item: item }));
        },
        saveUpdating: function saveUpdating(item) {
            item = fixNoteDevelopmentJsonServer(item, false);
            dispatch(_resource.usergroupEditor.actions.UPDATE_CONTINUE({ item: item }));
        },
        showParticipantPopUp: function showParticipantPopUp() {dispatch((0, _SHOW2.default)({ itemno: -1 }));},
        updateButtonFocus: function updateButtonFocus(buttonNr, origin, itm) {
            dispatch((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: buttonNr, origin: origin, buttonAction: undefined, lasttoucheditem: itm }));
        } };},
function (_ref2) {var creating = _ref2.creating,updating = _ref2.updating,item = _ref2.item,saveCreating = _ref2.saveCreating,cancelCreating = _ref2.cancelCreating,saveUpdating = _ref2.saveUpdating,cancelUpdating = _ref2.cancelUpdating;
    var visible = creating || updating;
    return _react.React.createElement("div", { className: (0, _style2.default)('bottom-panel', !visible ? 'wcag-invisible' : ''), "aria-hidden": !visible, "aria-labelledby": "Maak een gebruikersgroep aan" },
    _react.React.createElement("div", { className: (0, _style2.default)('bottom-buttons') },
    _react.React.createElement("div", { className: (0, _style2.default)('buttons-container') },
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Annuleren', "aria-haspopup": false, tabIndex: 0, onKeyDown: function onKeyDown(evt) {
            handleEnters(evt, creating ?
            function () {cancelCreating();} :
            function () {cancelUpdating();});
        }, onClick: creating ?
        function () {cancelCreating();} :
        function () {cancelUpdating();} },
    _react.React.createElement("span", null, "Annuleren")),
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', "aria-label": 'Opslaan', "aria-haspopup": false, tabIndex: item.name ? 0 : -1, disabled: !item.name, onKeyDown: function onKeyDown(evt) {
            handleEnters(evt, creating ?
            function () {return saveCreating(item);} :
            function () {return saveUpdating(item);});
        }, onClick: creating ?
        function () {return saveCreating(item);} :
        function () {return saveUpdating(item);} },
    _react.React.createElement("span", null, "Opslaan")))));
});
function handleEnters(evt, funct) {
    if (evt.key === 'Enter') {
        evt.preventDefault();
        funct();
    }
}
function fixNoteDevelopmentJsonServer(item, create) {
    return item;
}

/***/ }),

/***/ 1340:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(1341);

if (typeof content === 'string') {
  content = [[module.i, content, '']];
}

var options = {"attributes":{}}

options.insert = "head";
options.singleton = false;

var update = __webpack_require__(491)(content, options);

if (content.locals) {
  module.exports = content.locals;
}


/***/ }),

/***/ 1341:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(undefined);
// imports


// module
exports.push([module.i, "._1m5sRuoc{font-weight:300;color:#404040;color:rgba(0,0,0,.75)}._1LJxgLcx{display:block;float:right;margin-top:15px}._1LJxgLcx button{font-size:14px}._15fi6AvR{margin-bottom:15px}._39xVbwee{visibility:hidden}._2vTsaErs{height:70px;max-height:70px;overflow-y:auto}._1Y3b2CQ6{height:30px;max-height:30px}._16XL89kt{display:block;background-color:#eee;margin-bottom:5px}.y2sKN6Om{margin-top:15px;margin-left:5px;display:inline-block}._1V7J0L-4{display:inline-block;line-height:15px;margin:0 20px 15px 10px;vertical-align:middle}._2wWvrlVm span{margin-left:-10px;margin-top:-20px}.lWdyZia7{margin:0 16px 12px;font-size:14px;color:#414141;letter-spacing:.42px;line-height:18px;font-weight:700}._3-Maj-ku{margin:0 16px;font-size:12px;color:#414141;font-weight:400;line-height:16px;position:relative}._3-Maj-ku ._3RWANWvd ._23suqRA8,._3-Maj-ku ._15fi6AvR ._23suqRA8{display:block;font-weight:700;margin-bottom:4px}._3-Maj-ku ._3RWANWvd ._23suqRA8 .mmyW1dmp,._3-Maj-ku ._15fi6AvR ._23suqRA8 .mmyW1dmp{margin-left:2px;font-size:15px;line-height:20px;font-weight:700;color:#f36}._3-Maj-ku ._3RWANWvd ._3j4T5cKK,._3-Maj-ku ._15fi6AvR ._3j4T5cKK{display:block;margin-bottom:20px}._3-Maj-ku ._3RWANWvd ._3j4T5cKK textarea,._3-Maj-ku ._15fi6AvR ._3j4T5cKK textarea{display:block;line-height:16.8px;padding:16px;border:2px solid #e8e8e8;border-radius:4px;margin:0;width:100%}._3-Maj-ku ._3RWANWvd ._3j4T5cKK textarea:focus-visible,._3-Maj-ku ._15fi6AvR ._3j4T5cKK textarea:focus-visible{outline-color:#4b55f6}._3-Maj-ku ._3RWANWvd ._3j4T5cKK span:last-child,._3-Maj-ku ._15fi6AvR ._3j4T5cKK span:last-child{display:block;text-align:right}._3-Maj-ku ._3Cg7gg9y{display:block;font-weight:700;margin-bottom:4px}._3-Maj-ku ._2m4xGhKi{display:block;margin-bottom:16px;font-weight:400;color:#414141;line-height:16px;font-size:12px}._3-Maj-ku ._3XhNjmz4{display:block}._3-Maj-ku ._3XhNjmz4>*{display:inline-block}._3-Maj-ku ._3XhNjmz4 ._3QI1CbR5{width:16px;height:16px;margin:0;margin-right:10px;vertical-align:middle}._2ptZT9JJ{margin:0 16px;display:block}._2ptZT9JJ button span{border:2px solid #d6705d!important;color:#d6705d!important}._2ptZT9JJ button:focus-visible{outline-color:#d6705d}._2PxGpvRG{font-style:italic;text-decoration:underline}.IF9kQwm8{position:absolute;bottom:0;width:100%;left:0;right:0;-webkit-box-shadow:0 -7px 8px rgba(0,0,0,.1);box-shadow:0 -7px 8px rgba(0,0,0,.1);padding-top:15px;background:#fff;height:67px}.IF9kQwm8.FrVOcbeZ{position:relative}._363sKowM{position:absolute;bottom:0;width:100%;left:0;right:0;-webkit-box-shadow:0 -7px 8px rgba(0,0,0,.1);box-shadow:0 -7px 8px rgba(0,0,0,.1);padding-top:15px;background:#fff;height:67px}._363sKowM.FrVOcbeZ{position:relative}._15RC907x{margin:0 16px}._15RC907x button:first-child span{border-color:transparent}._15RC907x button:first-child:hover span{border-color:#4b55f6}._15RC907x button:last-child{float:right}.vPnsXuG8{display:block;position:relative;padding:16px;color:#414141;font-weight:400;white-space:normal;border-radius:20px}.vPnsXuG8 .JG4D5Ujj{display:block;font-size:18px;letter-spacing:.54px;line-height:18px;font-weight:700;margin-bottom:8px}.vPnsXuG8 ._75VMIJl1 p{font-size:14px;line-height:19.6px;letter-spacing:0;margin-bottom:10px;color:#414141}.vPnsXuG8 ._75VMIJl1 p._2-67S4AA{font-weight:500}._2PIQ6nkf .IF9kQwm8{background:transparent;-webkit-box-shadow:none;box-shadow:none}", ""]);

// exports
exports.locals = {
	"header": "_1m5sRuoc",
	"button-aria": "_1LJxgLcx",
	"input-naam-gebruikersgroep": "_15fi6AvR",
	"wcag-invisible": "_39xVbwee",
	"participant-container-with-items-container": "_2vTsaErs",
	"participant-container-with-no-items-container": "_1Y3b2CQ6",
	"usergroupuserscontainer": "_16XL89kt",
	"usergroupusersicon": "y2sKN6Om",
	"usergroupusersname": "_1V7J0L-4",
	"participant-selector": "_2wWvrlVm",
	"usergroup-title": "lWdyZia7",
	"usergroup-container": "_3-Maj-ku",
	"input-naam-fractie": "_3RWANWvd",
	"input-label": "_23suqRA8",
	"star": "mmyW1dmp",
	"usergroup-input": "_3j4T5cKK",
	"participants-of-groep": "_3Cg7gg9y",
	"participants-list-container": "_2m4xGhKi",
	"default-checkbox-div": "_3XhNjmz4",
	"default-checkbox": "_3QI1CbR5",
	"content-buttons-container": "_2ptZT9JJ",
	"name-label": "_2PxGpvRG",
	"bottom-buttons-container": "IF9kQwm8",
	"not-absolute": "FrVOcbeZ",
	"bottom-panel": "_363sKowM",
	"buttons-container": "_15RC907x",
	"warning-container": "vPnsXuG8",
	"warning-title": "JG4D5Ujj",
	"warning-content": "_75VMIJl1",
	"medium": "_2-67S4AA",
	"warning-buttons": "_2PIQ6nkf"
};

/***/ }),

/***/ 1342:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.InspectUsergroupModalButtons = undefined;__webpack_require__(76);
var _react = __webpack_require__(648);
var _index = __webpack_require__(979);
var _input = __webpack_require__(1017);
var _resource = __webpack_require__(233);
var _style = __webpack_require__(1059);var _style2 = _interopRequireDefault(_style);
var _resource2 = __webpack_require__(246);
var _UPDATE_BUTTON_NO = __webpack_require__(519);var _UPDATE_BUTTON_NO2 = _interopRequireDefault(_UPDATE_BUTTON_NO);
var _USERGROUP_INSPECT = __webpack_require__(698);var _USERGROUP_INSPECT2 = _interopRequireDefault(_USERGROUP_INSPECT);
var _focuslockext = __webpack_require__(978);var _focuslockext2 = _interopRequireDefault(_focuslockext);
var _selectors = __webpack_require__(975);var _selectors2 = _interopRequireDefault(_selectors);
var _selectors3 = __webpack_require__(649);var _selectors4 = _interopRequireDefault(_selectors3);
var _button = __webpack_require__(973);
var _reducer = __webpack_require__(737);
var _authcheck = __webpack_require__(518);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
(0, _react.PureConnect)('InspectUsergroupModal')(function (state) {return {
        inspectItem: state.usergroup.inspect,
        origin: state.notemenu.origin,
        screenSmall: _selectors2.default.small(state),
        accountmng: _selectors4.default.accountmanager(state),
        user: _resource2.participantsResource.selectors.items(state).qFirst(function (itm) {return itm.isUser;}) };},
function (dispatch) {return {
        stopInspectingUsergroup: function stopInspectingUsergroup() {return dispatch((0, _USERGROUP_INSPECT2.default)({ usergroup: _reducer.emptyInspectUser }));},
        exitGroup: function exitGroup(item) {
            dispatch(_resource.usergroupEditor.actions.UPDATE_CONTINUE({ item: item }));
            dispatch((0, _USERGROUP_INSPECT2.default)({ usergroup: _reducer.emptyInspectUser }));
        } };},
function (_ref) {var inspectItem = _ref.inspectItem,user = _ref.user,screenSmall = _ref.screenSmall,accountmng = _ref.accountmng,stopInspectingUsergroup = _ref.stopInspectingUsergroup,exitGroup = _ref.exitGroup;
    var inspecting = !!(inspectItem && inspectItem.id);
    var item = inspectItem || _reducer.emptyInspectUser;
    return _react.React.createElement(_index.Modal, { onEscKeyDown: function onEscKeyDown() {return stopInspectingUsergroup();}, visible: inspecting, type: screenSmall ? 'smallscreen' : 'center2nd', backdrop: true, header: _react.React.createElement("div", { className: (0, _style2.default)('usergroup-title') },
        item.type === _authcheck.typeRoleAdmin ? 'Rol' :
        item.type === _authcheck.typeRoleClerk ? 'Rol' :
        item.type === _authcheck.typeRolePracticioner ? 'Rol' :
        item.type === _authcheck.typeFactions ? 'Fractie' : 'Groep',
        " raadplegen") },
    _react.React.createElement("div", { className: (0, _style2.default)(!inspecting ? 'wcag-invisible' : '', 'fields-container'), "aria-hidden": !inspecting, "aria-labelledby": "Maak een gebruikersgroep aan" },
    _react.React.createElement(_focuslockext2.default, { disabled: !inspecting },
    _react.React.createElement("div", { className: (0, _style2.default)('usergroup-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('input-naam-gebruikersgroep') },
    _react.React.createElement("span", { className: (0, _style2.default)('input-label') },
    item.type === _authcheck.typeRoleAdmin ? 'Rol' :
    item.type === _authcheck.typeRoleClerk ? 'Rol' :
    item.type === _authcheck.typeRolePracticioner ? 'Rol' :
    item.type === _authcheck.typeFactions ? 'Fractie' : 'Groep',
    _react.React.createElement("span", { className: (0, _style2.default)('star') }, "*")),
    item ? item.name : ''),
    _react.React.createElement("div", { className: (0, _style2.default)('participants-of-groep') },
    "Leden van de ",
    item.type === _authcheck.typeRoleAdmin ? 'rol' :
    item.type === _authcheck.typeRoleClerk ? 'rol' :
    item.type === _authcheck.typeRolePracticioner ? 'rol' :
    item.type === _authcheck.typeFactions ? 'Fractie' : 'groep'),
    _react.React.createElement("div", { className: (0, _style2.default)('participants-list-container') },
    _react.React.createElement(_input.ParticipantListOfUsergroups, { selectedparticipantsIDs: item.userIDs }))),
    _react.React.createElement("div", { className: (0, _style2.default)('content-buttons-container') }, item.userIDs.filter(function (itm) {return itm === (user ? user.id : '');}).length ?
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Afmelden van groep', "aria-haspopup": false, tabIndex: 0, onKeyDown: function onKeyDown(evt) {
            item.userIDs = item.userIDs.filter(function (itm) {return itm !== (user ? user.id : '');});
            handleEnters(evt, function () {return exitGroup(item);});
        }, onClick: function onClick() {
            item.userIDs = item.userIDs.filter(function (itm) {return itm !== (user ? user.id : '');});
            exitGroup(item);
        } },
    _react.React.createElement("span", null,
    "AFMELDEN VAN ",
    item.type === _authcheck.typeRoleAdmin ? 'ROL' :
    item.type === _authcheck.typeRoleClerk ? 'ROL' :
    item.type === _authcheck.typeRolePracticioner ? 'ROL' :
    item.type === _authcheck.typeFactions ? 'FRACTIE' : 'GROEP')) :
    null),
    _react.React.createElement(InspectUsergroupModalButtons, null))));
});
var InspectUsergroupModalButtons = exports.InspectUsergroupModalButtons = (0, _react.PureConnect)('InspectUsergroupModalButtons')(function (state) {return {
        inspecting: !!state.usergroup.inspect,
        usergroupowner: _resource2.participantsResource.selectors.items(state).qFirst(function (itm) {return itm.isUser;}),
        origin: state.notemenu.origin,
        screenSmall: _selectors2.default.small(state),
        accountmng: _selectors4.default.accountmanager(state) };},
function (dispatch) {return {
        cancel: function cancel() {return dispatch(_resource.usergroupEditor.actions.RESET({}));},
        updateButtonFocus: function updateButtonFocus(buttonNr, origin, itm) {
            dispatch((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: buttonNr, origin: origin, buttonAction: undefined, lasttoucheditem: itm }));
        },
        stopInspectingUsergroup: function stopInspectingUsergroup() {return dispatch((0, _USERGROUP_INSPECT2.default)({ usergroup: undefined }));} };},
function (_ref2) {var inspecting = _ref2.inspecting,stopInspectingUsergroup = _ref2.stopInspectingUsergroup;
    var visible = inspecting;
    return _react.React.createElement("div", { className: (0, _style2.default)('bottom-panel', !visible ? 'wcag-invisible' : ''), "aria-hidden": !visible, "aria-labelledby": "Maak een gebruikersgroep aan" },
    _react.React.createElement("div", { className: (0, _style2.default)('bottom-buttons') },
    _react.React.createElement("div", { className: (0, _style2.default)('buttons-container') },
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Annuleren', "aria-haspopup": false, tabIndex: 0, onKeyDown: function onKeyDown(evt) {
            handleEnters(evt, function () {return stopInspectingUsergroup();});
        }, onClick: function onClick() {return stopInspectingUsergroup();} },
    _react.React.createElement("span", null, "Annuleren")))));
});
function handleEnters(evt, funct) {
    if (evt.key === 'Enter') {
        evt.preventDefault();
        funct();
    }
}

/***/ }),

/***/ 1343:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.UsergroupDeleteButtons = exports.UsergroupDeleteArea = undefined;__webpack_require__(76);
var _react = __webpack_require__(648);
var _resource = __webpack_require__(233);
var _style = __webpack_require__(1059);var _style2 = _interopRequireDefault(_style);
var _modal = __webpack_require__(979);
var _focuslockext = __webpack_require__(978);var _focuslockext2 = _interopRequireDefault(_focuslockext);
var _button = __webpack_require__(973);
var _USERGROUP_REMOVE = __webpack_require__(562);var _USERGROUP_REMOVE2 = _interopRequireDefault(_USERGROUP_REMOVE);
var _authcheck = __webpack_require__(518);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var defaultLimitTextLength = 40;
var limitText = function limitText(text) {
    if (text) {
        text = text.replace(/[\s\t\r\n]+/g, ' ');
        if (text.length > defaultLimitTextLength) {
            text = text.substring(0, defaultLimitTextLength) + '...';
        }
    }
    return text;
};exports.default =
(0, _react.PureConnect)('UsergroupDeleteModal')(function (state) {return {
        deleting: _resource.usergroupEditor.selectors.deleting(state),
        item: _resource.usergroupEditor.selectors.item(state) };},
function (dispatch) {return {
        cancelDelete: function cancelDelete() {return dispatch(_resource.usergroupEditor.actions.DELETE_CANCEL({}));},
        saveDelete: function saveDelete(item) {return dispatch(_resource.usergroupEditor.actions.DELETE_CONTINUE({ item: item }));} };},
function (_ref) {var deleting = _ref.deleting,item = _ref.item,cancelDelete = _ref.cancelDelete,saveDelete = _ref.saveDelete;
    return _react.React.createElement(_modal.Modal, { onEscKeyDown: cancelDelete, visible: deleting, type: "smallsize1", backdrop: true },
    _react.React.createElement("div", { className: (0, _style2.default)(!deleting ? 'wcag-invisible' : '', 'fields-container'), "aria-hidden": !deleting, "aria-labelledby": "Verwijder Gebruikersgroep" },
    _react.React.createElement(_focuslockext2.default, { disabled: !deleting },
    _react.React.createElement(UsergroupDeleteArea, null),
    _react.React.createElement(UsergroupDeleteButtons, null))));
});
var UsergroupDeleteArea = exports.UsergroupDeleteArea = (0, _react.PureConnect)('UsergroupDeleteArea')(function (state) {return {
        deleting: _resource.usergroupEditor.selectors.deleting(state),
        item: _resource.usergroupEditor.selectors.item(state) };},
function (dispatch) {return {};}, function (_ref2) {var deleting = _ref2.deleting,item = _ref2.item;
    return _react.React.createElement("div", { className: (0, _style2.default)(!deleting ? 'wcag-invisible' : '', 'warning'), "aria-hidden": !deleting, "aria-labelledby": "Verwijder gebruikersgroep" },
    _react.React.createElement("div", { className: (0, _style2.default)('warning-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('warning-title') },
    item.type === _authcheck.typeRoleAdmin ? 'Rol admin' :
    item.type === _authcheck.typeRoleClerk ? 'Rol griffier' :
    item.type === _authcheck.typeRolePracticioner ? 'Rol behandelaar' :
    item.type === _authcheck.typeFactions ? 'Fractie' : 'Gebruikersgroep',
    " verwijderen"),
    _react.React.createElement("div", { className: (0, _style2.default)('warning-content') },
    _react.React.createElement("p", null,
    "U staat op het punt ",
    item.type === _authcheck.typeRoleAdmin ? 'Rol admin' :
    item.type === _authcheck.typeRoleClerk ? 'Rol griffier' :
    item.type === _authcheck.typeRolePracticioner ? 'Rol behandelaar' :
    item.type === _authcheck.typeFactions ? 'Fractie' : 'Gebruikersgroep',
    " ",
    _react.React.createElement("span", { className: (0, _style2.default)('name-label') }, limitText(item.name)),
    " te verwijderen."),
    _react.React.createElement("p", { className: (0, _style2.default)('medium') }, "Deze actie kunt u niet ongedaan maken."))));
});
var UsergroupDeleteButtons = exports.UsergroupDeleteButtons = (0, _react.PureConnect)('UsergroupDeleteButtons')(function (state) {return {
        deleting: _resource.usergroupEditor.selectors.deleting(state),
        item: _resource.usergroupEditor.selectors.item(state) };},
function (dispatch) {return {
        cancelDelete: function cancelDelete() {return dispatch(_resource.usergroupEditor.actions.DELETE_CANCEL({}));},
        saveDelete: function saveDelete(item) {return dispatch((0, _USERGROUP_REMOVE2.default)({ usergroup: item }));} };},
function (_ref3) {var deleting = _ref3.deleting,item = _ref3.item,cancelDelete = _ref3.cancelDelete,saveDelete = _ref3.saveDelete;
    return _react.React.createElement("div", { className: (0, _style2.default)(!deleting ? 'wcag-invisible' : 'warning-buttons', 'fields-container'), "aria-hidden": !deleting, "aria-labelledby": "Verwijder notitie" },
    _react.React.createElement("div", { className: (0, _style2.default)('bottom-buttons-container', 'not-absolute') },
    _react.React.createElement("div", { className: (0, _style2.default)('buttons-container', !deleting ? 'wcag-invisible' : '') },
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Annuleren van het verwijderen', "aria-haspopup": false, tabIndex: 0, onKeyDown: function onKeyDown(evt) {return cancelDelete();}, onClick: function onClick(evt) {return cancelDelete();} },
    _react.React.createElement("span", null, "Annuleren")),
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', "aria-label": 'Verwijderen van gebruikersgroep', "aria-haspopup": false, tabIndex: 0, disabled: false, onKeyDown: function onKeyDown(evt) {return saveDelete(item);}, onClick: function onClick(evt) {return saveDelete(item);} },
    _react.React.createElement("span", null, "Verwijderen")))));
});

/***/ }),

/***/ 1344:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.FactionEditModalButtons = undefined;__webpack_require__(76);
var _react = __webpack_require__(648);
var _index = __webpack_require__(979);
var _input = __webpack_require__(990);var _input2 = _interopRequireDefault(_input);
var _input3 = __webpack_require__(1017);
var _resource = __webpack_require__(233);
var _style = __webpack_require__(1059);var _style2 = _interopRequireDefault(_style);
var _selectors = __webpack_require__(977);var _selectors2 = _interopRequireDefault(_selectors);
var _resource2 = __webpack_require__(246);
var _UPDATE_BUTTON_NO = __webpack_require__(519);var _UPDATE_BUTTON_NO2 = _interopRequireDefault(_UPDATE_BUTTON_NO);

var _SHOW = __webpack_require__(655);var _SHOW2 = _interopRequireDefault(_SHOW);
var _focuslockext = __webpack_require__(978);var _focuslockext2 = _interopRequireDefault(_focuslockext);
var _selectors3 = __webpack_require__(975);var _selectors4 = _interopRequireDefault(_selectors3);
var _types = __webpack_require__(245);
var _selectors5 = __webpack_require__(649);var _selectors6 = _interopRequireDefault(_selectors5);
var _button = __webpack_require__(973);
var _resource3 = __webpack_require__(106);
var _resource4 = __webpack_require__(494);
var _authcheck = __webpack_require__(518);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var maxNameLength = 200;
var typeFaction = 5;exports.default =
(0, _react.PureConnect)('FactionEditModal')(function (state) {return {
        creating: _resource.usergroupEditor.selectors.creating(state),
        item: _resource.usergroupEditor.selectors.item(state),
        updating: _resource.usergroupEditor.selectors.updating(state),
        origin: state.notemenu.origin,
        participantPopupVisible: _selectors2.default.visible(state),
        notes: _resource3.notesResource.selectors.items(state).concat(_resource4.notesSharedResource.selectors.items(state)),
        usergroups: _resource.usergroupResource.selectors.items(state),
        screenSmall: _selectors4.default.small(state),
        accountmng: _selectors6.default.accountmanager(state) };},
function (dispatch) {return {
        cancel: function cancel() {return dispatch(_resource.usergroupEditor.actions.RESET({}));},
        cancelCreating: function cancelCreating() {
            dispatch(_resource.usergroupEditor.actions.CREATE_CANCEL({}));
        },
        cancelUpdating: function cancelUpdating() {
            dispatch(_resource.usergroupEditor.actions.UPDATE_CANCEL({}));
        },
        change: function change(item) {dispatch(_resource.usergroupEditor.actions.APPLY({ item: item }));},
        saveCreating: function saveCreating(item) {
            dispatch(_resource.usergroupEditor.actions.CREATE_CONTINUE({ item: item }));
        },
        saveUpdating: function saveUpdating(item) {
            dispatch(_resource.usergroupEditor.actions.UPDATE_CONTINUE({ item: item }));
        },
        showParticipantPopUp: function showParticipantPopUp() {dispatch((0, _SHOW2.default)({ itemno: -1 }));},
        updateButtonFocus: function updateButtonFocus(buttonNr, origin, itm) {
            dispatch((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: buttonNr, origin: origin, buttonAction: undefined, lasttoucheditem: itm }));
        },
        deleteUsergroup: function deleteUsergroup(item) {return dispatch(_resource.usergroupEditor.actions.DELETE({ item: item }));} };},
function (_ref) {var creating = _ref.creating,updating = _ref.updating,item = _ref.item,notes = _ref.notes,usergroups = _ref.usergroups,origin = _ref.origin,screenSmall = _ref.screenSmall,accountmng = _ref.accountmng,updateButtonFocus = _ref.updateButtonFocus,deleteUsergroup = _ref.deleteUsergroup,change = _ref.change,saveCreating = _ref.saveCreating,cancelCreating = _ref.cancelCreating,saveUpdating = _ref.saveUpdating,cancelUpdating = _ref.cancelUpdating,showParticipantPopUp = _ref.showParticipantPopUp,participantPopupVisible = _ref.participantPopupVisible;
    var canDelete = !notes.qWhere(function (itm) {return (0, _types.isQuestion)(itm) &&
        item.userIDs && item.userIDs.includes(itm.userId) &&
        item.type === _authcheck.typeFactions;}).qAny();
    return _react.React.createElement(_index.Modal, { onEscKeyDown: !participantPopupVisible ?
        creating ? function () {return cancelCreating();} : function () {return cancelUpdating();} : function () {}, visible: (creating || updating) && item && item.type === typeFaction, type: screenSmall ? 'smallscreen' : 'center2nd', backdrop: true, header: _react.React.createElement("div", { className: (0, _style2.default)('usergroup-title') }, updating ? 'Fractie bewerken' : 'Fractie toevoegen') },
    _react.React.createElement("div", { className: (0, _style2.default)(!creating && !updating ? 'wcag-invisible' : '', 'fields-container'), "aria-hidden": !(creating || updating), "aria-labelledby": "Maak een fractie aan" },
    _react.React.createElement(_focuslockext2.default, { disabled: !(creating || updating) },
    _react.React.createElement("div", { className: (0, _style2.default)('usergroup-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('input-naam-fractie') },
    _react.React.createElement("span", { className: (0, _style2.default)('input-label') },
    "Fractie",
    _react.React.createElement("span", { className: (0, _style2.default)('star') }, "*")),
    _react.React.createElement(_input2.default, { className: (0, _style2.default)('usergroup-input'), type: "text", name: "name", value: item.name, maxLength: maxNameLength, multiline: true, onChange: function onChange(value) {return change({ name: value });}, floating: true }))),
    _react.React.createElement(_input3.ParticipantSelectionForFactions, { title: 'Fractieleden:', selectedparticipantsIDs: item.userIDs, selectedparticipantgroupIDs: [], participantPopupVisible: participantPopupVisible, onChange: function onChange(c) {
            change({ userIDs: c ? c : undefined });
        }, onChangeParticipantGroups: function onChangeParticipantGroups(d) {
            change({ particpantgroupIDs: d ? d : undefined });
        }, onAbort: function onAbort() {updateButtonFocus(_UPDATE_BUTTON_NO.buttonUsergroupEditenDeelnemers, origin, item);}, onSave: function onSave() {updateButtonFocus(_UPDATE_BUTTON_NO.buttonUsergroupEditenDeelnemers, origin, item);}, label: '' }),
    _react.React.createElement("div", { className: (0, _style2.default)('content-buttons-container') },
    _react.React.createElement(_button.Btn, { type: "button", disabled: !canDelete, className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Verwijder fractie', "aria-haspopup": false, tabIndex: 0, onKeyDown: function onKeyDown(evt) {
            handleEnters(evt, function () {return deleteUsergroup(item);});
        }, onClick: function onClick() {return deleteUsergroup(item);} },
    _react.React.createElement("span", null, "VERWIJDER FRACTIE"))),
    _react.React.createElement(FactionEditModalButtons, null))));
});
var FactionEditModalButtons = exports.FactionEditModalButtons = (0, _react.PureConnect)('FactionEditModalButtons')(function (state) {return {
        creating: _resource.usergroupEditor.selectors.creating(state),
        item: _resource.usergroupEditor.selectors.item(state),
        updating: _resource.usergroupEditor.selectors.updating(state),
        usergroupowner: _resource2.participantsResource.selectors.items(state).qFirst(function (itm) {return itm.isUser;}),
        origin: state.notemenu.origin,
        selectNote: state.selection.creating,
        participantPopupVisible: _selectors2.default.visible(state),
        screenSmall: _selectors4.default.small(state) };},
function (dispatch) {return {
        cancel: function cancel() {return dispatch(_resource.usergroupEditor.actions.RESET({}));},
        cancelCreating: function cancelCreating() {
            dispatch(_resource.usergroupEditor.actions.CREATE_CANCEL({}));
        },
        cancelUpdating: function cancelUpdating() {
            dispatch(_resource.usergroupEditor.actions.UPDATE_CANCEL({}));
        },
        change: function change(item) {dispatch(_resource.usergroupEditor.actions.APPLY({ item: item }));},
        saveCreating: function saveCreating(item) {
            item = fixNoteDevelopmentJsonServer(item, true);
            dispatch(_resource.usergroupEditor.actions.CREATE_CONTINUE({ item: item }));
        },
        saveUpdating: function saveUpdating(item) {
            item = fixNoteDevelopmentJsonServer(item, false);
            dispatch(_resource.usergroupEditor.actions.UPDATE_CONTINUE({ item: item }));
        },
        showParticipantPopUp: function showParticipantPopUp() {dispatch((0, _SHOW2.default)({ itemno: -1 }));},
        updateButtonFocus: function updateButtonFocus(buttonNr, origin, itm) {
            dispatch((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: buttonNr, origin: origin, buttonAction: undefined, lasttoucheditem: itm }));
        } };},
function (_ref2) {var creating = _ref2.creating,updating = _ref2.updating,item = _ref2.item,saveCreating = _ref2.saveCreating,cancelCreating = _ref2.cancelCreating,saveUpdating = _ref2.saveUpdating,cancelUpdating = _ref2.cancelUpdating;
    var visible = creating || updating;
    return _react.React.createElement("div", { className: (0, _style2.default)('bottom-panel', !visible ? 'wcag-invisible' : ''), "aria-hidden": !visible, "aria-labelledby": "Maak een fractie aan" },
    _react.React.createElement("div", { className: (0, _style2.default)('bottom-buttons') },
    _react.React.createElement("div", { className: (0, _style2.default)('buttons-container') },
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Annuleren', "aria-haspopup": false, tabIndex: 0, onKeyDown: function onKeyDown(evt) {
            handleEnters(evt, creating ?
            function () {cancelCreating();} :
            function () {cancelUpdating();});
        }, onClick: creating ?
        function () {cancelCreating();} :
        function () {cancelUpdating();} },
    _react.React.createElement("span", null, "Annuleren")),
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', "aria-label": 'Opslaan', "aria-haspopup": false, tabIndex: item.name ? 0 : -1, disabled: !item.name, onKeyDown: function onKeyDown(evt) {
            handleEnters(evt, creating ?
            function () {return saveCreating(item);} :
            function () {return saveUpdating(item);});
        }, onClick: creating ?
        function () {return saveCreating(item);} :
        function () {return saveUpdating(item);} },
    _react.React.createElement("span", null, "Opslaan")))));
});
function handleEnters(evt, funct) {
    if (evt.key === 'Enter') {
        evt.preventDefault();
        funct();
    }
}
function fixNoteDevelopmentJsonServer(item, create) {
    return item;
}

/***/ }),

/***/ 1345:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.RoleEditModalButtons = undefined;__webpack_require__(76);
var _react = __webpack_require__(648);
var _index = __webpack_require__(979);
var _input = __webpack_require__(1017);
var _resource = __webpack_require__(233);
var _style = __webpack_require__(1059);var _style2 = _interopRequireDefault(_style);
var _selectors = __webpack_require__(977);var _selectors2 = _interopRequireDefault(_selectors);
var _resource2 = __webpack_require__(246);
var _UPDATE_BUTTON_NO = __webpack_require__(519);var _UPDATE_BUTTON_NO2 = _interopRequireDefault(_UPDATE_BUTTON_NO);

var _SHOW = __webpack_require__(655);var _SHOW2 = _interopRequireDefault(_SHOW);
var _focuslockext = __webpack_require__(978);var _focuslockext2 = _interopRequireDefault(_focuslockext);
var _selectors3 = __webpack_require__(975);var _selectors4 = _interopRequireDefault(_selectors3);
var _selectors5 = __webpack_require__(649);var _selectors6 = _interopRequireDefault(_selectors5);
var _button = __webpack_require__(973);
var _adminText = __webpack_require__(1018);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var typeRoleAdmin = 1;
var typeRoleClerk = 2;
var typeRolePracticioner = 3;exports.default =
(0, _react.PureConnect)('RoleEditModal')(function (state) {return {
        creating: _resource.usergroupEditor.selectors.creating(state),
        item: _resource.usergroupEditor.selectors.item(state),
        updating: _resource.usergroupEditor.selectors.updating(state),
        origin: state.notemenu.origin,
        participantPopupVisible: _selectors2.default.visible(state),
        screenSmall: _selectors4.default.small(state),
        accountmng: _selectors6.default.accountmanager(state) };},
function (dispatch) {return {
        cancel: function cancel() {return dispatch(_resource.usergroupEditor.actions.RESET({}));},
        cancelCreating: function cancelCreating() {
            dispatch(_resource.usergroupEditor.actions.CREATE_CANCEL({}));
        },
        cancelUpdating: function cancelUpdating() {
            dispatch(_resource.usergroupEditor.actions.UPDATE_CANCEL({}));
        },
        change: function change(item) {dispatch(_resource.usergroupEditor.actions.APPLY({ item: item }));},
        saveCreating: function saveCreating(item) {
            dispatch(_resource.usergroupEditor.actions.CREATE_CONTINUE({ item: item }));
        },
        saveUpdating: function saveUpdating(item) {
            dispatch(_resource.usergroupEditor.actions.UPDATE_CONTINUE({ item: item }));
        },
        showParticipantPopUp: function showParticipantPopUp() {dispatch((0, _SHOW2.default)({ itemno: -1 }));},
        updateButtonFocus: function updateButtonFocus(buttonNr, origin, itm) {
            dispatch((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: buttonNr, origin: origin, buttonAction: undefined, lasttoucheditem: itm }));
        },
        deleteUsergroup: function deleteUsergroup(item) {return dispatch(_resource.usergroupEditor.actions.DELETE({ item: item }));} };},
function (_ref) {var creating = _ref.creating,updating = _ref.updating,item = _ref.item,origin = _ref.origin,screenSmall = _ref.screenSmall,accountmng = _ref.accountmng,updateButtonFocus = _ref.updateButtonFocus,deleteUsergroup = _ref.deleteUsergroup,change = _ref.change,saveCreating = _ref.saveCreating,cancelCreating = _ref.cancelCreating,saveUpdating = _ref.saveUpdating,cancelUpdating = _ref.cancelUpdating,showParticipantPopUp = _ref.showParticipantPopUp,participantPopupVisible = _ref.participantPopupVisible;
    return _react.React.createElement(_index.Modal, { onEscKeyDown: !participantPopupVisible ?
        creating ? function () {return cancelCreating();} : function () {return cancelUpdating();} : function () {}, visible: (creating || updating) && item && (
        item.type === typeRoleAdmin || item.type === typeRoleClerk || item.type === typeRolePracticioner), type: screenSmall ? 'smallscreen' : 'center2nd', backdrop: true, header: _react.React.createElement("div", { className: (0, _style2.default)('usergroup-title') }, item.type === typeRoleAdmin ? 'Rol admin' :
        item.type === typeRoleClerk ? 'Rol griffier' :
        item.type === typeRolePracticioner ? 'Rol behandelaar' :
        'Rol toekennen') },
    _react.React.createElement("div", { className: (0, _style2.default)(!creating && !updating ? 'wcag-invisible' : '', 'fields-container'), "aria-hidden": !(creating || updating), "aria-labelledby": "Maak een fractie aan" },
    _react.React.createElement(_focuslockext2.default, { disabled: !(creating || updating) },
    _react.React.createElement("div", { className: (0, _style2.default)('usergroup-container') }, item.type === typeRoleAdmin ? _adminText.extraTextAdmin :
    item.type === typeRoleClerk ? _adminText.extraTextClerk : _adminText.extraTextPracticioner),

    _react.React.createElement(_input.ParticipantSelectionForUsergroups, { title: item.type === typeRoleAdmin ?
        'Gebruikers met de rol admin: ' :
        item.type === typeRoleClerk ?
        'Gebruikers met de rol griffier: ' :
        'Gebruikers met de rol behandelaar: ', selectedparticipantsIDs: item.userIDs, selectedparticipantgroupIDs: [], participantPopupVisible: participantPopupVisible, onChange: function onChange(c) {
            change({ userIDs: c ? c : undefined });
        }, onChangeParticipantGroups: function onChangeParticipantGroups(d) {
            change({ particpantgroupIDs: d ? d : undefined });
        }, onAbort: function onAbort() {updateButtonFocus(_UPDATE_BUTTON_NO.buttonUsergroupEditenDeelnemers, origin, item);}, onSave: function onSave() {updateButtonFocus(_UPDATE_BUTTON_NO.buttonUsergroupEditenDeelnemers, origin, item);}, label: '' }),
    _react.React.createElement(RoleEditModalButtons, null))));
});
var RoleEditModalButtons = exports.RoleEditModalButtons = (0, _react.PureConnect)('RoleEditModalButtons')(function (state) {return {
        creating: _resource.usergroupEditor.selectors.creating(state),
        item: _resource.usergroupEditor.selectors.item(state),
        updating: _resource.usergroupEditor.selectors.updating(state),
        usergroupowner: _resource2.participantsResource.selectors.items(state).qFirst(function (itm) {return itm.isUser;}),
        origin: state.notemenu.origin,
        selectNote: state.selection.creating,
        participantPopupVisible: _selectors2.default.visible(state),
        screenSmall: _selectors4.default.small(state) };},
function (dispatch) {return {
        cancel: function cancel() {return dispatch(_resource.usergroupEditor.actions.RESET({}));},
        cancelCreating: function cancelCreating() {
            dispatch(_resource.usergroupEditor.actions.CREATE_CANCEL({}));
        },
        cancelUpdating: function cancelUpdating() {
            dispatch(_resource.usergroupEditor.actions.UPDATE_CANCEL({}));
        },
        change: function change(item) {dispatch(_resource.usergroupEditor.actions.APPLY({ item: item }));},
        saveCreating: function saveCreating(item) {
            item = fixNoteDevelopmentJsonServer(item, true);
            dispatch(_resource.usergroupEditor.actions.CREATE_CONTINUE({ item: item }));
        },
        saveUpdating: function saveUpdating(item) {
            item = fixNoteDevelopmentJsonServer(item, false);
            dispatch(_resource.usergroupEditor.actions.UPDATE_CONTINUE({ item: item }));
        },
        showParticipantPopUp: function showParticipantPopUp() {dispatch((0, _SHOW2.default)({ itemno: -1 }));},
        updateButtonFocus: function updateButtonFocus(buttonNr, origin, itm) {
            dispatch((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: buttonNr, origin: origin, buttonAction: undefined, lasttoucheditem: itm }));
        } };},
function (_ref2) {var creating = _ref2.creating,updating = _ref2.updating,item = _ref2.item,saveCreating = _ref2.saveCreating,cancelCreating = _ref2.cancelCreating,saveUpdating = _ref2.saveUpdating,cancelUpdating = _ref2.cancelUpdating;
    var visible = creating || updating;
    return _react.React.createElement("div", { className: (0, _style2.default)('bottom-panel', !visible ? 'wcag-invisible' : ''), "aria-hidden": !visible, "aria-labelledby": "Maak een fractie aan" },
    _react.React.createElement("div", { className: (0, _style2.default)('bottom-buttons') },
    _react.React.createElement("div", { className: (0, _style2.default)('buttons-container') },
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Annuleren', "aria-haspopup": false, tabIndex: 0, onKeyDown: function onKeyDown(evt) {
            handleEnters(evt, creating ?
            function () {cancelCreating();} :
            function () {cancelUpdating();});
        }, onClick: creating ?
        function () {cancelCreating();} :
        function () {cancelUpdating();} },
    _react.React.createElement("span", null, "Annuleren")),
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', "aria-label": 'Opslaan', "aria-haspopup": false, tabIndex: item.name ? 0 : -1, disabled: !item.name, onKeyDown: function onKeyDown(evt) {
            handleEnters(evt, creating ?
            function () {return saveCreating(item);} :
            function () {return saveUpdating(item);});
        }, onClick: creating ?
        function () {return saveCreating(item);} :
        function () {return saveUpdating(item);} },
    _react.React.createElement("span", null, "Opslaan")))));
});
function handleEnters(evt, funct) {
    if (evt.key === 'Enter') {
        evt.preventDefault();
        funct();
    }
}
function fixNoteDevelopmentJsonServer(item, create) {
    return item;
}

/***/ }),

/***/ 1346:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.QuestionAddresseeEditModalButtons = undefined;__webpack_require__(76);
var _react = __webpack_require__(648);
var _index = __webpack_require__(979);
var _input = __webpack_require__(990);var _input2 = _interopRequireDefault(_input);
var _resource = __webpack_require__(521);
var _style = __webpack_require__(1347);var _style2 = _interopRequireDefault(_style);
var _UPDATE_BUTTON_NO = __webpack_require__(519);var _UPDATE_BUTTON_NO2 = _interopRequireDefault(_UPDATE_BUTTON_NO);
var _focuslockext = __webpack_require__(978);var _focuslockext2 = _interopRequireDefault(_focuslockext);
var _selectors = __webpack_require__(975);var _selectors2 = _interopRequireDefault(_selectors);
var _button = __webpack_require__(973);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var maxNameLength = 200;exports.default =
(0, _react.PureConnect)('QuestionAddresseeEditModal')(function (state) {return {
        creating: _resource.questionaddresseeEditor.selectors.creating(state),
        item: _resource.questionaddresseeEditor.selectors.item(state),
        updating: _resource.questionaddresseeEditor.selectors.updating(state),
        origin: state.notemenu.origin,
        screenSmall: _selectors2.default.small(state) };},
function (dispatch) {return {
        cancel: function cancel() {return dispatch(_resource.questionaddresseeEditor.actions.RESET({}));},
        cancelCreating: function cancelCreating() {
            dispatch(_resource.questionaddresseeEditor.actions.CREATE_CANCEL({}));
        },
        cancelUpdating: function cancelUpdating() {
            dispatch(_resource.questionaddresseeEditor.actions.UPDATE_CANCEL({}));
        },
        change: function change(item) {dispatch(_resource.questionaddresseeEditor.actions.APPLY({ item: item }));} };},
function (_ref) {var creating = _ref.creating,updating = _ref.updating,item = _ref.item,origin = _ref.origin,screenSmall = _ref.screenSmall,change = _ref.change,cancelCreating = _ref.cancelCreating,cancelUpdating = _ref.cancelUpdating;
    return _react.React.createElement(_index.Modal, { onEscKeyDown: creating ? function () {return cancelCreating();} : function () {return cancelUpdating();}, visible: creating || updating, type: screenSmall ? 'smallscreen' : 'center2nd', backdrop: true, header: _react.React.createElement("div", { className: (0, _style2.default)('questionaddressee-title') }, updating ? 'Standaard emailadres voor vragen bewerken' : 'Standaard emailadres voor vragen toevoegen') },
    _react.React.createElement("div", { className: (0, _style2.default)(!creating && !updating ? 'wcag-invisible' : '', 'fields-container'), "aria-hidden": !(creating || updating), "aria-labelledby": "Maak standaard emailadres aan voor de vragen" },
    _react.React.createElement(_focuslockext2.default, { disabled: !(creating || updating) },
    _react.React.createElement("div", { className: (0, _style2.default)('questionaddressee-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('input-naam') },
    _react.React.createElement("span", { className: (0, _style2.default)('input-label') },
    "Naam",
    _react.React.createElement("span", { className: (0, _style2.default)('star') }, "*")),
    _react.React.createElement(_input2.default, { className: (0, _style2.default)('questionaddressee-input'), type: "text", name: "name", value: item.name, maxLength: maxNameLength, multiline: true, onChange: function onChange(value) {return change({ name: value });}, floating: true })),
    _react.React.createElement("div", { className: (0, _style2.default)('input-naam-emailadres') },
    _react.React.createElement("span", { className: (0, _style2.default)('input-label') },
    "Email",
    _react.React.createElement("span", { className: (0, _style2.default)('star') }, "*")),
    _react.React.createElement(_input2.default, { className: (0, _style2.default)('questionaddressee-input'), type: "text", name: "email", value: item.email, maxLength: maxNameLength, multiline: true, onChange: function onChange(value) {return change({ email: value });}, floating: true }))),
    _react.React.createElement(QuestionAddresseeEditModalButtons, null))));
});
var QuestionAddresseeEditModalButtons = exports.QuestionAddresseeEditModalButtons = (0, _react.PureConnect)('QuestionAddresseeEditModalButtons')(function (state) {return {
        creating: _resource.questionaddresseeEditor.selectors.creating(state),
        item: _resource.questionaddresseeEditor.selectors.item(state),
        updating: _resource.questionaddresseeEditor.selectors.updating(state),
        origin: state.notemenu.origin,
        selectNote: state.selection.creating,
        screenSmall: _selectors2.default.small(state) };},
function (dispatch) {return {
        cancel: function cancel() {return dispatch(_resource.questionaddresseeEditor.actions.RESET({}));},
        cancelCreating: function cancelCreating() {
            dispatch(_resource.questionaddresseeEditor.actions.CREATE_CANCEL({}));
        },
        cancelUpdating: function cancelUpdating() {
            dispatch(_resource.questionaddresseeEditor.actions.UPDATE_CANCEL({}));
        },
        change: function change(item) {dispatch(_resource.questionaddresseeEditor.actions.APPLY({ item: item }));},
        saveCreating: function saveCreating(item) {
            item = fixNoteDevelopmentJsonServer(item, true);
            dispatch(_resource.questionaddresseeEditor.actions.CREATE_CONTINUE({ item: item }));
        },
        saveUpdating: function saveUpdating(item) {
            item = fixNoteDevelopmentJsonServer(item, false);
            dispatch(_resource.questionaddresseeEditor.actions.UPDATE_CONTINUE({ item: item }));
        },
        updateButtonFocus: function updateButtonFocus(buttonNr, origin, itm) {
            dispatch((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: buttonNr, origin: origin, buttonAction: undefined, lasttoucheditem: itm }));
        } };},
function (_ref2) {var creating = _ref2.creating,updating = _ref2.updating,item = _ref2.item,saveCreating = _ref2.saveCreating,cancelCreating = _ref2.cancelCreating,saveUpdating = _ref2.saveUpdating,cancelUpdating = _ref2.cancelUpdating;
    var visible = creating || updating;
    return _react.React.createElement("div", { className: (0, _style2.default)('bottom-panel', !visible ? 'wcag-invisible' : ''), "aria-hidden": !visible, "aria-labelledby": "Maak een standaard emailadres aan voor de vragen" },
    _react.React.createElement("div", { className: (0, _style2.default)('bottom-buttons') },
    _react.React.createElement("div", { className: (0, _style2.default)('buttons-container') },
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Annuleren', "aria-haspopup": false, tabIndex: 0, onKeyDown: function onKeyDown(evt) {
            handleEnters(evt, creating ?
            function () {cancelCreating();} :
            function () {cancelUpdating();});
        }, onClick: creating ?
        function () {cancelCreating();} :
        function () {cancelUpdating();} },
    _react.React.createElement("span", null, "Annuleren")),
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', "aria-label": 'Opslaan', "aria-haspopup": false, tabIndex: item.email && item.name ? 0 : -1, disabled: !item.email || !item.name, onKeyDown: function onKeyDown(evt) {
            handleEnters(evt, creating ?
            function () {return saveCreating(item);} :
            function () {return saveUpdating(item);});
        }, onClick: creating ?
        function () {return saveCreating(item);} :
        function () {return saveUpdating(item);} },
    _react.React.createElement("span", null, "Opslaan")))));
});
function handleEnters(evt, funct) {
    if (evt.key === 'Enter') {
        evt.preventDefault();
        funct();
    }
}
function fixNoteDevelopmentJsonServer(item, create) {
    return item;
}

/***/ }),

/***/ 1347:
/***/ (function(module, exports, __webpack_require__) {


        // classnames-loader: automatically bind css-modules to classnames
        var classNames = __webpack_require__(492);
        var locals = __webpack_require__(1348);
        var css = classNames.bind(locals);
        for (var style in locals) css[style] = locals[style];
        module.exports = css;
    

/***/ }),

/***/ 1348:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(1349);

if (typeof content === 'string') {
  content = [[module.i, content, '']];
}

var options = {"attributes":{}}

options.insert = "head";
options.singleton = false;

var update = __webpack_require__(491)(content, options);

if (content.locals) {
  module.exports = content.locals;
}


/***/ }),

/***/ 1349:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(undefined);
// imports


// module
exports.push([module.i, "._28e96I9Y{font-weight:300;color:#404040;color:rgba(0,0,0,.75)}.lJiAFD8i{display:block;float:right;margin-top:15px}.lJiAFD8i button{font-size:14px}._2A0AH20z{margin-bottom:15px}._10Hea1_n{visibility:hidden}._3drtzzUQ{height:70px;max-height:70px;overflow-y:auto}._3wswhxQD{height:30px;max-height:30px}.sVIYFTIH span{margin-left:-10px;margin-top:-20px}.tg7ZyaXs{margin:0 16px 12px;font-size:14px;color:#414141;letter-spacing:.42px;line-height:18px;font-weight:700}.luWrWmzh{margin:0 16px;font-size:12px;color:#414141;font-weight:400;line-height:16px;position:relative}.luWrWmzh ._2A0AH20z ._1hMvf1OT,.luWrWmzh ._2IqUTl2J ._1hMvf1OT{display:block;font-weight:700;margin-bottom:4px}.luWrWmzh ._2A0AH20z ._1hMvf1OT ._1Wn4-u86,.luWrWmzh ._2IqUTl2J ._1hMvf1OT ._1Wn4-u86{margin-left:2px;font-size:15px;line-height:20px;font-weight:700;color:#f36}.luWrWmzh ._2A0AH20z ._1EItaGgz,.luWrWmzh ._2IqUTl2J ._1EItaGgz{display:block;margin-bottom:20px}.luWrWmzh ._2A0AH20z ._1EItaGgz textarea,.luWrWmzh ._2IqUTl2J ._1EItaGgz textarea{display:block;line-height:16.8px;padding:16px;border:2px solid #e8e8e8;border-radius:4px;margin:0;width:100%}.luWrWmzh ._2A0AH20z ._1EItaGgz textarea:focus-visible,.luWrWmzh ._2IqUTl2J ._1EItaGgz textarea:focus-visible{outline-color:#4b55f6}.luWrWmzh ._2A0AH20z ._1EItaGgz span:last-child,.luWrWmzh ._2IqUTl2J ._1EItaGgz span:last-child{display:block;text-align:right}.luWrWmzh ._2FYsiW-8{display:block}.luWrWmzh ._2FYsiW-8>*{display:inline-block}.luWrWmzh ._2FYsiW-8 ._1jxWRW8z{width:16px;height:16px;margin:0;margin-right:10px;vertical-align:middle}._2Vte_aPX{margin:0 16px;display:block}._2Vte_aPX button span{border:2px solid #d6705d!important;color:#d6705d!important}._2Vte_aPX button:focus-visible{outline-color:#d6705d}._3WM2PuoP{font-style:italic;text-decoration:underline}._1SVjRJ6c{position:absolute;bottom:0;width:100%;left:0;right:0;-webkit-box-shadow:0 -7px 8px rgba(0,0,0,.1);box-shadow:0 -7px 8px rgba(0,0,0,.1);padding-top:15px;background:#fff;height:67px}._1SVjRJ6c._1kQrPIym{position:relative}.H_9U_eOj{position:absolute;bottom:0;width:100%;left:0;right:0;-webkit-box-shadow:0 -7px 8px rgba(0,0,0,.1);box-shadow:0 -7px 8px rgba(0,0,0,.1);padding-top:15px;background:#fff;height:67px}.H_9U_eOj._1kQrPIym{position:relative}._38gZXMLf{margin:0 16px}._38gZXMLf button:first-child span{border-color:transparent}._38gZXMLf button:first-child:hover span{border-color:#4b55f6}._38gZXMLf button:last-child{float:right}.d5Xu9s_3{display:block;position:relative;padding:16px;color:#414141;font-weight:400;white-space:normal;border-radius:20px}.d5Xu9s_3 ._1nNGt29p{display:block;font-size:18px;letter-spacing:.54px;line-height:18px;font-weight:700;margin-bottom:8px}.d5Xu9s_3 ._3eyTIjX6 p{font-size:14px;line-height:19.6px;letter-spacing:0;margin-bottom:10px;color:#414141}.d5Xu9s_3 ._3eyTIjX6 p._1z_ZoIWM{font-weight:500}", ""]);

// exports
exports.locals = {
	"header": "_28e96I9Y",
	"button-aria": "lJiAFD8i",
	"input-naam-emailadres": "_2A0AH20z",
	"wcag-invisible": "_10Hea1_n",
	"participant-container-with-items-container": "_3drtzzUQ",
	"participant-container-with-no-items-container": "_3wswhxQD",
	"participant-selector": "sVIYFTIH",
	"questionaddressee-title": "tg7ZyaXs",
	"questionaddressee-container": "luWrWmzh",
	"input-label": "_1hMvf1OT",
	"input-naam": "_2IqUTl2J",
	"star": "_1Wn4-u86",
	"questionaddressee-input": "_1EItaGgz",
	"default-checkbox-div": "_2FYsiW-8",
	"default-checkbox": "_1jxWRW8z",
	"content-buttons-container": "_2Vte_aPX",
	"name-label": "_3WM2PuoP",
	"bottom-buttons-container": "_1SVjRJ6c",
	"not-absolute": "_1kQrPIym",
	"bottom-panel": "H_9U_eOj",
	"buttons-container": "_38gZXMLf",
	"warning-container": "d5Xu9s_3",
	"warning-title": "_1nNGt29p",
	"warning-content": "_3eyTIjX6",
	"medium": "_1z_ZoIWM"
};

/***/ }),

/***/ 1350:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.QuestionEditModal = undefined;__webpack_require__(76);
var _react = __webpack_require__(648);
var _index = __webpack_require__(979);
var _resource = __webpack_require__(106);
var _style = __webpack_require__(1004);var _style2 = _interopRequireDefault(_style);
var _selectors = __webpack_require__(649);var _selectors2 = _interopRequireDefault(_selectors);
var _selectors3 = __webpack_require__(651);var _selectors4 = _interopRequireDefault(_selectors3);
var _selectors5 = __webpack_require__(986);var _selectors6 = _interopRequireDefault(_selectors5);
var _selectors7 = __webpack_require__(977);var _selectors8 = _interopRequireDefault(_selectors7);
var _selectors9 = __webpack_require__(981);var _selectors10 = _interopRequireDefault(_selectors9);
var _resource2 = __webpack_require__(246);
var _questionEditArea = __webpack_require__(1156);
var _UPDATE_BUTTON_NO = __webpack_require__(519);var _UPDATE_BUTTON_NO2 = _interopRequireDefault(_UPDATE_BUTTON_NO);
var _focuslockext = __webpack_require__(978);var _focuslockext2 = _interopRequireDefault(_focuslockext);
var _selectors11 = __webpack_require__(975);var _selectors12 = _interopRequireDefault(_selectors11);
var _questionLinkEditor = __webpack_require__(1351);var _questionLinkEditor2 = _interopRequireDefault(_questionLinkEditor);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var QuestionEditModal = exports.QuestionEditModal = (0, _react.PureConnect)('QuestionEditModal')(function (state) {return {
        creating: _resource.notesEditor.selectors.creating(state),
        updating: _resource.notesEditor.selectors.updating(state),
        item: _resource.notesEditor.selectors.item(state),
        user: _selectors2.default.user(state),
        userparticipant: _resource2.participantsResource.selectors.items(state).qFirst(function (itm) {return itm.isUser;}),
        origin: state.notemenu.origin,
        participantPopupVisible: _selectors8.default.visible(state),
        categoryPopupVisible: _selectors10.default.visible(state),
        screenSmall: _selectors12.default.small(state),
        isminimized: _selectors4.default.isminimized(state),
        flyoverVisible: state.flyover.visible,
        ismaximized: _selectors6.default.ismaximized(state) };},
function (dispatch) {return {
        cancel: function cancel() {return dispatch(_resource.notesEditor.actions.RESET({}));},
        cancelCreating: function cancelCreating() {
            dispatch(_resource.notesEditor.actions.CREATE_CANCEL({}));
        },
        cancelUpdating: function cancelUpdating() {
            dispatch(_resource.notesEditor.actions.UPDATE_CANCEL({}));
        },
        updateButtonFocus: function updateButtonFocus(buttonNr, origin, itm) {
            dispatch((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: buttonNr, origin: origin, buttonAction: undefined, lasttoucheditem: itm }));
        } };},
function (_ref) {var flyoverVisible = _ref.flyoverVisible,creating = _ref.creating,updating = _ref.updating,item = _ref.item,isminimized = _ref.isminimized,ismaximized = _ref.ismaximized,origin = _ref.origin,screenSmall = _ref.screenSmall,cancelCreating = _ref.cancelCreating,cancelUpdating = _ref.cancelUpdating,participantPopupVisible = _ref.participantPopupVisible,categoryPopupVisible = _ref.categoryPopupVisible;
    var isquestion = item && !!item.isquestion;
    return _react.React.createElement(_index.Modal, { onEscKeyDown: !participantPopupVisible && !categoryPopupVisible ?
        creating ? function () {return cancelCreating();} : function () {return cancelUpdating();} : function () {}, visible: !flyoverVisible && (creating || updating) && isquestion, type: screenSmall ? 'smallscreen' : ismaximized ? 'maximized' : 'center2nd', backdrop: true, minimized: isminimized, header: _react.React.createElement("div", { className: (0, _style2.default)('app') }) },
    _react.React.createElement("div", { className: (0, _style2.default)(!creating && !updating || isminimized ? 'wcag-invisible' : '', 'fields-container'), "aria-hidden": !(creating || updating) || isminimized, "aria-labelledby": "Maak een vraag aan" },
    _react.React.createElement(_focuslockext2.default, { disabled: !(creating || updating) },
    _react.React.createElement(_questionLinkEditor2.default, null),
    _react.React.createElement(_questionLinkEditor.CommitLinkQuestionModal, null),
    _react.React.createElement(_questionLinkEditor.LinksOfQuestionModal, null),
    _react.React.createElement(_questionLinkEditor.LinksOfQuestionModalCancel, null),
    _react.React.createElement(_questionEditArea.ModalQuestionEditLayout, null),
    _react.React.createElement(_questionEditArea.QuestionSaveArea, null))));
});

/***/ }),

/***/ 1351:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.LinksOfQuestionModalCancel = exports.LinksOfQuestionModal = exports.CommitLinkQuestionModal = undefined;__webpack_require__(76);
var _react = __webpack_require__(648);
var _questionLinkEditor = __webpack_require__(1352);var _questionLinkEditor2 = _interopRequireDefault(_questionLinkEditor);
var _selectors = __webpack_require__(975);var _selectors2 = _interopRequireDefault(_selectors);
var _selectors3 = __webpack_require__(986);var _selectors4 = _interopRequireDefault(_selectors3);
var _reselectors = __webpack_require__(1355);var _reselectors2 = _interopRequireDefault(_reselectors);
var _resource = __webpack_require__(106);
var _collapsiblePanel = __webpack_require__(1065);var _collapsiblePanel2 = _interopRequireDefault(_collapsiblePanel);
var _button = __webpack_require__(973);
var _resource2 = __webpack_require__(223);
var _focuslockext = __webpack_require__(978);var _focuslockext2 = _interopRequireDefault(_focuslockext);
var _QUESTION_LINK = __webpack_require__(663);var _QUESTION_LINK2 = _interopRequireDefault(_QUESTION_LINK);
var _resource3 = __webpack_require__(494);
var _reselectors3 = __webpack_require__(542);var _reselectors4 = _interopRequireDefault(_reselectors3);
var _QUESTION_SHOWLINKS = __webpack_require__(664);var _QUESTION_SHOWLINKS2 = _interopRequireDefault(_QUESTION_SHOWLINKS);
var _QUESTION_SEARCH_TERM_LINK = __webpack_require__(741);var _QUESTION_SEARCH_TERM_LINK2 = _interopRequireDefault(_QUESTION_SEARCH_TERM_LINK);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
(0, _react.PureConnect)('LinkQuestionEditModal')(function (state) {return {
        linkitem: _selectors4.default.linkitem(state),
        notes: _resource.notesResource.selectors.items(state).concat(_resource3.notesSharedResource.selectors.items(state)),
        linking: _selectors4.default.linking(state),
        screenSmall: _selectors2.default.small(state),
        searchTermLinking: _selectors4.default.searchTermLinkingSelector(state),
        allquestions: _reselectors4.default.questionsItemsSelector(state),
        unlinkedQuestions: _reselectors2.default.questionSelectorSearching(state) };},
function (dispatch) {return {
        cancel: function cancel() {return dispatch((0, _QUESTION_LINK2.default)({ linkvisible: false, linkitem: undefined }));},
        change: function change(item) {dispatch(_resource2.questionsEditor.actions.APPLY({ item: item }));},
        setlinkid: function setlinkid(linkitem) {return dispatch((0, _QUESTION_LINK2.default)({ linkvisible: true, linkitem: linkitem }));},
        updateSearchTerm: function updateSearchTerm(searchTermLinking) {dispatch((0, _QUESTION_SEARCH_TERM_LINK2.default)({ searchTermLinking: searchTermLinking }));} };},
function (_ref) {var linking = _ref.linking,linkitem = _ref.linkitem,setlinkid = _ref.setlinkid,notes = _ref.notes,allquestions = _ref.allquestions,unlinkedQuestions = _ref.unlinkedQuestions,screenSmall = _ref.screenSmall,searchTermLinking = _ref.searchTermLinking,updateSearchTerm = _ref.updateSearchTerm;
    var selected = notes.qFirst(function (x) {return x.id === (linkitem ? linkitem.parentId : undefined);});
    var searchTermShowing = !searchTermLinking ? 'Selecteer' : searchTermLinking;
    return _react.React.createElement("div", { className: (0, _questionLinkEditor2.default)(!linking ? 'wcag-invisible' : '', 'container'), "aria-hidden": !linking, "aria-labelledby": "Linken" },
    _react.React.createElement(_focuslockext2.default, { disabled: !linking },
    _react.React.createElement(_collapsiblePanel2.default, { defaultOpened: false, label: selected ? selected.text : searchTermShowing },
    _react.React.createElement("div", { className: (0, _questionLinkEditor2.default)('input-search-container') },
    _react.React.createElement("input", { id: "link-input-$`{linkitem.id}`", placeholder: "Zoeken...", name: "q", className: (0, _questionLinkEditor2.default)('input-search'), ref: "term", value: searchTermLinking, onChange: function onChange(x) {return updateSearchTerm(x.target.value);} })),
    _react.React.createElement("div", { className: (0, _questionLinkEditor2.default)('search-list') }, unlinkedQuestions.
    qSelect(function (unlinked) {
        return _react.React.createElement("div", { tabIndex: 0, key: 'keyquestion' + unlinked.id.toString(), className: (0, _questionLinkEditor2.default)('item'), onKeyDown: function onKeyDown(ev) {
                ev.preventDefault();
                linkitem.parentId = unlinked.id;
                linkitem.status = unlinked.status;
                linkitem.antwoordConcern = unlinked.antwoordConcern;
                setlinkid(linkitem);
            }, onClick: function onClick(ev) {
                ev.preventDefault();
                linkitem.parentId = unlinked.id;
                linkitem.status = unlinked.status;
                linkitem.antwoordConcern = unlinked.antwoordConcern;
                setlinkid(linkitem);
            } },
        _react.React.createElement("label", { className: (0, _questionLinkEditor2.default)('selection-container') }, unlinked.text));
    })))));
});
var CommitLinkQuestionModal = exports.CommitLinkQuestionModal = (0, _react.PureConnect)('CommitLinkQuestionModal')(function (state) {return {
        linking: _selectors4.default.linking(state),
        linkitem: _selectors4.default.linkitem(state) };},
function (dispatch) {return {
        cancelLinking: function cancelLinking(linkitem) {return dispatch((0, _QUESTION_LINK2.default)({ linkvisible: false, linkitem: linkitem }));},
        applyLinking: function applyLinking(linkitem) {return dispatch((0, _QUESTION_LINK2.default)({ linkvisible: false, linkitem: linkitem }));} };},
function (_ref2) {var linking = _ref2.linking,linkitem = _ref2.linkitem,cancelLinking = _ref2.cancelLinking,applyLinking = _ref2.applyLinking;
    var visible = linking;
    return _react.React.createElement("div", { className: (0, _questionLinkEditor2.default)('bottom-panel', !visible ? 'wcag-invisible' : ''), "aria-hidden": !visible, "aria-labelledby": "Maak een notitie aan" },
    _react.React.createElement("div", { className: (0, _questionLinkEditor2.default)('bottom-buttons') },
    _react.React.createElement("div", { className: (0, _questionLinkEditor2.default)('buttons-container', !visible ? 'wcag-invisible' : '') },
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Annuleren', "aria-haspopup": false, tabIndex: 0, onKeyDown: function onKeyDown(evt) {
            handleEnters(evt, function () {return cancelLinking(linkitem);});
        }, onClick: function onClick() {return cancelLinking(linkitem);} },
    _react.React.createElement("span", null, "Annuleren")),
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', "aria-label": 'Koppelen', "aria-haspopup": false, tabIndex: !!linkitem ? 0 : -1, disabled: !linkitem, onKeyDown: function onKeyDown(evt) {return handleEnters(evt, function () {return applyLinking(linkitem);});}, onClick: function onClick() {return applyLinking(linkitem);} },
    _react.React.createElement("span", null, "Koppelen")))));
});
var LinksOfQuestionModal = exports.LinksOfQuestionModal = (0, _react.PureConnect)('LinksOfQuestionModal')(function (state) {return {
        showitem: _selectors4.default.showitem(state),
        showlinks: _selectors4.default.showlinks(state),
        notes: _resource.notesResource.selectors.items(state).concat(_resource3.notesSharedResource.selectors.items(state)),
        linking: _selectors4.default.linking(state),
        screenSmall: _selectors2.default.small(state),
        searchTermLinking: _selectors4.default.searchTermLinkingSelector(state),
        allquestions: _reselectors4.default.questionsItemsSelector(state) };},
function (dispatch) {return {
        cancel: function cancel() {return dispatch((0, _QUESTION_LINK2.default)({ linkvisible: false, linkitem: undefined }));} };},
function (_ref3) {var showlinks = _ref3.showlinks,showitem = _ref3.showitem,allquestions = _ref3.allquestions,screenSmall = _ref3.screenSmall,searchTermLinking = _ref3.searchTermLinking;
    var linkedQuestions = allquestions.qWhere(function (z) {return z.parentId === (showitem ? showitem.noteId : '');});
    return _react.React.createElement("div", { className: (0, _questionLinkEditor2.default)(!showlinks ? 'wcag-invisible' : '', 'container-linked'), "aria-hidden": !showlinks, "aria-labelledby": "Linken" },
    _react.React.createElement("div", { className: (0, _questionLinkEditor2.default)('list') }, linkedQuestions.
    qSelect(function (linked) {
        return _react.React.createElement("div", { tabIndex: 0, key: 'keyquestion' + linked.id.toString(), className: (0, _questionLinkEditor2.default)('item') },
        _react.React.createElement("label", { className: (0, _questionLinkEditor2.default)('selection-container') }, linked.text));
    })));
});
var LinksOfQuestionModalCancel = exports.LinksOfQuestionModalCancel = (0, _react.PureConnect)('LinksOfQuestionModalCancel')(function (state) {return {
        showlinks: _selectors4.default.showlinks(state),
        showitem: _selectors4.default.showitem(state) };},
function (dispatch) {return {
        cancelLinking: function cancelLinking(showitem) {return dispatch((0, _QUESTION_SHOWLINKS2.default)({ showlinks: false, showitem: showitem }));} };},
function (_ref4) {var showlinks = _ref4.showlinks,showitem = _ref4.showitem,cancelLinking = _ref4.cancelLinking;
    var visible = showlinks;
    return _react.React.createElement("div", { className: (0, _questionLinkEditor2.default)('bottom-panel', !visible ? 'wcag-invisible' : ''), "aria-hidden": !visible, "aria-labelledby": "Toon links van vraag" },
    _react.React.createElement("div", { className: (0, _questionLinkEditor2.default)('bottom-buttons') },
    _react.React.createElement("div", { className: (0, _questionLinkEditor2.default)('buttons-container', !visible ? 'wcag-invisible' : '') },
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Annuleren', "aria-haspopup": false, tabIndex: 0, onKeyDown: function onKeyDown(evt) {
            handleEnters(evt, function () {return cancelLinking(showitem);});
        }, onClick: function onClick() {return cancelLinking(showitem);} },
    _react.React.createElement("span", null, "Annuleren")))));
});
function handleEnters(evt, funct) {
    if (evt.key === 'Enter') {
        evt.preventDefault();
        funct();
    }
}

/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {


        // classnames-loader: automatically bind css-modules to classnames
        var classNames = __webpack_require__(492);
        var locals = __webpack_require__(1353);
        var css = classNames.bind(locals);
        for (var style in locals) css[style] = locals[style];
        module.exports = css;
    

/***/ }),

/***/ 1353:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(1354);

if (typeof content === 'string') {
  content = [[module.i, content, '']];
}

var options = {"attributes":{}}

options.insert = "head";
options.singleton = false;

var update = __webpack_require__(491)(content, options);

if (content.locals) {
  module.exports = content.locals;
}


/***/ }),

/***/ 1354:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(undefined);
// imports


// module
exports.push([module.i, "._2q58Jeoa{padding:1px;background:#fff;border:2px solid transparent;border-radius:100px}._2q58Jeoa,._2q58Jeoa span{-webkit-transition:all .5s ease-in-out;transition:all .5s ease-in-out}._2q58Jeoa span{padding:9px 16px 8px;background:#4b55f6;font-size:12px;line-height:18px;letter-spacing:1.2px;text-align:center;color:#fff;display:inline-block;border-radius:100px;font-weight:700;text-transform:uppercase}._2q58Jeoa:hover span{background:#30379d}._2q58Jeoa:focus{border-color:#30379d;outline:none}._2q58Jeoa:focus span{background:#30379d}._2q58Jeoa.d1YuTbfo{cursor:not-allowed}._2q58Jeoa.d1YuTbfo span{background:#f4f4f8;color:#6e6e77}._2q58Jeoa._3Z03dudg{display:inline-block;width:40px;height:40px;border-radius:100%;background:#4b55f6;color:#fff;margin-right:8px}._2q58Jeoa.aSB40c13 span{background:#fff;color:#4b55f6;border:1px solid #4b55f6;letter-spacing:.36px}._2q58Jeoa.aSB40c13:hover span{background:#f4f4f8}._2q58Jeoa.aSB40c13:focus{border-color:#30379d}._2q58Jeoa.aSB40c13.d1YuTbfo{cursor:not-allowed}._2q58Jeoa.aSB40c13.d1YuTbfo span{color:#6e6e77;border-color:#6e6e77;background:#f4f4f8}._2q58Jeoa._26FUcdJF span{background:#fff;color:#4b55f6;border:1px solid #4b55f6}._2q58Jeoa._26FUcdJF span:before{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";margin-right:3px;vertical-align:middle;display:inline-block}._2q58Jeoa._26FUcdJF:hover span{background:#f4f4f8}._2q58Jeoa._26FUcdJF:focus{border-color:#30379d}._2q58Jeoa._26FUcdJF.d1YuTbfo{cursor:not-allowed}._2q58Jeoa._26FUcdJF.d1YuTbfo span{color:#6e6e77;border-color:#6e6e77;background:#f4f4f8}._2q58Jeoa._15YQu5kf span{background:transparent;color:#414141;letter-spacing:.36px}._2q58Jeoa._15YQu5kf:hover span{background:#f4f4f8}._2q58Jeoa._15YQu5kf:focus{border-color:#30379d}._2q58Jeoa._15YQu5kf:focus span{background:#f4f4f8}._2q58Jeoa._15YQu5kf.d1YuTbfo{cursor:not-allowed}._2q58Jeoa._15YQu5kf.d1YuTbfo span{background:#f4f4f8;color:#6e6e77}._3ofODdrQ{color:#4b55f6;letter-spacing:.42px;line-height:19px;font-size:14px;text-transform:uppercase;padding:6px 8px;position:relative;border:none;background:transparent;font-weight:700}._3ofODdrQ._67lhIMqU:before{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";content:\"\\E5C4\";color:#4b55f6;font-size:28px;margin-right:6px;width:24px;vertical-align:middle}._1WA8_8z4{width:100%;border-radius:4px;background:#fff;border:2px solid #fff;padding:6px 40px 6px 16px;text-align:left;position:relative;outline-color:#4b55f6}._1WA8_8z4,._1WA8_8z4 span{display:inline-block}._1WA8_8z4 span.QbdCcnbj{font-size:12px;line-height:16px;font-weight:300;color:#414141;padding:10px 34px 10px 8px;font-style:italic;white-space:normal}._1WA8_8z4 span._2eJJVnMY{position:absolute;top:50%;right:16px;float:right;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:24px;height:24px}._1WA8_8z4 span._2eJJVnMY:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle;color:#4b55f6}._1WA8_8z4 span._2eJJVnMY.Txqkt-ia:after{content:\"\\E5CF\"}._1WA8_8z4 span._2eJJVnMY._1f2FsG3u:after{content:\"\\E5CE\"}._1WA8_8z4:focus{outline-color:#4b55f6}._2q58Jeoa._1c6Dd_Rs{border-radius:50%;width:40px;height:40px;position:relative}._2q58Jeoa._1c6Dd_Rs span{border-radius:50%;font-size:16px;background:transparent;width:34px;height:34px;padding:5px;margin:0;-webkit-box-shadow:none;box-shadow:none}._2q58Jeoa._1c6Dd_Rs span,._2q58Jeoa._1c6Dd_Rs span:after{color:#4b55f6;display:inline-block;position:relative}._2q58Jeoa._1c6Dd_Rs span:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\"}._2q58Jeoa._1c6Dd_Rs:hover span{background:#f4f4f8}._2q58Jeoa._1c6Dd_Rs:focus{border-color:#4b55f6}._2q58Jeoa._1c6Dd_Rs:focus span{background:#f4f4f8}._2q58Jeoa._1c6Dd_Rs.d1YuTbfo span{background:#f4f4f8;color:#6e6e77}._2q58Jeoa._1c6Dd_Rs._2Dhaw97S span:after{content:\"\\E7FD\"}._2q58Jeoa._1c6Dd_Rs._2jZS-wsL span:after{content:\"\\F233\"}._2q58Jeoa._1c6Dd_Rs.jqVAojm1 span:after{content:\"\\F1CF\"}._2q58Jeoa._1c6Dd_Rs._1mXUzxKB span:after{content:\"\\F1CE\";font-family:Material Icons Outlined}._2q58Jeoa._1c6Dd_Rs._1O3zFW8T span:after{content:\"\\EAAA\";font-family:Material Icons Outlined}._2q58Jeoa._1c6Dd_Rs._1S2upQnC span:after{content:\"\\E86C\";font-family:Material Icons Outlined}._2q58Jeoa._1c6Dd_Rs._1UFizXjC span:after{content:\"\\E876\"}._2q58Jeoa._1c6Dd_Rs._13rE3wbH span:after{content:\"\\E835\";font-family:Material Icons Outlined}._2q58Jeoa._1c6Dd_Rs.kB7FlEuu span:after{content:\"\\E834\"}._2q58Jeoa._1c6Dd_Rs._22wdBFCg span:after{content:\"\\E5CF\"}._2q58Jeoa._1c6Dd_Rs.rmVuYkov span:after{content:\"\\E5CE\"}._2q58Jeoa._1c6Dd_Rs.AJpf2H0- span:after{content:\"\\E5CD\"}._2q58Jeoa._1c6Dd_Rs._37GgXb5z span:after{content:\"\\E0C6\"}._2q58Jeoa._1c6Dd_Rs._1UsEm4-U span:after{content:\"\\E5D4\"}._2q58Jeoa._1c6Dd_Rs._1IyP1nBx span:after{content:\"\\E880\"}._2q58Jeoa._1c6Dd_Rs.sIpHysOW span:after{content:\"\\EF4F\";font-family:Material Icons Outlined}._2q58Jeoa._1c6Dd_Rs._3fOpaBm2 span:after{content:\"\\E87D\"}._2q58Jeoa._1c6Dd_Rs._3Wz6b79h span:after{content:\"\\E87E\";font-family:Material Icons Outlined}._2q58Jeoa._1c6Dd_Rs._1qRU7jLn span:after{content:\"\\E41A\"}._2q58Jeoa._1c6Dd_Rs._1TiqET-s span:after{content:\"\\E8B6\"}._2q58Jeoa._1c6Dd_Rs._12L7dCMa span:after{content:\"\\E0B7\"}._2q58Jeoa._1c6Dd_Rs._22KFTkEW span:after{content:\"\\E150\"}._2q58Jeoa._1c6Dd_Rs._17mLtbj_ span:after{content:\"\\E150\";font-family:Material Icons Outlined}._2q58Jeoa._1c6Dd_Rs._1YEU1QY9 span:after{content:\"\\E145\"}._2q58Jeoa._1c6Dd_Rs.nlO1sARE span:after{content:\"\\E836\"}._2q58Jeoa._1c6Dd_Rs._2nHuFkLE span:after{content:\"\\E837\"}._2q58Jeoa._1c6Dd_Rs._8Y9Ber_Z span:after{content:\"\\E163\"}._2q58Jeoa._1c6Dd_Rs._3gJrerV1 span:after{content:\"\\E0B7\";font-family:Material Icons Outlined}._2q58Jeoa._1c6Dd_Rs.vMW2mf7M span:after{content:\"\\E872\";font-family:Material Icons Outlined}._2q58Jeoa._1c6Dd_Rs._1UnxPhDr span:after{content:\"\\E5C4\"}._2q58Jeoa._1c6Dd_Rs._29WwKauL span:after{content:\"\\E5C8\"}._2q58Jeoa._1c6Dd_Rs._1qJkatcx,._2q58Jeoa._1c6Dd_Rs._3OS1QNqn{background:transparent;border-radius:0;color:#414141;padding:0;height:28px;width:28px}._2q58Jeoa._1c6Dd_Rs._1qJkatcx span,._2q58Jeoa._1c6Dd_Rs._3OS1QNqn span{padding:0;height:24px;width:24px}._2q58Jeoa._1c6Dd_Rs._1qJkatcx span:after,._2q58Jeoa._1c6Dd_Rs._3OS1QNqn span:after{color:#414141}._2q58Jeoa._1c6Dd_Rs._1qJkatcx._1bG_en2e,._2q58Jeoa._1c6Dd_Rs._1qJkatcx._1bG_en2e span:after,._2q58Jeoa._1c6Dd_Rs._3OS1QNqn._1bG_en2e,._2q58Jeoa._1c6Dd_Rs._3OS1QNqn._1bG_en2e span:after{color:#4b55f6}._2q58Jeoa._1c6Dd_Rs._1qJkatcx span:after{content:\"\\E8EF\"}._2q58Jeoa._1c6Dd_Rs._3OS1QNqn span:after{content:\"\\E9B0\"}._2q58Jeoa._3O2o3VJv{position:relative;padding:0;border:none;border-radius:0}._2q58Jeoa._3O2o3VJv span{color:#4b55f6;font-size:16px;background:transparent;display:inline-block;width:24px;height:24px;position:relative;margin:0;-webkit-box-shadow:none;box-shadow:none;padding:0;padding:5px}._2q58Jeoa._3O2o3VJv span:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";font-size:14px;font-weight:700}._2q58Jeoa._3O2o3VJv:hover span{background:#f4f4f8}._2q58Jeoa._3O2o3VJv._1UsEm4-U span:after{content:\"\\E5D4\"}._2b73eARt ._9Tr3TBX1{display:none}._2b73eARt ._9Tr3TBX1+._3H_qxlUU{display:inline-block}._2b73eARt ._9Tr3TBX1+._3H_qxlUU:before{content:\"\\E835\";font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle}._2b73eARt ._9Tr3TBX1:checked+._3H_qxlUU:before{content:\"\\E834\"}._2b73eARt span{padding-left:14px}._3h9bLako{display:block}._3h9bLako input[type=radio]{position:absolute;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";opacity:0}._3h9bLako input[type=radio]+._3E2k5CMQ:before{content:\"\\E836\";font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle}._3h9bLako input[type=radio]+._3E2k5CMQ span{padding-left:14px;font-size:12px;line-height:16px;color:#414141;font-weight:400}._3h9bLako input[type=radio]:checked+._3E2k5CMQ:before{content:\"\\E837\"}._3h9bLako input[type=radio]+._3E2k5CMQ:empty:before{margin-right:0}._22LBvfA0{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\"}.-HyBLH0Y{visibility:hidden;position:absolute;overflow:hidden;clip:rect(0 0 0 0);height:1px;width:1px;margin:-1px;padding:0;border:0}._1W2bz0J8{padding:0 16px}._1W2bz0J8 .koePARn7 .Oa1dJ4ZO{display:inline-block;width:100%;border-bottom:1px solid #e8e8e8;padding:16px}._1W2bz0J8 .koePARn7 .Oa1dJ4ZO .jq8UQIqc{padding:14px 16px;background:#fff;border:2px solid #f4f4f8;border-radius:4px;line-height:16px;font-size:12px;font-style:italic;font-weight:300;width:100%}._1W2bz0J8 .koePARn7 ._1qJkatcx{max-height:340px;overflow-y:auto;border-top:1px solid #e8e8e8}._1W2bz0J8 .koePARn7 ._1qJkatcx .Sr5Be3iJ{border-bottom:1px solid #e8e8e8}._1W2bz0J8 .koePARn7 ._1qJkatcx .Sr5Be3iJ ._2dEXTXxK{padding:7.5px 16px;font-size:14px;letter-spacing:.42px;line-height:29px;margin-bottom:unset;display:block;font-weight:400}._1W2bz0J8 .koePARn7 ._1qJkatcx .Sr5Be3iJ ._2dEXTXxK:hover{background:#e8e8e8}._3hUoPVAn ._1N0m9daz{font-size:14px;letter-spacing:.42px;line-height:40px;font-weight:700}._3hUoPVAn ._1u91aAw0{font-size:12px;line-height:16px;font-style:italic;margin-bottom:10px}._21UwjsdI{padding:16px;position:absolute;bottom:0;left:0;right:0}._21UwjsdI .DwL8NJY- ._2VO7lqsb{display:block}._21UwjsdI .DwL8NJY- ._2VO7lqsb button:first-child{float:left}._21UwjsdI .DwL8NJY- ._2VO7lqsb button:last-child{float:right}._2DWHVvL6 ._1qJkatcx{border:1px solid #e8e8e8}._2DWHVvL6 ._1qJkatcx .Sr5Be3iJ{border-bottom:1px solid #e8e8e8;padding:12px;background:#fff}._2DWHVvL6 ._1qJkatcx .Sr5Be3iJ:last-child{border-bottom:0}._2DWHVvL6 ._1qJkatcx .Sr5Be3iJ ._35Do-itA{margin:0;font-size:11px;line-height:13px;font-weight:500;color:#717171}.Oa1dJ4ZO .jq8UQIqc{padding:15px 16px;font-size:12px;line-height:29px;letter-spacing:.42px;font-style:italic;color:#6e6e77;border:2px solid #f4f4f8;margin:10px 16px;width:calc(100% - 36px);border-radius:4px}._2PUIA0RV{border-top:1px solid #e8e8e8;border-bottom:1px solid #e8e8e8;border-bottom-left-radius:4px;border-bottom-right-radius:4px;overflow:hidden}._2PUIA0RV .Sr5Be3iJ{border-bottom:1px solid #e8e8e8;padding:12px;background:#fff;width:100%}._2PUIA0RV .Sr5Be3iJ ._35Do-itA{margin:0;font-size:12px;line-height:13px;font-weight:500;color:#717171}._2PUIA0RV .Sr5Be3iJ:hover{background:#f4f4f8}._2PUIA0RV .Sr5Be3iJ:last-child{border-bottom:none}", ""]);

// exports
exports.locals = {
	"btn": "_2q58Jeoa",
	"disabled": "d1YuTbfo",
	"user-btn": "_3Z03dudg",
	"secondary-btn": "aSB40c13",
	"secondary-button_icon": "_26FUcdJF",
	"ghost-btn": "_15YQu5kf",
	"btn-icon-text_back": "_3ofODdrQ",
	"icon_arrow-back": "_67lhIMqU",
	"btn-type-dropdown": "_1WA8_8z4",
	"default-header": "QbdCcnbj",
	"icon": "_2eJJVnMY",
	"icon_chevron-down": "Txqkt-ia",
	"icon_chevron-up": "_1f2FsG3u",
	"icon-btn": "_1c6Dd_Rs",
	"account": "_2Dhaw97S",
	"account_group": "_2jZS-wsL",
	"collapse": "jqVAojm1",
	"expand": "_1mXUzxKB",
	"arrow_right": "_1O3zFW8T",
	"check_circle": "_1S2upQnC",
	"check": "_1UFizXjC",
	"checkbox_blank": "_13rE3wbH",
	"checkbox_marked": "kB7FlEuu",
	"chevron_down": "_22wdBFCg",
	"chevron_up": "rmVuYkov",
	"close": "AJpf2H0-",
	"comment_question": "_37GgXb5z",
	"dots_vertical": "_1UsEm4-U",
	"file_document_box": "_1IyP1nBx",
	"filter": "sIpHysOW",
	"heart": "_3fOpaBm2",
	"heart_outline": "_3Wz6b79h",
	"loading": "_1qRU7jLn",
	"magnify": "_1TiqET-s",
	"message": "_12L7dCMa",
	"pencil": "_22KFTkEW",
	"pencil_outline": "_17mLtbj_",
	"plus": "_1YEU1QY9",
	"radiobox_blank": "nlO1sARE",
	"radiobox_marked": "_2nHuFkLE",
	"icon-send": "_8Y9Ber_Z",
	"tooltip_text_outline": "_3gJrerV1",
	"trash_can_outline": "vMW2mf7M",
	"icon_arrow-left": "_1UnxPhDr",
	"icon_arrow-right": "_29WwKauL",
	"list": "_1qJkatcx",
	"tile": "_3OS1QNqn",
	"active": "_1bG_en2e",
	"list-item-icon-btn": "_3O2o3VJv",
	"default-checkbox-div": "_2b73eARt",
	"default-checkbox": "_9Tr3TBX1",
	"checkmark": "_3H_qxlUU",
	"radio": "_3h9bLako",
	"radio-label": "_3E2k5CMQ",
	"material-icons": "_22LBvfA0",
	"wcag-invisible": "-HyBLH0Y",
	"container": "_1W2bz0J8",
	"dropdown-container": "koePARn7",
	"input-search-container": "Oa1dJ4ZO",
	"input-search": "jq8UQIqc",
	"item": "Sr5Be3iJ",
	"selection-text": "_2dEXTXxK",
	"linking-text-container": "_3hUoPVAn",
	"linking-title": "_1N0m9daz",
	"linking-text": "_1u91aAw0",
	"bottom-panel": "_21UwjsdI",
	"bottom-buttons": "DwL8NJY-",
	"buttons-container": "_2VO7lqsb",
	"container-linked": "_2DWHVvL6",
	"selection-container": "_35Do-itA",
	"search-list": "_2PUIA0RV"
};

/***/ }),

/***/ 1355:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _reselect = __webpack_require__(221);
var _selectors = __webpack_require__(986);var _selectors2 = _interopRequireDefault(_selectors);
var _reselectors = __webpack_require__(542);var _reselectors2 = _interopRequireDefault(_reselectors);
var _authcheck = __webpack_require__(518);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
function wildcardLinkingMatcher(searchTerm) {
    if (searchTerm) {
        var term = searchTerm;
        term = term.replace(/[\\]/g, '\\\\');
        term = term.replace(/[\.\?\{\}\[\]\^\$]/g, function (x) {return '\\' + x;});
        term = term.replace(/\*/g, function (x) {return '.*';});
        term = term.replace(/\s+/g, ' ');
        term = term.split(' ').qSelect(function (x) {return '(?=.*' + x + ')';}).join('');
        var rx = new RegExp(term, 'i');
        return function (text) {return rx.test(text);};
    } else
    {
        return function (text) {return true;};
    }
}
var searchTermQuestionMatcherSelector = (0, _reselect.createSelector)(_selectors2.default.searchTermLinkingSelector, wildcardLinkingMatcher);exports.default =
{
    questionSelectorSearching: (0, _reselect.createSelector)(_reselectors2.default.questionsItemsSelector, _selectors2.default.linkitem, searchTermQuestionMatcherSelector, function (questions, linkitem, wildcardLinkingMatcher) {
        return questions.qWhere(function (x) {return wildcardLinkingMatcher(x.text) &&
            x.id !== linkitem.noteId &&
            linkitem.status === _authcheck.statusNieuw &&
            !x.parentId;});
    }) };

/***/ }),

/***/ 1356:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.QuestionInspectButtons = undefined;__webpack_require__(76);
var _react = __webpack_require__(648);
var _index = __webpack_require__(979);
var _types = __webpack_require__(245);
var _resource = __webpack_require__(106);
var _style = __webpack_require__(1004);var _style2 = _interopRequireDefault(_style);
var _selectors = __webpack_require__(649);var _selectors2 = _interopRequireDefault(_selectors);
var _selectors3 = __webpack_require__(651);var _selectors4 = _interopRequireDefault(_selectors3);
var _selectors5 = __webpack_require__(986);var _selectors6 = _interopRequireDefault(_selectors5);
var _selectors7 = __webpack_require__(977);var _selectors8 = _interopRequireDefault(_selectors7);
var _selectors9 = __webpack_require__(981);var _selectors10 = _interopRequireDefault(_selectors9);
var _resource2 = __webpack_require__(246);
var _focuslockext = __webpack_require__(978);var _focuslockext2 = _interopRequireDefault(_focuslockext);
var _selectors11 = __webpack_require__(975);var _selectors12 = _interopRequireDefault(_selectors11);
var _NOTES_INSPECT = __webpack_require__(544);var _NOTES_INSPECT2 = _interopRequireDefault(_NOTES_INSPECT);
var _details = __webpack_require__(1119);
var _button = __webpack_require__(973);
var _editChatArea = __webpack_require__(1066);
var _resource3 = __webpack_require__(517);

var _resource4 = __webpack_require__(233);
var _resource5 = __webpack_require__(223);
var _authcheck = __webpack_require__(518);
var _resource6 = __webpack_require__(234);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
(0, _react.PureConnect)('QuestionInspectModal')(function (state) {return {
        user: _selectors2.default.user(state),
        userparticipant: _resource2.participantsResource.selectors.items(state).qFirst(function (itm) {return itm.isUser;}),
        participantPopupVisible: _selectors8.default.visible(state),
        categoryPopupVisible: _selectors10.default.visible(state),
        updating: _resource3.notechatEditor.selectors.updating(state),
        creatingNote: _resource.notesEditor.selectors.creating(state),
        updatingNote: _resource.notesEditor.selectors.updating(state),
        selectNote: state.selection.creating,
        selectTextArea: state.selection.creating,
        screenSmall: _selectors12.default.small(state),
        isminimized: _selectors4.default.isminimized(state),
        flyoverVisible: state.flyover.visible,
        inspectItem: _selectors4.default.inspect(state),
        inspectQuestion: _selectors6.default.inspect(state),
        linking: _selectors6.default.linking(state),
        ismaximized: _selectors6.default.ismaximized(state) };},
function (dispatch) {return {
        cancelInspect: function cancelInspect() {return dispatch((0, _NOTES_INSPECT2.default)({ item: undefined }));},
        doinspect: function doinspect(item) {return dispatch((0, _NOTES_INSPECT2.default)({ item: item }));} };},
function (_ref) {var flyoverVisible = _ref.flyoverVisible,inspectItem = _ref.inspectItem,inspectQuestion = _ref.inspectQuestion,linking = _ref.linking,isminimized = _ref.isminimized,screenSmall = _ref.screenSmall,ismaximized = _ref.ismaximized,cancelInspect = _ref.cancelInspect,updating = _ref.updating,creatingNote = _ref.creatingNote,updatingNote = _ref.updatingNote,selectNote = _ref.selectNote,participantPopupVisible = _ref.participantPopupVisible,categoryPopupVisible = _ref.categoryPopupVisible,selectTextArea = _ref.selectTextArea;
    var visibleChatUpdate = updating && !creatingNote && !updatingNote && !selectNote && !participantPopupVisible && !categoryPopupVisible && !selectTextArea;
    var inspecting = !!inspectItem && inspectItem.isquestion;
    return _react.React.createElement(_index.Modal, { onEscKeyDown: function onEscKeyDown() {return cancelInspect();}, visible: !flyoverVisible && inspecting, type: screenSmall ? 'smallscreen' : ismaximized ? 'maximized' : 'center2nd', backdrop: true, minimized: isminimized, header: _react.React.createElement("div", { className: (0, _style2.default)('app') }) },
    _react.React.createElement("div", { className: (0, _style2.default)(!inspecting || isminimized ? 'wcag-invisible' : '', 'fields-container'), "aria-hidden": !inspecting || isminimized, "aria-labelledby": "Maak een notitie aan" },
    _react.React.createElement(_focuslockext2.default, { disabled: !inspecting },
    _react.React.createElement("div", { className: (0, _style2.default)('note-details', !flyoverVisible && !visibleChatUpdate && inspectItem && !linking ? '' : 'wcag-invisible') },
    _react.React.createElement(_details.QuestionDetailsControl, { item: inspectItem, itemQuestion: inspectQuestion }),
    _react.React.createElement(QuestionInspectButtons, { item: inspectItem })),
    _react.React.createElement("div", { className: (0, _style2.default)('chat-details', !flyoverVisible && visibleChatUpdate && inspectItem ? '' : 'wcag-invisible') },
    _react.React.createElement(_editChatArea.NoteChatEditArea, null),
    _react.React.createElement(_editChatArea.NoteChatSaveArea, null)))));
});
var QuestionInspectButtons = exports.QuestionInspectButtons = (0, _react.PureConnect)('QuestionInspectButtons')(function (state) {return {
        origin: state.notemenu.origin,
        screenSmall: _selectors12.default.small(state),
        isminimized: _selectors4.default.isminimized(state),
        inspectItem: _selectors4.default.inspect(state),
        flyoverVisible: state.flyover.visible,
        allparticipants: _resource2.participantsResource.selectors.items(state).qSelect(function (item) {return item;}),
        allparticipantsgroups: _resource4.usergroupResource.selectors.items(state).qSelect(function (item) {return item;}),
        allQuestions: _resource5.questionsResource.selectors.items(state),
        beheer: _resource6.beheerResource.selectors.items(state) };},
function (dispatch) {return {
        cancelInspect: function cancelInspect() {return dispatch((0, _NOTES_INSPECT2.default)({ item: undefined }));},
        editNote: function editNote(item) {
            dispatch((0, _NOTES_INSPECT2.default)({ item: undefined }));
            dispatch(_resource.notesEditor.actions.UPDATE({ item: item }));
        } };},
function (_ref2) {var inspectItem = _ref2.inspectItem,editNote = _ref2.editNote,flyoverVisible = _ref2.flyoverVisible,cancelInspect = _ref2.cancelInspect,allparticipants = _ref2.allparticipants,allQuestions = _ref2.allQuestions,allparticipantsgroups = _ref2.allparticipantsgroups,beheer = _ref2.beheer;
    var visible = !flyoverVisible && !!inspectItem && inspectItem.isquestion;
    var isShared = (0, _types.isSharedNote)(inspectItem);
    var currentUser = allparticipants.qWhere(function (i) {return i.isUser;}).qFirst();
    var currentUserId = currentUser ? currentUser.id : '';
    var admin = beheer && beheer.qAny() && beheer.qFirst();
    var itemQuestion = null;
    var status = _authcheck.statusNieuw;
    var canChange = false;
    if (inspectItem.isquestion) {
        itemQuestion = allQuestions.qFirst(function (o) {return o.noteId === inspectItem.id;});
        status = !!itemQuestion && itemQuestion.status ? itemQuestion.status : _authcheck.statusNieuw;
    }
    var canChange = !!itemQuestion && (0, _authcheck.canChangeQuestion)(_authcheck.statusses, status, currentUserId, allparticipantsgroups, admin) ||
    !itemQuestion && !isShared;
    return _react.React.createElement("div", { className: (0, _style2.default)('bottom-panel', !visible ? 'wcag-invisible' : ''), "aria-hidden": !visible, "aria-labelledby": "Sluit het inzien scherm" },
    _react.React.createElement("div", { className: (0, _style2.default)('buttons-container', !visible ? 'wcag-invisible' : '') },
    canChange ?
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Bewerken', "aria-haspopup": false, tabIndex: 0, disabled: false, onKeyDown: function onKeyDown(evt) {handleEnters(evt, function () {return editNote(inspectItem);});}, onClick: function onClick() {return editNote(inspectItem);} },
    _react.React.createElement("span", null, "Bewerken")) : null,
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', "aria-label": 'Sluiten', "aria-haspopup": false, tabIndex: 0, onKeyDown: function onKeyDown(evt) {
            handleEnters(evt, function () {cancelInspect();});
        }, onClick: function onClick() {cancelInspect();} },
    _react.React.createElement("span", null, "Sluiten"))));
});
function handleEnters(evt, funct) {
    if (evt.key === 'Enter') {
        evt.preventDefault();
        funct();
    }
}

/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.QuestionChangeStatusAreaSave = exports.QuestionChangeStatusArea = undefined;__webpack_require__(76);
var _react = __webpack_require__(648);
var _style = __webpack_require__(1004);var _style2 = _interopRequireDefault(_style);
var _button = __webpack_require__(973);
var _modal = __webpack_require__(979);
var _focuslockext = __webpack_require__(978);var _focuslockext2 = _interopRequireDefault(_focuslockext);
var _QUESTION_CHANGE_STATUS_BATCH_CANCEL = __webpack_require__(738);var _QUESTION_CHANGE_STATUS_BATCH_CANCEL2 = _interopRequireDefault(_QUESTION_CHANGE_STATUS_BATCH_CANCEL);
var _QUESTION_CHANGE_STATUS_BATCH = __webpack_require__(563);var _QUESTION_CHANGE_STATUS_BATCH2 = _interopRequireDefault(_QUESTION_CHANGE_STATUS_BATCH);
var _dropdownbasic = __webpack_require__(1067);var _dropdownbasic2 = _interopRequireDefault(_dropdownbasic);
var _authcheck = __webpack_require__(518);
var _resource = __webpack_require__(495);
var _resource2 = __webpack_require__(233);
var _OPEN_DROPDOWN_STATUS = __webpack_require__(662);var _OPEN_DROPDOWN_STATUS2 = _interopRequireDefault(_OPEN_DROPDOWN_STATUS);
var _selectors = __webpack_require__(986);var _selectors2 = _interopRequireDefault(_selectors);
var _QUESTION_APPLY_STATUS_BATCH = __webpack_require__(740);var _QUESTION_APPLY_STATUS_BATCH2 = _interopRequireDefault(_QUESTION_APPLY_STATUS_BATCH);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
(0, _react.PureConnect)('QuestionChangeStatusModal')(function (state) {return {
        changing: !!state.questionReducer.batchchange };},
function (dispatch) {return {
        onCancel: function onCancel() {dispatch((0, _QUESTION_CHANGE_STATUS_BATCH_CANCEL2.default)({ items: undefined, batchstatus: undefined, batchchange: false }));} };},
function (_ref) {var changing = _ref.changing,onCancel = _ref.onCancel;
    return _react.React.createElement(_modal.Modal, { onEscKeyDown: onCancel, visible: changing, type: "smallsize1", backdrop: true },
    _react.React.createElement("div", { className: (0, _style2.default)(!changing ? 'wcag-invisible' : '', 'fields-container'), "aria-hidden": !changing, "aria-labelledby": "Verwijder notitie" },
    _react.React.createElement(_focuslockext2.default, { disabled: !changing },
    _react.React.createElement(QuestionChangeStatusArea, null),
    _react.React.createElement(QuestionChangeStatusAreaSave, null))));
});
var QuestionChangeStatusArea = exports.QuestionChangeStatusArea = (0, _react.PureConnect)('QuestionChangeStatusArea')(function (state) {return {
        changing: !!state.questionReducer.batchchange,
        items: state.questionReducer.items,
        batchstatus: state.questionReducer.batchstatus,
        currentUser: _resource.useridResource.selectors.items(state),
        usergroups: _resource2.usergroupResource.selectors.items(state),
        dropdownStatusOpen: _selectors2.default.open(state) };},
function (dispatch) {return {
        showDropdownStatusBatch: function showDropdownStatusBatch(dropdownStatusOpen) {return dispatch((0, _OPEN_DROPDOWN_STATUS2.default)({ dropdownopen: dropdownStatusOpen }));},
        applyStatus: function applyStatus(items, batchstatus) {return dispatch((0, _QUESTION_APPLY_STATUS_BATCH2.default)({ items: items, batchstatus: batchstatus, batchchange: true }));} };},
function (_ref2) {var changing = _ref2.changing,items = _ref2.items,currentUser = _ref2.currentUser,usergroups = _ref2.usergroups,dropdownStatusOpen = _ref2.dropdownStatusOpen,showDropdownStatusBatch = _ref2.showDropdownStatusBatch,applyStatus = _ref2.applyStatus,batchstatus = _ref2.batchstatus;
    var currentUserid = currentUser.length > 0 ? currentUser[0].id : '';
    var statussesallowed = (0, _authcheck.statussesallowedbatch)(_authcheck.statusses, items, currentUserid, usergroups);
    var status = batchstatus ? batchstatus.id : statussesallowed.qAny() ? statussesallowed.qFirst().id : _authcheck.statusNieuw;
    var statusitems = [];
    var statusSelectie = undefined;
    if (statussesallowed && currentUserid && usergroups) {
        statusitems = statussesallowed.map(function (status) {
            var dropDownItem = {
                key: status.id,
                name: status.name.toUpperCase(),
                statusclass: 'status-' + status.id.toString(),
                prefix: 'status-' };

            return dropDownItem;
        });
    }
    statusSelectie = statusitems && statusitems.length && status ? _react.React.createElement(_dropdownbasic2.default, { title: 'Status', value: status, items: statusitems, extraclass: 'status-class', prefix: 'status-', toggleDropDown: function toggleDropDown(key) {showDropdownStatusBatch(!dropdownStatusOpen);}, itemSelection: function itemSelection(key) {
            batchstatus = key ? statussesallowed.qFirst(function (itm) {return itm.id === key;}) : statussesallowed.qFirst();
            applyStatus(items, batchstatus);
        } }) : null;
    return _react.React.createElement("div", { className: (0, _style2.default)(!changing ? 'wcag-invisible' : '', 'warning'), "aria-hidden": !changing, "aria-labelledby": "Verwijder notitie" },
    _react.React.createElement("div", { className: (0, _style2.default)('warning-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('warning-title') }, "Status vraag wijzigen"),
    _react.React.createElement("div", { className: (0, _style2.default)('warning-content') },
    _react.React.createElement("div", null, statusSelectie),
    _react.React.createElement("p", null,
    "U staat op het punt de status van ",
    _react.React.createElement("span", { className: (0, _style2.default)('name-label') },
    items ? items.length : 0,
    " vragen"),
    " te veranderen."),
    _react.React.createElement("p", { className: (0, _style2.default)('medium') }, "Deze actie kunt u niet ongedaan maken."))));
});
var QuestionChangeStatusAreaSave = exports.QuestionChangeStatusAreaSave = (0, _react.PureConnect)('QuestionChangeStatusAreaSave')(function (state) {return {
        changing: !!state.questionReducer.batchchange,
        items: state.questionReducer.items,
        batchstatus: state.questionReducer.batchstatus,
        origin: state.notemenu.origin };},
function (dispatch) {return {
        onCancel: function onCancel() {dispatch((0, _QUESTION_CHANGE_STATUS_BATCH_CANCEL2.default)({ items: undefined, batchstatus: undefined, batchchange: false }));},
        onSave: function onSave(items, batchstatus) {return dispatch((0, _QUESTION_CHANGE_STATUS_BATCH2.default)({ items: items, batchstatus: batchstatus, batchchange: true }));} };},
function (_ref3) {var changing = _ref3.changing,items = _ref3.items,onCancel = _ref3.onCancel,onSave = _ref3.onSave,batchstatus = _ref3.batchstatus;
    return _react.React.createElement("div", { className: (0, _style2.default)(!changing ? 'wcag-invisible' : '', 'fields-container'), "aria-hidden": !changing, "aria-labelledby": "Verwijder notitie" },
    _react.React.createElement("div", { className: (0, _style2.default)('bottom-buttons-container') },
    _react.React.createElement("div", { className: (0, _style2.default)('buttons-container', !changing ? 'wcag-invisible' : '') },
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', extraClassNames: 'secondary-btn', "aria-label": 'Annuleren', "aria-haspopup": false, tabIndex: 0, onKeyDown: function onKeyDown(evt) {return onCancel();}, onClick: function onClick(evt) {return onCancel();} },
    _react.React.createElement("span", null, "Annuleren")),
    _react.React.createElement(_button.Btn, { type: "button", className: 'btn', "aria-label": 'Verander status', "aria-haspopup": false, tabIndex: 0, disabled: false, onKeyDown: function onKeyDown(evt) {return onSave(items, batchstatus);}, onClick: function onClick(evt) {return onSave(items, batchstatus);} },
    _react.React.createElement("span", null, "Verander status")))));
});

/***/ }),

/***/ 967:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);var _for = __webpack_require__(520);var _for2 = _interopRequireDefault(_for);var _symbol = __webpack_require__(69);var _symbol2 = _interopRequireDefault(_symbol);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} /**
                                                                                                                                                                                                                                                                                                                                                                                                                        * Copyright (c) 2013-present, Facebook, Inc.
                                                                                                                                                                                                                                                                                                                                                                                                                        *
                                                                                                                                                                                                                                                                                                                                                                                                                        * This source code is licensed under the MIT license found in the
                                                                                                                                                                                                                                                                                                                                                                                                                        * LICENSE file in the root directory of this source tree.
                                                                                                                                                                                                                                                                                                                                                                                                                        */

if (false) {
  var REACT_ELEMENT_TYPE = typeof _symbol2.default === 'function' && _for2.default &&

  (0, _for2.default)('react.element') ||
  0xeac7;

  var isValidElement = function isValidElement(object) {
    return (typeof object === 'undefined' ? 'undefined' : (0, _typeof3.default)(object)) === 'object' &&
    object !== null &&
    object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1006)();
}

/***/ }),

/***/ 970:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _react = __webpack_require__(648);
__webpack_require__(245);
var _component = __webpack_require__(1327);var _component2 = _interopRequireDefault(_component);
var _noteEditModal = __webpack_require__(1328);
var _noteInspectModal = __webpack_require__(1329);var _noteInspectModal2 = _interopRequireDefault(_noteInspectModal);
var _batchDeleteModal = __webpack_require__(1330);var _batchDeleteModal2 = _interopRequireDefault(_batchDeleteModal);
var _noteDeleteModal = __webpack_require__(1331);var _noteDeleteModal2 = _interopRequireDefault(_noteDeleteModal);
var _batchDeleteModal3 = __webpack_require__(1332);var _batchDeleteModal4 = _interopRequireDefault(_batchDeleteModal3);
var _editModal = __webpack_require__(1335);var _editModal2 = _interopRequireDefault(_editModal);
var _batchDeleteModal5 = __webpack_require__(1336);var _batchDeleteModal6 = _interopRequireDefault(_batchDeleteModal5);
var _deleteModal = __webpack_require__(1337);var _deleteModal2 = _interopRequireDefault(_deleteModal);
var _categoryEditModal = __webpack_require__(1338);var _categoryEditModal2 = _interopRequireDefault(_categoryEditModal);
var _editModal3 = __webpack_require__(1339);var _editModal4 = _interopRequireDefault(_editModal3);
var _inspectModal = __webpack_require__(1342);var _inspectModal2 = _interopRequireDefault(_inspectModal);
var _deleteModal3 = __webpack_require__(1343);var _deleteModal4 = _interopRequireDefault(_deleteModal3);
var _editFactionModal = __webpack_require__(1344);var _editFactionModal2 = _interopRequireDefault(_editFactionModal);
var _editRoleModal = __webpack_require__(1345);var _editRoleModal2 = _interopRequireDefault(_editRoleModal);
var _editModal5 = __webpack_require__(1346);var _editModal6 = _interopRequireDefault(_editModal5);
var _questionEditModal = __webpack_require__(1350);
var _questionInspectModal = __webpack_require__(1356);var _questionInspectModal2 = _interopRequireDefault(_questionInspectModal);
var _batchChangeStatusModal = __webpack_require__(1357);var _batchChangeStatusModal2 = _interopRequireDefault(_batchChangeStatusModal);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
(0, _react.PureFunctional)('NoteUI')(function () {return _react.React.createElement("div", null,
    _react.React.createElement(_component2.default, null),
    _react.React.createElement(_noteEditModal.NotesEditModal, null),
    _react.React.createElement(_questionEditModal.QuestionEditModal, null),
    _react.React.createElement(_noteInspectModal2.default, null),
    _react.React.createElement(_questionInspectModal2.default, null),
    _react.React.createElement(_batchChangeStatusModal2.default, null),
    _react.React.createElement(_noteDeleteModal2.default, null),
    _react.React.createElement(_batchDeleteModal2.default, null),
    _react.React.createElement(_editModal2.default, null),
    _react.React.createElement(_batchDeleteModal4.default, null),
    _react.React.createElement(_categoryEditModal2.default, null),
    _react.React.createElement(_deleteModal2.default, null),
    _react.React.createElement(_batchDeleteModal6.default, null),
    _react.React.createElement(_deleteModal2.default, null),
    _react.React.createElement(_editModal4.default, null),
    _react.React.createElement(_editFactionModal2.default, null),
    _react.React.createElement(_editRoleModal2.default, null),
    _react.React.createElement(_inspectModal2.default, null),
    _react.React.createElement(_deleteModal4.default, null),
    _react.React.createElement(_editModal6.default, null));});

/***/ }),

/***/ 973:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.Btn = undefined;var _getPrototypeOf = __webpack_require__(232);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(105);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(110);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(515);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _inherits2 = __webpack_require__(516);var _inherits3 = _interopRequireDefault(_inherits2);var _react = __webpack_require__(171);var _react2 = _interopRequireDefault(_react);
var _button = __webpack_require__(1042);var _button2 = _interopRequireDefault(_button);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var
Btn = exports.Btn = function (_React$Component) {(0, _inherits3.default)(Btn, _React$Component);
    function Btn() {(0, _classCallCheck3.default)(this, Btn);var _this = (0, _possibleConstructorReturn3.default)(this, (Btn.__proto__ || (0, _getPrototypeOf2.default)(Btn)).apply(this,
        arguments));
        _this.className = _this.props.className;
        _this.type = _this.props.type;
        _this.role = _this.props.role;
        _this.disabled = _this.props.disabled;
        _this.extraClassNames = _this.props.extraClassNames ? _this.props.extraClassNames : [];
        _this.arialabel = _this.props['aria-label'];
        _this.ariahaspopup = _this.props['has-popup'];
        _this.tabIndex = _this.props.tabIndex;
        _this.allClassNames = [];return _this;
    }(0, _createClass3.default)(Btn, [{ key: 'render', value: function render()
        {var _this2 = this;
            this.allClassNames = [this.className];
            if (this.extraClassNames)
            this.allClassNames = this.allClassNames.concat(this.extraClassNames);
            if (this.props.disabled)
            this.allClassNames = this.allClassNames.concat('disabled');
            var button = _react2.default.createElement("button", { type: this.type, role: this.role, disabled: this.props.disabled, tabIndex: this.tabIndex, "aria-label": this.arialabel, "aria-haspopup": this.ariahaspopup, className: (0, _button2.default)(this.allClassNames), onClick: function onClick() {return _this2.props.onClick();} }, this.props.children);
            return button;
        } }]);return Btn;}(_react2.default.Component);

/***/ }),

/***/ 975:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _reselect = __webpack_require__(221);
var _reducer = __webpack_require__(661);
var smallScreenSize = 800;exports.default =
{
    dimensions: (0, _reselect.createSelector)(_reducer.selector, function (state) {return state;}),
    landscape: (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.width > state.height;}),
    portrait: (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.width <= state.height;}),
    small: (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.width <= smallScreenSize;}),
    width: (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.width;}),
    height: (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.height;}) };

/***/ }),

/***/ 976:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var toArray = exports.toArray = function toArray(a) {
  var ret = Array(a.length);
  for (var i = 0; i < a.length; ++i) {
    ret[i] = a[i];
  }
  return ret;
};

var arrayFind = exports.arrayFind = function arrayFind(array, search) {
  return array.filter(function (a) {
    return a === search;
  })[0];
};

var asArray = exports.asArray = function asArray(a) {
  return Array.isArray(a) ? a : [a];
};

/***/ }),

/***/ 977:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _reselect = __webpack_require__(221);
var _reducer = __webpack_require__(692);exports.default =
{
    participants: (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.participants;}),
    usergroups: (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.usergroups;}),
    visible: (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.visible;}),
    visibleitemnumber: (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.itemno;}),
    searchTermParticipantSelector: (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.searchTermParticipant;}),
    searchTermUsergroupSelector: (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.searchTermUsergroup;}) };

/***/ }),

/***/ 978:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _getPrototypeOf = __webpack_require__(232);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(105);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(110);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(515);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _inherits2 = __webpack_require__(516);var _inherits3 = _interopRequireDefault(_inherits2);var _react = __webpack_require__(171);var _react2 = _interopRequireDefault(_react);
var _reactFocusLock = __webpack_require__(991);var _reactFocusLock2 = _interopRequireDefault(_reactFocusLock);
var _reactDom = __webpack_require__(658);var _reactDom2 = _interopRequireDefault(_reactDom);
var _launch = __webpack_require__(235);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var TAB_KEY = 9;var
FocusLockFocusGuard = function (_React$Component) {(0, _inherits3.default)(FocusLockFocusGuard, _React$Component);
    function FocusLockFocusGuard() {(0, _classCallCheck3.default)(this, FocusLockFocusGuard);var _this = (0, _possibleConstructorReturn3.default)(this, (FocusLockFocusGuard.__proto__ || (0, _getPrototypeOf2.default)(FocusLockFocusGuard)).apply(this,
        arguments));
        _this.queryString = 'button:not([disabled]):not([disabled="true"]):not([tabindex="-1"]), [href], input:not([type="reset"]), select, textarea, [tabindex]:not([tabindex="-1"]), video';
        _this.disabled = _this.props.disabled;
        _this.functiondisabled = _this.props.functiondisabled;
        _this.className = _this.props.className;
        _this.config = { attributes: true, childList: true, subtree: true };
        _this.ref = _react2.default.createRef();return _this;
    }(0, _createClass3.default)(FocusLockFocusGuard, [{ key: 'tablastItem', value: function tablastItem(
        event, tabToItem, tabItems) {
            if (event.keyCode === TAB_KEY && !event.shiftKey && event.target === tabItems[tabItems.length - 1]) {
                event.preventDefault();
                tabToItem.focus();
            }
        } }, { key: 'shifttabfirstItem', value: function shifttabfirstItem(
        event, tabToItem, tabItems) {
            if (event.keyCode === TAB_KEY && event.shiftKey && event.target === tabItems[0]) {
                event.preventDefault();
                tabToItem.focus();
            }
        } }, { key: 'componentDidMount', value: function componentDidMount()
        {var _this2 = this;
            var node = _reactDom2.default.findDOMNode(this);
            if (node) {
                this.focusableItems = node.querySelectorAll(this.queryString);
                this.firstfocusableitem = this.focusableItems[0];
                this.lastfocusableitem = this.focusableItems[this.focusableItems.length - 1];
                this.lastfocusableitem.addEventListener('keydown', function (event) {_this2.tablastItem(event, _this2.firstfocusableitem, _this2.focusableItems);}, true);
                this.firstfocusableitem.addEventListener('keydown', function (event) {_this2.shifttabfirstItem(event, _this2.lastfocusableitem, _this2.focusableItems);}, true);
                this.observer =
                new MutationObserver(function () {
                    var currentFocussableItems = node.querySelectorAll(_this2.queryString);
                    if (_this2.focusableItems && currentFocussableItems) {
                        if (_this2.focusableItems.length !== currentFocussableItems.length) {
                            if (_this2.lastfocusableitem && _this2.firstfocusableitem) {
                                _this2.lastfocusableitem.removeEventListener('keydown', function (event) {_this2.tablastItem(event, _this2.firstfocusableitem, _this2.focusableItems);}, true);
                                _this2.firstfocusableitem.removeEventListener('keydown', function (event) {_this2.shifttabfirstItem(event, _this2.lastfocusableitem, _this2.focusableItems);}, true);
                            }
                            _this2.focusableItems = currentFocussableItems;
                            _this2.firstfocusableitem = _this2.focusableItems[0];
                            _this2.lastfocusableitem = _this2.focusableItems[_this2.focusableItems.length - 1];
                            _this2.lastfocusableitem.addEventListener('keydown', function (event) {_this2.tablastItem(event, _this2.firstfocusableitem, _this2.focusableItems);}, true);
                            _this2.firstfocusableitem.addEventListener('keydown', function (event) {_this2.shifttabfirstItem(event, _this2.lastfocusableitem, _this2.focusableItems);}, true);
                        }
                    }
                }).
                observe(this.ref.current, this.config);
            }
        } }, { key: 'componentDidUpdate', value: function componentDidUpdate()
        {var _this3 = this;
            if (this.observer) {
                this.observer.disconnect();
            }
            if (this.lastfocusableitem && this.firstfocusableitem) {
                this.lastfocusableitem.removeEventListener('keydown', function (event) {_this3.tablastItem(event, _this3.firstfocusableitem, _this3.focusableItems);}, true);
                this.firstfocusableitem.removeEventListener('keydown', function (event) {_this3.shifttabfirstItem(event, _this3.lastfocusableitem, _this3.focusableItems);}, true);
            }
            if (this.lastfocusableitem && this.firstfocusableitem) {
                var node = _reactDom2.default.findDOMNode(this);
                this.focusableItems = node.querySelectorAll(this.queryString);
                this.firstfocusableitem = this.focusableItems[0];
                this.lastfocusableitem = this.focusableItems[this.focusableItems.length - 1];
                this.lastfocusableitem.addEventListener('keydown', function (event) {_this3.tablastItem(event, _this3.firstfocusableitem, _this3.focusableItems);}, true);
                this.firstfocusableitem.addEventListener('keydown', function (event) {_this3.shifttabfirstItem(event, _this3.lastfocusableitem, _this3.focusableItems);}, true);
            }
        } }, { key: 'componentWillReceiveProps', value: function componentWillReceiveProps(
        nextProps) {var _this4 = this;
            if (this.props.disabled !== nextProps.disabled && nextProps.disabled) {
                if (this.props.functiondisabled) {
                    _launch.hack.store.dispatch(this.props.functiondisabled);
                }
            }
            if (this.props.disabled !== nextProps.disabled && !nextProps.disabled) {
                if (this.firstfocusableitem) {
                    setTimeout(function () {_this4.firstfocusableitem.focus();}, 500);
                }
            }
        } }, { key: 'componentWillUnmount', value: function componentWillUnmount()
        {var _this5 = this;
            if (this.observer) {
                this.observer.disconnect();
            }
            if (this.lastfocusableitem && this.firstfocusableitem) {
                this.lastfocusableitem.removeEventListener('keydown', function (event) {_this5.tablastItem(event, _this5.focusableItems, _this5.focusableItems);}, true);
                this.firstfocusableitem.removeEventListener('keydown', function (event) {_this5.shifttabfirstItem(event, _this5.focusableItems, _this5.focusableItems);}, true);
            }
        } }, { key: 'render', value: function render()
        {
            return _react2.default.createElement(_reactFocusLock2.default, { className: this.className, noFocusGuards: true, disabled: this.disabled },
            _react2.default.createElement("div", { className: this.className, ref: this.ref }, this.props.children));
        } }]);return FocusLockFocusGuard;}(_react2.default.Component);exports.default = FocusLockFocusGuard;

/***/ }),

/***/ 979:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.Modal = undefined;var _getPrototypeOf = __webpack_require__(232);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(105);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(110);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(515);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _inherits2 = __webpack_require__(516);var _inherits3 = _interopRequireDefault(_inherits2);var _defineProperty = __webpack_require__(161);var _defineProperty2 = _interopRequireDefault(_defineProperty);var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);var _getOwnPropertyDescriptor = __webpack_require__(652);var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);





var _reactMotion = __webpack_require__(1002);
var _react = __webpack_require__(648);
var _plain = __webpack_require__(1063);var _plain2 = _interopRequireDefault(_plain);
var _selectors = __webpack_require__(545);var _selectors2 = _interopRequireDefault(_selectors);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {var c = arguments.length,r = c < 3 ? target : desc === null ? desc = (0, _getOwnPropertyDescriptor2.default)(target, key) : desc,d;if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeof3.default)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;}return c > 3 && r && (0, _defineProperty2.default)(target, key, r), r;};
var styles = {
    center: [{ translateY: -0.1, opacity: 0 }, { translateY: (0, _reactMotion.spring)(-0.1), opacity: (0, _reactMotion.spring)(0) }, { translateY: (0, _reactMotion.spring)(0), opacity: (0, _reactMotion.spring)(1) }, { translateY: 0, opacity: 1 }],
    center2nd: [{ translateY: -0.1, opacity: 0 }, { translateY: (0, _reactMotion.spring)(-0.1), opacity: (0, _reactMotion.spring)(0) }, { translateY: (0, _reactMotion.spring)(0), opacity: (0, _reactMotion.spring)(1) }, { translateY: 0, opacity: 1 }],
    smallscreen: [{ translateY: -0.1, opacity: 0 }, { translateY: (0, _reactMotion.spring)(-0.1), opacity: (0, _reactMotion.spring)(0) }, { translateY: (0, _reactMotion.spring)(0), opacity: (0, _reactMotion.spring)(1) }, { translateY: 0, opacity: 1 }],
    maximized: [{ translateY: -0.1, opacity: 0 }, { translateY: (0, _reactMotion.spring)(-0.1), opacity: (0, _reactMotion.spring)(0) }, { translateY: (0, _reactMotion.spring)(0), opacity: (0, _reactMotion.spring)(1) }, { translateY: 0, opacity: 1 }],
    smallsize1: [{ translateY: -0.1, opacity: 0 }, { translateY: (0, _reactMotion.spring)(-0.1), opacity: (0, _reactMotion.spring)(0) }, { translateY: (0, _reactMotion.spring)(0), opacity: (0, _reactMotion.spring)(1) }, { translateY: 0, opacity: 1 }],
    flyover: [{ translateY: 1.1, opacity: 1 }, { translateY: (0, _reactMotion.spring)(1.1), opacity: 1 }, { translateY: (0, _reactMotion.spring)(0), opacity: 1 }, { translateY: 0, opacity: 1 }],
    flyover2: [{ translateY: 1.1, opacity: 1 }, { translateY: (0, _reactMotion.spring)(1.1), opacity: 1 }, { translateY: (0, _reactMotion.spring)(0), opacity: 1 }, { translateY: 0, opacity: 1 }],
    top: [{ translateY: -1, opacity: 0 }, { translateY: (0, _reactMotion.spring)(-1), opacity: (0, _reactMotion.spring)(0) },
    { translateY: (0, _reactMotion.spring)(0), opacity: (0, _reactMotion.spring)(1) }, { translateY: 0, opacity: 1 }] };

var styleHidden = 1;
var styleVisible = 2;
var modalZIndex = 500;
var Modal = function (_React$Component) {(0, _inherits3.default)(Modal, _React$Component);
    function Modal() {(0, _classCallCheck3.default)(this, Modal);var _this = (0, _possibleConstructorReturn3.default)(this, (Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).apply(this,
        arguments));
        _this.state = {
            zIndex: ++modalZIndex };return _this;

    }(0, _createClass3.default)(Modal, [{ key: "render", value: function render()
        {var _props =
            this.props,visible = _props.visible,type = _props.type,header = _props.header,arialabel = _props.arialabel,onClick = _props.onClick,onEscKeyDown = _props.onEscKeyDown,backdrop = _props.backdrop,minimized = _props.minimized,children = _props.children;var
            zIndex = this.state.zIndex;
            var translateY = visible ? styles[type][styleVisible].translateY["val"] : styles[type][styleHidden].translateY["val"];
            var opacity = visible ? styles[type][styleVisible].opacity["val"] : styles[type][styleHidden].opacity["val"];
            return opacity === 0 ? null :
            _react.React.createElement(_plain2.default, { transform: { zIndex: opacity === 0 ? 0 : zIndex, opacity: opacity, translateY: percentage(translateY) + "%" }, visible: visible, type: type, header: header, arialabel: arialabel, onClick: onClick, onEscKeyDown: onEscKeyDown, backdrop: backdrop, minimized: minimized }, children);
        } }, { key: "componentWillReceiveProps", value: function componentWillReceiveProps(
        nextProps) {
            if (this.props.visible !== nextProps.visible && nextProps.visible) {
                this.setState({ zIndex: ++modalZIndex });
            }
        } }]);return Modal;}(_react.React.Component);

exports.




Modal = Modal = __decorate([(0, _react.Connect)(function (state) {return { avoidSlideIn: _selectors2.default.restoringSession(state) };}, null)], Modal);exports.Modal = Modal;
function percentage(r) {
    var m = 100;
    return r * m;
}

/***/ }),

/***/ 980:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.getAllAffectedNodes = exports.constants = exports.getFocusabledIn = exports.focusMerge = exports.focusIsHidden = exports.focusInside = exports.tabHook = undefined;var _tabHook = __webpack_require__(1026);var _tabHook2 = _interopRequireDefault(_tabHook);
var _focusMerge = __webpack_require__(1000);var _focusMerge2 = _interopRequireDefault(_focusMerge);
var _focusInside = __webpack_require__(1032);var _focusInside2 = _interopRequireDefault(_focusInside);
var _focusIsHidden = __webpack_require__(1033);var _focusIsHidden2 = _interopRequireDefault(_focusIsHidden);
var _setFocus = __webpack_require__(1034);var _setFocus2 = _interopRequireDefault(_setFocus);
var _constants = __webpack_require__(983);var constants = _interopRequireWildcard(_constants);
var _allAffected = __webpack_require__(989);var _allAffected2 = _interopRequireDefault(_allAffected);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.

tabHook = _tabHook2.default;exports.focusInside = _focusInside2.default;exports.focusIsHidden = _focusIsHidden2.default;exports.focusMerge = _focusMerge2.default;exports.getFocusabledIn = _focusMerge.getFocusabledIn;exports.constants = constants;exports.getAllAffectedNodes = _allAffected2.default;exports.default = _setFocus2.default;

/***/ }),

/***/ 981:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _reselect = __webpack_require__(221);
var _reducer = __webpack_require__(690);exports.default =
{
    categoryId: (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.categoryId;}),
    visible: (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.visible;}) };

/***/ }),

/***/ 982:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _assign = __webpack_require__(77);var _assign2 = _interopRequireDefault(_assign);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _extends() {
  module.exports = _extends = _assign2.default || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),

/***/ 983:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var FOCUS_GROUP = exports.FOCUS_GROUP = 'data-focus-lock';
var FOCUS_DISABLED = exports.FOCUS_DISABLED = 'data-focus-lock-disabled';
var FOCUS_ALLOW = exports.FOCUS_ALLOW = 'data-no-focus-lock';
var FOCUS_AUTO = exports.FOCUS_AUTO = 'data-autofocus-inside';

/***/ }),

/***/ 984:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.deferAction = deferAction;function deferAction(action) {
  // Hidding setImmediate from Webpack to avoid inserting polyfill
  var setImmediate = window.setImmediate;

  if (typeof setImmediate !== 'undefined') {
    setImmediate(action);
  } else {
    setTimeout(action, 1);
  }
}
var inlineProp = exports.inlineProp = function inlineProp(name, value) {
  var obj = {};
  obj[name] = value;
  return obj;
};

/***/ }),

/***/ 985:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _isPlaceholder = __webpack_require__(1015);


/**
                                                                * Optimized internal one-arity curry function.
                                                                *
                                                                * @private
                                                                * @category Function
                                                                * @param {Function} fn The function to curry.
                                                                * @return {Function} The curried function.
                                                                */
module.exports = function _curry1(fn) {
  return function f1(a) {
    if (arguments.length === 0 || _isPlaceholder(a)) {
      return f1;
    } else {
      return fn.apply(this, arguments);
    }
  };
};

/***/ }),

/***/ 986:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _reselect = __webpack_require__(221);
var _resource = __webpack_require__(106);
var _resource2 = __webpack_require__(223);
var _reducer = __webpack_require__(701);
var questionItemSelector = (0, _reselect.createSelector)(_resource.notesEditor.selectors.item, _resource2.questionsEditor.selectors.item, function (item, itemQuestion) {
    var question = item;
    if (itemQuestion.noteId === item.id) {
        var quest = itemQuestion;
        if (quest) {
            question.status = quest.status;
            question.antwoordConcern = quest.antwoordConcern;
            question.practicionerId = quest.practicionerId;
        }
    }
    return question;
});exports.default =
{
    currentitem: function currentitem(state) {return state.questionReducer.questionselected;},
    questionItemSelector: questionItemSelector,
    open: function open(state) {return state.questionReducer && !!state.questionReducer.dropdownopen;},
    opendropdownPracticioner: function opendropdownPracticioner(state) {return state.questionReducer && !!state.questionReducer.dropdownopenPracticioner;},
    inspect: function inspect(state) {return state ? state.questionReducer.inspect : {};},
    linking: function linking(state) {return state ? state.questionReducer.linkvisible : false;},
    showlinks: function showlinks(state) {return state ? state.questionReducer.showlinks : false;},
    showitem: function showitem(state) {return state ? state.questionReducer.showitem : false;},
    ismaximized: function ismaximized(state) {return state ? state.questionReducer.maximized : false;},
    linkitem: (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.linkitem;}),
    searchTermLinkingSelector: (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.searchTermLinking;}) };

/***/ }),

/***/ 987:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.DateTimeText = exports.DateText = undefined;var _react = __webpack_require__(648);
var DateText = exports.DateText = function DateText(_ref) {var date = _ref.date;return _react.React.createElement("span", null, new Date(date).toLocaleDateString('nl-NL', { day: 'numeric', month: 'long', year: 'numeric' }));};
var DateTimeText = exports.DateTimeText = function DateTimeText(_ref2) {var date = _ref2.date;return _react.React.createElement("span", null,
    new Date(date).toLocaleDateString('nl-NL', { day: 'numeric', month: 'long', year: 'numeric' }),
    ",",
    new Date(date).toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' }));};

/***/ }),

/***/ 988:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _assign = __webpack_require__(77);var _assign2 = _interopRequireDefault2(_assign);function _interopRequireDefault2(obj) {return obj && obj.__esModule ? obj : { default: obj };}

Object.defineProperty(exports, "__esModule", {
  value: true });

exports.FontIcon = undefined;

var _extends = _assign2.default || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};

var _react = __webpack_require__(171);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(967);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(993);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}

var FontIcon = function FontIcon(_ref) {
  var alt = _ref.alt,
  children = _ref.children,
  className = _ref.className,
  theme = _ref.theme,
  value = _ref.value,
  other = _objectWithoutProperties(_ref, ['alt', 'children', 'className', 'theme', 'value']);

  return (// eslint-disable-line
    _react2.default.createElement(
    'span',
    _extends({
      'data-react-toolbox': 'font-icon',
      'aria-label': alt,
      className: (0, _classnames2.default)({ 'material-icons': typeof value === 'string' || typeof children === 'string' }, className) },
    other),
    value,
    children));


};

FontIcon.propTypes = {
  alt: _propTypes2.default.string,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  theme: _propTypes2.default.object, // eslint-disable-line
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]) };


FontIcon.defaultProps = {
  alt: '',
  className: '' };


exports.default = FontIcon;
exports.FontIcon = FontIcon;

/***/ }),

/***/ 989:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _iterator = __webpack_require__(79);var _iterator2 = _interopRequireDefault(_iterator);var _typeof3 = __webpack_require__(25);var _typeof4 = _interopRequireDefault(_typeof3);var _symbol = __webpack_require__(69);var _symbol2 = _interopRequireDefault(_symbol);

var _constants = __webpack_require__(983);
var _array = __webpack_require__(976);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _typeof = typeof _symbol2.default === "function" && (0, _typeof4.default)(_iterator2.default) === "symbol" ? function (obj) {return typeof obj === "undefined" ? "undefined" : (0, _typeof4.default)(obj);} : function (obj) {return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, _typeof4.default)(obj);};

var filterNested = function filterNested(nodes) {
  var l = nodes.length;
  for (var i = 0; i < l; i += 1) {
    var _loop = function _loop(j) {
      if (i !== j) {
        if (nodes[i].contains(nodes[j])) {
          return {
            v: filterNested(nodes.filter(function (x) {
              return x !== nodes[j];
            })) };

        }
      }
    };

    for (var j = 0; j < l; j += 1) {
      var _ret = _loop(j);

      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
    }
  }
  return nodes;
};

var getTopParent = function getTopParent(node) {
  return node.parentNode ? getTopParent(node.parentNode) : node;
};

var getAllAffectedNodes = function getAllAffectedNodes(node) {
  var nodes = (0, _array.asArray)(node);
  return nodes.filter(Boolean).reduce(function (acc, currentNode) {
    var group = currentNode.getAttribute(_constants.FOCUS_GROUP);
    acc.push.apply(acc, group ? filterNested((0, _array.toArray)(getTopParent(currentNode).querySelectorAll('[' + _constants.FOCUS_GROUP + '="' + group + '"]:not([' + _constants.FOCUS_DISABLED + '="disabled"])'))) : [currentNode]);
    return acc;
  }, []);
};exports.default =

getAllAffectedNodes;module.exports = exports["default"];

/***/ }),

/***/ 990:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true });

exports.Input = undefined;

var _reactCssThemr = __webpack_require__(994);

var _identifiers = __webpack_require__(995);

var _Input = __webpack_require__(1123);

var _FontIcon = __webpack_require__(988);

var _theme = __webpack_require__(1137);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var Input = (0, _Input.inputFactory)(_FontIcon.FontIcon);
var ThemedInput = (0, _reactCssThemr.themr)(_identifiers.INPUT, _theme2.default, { withRef: true })(Input);

exports.default = ThemedInput;
exports.Input = ThemedInput;

/***/ }),

/***/ 991:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.InFocusGuard = exports.FreeFocusInside = exports.MoveFocusInside = exports.AutoFocusInside = undefined;var _Lock = __webpack_require__(1025);var _Lock2 = _interopRequireDefault(_Lock);
var _AutoFocusInside = __webpack_require__(1039);var _AutoFocusInside2 = _interopRequireDefault(_AutoFocusInside);
var _MoveFocusInside = __webpack_require__(1040);var _MoveFocusInside2 = _interopRequireDefault(_MoveFocusInside);
var _FreeFocusInside = __webpack_require__(1041);var _FreeFocusInside2 = _interopRequireDefault(_FreeFocusInside);
var _FocusGuard = __webpack_require__(1001);var _FocusGuard2 = _interopRequireDefault(_FocusGuard);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.
AutoFocusInside = _AutoFocusInside2.default;exports.MoveFocusInside = _MoveFocusInside2.default;exports.FreeFocusInside = _FreeFocusInside2.default;exports.InFocusGuard = _FocusGuard2.default;exports.default = _Lock2.default;

/***/ }),

/***/ 992:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}



exports.__esModule = true;
exports['default'] = stripStyle;

function stripStyle(style) {
  var ret = {};
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }
    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),

/***/ 993:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} /*!
                                                                                                                                                                                                                    Copyright (c) 2016 Jed Watson.
                                                                                                                                                                                                                    Licensed under the MIT License (MIT), see
                                                                                                                                                                                                                    http://jedwatson.github.io/classnames
                                                                                                                                                                                                                  */
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg === 'undefined' ? 'undefined' : (0, _typeof3.default)(arg);

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if ("function" === 'function' && (0, _typeof3.default)(__webpack_require__(653)) === 'object' && __webpack_require__(653)) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
})();

/***/ }),

/***/ 994:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _ThemeProvider = __webpack_require__(1091);

Object.defineProperty(exports, 'ThemeProvider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ThemeProvider).default;
  } });


var _themr = __webpack_require__(1093);

Object.defineProperty(exports, 'themr', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_themr).default;
  } });

Object.defineProperty(exports, 'themeable', {
  enumerable: true,
  get: function get() {
    return _themr.themeable;
  } });


function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

/***/ }),

/***/ 995:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true });

var APP_BAR = exports.APP_BAR = 'RTAppBar';
var AUTOCOMPLETE = exports.AUTOCOMPLETE = 'RTAutocomplete';
var AVATAR = exports.AVATAR = 'RTAvatar';
var BUTTON = exports.BUTTON = 'RTButton';
var CARD = exports.CARD = 'RTCard';
var CHIP = exports.CHIP = 'RTChip';
var CHECKBOX = exports.CHECKBOX = 'RTCheckbox';
var DATE_PICKER = exports.DATE_PICKER = 'RTDatePicker';
var DIALOG = exports.DIALOG = 'RTDialog';
var DRAWER = exports.DRAWER = 'RTDrawer';
var DROPDOWN = exports.DROPDOWN = 'RTDropdown';
var INPUT = exports.INPUT = 'RTInput';
var LAYOUT = exports.LAYOUT = 'RTLayout';
var LINK = exports.LINK = 'RTLink';
var LIST = exports.LIST = 'RTList';
var MENU = exports.MENU = 'RTMenu';
var NAVIGATION = exports.NAVIGATION = 'RTNavigation';
var OVERLAY = exports.OVERLAY = 'RTOverlay';
var PROGRESS_BAR = exports.PROGRESS_BAR = 'RTProgressBar';
var RADIO = exports.RADIO = 'RTRadio';
var RIPPLE = exports.RIPPLE = 'RTRipple';
var SLIDER = exports.SLIDER = 'RTSlider';
var SNACKBAR = exports.SNACKBAR = 'RTSnackbar';
var SWITCH = exports.SWITCH = 'RTSwitch';
var TABLE = exports.TABLE = 'RTTable';
var TABS = exports.TABS = 'RTTabs';
var TOOLTIP = exports.TOOLTIP = 'RTTooltip';
var TIME_PICKER = exports.TIME_PICKER = 'RTTimePicker';

/***/ }),

/***/ 996:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _curry1 = __webpack_require__(985);
var _isPlaceholder = __webpack_require__(1015);


/**
                                                   * Optimized internal two-arity curry function.
                                                   *
                                                   * @private
                                                   * @category Function
                                                   * @param {Function} fn The function to curry.
                                                   * @return {Function} The curried function.
                                                   */
module.exports = function _curry2(fn) {
  return function f2(a, b) {
    switch (arguments.length) {
      case 0:
        return f2;
      case 1:
        return _isPlaceholder(a) ? f2 :
        _curry1(function (_b) {return fn(a, _b);});
      default:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f2 :
        _isPlaceholder(a) ? _curry1(function (_a) {return fn(_a, b);}) :
        _isPlaceholder(b) ? _curry1(function (_b) {return fn(a, _b);}) :
        fn(a, b);}

  };
};

/***/ }),

/***/ 997:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _create = __webpack_require__(222);var _create2 = _interopRequireDefault(_create);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _inheritsLoose(subClass, superClass) {
  subClass.prototype = (0, _create2.default)(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;

/***/ }),

/***/ 998:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),

/***/ 999:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _defineProperty2 = __webpack_require__(161);var _defineProperty3 = _interopRequireDefault(_defineProperty2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _defineProperty(obj, key, value) {
  if (key in obj) {
    (0, _defineProperty3.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true });

  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ })

});


// WEBPACK FOOTER //
// 2.js